(function () {
  var PIPELINE_STEPS = [
    { key: 'quote_requested', labelKey: 'pipeline.quote_requested' },
    { key: 'quote_sent', labelKey: 'pipeline.quote_sent' },
    { key: 'quote_approved', labelKey: 'pipeline.quote_approved' },
    { key: 'bat_pending', labelKey: 'pipeline.proof_mockup' },
    { key: 'in_production', labelKey: 'pipeline.production' },
    { key: 'stored', labelKey: 'pipeline.storage' },
    { key: 'shipping', labelKey: 'pipeline.shipping' }
  ];

  var PIPELINE_INDEX = {
    quote_requested: 0,
    quote_in_progress: 0,
    quote_sent: 1,
    quote_approved: 2,
    design_in_progress: 2,
    bat_pending: 3,
    bat_changes_requested: 3,
    bat_signed: 3,
    production_scheduled: 4,
    in_production: 4,
    stored: 5,
    shipping: 6,
    delivered: 6,
    closed: 6
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function readI18n(root) {
    var script = root.querySelector('[data-b2b-i18n]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function interpolate(template, values) {
    return String(template == null ? '' : template)
      .replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (match, key) {
        return values && values[key] != null ? values[key] : match;
      })
      .replace(/__([A-Z0-9_]+)__/g, function (match, key) {
        if (!values) return match;
        if (values[key] != null) return values[key];
        return values[key.toLowerCase()] != null ? values[key.toLowerCase()] : match;
      });
  }

  function formatDate(value, locale) {
    if (!value) return '--';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    try {
      return new Intl.DateTimeFormat(locale || undefined, { day: '2-digit', month: 'short', year: 'numeric' }).format(date);
    } catch (error) {
      return String(value);
    }
  }

  function money(value, locale) {
    if (!value || typeof value !== 'object') return '';
    var amount = Number(value.amount);
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency: value.currency || 'EUR' }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + (value.currency || 'EUR');
    }
  }

  function toNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function localizedPath(path) {
    var rootUrl = window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.root_url;
    var localeRoot = String(rootUrl || '/').replace(/\/?$/, '/');
    return localeRoot + String(path || '').replace(/^\/+/, '');
  }

  function daysUntil(value) {
    if (!value) return null;
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    var now = new Date();
    return Math.ceil((date.setHours(23, 59, 59, 999) - now.getTime()) / 86400000);
  }

  function latestTimestamp(item) {
    var value = item && (item.updatedAt || item.createdAt);
    var time = value ? new Date(value).getTime() : 0;
    return Number.isFinite(time) ? time : 0;
  }

  var legacyPortalControllers = new Set();
  var legacyPortalLocked = false;

  function legacyPortalAuthError() {
    var error = new Error('Client portal authentication is required');
    error.name = 'PortalApiError';
    error.status = 401;
    error.code = 'CLIENT_AUTH_REQUIRED';
    return error;
  }

  function lockLegacyPortal(currentController) {
    if (legacyPortalLocked) return;
    legacyPortalLocked = true;
    legacyPortalControllers.forEach(function (controller) {
      if (controller !== currentController) controller.abort();
    });
    legacyPortalControllers.clear();
  }

  function legacyPortalFetch(url, options) {
    if (legacyPortalLocked) return Promise.reject(legacyPortalAuthError());
    var controller = new AbortController();
    legacyPortalControllers.add(controller);
    return fetch(url, Object.assign({}, options || {}, { signal: controller.signal }))
      .then(function (response) {
        if (response.status === 401) lockLegacyPortal(controller);
        return response;
      })
      .finally(function () { legacyPortalControllers.delete(controller); });
  }

  function postJSON(url, payload, mutation) {
    var intentHelper = window.TodayMerchClientMutationIntent;
    var expectedVersion = mutation && mutation.expectedVersion;
    if (!intentHelper || typeof intentHelper.get !== 'function'
      || typeof intentHelper.withContract !== 'function' || typeof intentHelper.clear !== 'function'
      || !mutation || !Number.isSafeInteger(expectedVersion) || expectedVersion < 0) {
      return Promise.reject(new Error('Secure mutation intent is unavailable'));
    }
    var materialPayload = Object.assign({}, payload || {}, { expected_version: expectedVersion });
    return intentHelper.get({
      operation: mutation.operation,
      resource: mutation.resource,
      payload: materialPayload
    }).then(function (intent) {
      var contract = intentHelper.withContract(payload || {}, intent, expectedVersion);
      return legacyPortalFetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: Object.assign({
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }, contract.headers),
        body: JSON.stringify(contract.body)
      }).then(function (response) {
        return response.text().then(function (text) {
          var data = text ? JSON.parse(text) : {};
          if (!response.ok) {
            var publicApi = window.TodayMerchPublicApi;
            throw publicApi && typeof publicApi.responseError === 'function'
              ? publicApi.responseError(data, document.documentElement.lang)
              : new Error('Client portal unavailable');
          }
          try {
            intentHelper.clear(mutation.operation, intent);
          } catch (error) {
            // A confirmed response stays authoritative; a retained intent safely replays.
          }
          return data;
        });
      });
    });
  }

  function ClientPortal(root, options) {
    options = options || {};
    this.root = root;
    this.readOnly = options.readOnly === true;
    this.i18n = readI18n(root);
    this.dateLocale = this.i18n.locale || document.documentElement.lang || undefined;
    this.apiBase = String(root.getAttribute('data-api-base') || '/apps/todays-studio').replace(/\/$/, '');
    this.quoteUrl = root.getAttribute('data-quote-url') || localizedPath('pages/demande-de-devis');
    this.customerName = root.getAttribute('data-customer-name') || '';
    this.companyName = options.companyName || root.getAttribute('data-company-name') || this.customerName;
    this.stateEl = root.querySelector('[data-b2b-state]');
    this.views = root.querySelectorAll('[data-b2b-view]');
    this.navButtons = root.querySelectorAll('[data-b2b-nav]');
    this.projectFilter = root.querySelector('[data-b2b-project-filter]');
    this.countEls = root.querySelectorAll('[data-b2b-count]');
    this.pageTitleEl = root.querySelector('[data-b2b-page-title]');
    this.currentProjectTitleEl = root.querySelector('[data-b2b-current-project-title]');
    this.projectSwitcherEl = root.querySelector('[data-b2b-project-switcher]');
    this.projectHeroEl = root.querySelector('[data-b2b-project-hero]');
    this.infoEls = root.querySelectorAll('[data-b2b-info]');
    this.kpiNoteEls = root.querySelectorAll('[data-b2b-kpi-note]');
    this.healthEl = root.querySelector('[data-b2b-health]');
    this.pipelineEl = root.querySelector('[data-b2b-pipeline]');
    this.quickActionsEl = root.querySelector('[data-b2b-quick-actions]');
    this.projectsEl = root.querySelector('[data-b2b-projects]');
    this.productsEl = root.querySelector('[data-b2b-products]');
    this.proofsEl = root.querySelector('[data-b2b-proofs]');
    this.stockEl = root.querySelector('[data-b2b-stock]');
    this.documentsEl = root.querySelector('[data-b2b-documents]');
    this.messagesEl = root.querySelector('[data-b2b-messages]');
    this.linkedOrdersEl = root.querySelector('[data-b2b-linked-orders]');
    this.detailEl = root.querySelector('[data-b2b-detail]');
    this.detailContentEl = root.querySelector('[data-b2b-detail-content]');
    this.data = { summary: {}, actions: [], projects: [], stockItems: [] };
    this.activeProject = null;
    this.activeView = 'overview';
    this.mutationInFlight = Object.create(null);
    this.mutationCompleted = Object.create(null);
  }

  ClientPortal.prototype.apiUrl = function (path) {
    return this.apiBase + path;
  };

  ClientPortal.prototype.t = function (key, values) {
    var label = this.i18n && this.i18n[key] ? this.i18n[key] : '';
    return interpolate(label, values);
  };

  ClientPortal.prototype.statusLabel = function (item) {
    var status = String(item && item.status || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
    return this.t('status.' + status) || String(item && item.statusLabel || status || this.t('fallback.project'));
  };

  ClientPortal.prototype.hasGeneratedTitle = function (item) {
    var titleKind = String(item && item.titleKind || '').trim().toLowerCase();
    return Boolean(item && item.titleIsGenerated) || titleKind === 'default' || titleKind === 'fallback';
  };

  ClientPortal.prototype.projectTitle = function (project) {
    var title = String(project && project.title || '').trim();
    if (!title || this.hasGeneratedTitle(project)) return this.t('fallback.merch_project');
    return title;
  };

  ClientPortal.prototype.quoteTitle = function (quote) {
    var title = String(quote && quote.title || '').trim();
    return !title || this.hasGeneratedTitle(quote) ? this.t('fallback.quote_type') : title;
  };

  ClientPortal.prototype.proofTitle = function (proof) {
    return String(proof && proof.title || '').trim() || this.t('fallback.proof_type');
  };

  ClientPortal.prototype.stockTitle = function (item) {
    var title = String(item && item.title || '').trim();
    return !title || this.hasGeneratedTitle(item) ? this.t('fallback.product') : title;
  };

  ClientPortal.prototype.messageBody = function (message) {
    var type = String(message && message.type || '').trim();
    var payload = message && message.payload && typeof message.payload === 'object' ? message.payload : {};
    if (type === 'quote_request') return this.t('message.quote_request');

    if (type === 'proof_decision') {
      var decisionPayload = payload.decision && typeof payload.decision === 'object' ? payload.decision : {};
      var decision = String(decisionPayload.decision || payload.status || '').trim();
      if (decision === 'approved') return this.t('message.proof_approved');
      var comment = String(decisionPayload.comment || payload.comment || '').trim();
      return comment
        ? this.t('message.proof_changes_requested_with_comment', { COMMENT: comment })
        : this.t('message.proof_changes_requested');
    }

    if (type === 'stock_reorder_request') {
      var count = Number(payload.quantity || payload.reorder_request && payload.reorder_request.quantity || 0);
      if (!Number.isFinite(count) || count <= 0) return this.t('message.reorder_request');
      var category = 'other';
      try {
        category = new Intl.PluralRules(this.dateLocale || undefined).select(count);
      } catch (error) {
        category = count === 1 ? 'one' : 'other';
      }
      var note = String(message.body || payload.note || '').trim();
      return this.t(category === 'one' ? 'message.reorder_request_one' : 'message.reorder_request_other', {
        COUNT: count,
        NOTE: note ? ' · ' + note : ''
      });
    }

    return String(message && message.body || '');
  };

  ClientPortal.prototype.setState = function (tone, title, text) {
    if (!this.stateEl) return;
    this.stateEl.className = 'b2b-sync-state' + (tone ? ' is-' + tone : '');
    this.stateEl.querySelector('strong').textContent = title;
    this.stateEl.querySelector('small').textContent = text;
  };

  ClientPortal.prototype.load = function () {
    var self = this;
    this.setState('loading', this.t('state.sync_title'), this.t('state.sync_loading'));
    return legacyPortalFetch(this.apiUrl('/client/dashboard'), {
      headers: { Accept: 'application/json' },
      credentials: 'include'
    })
      .then(function (response) {
        return response.text().then(function (text) {
          var data = text ? JSON.parse(text) : {};
          if (!response.ok) {
            var publicApi = window.TodayMerchPublicApi;
            throw publicApi && typeof publicApi.responseError === 'function'
              ? publicApi.responseError(data, self.dateLocale)
              : new Error('Client portal unavailable');
          }
          return data;
        });
      })
      .then(function (data) {
        self.data = {
          summary: data.summary || {},
          actions: Array.isArray(data.actions) ? data.actions : [],
          projects: Array.isArray(data.projects) ? data.projects : [],
          stockItems: Array.isArray(data.stockItems) ? data.stockItems : []
        };
        self.activeProject = self.selectActiveProject();
        self.setState(
          'ready',
          self.t('state.ready_title'),
          self.activeProject ? self.t('state.dashboard_up_to_date') : self.t('state.no_active_client_project')
        );
        self.render();
      })
      .catch(function (error) {
        self.activeProject = null;
        self.setState('warning', self.t('state.portal_pending'), error.code === 'CLIENT_AUTH_REQUIRED'
          ? self.t('state.login_to_load_b2b')
          : self.t('state.project_data_unavailable'));
        self.renderEmpty();
      });
  };

  ClientPortal.prototype.selectActiveProject = function () {
    var projects = (this.data.projects || []).slice();
    if (!projects.length) return null;
    function priority(project) {
      var status = project.status || '';
      var pendingProof = (project.proofs || []).some(function (proof) { return proof.status === 'bat_pending'; });
      if (pendingProof || status === 'bat_pending') return 0;
      if (/^quote_/.test(status)) return 1;
      if (['production_scheduled', 'in_production', 'stored', 'shipping'].includes(status)) return 2;
      if (!['closed', 'delivered'].includes(status)) return 3;
      return 4;
    }
    projects.sort(function (a, b) {
      return priority(a) - priority(b) || latestTimestamp(b) - latestTimestamp(a);
    });
    return projects[0];
  };

  ClientPortal.prototype.metrics = function () {
    var projects = this.data.projects || [];
    var stockItems = this.data.stockItems || [];
    var active = this.activeProject;
    var lowStock = stockItems.filter(function (item) { return item.lowStock; }).length;
    var reserved = stockItems.reduce(function (sum, item) { return sum + toNumber(item.reserved); }, 0);
    var productionOrders = projects.filter(function (project) {
      return ['production_scheduled', 'in_production', 'stored', 'shipping'].includes(project.status);
    }).length;
    var pendingProofs = projects.reduce(function (sum, project) {
      return sum + (project.proofs || []).filter(function (proof) { return proof.status === 'bat_pending'; }).length;
    }, 0);
    var pendingQuotes = projects.filter(function (project) {
      return ['quote_requested', 'quote_in_progress', 'quote_sent'].includes(project.status);
    }).length;
    var days = daysUntil(active && active.targetDate);
    return {
      activeProjects: projects.filter(function (project) { return !['closed', 'delivered'].includes(project.status); }).length,
      pendingQuotes: this.data.summary.pendingQuotes || pendingQuotes,
      pendingProofs: this.data.summary.pendingProofs || pendingProofs,
      productionOrders: productionOrders,
      lowStock: this.data.summary.lowStock || lowStock,
      reservedItems: reserved,
      daysRemaining: days == null ? '--' : Math.max(days, 0)
    };
  };

  ClientPortal.prototype.setView = function (view) {
    this.activeView = view || 'overview';
    this.navButtons.forEach(function (button) {
      var active = button.getAttribute('data-b2b-nav') === this.activeView;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-current', active ? 'page' : 'false');
    }, this);
    this.views.forEach(function (panel) {
      var active = panel.getAttribute('data-b2b-view') === this.activeView;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    }, this);
    if (this.pageTitleEl) {
      var titles = {
        overview: this.t('page.dashboard_project'),
        projects: this.t('page.all_projects'),
        products: this.t('page.project_products'),
        proofs: this.t('page.proofs'),
        orders: this.t('page.orders'),
        stock: this.t('page.stock'),
        documents: this.t('page.documents'),
        messages: this.t('page.messages'),
        settings: this.t('page.settings')
      };
      this.pageTitleEl.textContent = titles[this.activeView] || this.t('page.dashboard_project');
    }
  };

  ClientPortal.prototype.render = function () {
    this.renderCounts();
    this.renderProjectContext();
    this.renderInfoCards();
    this.renderHealth();
    this.renderPipeline();
    this.renderQuickActions();
    this.renderProjectSwitcher();
    this.renderProjects();
    this.renderProducts();
    this.renderProofs();
    this.renderStock();
    this.renderDocuments();
    this.renderMessages();
    this.renderLinkedOrders();
  };

  ClientPortal.prototype.renderEmpty = function () {
    var emptyProject = '<div class="b2b-project-hero__logo" aria-hidden="true">TM</div><div><span class="b2b-status">' + escapeHtml(this.t('empty.new')) + '</span><h2>' + escapeHtml(this.t('empty.no_active_project')) + '</h2>'
      + (this.readOnly ? '' : '<p>' + escapeHtml(this.t('empty.create_quote_text')) + '</p><a class="b2b-button b2b-button--dark" href="' + escapeHtml(this.quoteUrl) + '">' + escapeHtml(this.t('action.create_quote')) + '</a>') + '</div>';
    if (this.projectHeroEl) this.projectHeroEl.innerHTML = emptyProject;
    if (this.quickActionsEl) this.quickActionsEl.innerHTML = this.readOnly ? '' : '<a class="b2b-quick-action b2b-quick-action--primary" href="' + escapeHtml(this.quoteUrl) + '">' + escapeHtml(this.t('action.create_quote')) + '</a>';
    if (this.pipelineEl) this.pipelineEl.innerHTML = this.pipelineRows(null);
    if (this.projectsEl) this.projectsEl.innerHTML = '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_project')) + '</strong><p>' + escapeHtml(this.t('empty.projects_text')) + '</p></div>';
    if (this.productsEl) this.productsEl.innerHTML = '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_product')) + '</strong><p>' + escapeHtml(this.t('empty.products_text')) + '</p></div>';
    if (this.proofsEl) this.proofsEl.innerHTML = '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_proof')) + '</strong><p>' + escapeHtml(this.t('empty.proofs_text')) + '</p></div>';
    if (this.stockEl) this.stockEl.innerHTML = '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_stock')) + '</strong><p>' + escapeHtml(this.t('empty.stock_text')) + '</p></div>';
    if (this.documentsEl) this.documentsEl.innerHTML = '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_document')) + '</strong><p>' + escapeHtml(this.t('empty.documents_text')) + '</p></div>';
    if (this.messagesEl) this.messagesEl.innerHTML = '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_message')) + '</strong><p>' + escapeHtml(this.t('empty.messages_text')) + '</p></div>';
    if (this.projectSwitcherEl) this.projectSwitcherEl.innerHTML = '<p>' + escapeHtml(this.t('empty.no_other_project')) + '</p>';
    if (this.healthEl) this.healthEl.innerHTML = '<span aria-hidden="true">!</span><strong>' + escapeHtml(this.t('health.no_project')) + '</strong>';
    this.renderCounts();
  };

  ClientPortal.prototype.renderCounts = function () {
    var metrics = this.metrics();
    this.countEls.forEach(function (el) {
      var key = el.getAttribute('data-b2b-count');
      el.textContent = metrics[key] == null ? 0 : metrics[key];
    });
  };

  ClientPortal.prototype.renderProjectContext = function () {
    var project = this.activeProject;
    if (this.currentProjectTitleEl) this.currentProjectTitleEl.textContent = project ? this.projectTitle(project) : this.t('empty.no_active_project');
    if (!this.projectHeroEl) return;
    if (!project) {
      this.renderEmpty();
      return;
    }
    var company = this.companyName;
    var logo = String(company || this.projectTitle(project) || 'TM').slice(0, 2).toUpperCase();
    this.projectHeroEl.innerHTML = '<div class="b2b-project-hero__logo" aria-hidden="true">' + escapeHtml(logo) + '</div>' +
      '<div class="b2b-project-hero__main">' +
        '<span class="b2b-status b2b-status--' + escapeHtml(project.status) + '">' + escapeHtml(this.statusLabel(project)) + '</span>' +
        '<h2>' + escapeHtml(this.projectTitle(project)) + '</h2>' +
        '<p>' + escapeHtml(company || this.t('fallback.account')) + (project.projectType ? ' · ' + escapeHtml(project.projectType) : '') + '</p>' +
      '</div>' +
      '<button type="button" class="b2b-button b2b-button--light" data-b2b-open-project="' + escapeHtml(project.handle || project.id) + '">' + escapeHtml(this.t('action.open_detail')) + '</button>';
  };

  ClientPortal.prototype.renderInfoCards = function () {
    var project = this.activeProject;
    var values = {
      account: this.companyName,
      created: project ? formatDate(project.createdAt, this.dateLocale) : '--',
      target: project ? formatDate(project.targetDate, this.dateLocale) : '--',
      products: project ? (project.products || []).length : 0
    };
    this.infoEls.forEach(function (el) {
      el.textContent = values[el.getAttribute('data-b2b-info')] || '--';
    });
  };

  ClientPortal.prototype.renderHealth = function () {
    if (!this.healthEl) return;
    var metrics = this.metrics();
    var project = this.activeProject;
    var tone = 'healthy';
    var label = this.t('health.project_up_to_date');
    if (!project) {
      tone = 'warning';
      label = this.t('health.no_project');
    } else if (metrics.lowStock > 0) {
      tone = 'stock';
      label = this.t('health.low_stock');
    } else if (metrics.pendingProofs > 0 || metrics.pendingQuotes > 0 || project.status === 'bat_pending') {
      tone = 'action';
      label = this.t('health.action_required');
    }
    this.healthEl.className = 'b2b-health-banner b2b-health-banner--' + tone;
    this.healthEl.innerHTML = '<span aria-hidden="true">' + (tone === 'healthy' ? '✓' : '!') + '</span><strong>' + escapeHtml(label) + '</strong>';
  };

  ClientPortal.prototype.pipelineRows = function (project) {
    var index = project ? (PIPELINE_INDEX[project.status] ?? 0) : -1;
    return PIPELINE_STEPS.map(function (step, stepIndex) {
      var progress = stepIndex < index ? 100 : (stepIndex === index ? 100 : 0);
      return '<div class="b2b-pipeline__row">' +
        '<span>' + escapeHtml(this.t(step.labelKey)) + '</span>' +
        '<div class="b2b-pipeline__track"><i style="--progress:' + progress + '%"></i></div>' +
        '<strong>' + (progress ? '1' : '0') + '</strong>' +
        '<small>' + (progress ? '100%' : '0%') + '</small>' +
      '</div>';
    }, this).join('');
  };

  ClientPortal.prototype.renderPipeline = function () {
    if (!this.pipelineEl) return;
    this.pipelineEl.innerHTML = this.pipelineRows(this.activeProject);
  };

  ClientPortal.prototype.renderQuickActions = function () {
    if (!this.quickActionsEl) return;
    var project = this.activeProject;
    var pendingProof = project ? (project.proofs || []).find(function (proof) { return proof.status === 'bat_pending'; }) : null;
    var lowStock = (this.data.stockItems || []).find(function (item) { return item.lowStock; });
    var actions = [];
    if (this.readOnly) {
      this.quickActionsEl.innerHTML = '<button type="button" class="b2b-quick-action" data-b2b-nav-shortcut="documents">' + escapeHtml(this.t('action.view_documents')) + '</button>';
      return;
    }
    if (pendingProof) {
      actions.push('<button type="button" class="b2b-quick-action b2b-quick-action--primary" data-b2b-nav-shortcut="proofs">' + escapeHtml(this.t('action.sign_proof')) + '</button>');
      actions.push('<button type="button" class="b2b-quick-action" data-b2b-open-project="' + escapeHtml(project.handle || project.id) + '">' + escapeHtml(this.t('action.request_changes')) + '</button>');
    }
    if (lowStock) {
      actions.push('<button type="button" class="b2b-quick-action" data-b2b-reorder="' + escapeHtml(lowStock.sku) + '">' + escapeHtml(this.t('action.request_reorder')) + '</button>');
    }
    actions.push('<button type="button" class="b2b-quick-action" data-b2b-nav-shortcut="documents">' + escapeHtml(this.t('action.view_documents')) + '</button>');
    actions.push('<a class="b2b-quick-action" href="' + escapeHtml(this.quoteUrl) + '">' + escapeHtml(this.t('action.new_quote')) + '</a>');
    this.quickActionsEl.innerHTML = actions.join('');
  };

  ClientPortal.prototype.renderProjectSwitcher = function () {
    if (!this.projectSwitcherEl) return;
    var active = this.activeProject;
    var projects = (this.data.projects || []).filter(function (project) {
      return !active || project.handle !== active.handle;
    }).slice(0, 5);
    this.projectSwitcherEl.innerHTML = projects.map(function (project) {
      return '<button type="button" data-b2b-open-project="' + escapeHtml(project.handle || project.id) + '">' +
        '<strong>' + escapeHtml(this.projectTitle(project)) + '</strong>' +
        '<small>' + escapeHtml(this.statusLabel(project)) + '</small>' +
      '</button>';
    }, this).join('') || '<p>' + escapeHtml(this.t('empty.no_other_project')) + '</p>';
  };

  ClientPortal.prototype.projectMatchesFilter = function (project) {
    var filter = this.projectFilter ? this.projectFilter.value : 'all';
    if (filter === 'all') return true;
    if (filter === 'active') return !['closed', 'delivered'].includes(project.status);
    if (filter === 'quote') return /^quote_/.test(project.status);
    if (filter === 'proof') return project.status.indexOf('bat_') === 0 || (project.proofs || []).length > 0;
    if (filter === 'production') return ['production_scheduled', 'in_production', 'stored', 'shipping'].includes(project.status);
    if (filter === 'closed') return ['closed', 'delivered'].includes(project.status);
    return true;
  };

  ClientPortal.prototype.projectCard = function (project) {
    var total = money(project.total, this.dateLocale);
    return '<article class="b2b-project-card">' +
      '<div class="b2b-project-card__main">' +
        '<span class="b2b-status b2b-status--' + escapeHtml(project.status) + '">' + escapeHtml(this.statusLabel(project)) + '</span>' +
        '<h3>' + escapeHtml(this.projectTitle(project)) + '</h3>' +
        '<p>' + escapeHtml(project.summary || project.projectType || this.t('fallback.merch_project')) + '</p>' +
      '</div>' +
      '<div class="b2b-project-card__meta">' +
        '<span>' + escapeHtml(this.t('meta.target_date')) + '<br><strong>' + escapeHtml(formatDate(project.targetDate, this.dateLocale)) + '</strong></span>' +
        (total ? '<span>' + escapeHtml(this.t('meta.budget')) + '<br><strong>' + escapeHtml(total) + '</strong></span>' : '') +
        '<span>' + escapeHtml(this.t('meta.proof')) + '<br><strong>' + escapeHtml((project.proofs || []).length) + '</strong></span>' +
      '</div>' +
      '<button type="button" class="b2b-link-button" data-b2b-open-project="' + escapeHtml(project.handle || project.id) + '">' + escapeHtml(this.t('action.open')) + '</button>' +
    '</article>';
  };

  ClientPortal.prototype.renderProjects = function () {
    if (!this.projectsEl) return;
    var projects = (this.data.projects || []).filter(this.projectMatchesFilter.bind(this));
    this.projectsEl.innerHTML = projects.map(this.projectCard.bind(this)).join('') ||
      '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_project_in_filter')) + '</strong><p>' + escapeHtml(this.t('empty.no_project_in_filter_text')) + '</p></div>';
  };

  ClientPortal.prototype.renderProducts = function () {
    if (!this.productsEl) return;
    var products = this.activeProject ? (this.activeProject.products || []) : [];
    this.productsEl.innerHTML = products.slice(0, 24).map(function (item) {
      return '<article class="b2b-product-card">' +
        '<div class="b2b-product-card__visual">' + escapeHtml(String(item.title || item.product_title || item.name || 'TM').slice(0, 2).toUpperCase()) + '</div>' +
        '<div><strong>' + escapeHtml(item.title || item.product_title || item.name || this.t('fallback.product')) + '</strong>' +
        '<small>' + escapeHtml(item.sku || item.variant_title || this.t('fallback.active_project')) + '</small></div>' +
        '<span>' + escapeHtml(item.quantity || item.qty || 0) + '</span>' +
      '</article>';
    }, this).join('') || '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_detailed_product')) + '</strong><p>' + escapeHtml(this.t('empty.detailed_products_text')) + '</p></div>';
  };

  ClientPortal.prototype.renderProofs = function () {
    if (!this.proofsEl) return;
    var proofs = [];
    (this.data.projects || []).forEach(function (project) {
      (project.proofs || []).forEach(function (proof) {
        proofs.push({ project: project, proof: proof });
      });
    });
    this.proofsEl.innerHTML = proofs.map(function (item) {
      return this.proofCard(item.project, item.proof);
    }, this).join('') || '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_current_proof')) + '</strong><p>' + escapeHtml(this.t('empty.current_proofs_text')) + '</p></div>';
  };

  ClientPortal.prototype.proofCard = function (project, proof) {
    var resourceVersion = Number(proof.resourceVersion);
    var pending = proof.status === 'bat_pending'
      && Number.isSafeInteger(resourceVersion) && resourceVersion > 0;
    return '<article class="b2b-proof-card">' +
      '<div class="b2b-proof-card__visual">' +
        (proof.previewUrl ? '<img src="' + escapeHtml(proof.previewUrl) + '" alt="' + escapeHtml(this.proofTitle(proof)) + '" loading="lazy">' : '<span>' + escapeHtml(this.t('fallback.proof_type')) + '</span>') +
      '</div>' +
      '<div class="b2b-proof-card__body">' +
        '<span class="b2b-status b2b-status--' + escapeHtml(proof.status) + '">' + escapeHtml(this.statusLabel(proof)) + '</span>' +
        '<h3>' + escapeHtml(this.proofTitle(proof)) + '</h3>' +
        '<p>' + escapeHtml(this.projectTitle(project)) + ' · ' + escapeHtml(proof.version || 'v1') + '</p>' +
        (proof.fileUrl ? '<a href="' + escapeHtml(proof.fileUrl) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(this.t('action.open_file')) + '</a>' : '') +
        (pending && !this.readOnly ? this.proofDecisionForm(project, proof) : '') +
      '</div>' +
    '</article>';
  };

  ClientPortal.prototype.proofDecisionForm = function (project, proof) {
    var resourceVersion = Number(proof && proof.resourceVersion);
    var projectId = project && (project.handle || project.id);
    var proofId = proof && (proof.handle || proof.id);
    if (!Number.isSafeInteger(resourceVersion) || resourceVersion < 1 || !projectId || !proofId) return '';
    return '<form class="b2b-proof-decision" data-b2b-proof-form data-project="' + escapeHtml(projectId) + '" data-proof="' + escapeHtml(proofId) + '" data-version="' + escapeHtml(resourceVersion) + '">' +
      '<label><span>' + escapeHtml(this.t('proof.signer_name')) + '</span><input type="text" name="signer_name" required maxlength="160" autocomplete="name"></label>' +
      '<label><span>' + escapeHtml(this.t('proof.company')) + '</span><input type="text" name="company" maxlength="160" autocomplete="organization"></label>' +
      '<label class="b2b-proof-decision__comment"><span>' + escapeHtml(this.t('proof.comment')) + '</span><textarea name="comment" rows="3" maxlength="1200"></textarea></label>' +
      '<div class="b2b-proof-decision__actions">' +
        '<button type="submit" name="decision" value="approved" class="b2b-button b2b-button--dark">' + escapeHtml(this.t('action.submit_proof')) + '</button>' +
        '<button type="submit" name="decision" value="changes_requested" class="b2b-button b2b-button--light">' + escapeHtml(this.t('action.submit_changes')) + '</button>' +
      '</div>' +
    '</form>';
  };

  ClientPortal.prototype.renderStock = function () {
    if (!this.stockEl) return;
    var stockItems = this.data.stockItems || [];
    this.stockEl.innerHTML = stockItems.length ? '<div class="b2b-stock-table__head"><span>' + escapeHtml(this.t('stock.product')) + '</span><span>' + escapeHtml(this.t('stock.available')) + '</span><span>' + escapeHtml(this.t('stock.reserved')) + '</span><span>' + escapeHtml(this.t('stock.incoming')) + '</span><span></span></div>' +
      stockItems.map(this.stockRow.bind(this)).join('') : '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_stock')) + '</strong><p>' + escapeHtml(this.t('empty.stock_text')) + '</p></div>';
  };

  ClientPortal.prototype.stockRow = function (item) {
    return '<article class="b2b-stock-row' + (item.lowStock ? ' is-low' : '') + '">' +
      '<div class="b2b-stock-row__product">' +
        (item.imageUrl ? '<img src="' + escapeHtml(item.imageUrl) + '" alt="" loading="lazy">' : '<span aria-hidden="true"></span>') +
        '<div><strong>' + escapeHtml(this.stockTitle(item)) + '</strong><small>' + escapeHtml(item.sku || this.t('fallback.sku')) + '</small></div>' +
      '</div>' +
      '<span>' + escapeHtml(item.available) + '</span>' +
      '<span>' + escapeHtml(item.reserved) + '</span>' +
      '<span>' + escapeHtml(item.incoming) + '</span>' +
      (this.readOnly ? '<span></span>' : '<button type="button" class="b2b-link-button" data-b2b-reorder="' + escapeHtml(item.sku) + '">' + escapeHtml(this.t('action.reorder')) + '</button>') +
    '</article>';
  };

  ClientPortal.prototype.collectDocuments = function () {
    var self = this;
    var documents = [];
    var quoteType = this.t('fallback.quote_type');
    var documentType = this.t('fallback.document');
    var proofType = this.t('fallback.proof_type');
    (this.data.projects || []).forEach(function (project) {
      (project.documents || []).forEach(function (document) {
        documents.push({ project: project, title: document.title || document.name || documentType, url: document.url || document.file_url, type: document.type || documentType });
      });
      (project.proofs || []).forEach(function (proof) {
        if (proof.fileUrl) documents.push({ project: project, title: self.proofTitle(proof), url: proof.fileUrl, type: proofType });
      });
      (project.quotes || []).forEach(function (quote) {
        if (quote.fileUrl || quote.invoiceUrl) documents.push({ project: project, title: self.quoteTitle(quote), url: quote.fileUrl || quote.invoiceUrl, type: quoteType });
      });
    });
    return documents;
  };

  ClientPortal.prototype.renderDocuments = function () {
    if (!this.documentsEl) return;
    var documents = this.collectDocuments();
    this.documentsEl.innerHTML = documents.map(function (document) {
      return '<a class="b2b-document" href="' + escapeHtml(document.url) + '" target="_blank" rel="noopener noreferrer">' +
        '<span>' + escapeHtml(document.type) + '</span>' +
        '<strong>' + escapeHtml(document.title) + '</strong>' +
        '<small>' + escapeHtml(this.projectTitle(document.project)) + '</small>' +
      '</a>';
    }, this).join('') || '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_document')) + '</strong><p>' + escapeHtml(this.t('empty.documents_text')) + '</p></div>';
  };

  ClientPortal.prototype.renderMessages = function () {
    if (!this.messagesEl) return;
    var messages = [];
    (this.data.projects || []).forEach(function (project) {
      (project.messages || []).forEach(function (message) {
        messages.push({ project: project, message: message });
      });
    });
    messages.sort(function (a, b) { return latestTimestamp(b.message) - latestTimestamp(a.message); });
    this.messagesEl.innerHTML = messages.map(function (item) {
      return '<article class="b2b-message-card">' +
        '<span>' + escapeHtml(formatDate(item.message.createdAt, this.dateLocale)) + ' · ' + escapeHtml(this.projectTitle(item.project)) + '</span>' +
        '<strong>' + escapeHtml(item.message.author || 'Today Merch') + '</strong>' +
        '<p>' + escapeHtml(this.messageBody(item.message)) + '</p>' +
      '</article>';
    }, this).join('') || '<div class="b2b-empty"><strong>' + escapeHtml(this.t('empty.no_message')) + '</strong><p>' + escapeHtml(this.t('empty.messages_text')) + '</p></div>';
  };

  ClientPortal.prototype.renderLinkedOrders = function () {
    if (!this.linkedOrdersEl) return;
    var linked = (this.data.projects || []).filter(function (project) { return project.order; });
    if (!linked.length) {
      this.linkedOrdersEl.innerHTML = '';
      return;
    }
    this.linkedOrdersEl.innerHTML = '<div class="b2b-section-heading b2b-section-heading--small"><div><p>' + escapeHtml(this.t('linked_orders.kicker')) + '</p><h2>' + escapeHtml(this.t('linked_orders.heading')) + '</h2></div></div>' +
      linked.map(function (project) {
        return '<article class="b2b-project-card">' +
          '<div class="b2b-project-card__main"><span class="b2b-status b2b-status--' + escapeHtml(project.status) + '">' + escapeHtml(this.statusLabel(project)) + '</span><h3>' + escapeHtml(this.projectTitle(project)) + '</h3><p>' + escapeHtml(project.order.name || project.order.id || this.t('fallback.linked_order')) + '</p></div>' +
          (project.order.url ? '<a class="b2b-link-button" href="' + escapeHtml(project.order.url) + '">' + escapeHtml(this.t('action.view')) + '</a>' : '') +
        '</article>';
      }, this).join('');
  };

  ClientPortal.prototype.openProject = function (handle) {
    var project = (this.data.projects || []).find(function (item) { return item.handle === handle || item.id === handle; });
    if (!project || !this.detailEl || !this.detailContentEl) return;
    this.detailContentEl.innerHTML = this.projectDetail(project);
    this.detailEl.hidden = false;
    this.detailEl.classList.add('is-open');
  };

  ClientPortal.prototype.projectDetail = function (project) {
    return '<header class="b2b-detail__header">' +
      '<span class="b2b-status b2b-status--' + escapeHtml(project.status) + '">' + escapeHtml(this.statusLabel(project)) + '</span>' +
      '<h2>' + escapeHtml(this.projectTitle(project)) + '</h2>' +
      '<p>' + escapeHtml(project.summary || project.projectType || this.t('fallback.merch_project')) + '</p>' +
    '</header>' +
    '<div class="b2b-detail__timeline">' + this.pipelineRows(project) + '</div>' +
    '<section class="b2b-detail__section"><h3>' + escapeHtml(this.t('section.products')) + '</h3>' + this.productList(project.products || []) + '</section>' +
    '<section class="b2b-detail__section"><h3>' + escapeHtml(this.t('section.quotes')) + '</h3>' + this.quoteList(project.quotes || []) + '</section>' +
    '<section class="b2b-detail__section"><h3>' + escapeHtml(this.t('section.proofs')) + '</h3>' + ((project.proofs || []).map(function (proof) { return this.proofCard(project, proof); }, this).join('') || '<p>' + escapeHtml(this.t('empty.no_attached_proof')) + '</p>') + '</section>' +
    '<section class="b2b-detail__section"><h3>' + escapeHtml(this.t('section.messages')) + '</h3>' + this.messageList(project.messages || []) + '</section>';
  };

  ClientPortal.prototype.productList = function (products) {
    if (!products.length) return '<p>' + escapeHtml(this.t('empty.no_detailed_product_short')) + '</p>';
    return '<ul class="b2b-detail-list">' + products.slice(0, 20).map(function (item) {
      return '<li><strong>' + escapeHtml(item.title || item.product_title || item.name || this.t('fallback.product')) + '</strong><span>' + escapeHtml(item.quantity || item.qty || '') + '</span></li>';
    }, this).join('') + '</ul>';
  };

  ClientPortal.prototype.quoteList = function (quotes) {
    if (!quotes.length) return '<p>' + escapeHtml(this.t('empty.no_attached_quote')) + '</p>';
    return '<ul class="b2b-detail-list">' + quotes.map(function (quote) {
      return '<li><strong>' + escapeHtml(this.quoteTitle(quote)) + '</strong><span>' + escapeHtml(this.statusLabel(quote)) + (quote.amount ? ' · ' + escapeHtml(money(quote.amount, this.dateLocale)) : '') + '</span></li>';
    }, this).join('') + '</ul>';
  };

  ClientPortal.prototype.messageList = function (messages) {
    if (!messages.length) return '<p>' + escapeHtml(this.t('empty.no_message_now')) + '</p>';
    return '<ol class="b2b-message-list">' + messages.map(function (message) {
      return '<li><span>' + escapeHtml(formatDate(message.createdAt, this.dateLocale)) + '</span><strong>' + escapeHtml(message.author) + '</strong><p>' + escapeHtml(this.messageBody(message)) + '</p></li>';
    }, this).join('') + '</ol>';
  };

  ClientPortal.prototype.submitProofDecision = function (form, submitter) {
    if (this.readOnly) return Promise.reject(new Error('The legacy portal is read-only'));
    var self = this;
    var projectId = form.getAttribute('data-project');
    var proofId = form.getAttribute('data-proof');
    var resourceVersion = Number(form.getAttribute('data-version'));
    if (!projectId || !proofId || !Number.isSafeInteger(resourceVersion) || resourceVersion < 1) {
      return Promise.reject(new Error('A current proof version is required'));
    }
    var inflightKey = 'proofs.decide:' + projectId + ':' + proofId + ':' + resourceVersion;
    this.mutationCompleted = this.mutationCompleted || Object.create(null);
    if (this.mutationCompleted[inflightKey]) return Promise.resolve(this.mutationCompleted[inflightKey]);
    if (this.mutationInFlight[inflightKey]) return this.mutationInFlight[inflightKey];
    var decision = submitter && submitter.value ? String(submitter.value) : 'approved';
    var signerName = String(form.elements.signer_name ? form.elements.signer_name.value : '').trim();
    var company = String(form.elements.company ? form.elements.company.value : '').trim();
    var comment = String(form.elements.comment ? form.elements.comment.value : '').trim();
    if (!['approved', 'changes_requested'].includes(decision)
      || !signerName || signerName.length > 160 || company.length > 160 || comment.length > 1200) {
      return Promise.reject(new Error('A valid proof decision and signer are required'));
    }
    if (decision === 'changes_requested' && !comment) {
      return Promise.reject(new Error('A correction comment is required'));
    }
    var payload = { decision: decision, signer_name: signerName, company: company, comment: comment };
    form.classList.add('is-loading');
    form.setAttribute('aria-busy', 'true');
    Array.prototype.forEach.call(form.querySelectorAll('button'), function (button) { button.disabled = true; });
    var request = postJSON(this.apiUrl('/client/projects/' + encodeURIComponent(projectId) + '/bat/' + encodeURIComponent(proofId) + '/decision'), payload, {
      operation: 'proofs.decide',
      resource: projectId + '/' + proofId,
      expectedVersion: resourceVersion
    })
      .then(function (data) {
        self.mutationCompleted[inflightKey] = data || { ok: true };
        return Promise.resolve(self.load()).then(function () {
          delete self.mutationCompleted[inflightKey];
          return data;
        }, function () {
          return data;
        });
      })
      .finally(function () {
        delete self.mutationInFlight[inflightKey];
        form.classList.remove('is-loading');
        form.removeAttribute('aria-busy');
        Array.prototype.forEach.call(form.querySelectorAll('button'), function (button) { button.disabled = false; });
      });
    this.mutationInFlight[inflightKey] = request;
    return request;
  };

  ClientPortal.prototype.openReorderDialog = function (sku, trigger) {
    if (this.readOnly) return null;
    var fallbackSku = sku || ((this.data.stockItems || []).find(function (item) { return item.lowStock; }) || {}).sku || '';
    if (!fallbackSku) {
      this.setView('stock');
      return null;
    }
    this.root.querySelector('[data-b2b-reorder-dialog]')?.close?.('replace');
    var dialog = document.createElement('dialog');
    dialog.className = 'b2b-reorder-dialog';
    dialog.setAttribute('data-b2b-reorder-dialog', '');
    dialog.innerHTML = '<form data-b2b-reorder-form data-sku="' + escapeHtml(fallbackSku) + '">'
      + '<h2>' + escapeHtml(this.t('action.reorder')) + '</h2>'
      + '<label><span>' + escapeHtml(this.t('prompt.reorder_quantity')) + '</span><input name="quantity" type="number" min="1" max="1000000" step="1" value="100" required></label>'
      + '<label><span>' + escapeHtml(this.t('prompt.reorder_note')) + '</span><textarea name="note" rows="4" maxlength="1200"></textarea></label>'
      + '<p data-b2b-reorder-error role="alert"></p><div class="b2b-reorder-dialog__actions">'
      + '<button type="button" class="b2b-button b2b-button--light" data-b2b-reorder-cancel>' + escapeHtml(this.t('action.cancel')) + '</button>'
      + '<button type="submit" class="b2b-button b2b-button--dark">' + escapeHtml(this.t('action.reorder')) + '</button></div></form>';
    dialog.addEventListener('close', function () {
      dialog.remove();
      trigger?.focus?.();
    }, { once: true });
    this.root.appendChild(dialog);
    dialog.showModal();
    dialog.querySelector('input[name="quantity"]')?.focus();
    return dialog;
  };

  ClientPortal.prototype.requestReorder = function (sku, input) {
    if (this.readOnly) return Promise.reject(new Error('The legacy portal is read-only'));
    var fallbackSku = sku || '';
    if (!fallbackSku) return Promise.resolve(null);
    var inflightKey = 'stock.reorder:' + fallbackSku;
    this.mutationCompleted = this.mutationCompleted || Object.create(null);
    if (this.mutationCompleted[inflightKey]) return Promise.resolve(this.mutationCompleted[inflightKey]);
    if (this.mutationInFlight[inflightKey]) return this.mutationInFlight[inflightKey];
    var testPrompt = window.__TODAYMERCH_CUSTOMER_PORTAL_TEST__ === true && typeof window['prompt'] === 'function'
      ? window['prompt'].bind(window) : null;
    var quantityInput = input?.quantity;
    if (input === undefined && testPrompt) {
      quantityInput = testPrompt(this.t('prompt.reorder_quantity'), '100');
      if (quantityInput == null) return Promise.resolve(null);
    }
    var normalizedQuantity = String(quantityInput).trim();
    if (!/^\+?\d+$/.test(normalizedQuantity)) {
      return Promise.reject(new Error('Reorder quantity must be a positive whole number'));
    }
    var quantity = Number(normalizedQuantity);
    if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 1_000_000) {
      return Promise.reject(new Error('Reorder quantity must be a positive whole number'));
    }
    var noteInput = input?.note;
    if (input === undefined && testPrompt) noteInput = testPrompt(this.t('prompt.reorder_note'), '');
    var note = String(noteInput || '').trim().slice(0, 1200);
    var self = this;
    var request = postJSON(this.apiUrl('/client/stock/' + encodeURIComponent(fallbackSku) + '/reorder-request'), {
      quantity: quantity,
      note: note
    }, {
      operation: 'stock.reorder',
      resource: fallbackSku,
      expectedVersion: 0
    }).then(function (data) {
      self.mutationCompleted[inflightKey] = data || { ok: true };
      return Promise.resolve(self.load()).then(function () {
        delete self.mutationCompleted[inflightKey];
        self.setView('projects');
        return data;
      }, function () {
        return data;
      });
    }).catch(function (error) {
      self.setState('warning', self.t('state.reorder_not_sent'), self.t('state.try_again'));
      throw error;
    }).finally(function () {
      delete self.mutationInFlight[inflightKey];
    });
    this.mutationInFlight[inflightKey] = request;
    return request;
  };

  ClientPortal.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (event) {
      var nav = event.target.closest('[data-b2b-nav], [data-b2b-nav-shortcut]');
      if (nav) {
        event.preventDefault();
        self.setView(nav.getAttribute('data-b2b-nav') || nav.getAttribute('data-b2b-nav-shortcut'));
        return;
      }

      var openProject = event.target.closest('[data-b2b-open-project]');
      if (openProject) {
        event.preventDefault();
        self.openProject(openProject.getAttribute('data-b2b-open-project'));
        return;
      }

      var reorder = event.target.closest('[data-b2b-reorder], [data-b2b-quick-reorder]');
      if (reorder) {
        event.preventDefault();
        self.openReorderDialog(reorder.getAttribute('data-b2b-reorder'), reorder);
        return;
      }

      var reorderCancel = event.target.closest('[data-b2b-reorder-cancel]');
      if (reorderCancel) {
        event.preventDefault();
        reorderCancel.closest('dialog')?.close('cancel');
        return;
      }

      if (event.target.closest('[data-b2b-detail-close]')) {
        event.preventDefault();
        self.detailEl.hidden = true;
        self.detailEl.classList.remove('is-open');
      }
    });

    this.root.addEventListener('submit', function (event) {
      var reorderForm = event.target.closest('[data-b2b-reorder-form]');
      if (reorderForm) {
        event.preventDefault();
        var buttons = Array.from(reorderForm.querySelectorAll('button'));
        reorderForm.setAttribute('aria-busy', 'true');
        buttons.forEach(function (button) { button.disabled = true; });
        self.requestReorder(reorderForm.dataset.sku, {
          quantity: reorderForm.elements.quantity.value,
          note: reorderForm.elements.note.value
        }).then(function () {
          reorderForm.closest('dialog')?.close('submitted');
        }).catch(function () {
          var error = reorderForm.querySelector('[data-b2b-reorder-error]');
          if (error) error.textContent = self.t('state.reorder_not_sent') + ' ' + self.t('state.try_again');
        }).finally(function () {
          reorderForm.removeAttribute('aria-busy');
          buttons.forEach(function (button) { button.disabled = false; });
        });
        return;
      }
      var form = event.target.closest('[data-b2b-proof-form]');
      if (!form) return;
      event.preventDefault();
      self.submitProofDecision(form, event.submitter).catch(function (error) {
        self.setState('warning', self.t('state.decision_not_sent'), self.t('state.try_again'));
      });
    });

    if (this.projectFilter) {
      this.projectFilter.addEventListener('change', function () {
        self.renderProjects();
      });
    }
  };

  ClientPortal.prototype.init = function () {
    if (this.readOnly) {
      this.root.querySelectorAll('[data-b2b-create-quote], [data-b2b-quick-reorder], [data-b2b-proof-form], [data-b2b-reorder]').forEach(function (control) {
        control.remove();
      });
    }
    this.bind();
    this.setView(this.activeView);
    this.load();
  };

  var PORTAL_V1_FALLBACK_DICTIONARIES = Object.freeze({
    fr: Object.freeze({
      'project_status.draft': 'Brouillon',
      'project_status.quote_requested': 'Devis demandé',
      'project_status.in_progress': 'En cours',
      'project_status.completed': 'Terminé',
      'project_status.cancelled': 'Annulé',
      'project_status.archived': 'Archivé',
      'dashboard.action_campaign': 'Campagne à suivre',
      'dashboard.greeting_simple': 'Bonjour {{name}}',
      'dashboard.next_step': 'Et maintenant ?',
      'dashboard.new_order': 'Nouvelle commande',
      'dashboard.inventory': 'Inventaire',
      'dashboard.start_project': 'Créer un projet',
      'dashboard.review_artwork': 'Voir les BAT',
      'dashboard.recent_projects_title': 'Projets récents',
      'dashboard.delivery_action': 'Organiser une livraison',
      'project.storage_help': 'Une fois la production réceptionnée, retrouvez vos articles disponibles et préparez vos réassorts depuis le stock.',
      'project.delivery_help': 'Préparez une livraison sur site ou un envoi à plusieurs destinataires depuis vos articles disponibles.',
      'project.campaign_help': 'Organisez une distribution par lien magique : chacun choisit ses cadeaux et renseigne son adresse. Vous pouvez aussi prévoir une livraison commune.',
      'dashboard.studio': 'Studio',
      'dashboard.new_campaign': 'Nouvelle campagne',
      'dashboard.reorder': 'Recommander',
      'dashboard.invite_team': 'Inviter l’équipe',
      'dashboard.recent_orders': 'Commandes récentes',
      'dashboard.order_quantity': '{{quantity}} articles',
      'dashboard.review_quote': 'Consulter le devis',
      'dashboard.review_proof': 'Vérifier le BAT',
      'dashboard.quote_pending': 'Devis à confirmer',
      'dashboard.proof_pending': 'BAT à valider',
      'dashboard.orders_empty': 'Votre espace est prêt. Lancez une nouvelle commande pour retrouver ici son suivi.',
      'access.unavailable_title': 'Portail momentanément indisponible',
      'access.unavailable_body': 'Réessayez dans quelques instants.',
      'nav.open': 'Ouvrir la navigation',
      'nav.close': 'Fermer la navigation',
      'refresh.projects_empty': 'Votre espace est prêt. Lancez un nouveau projet pour retrouver ici son suivi.',
      'refresh.activity_empty': 'Les étapes de vos projets apparaîtront ici au fil de leur avancement.',
      'refresh.documents_empty': 'Vos devis, factures et documents de projet seront réunis ici dès leur publication.',
      'refresh.project_history': 'Historique du projet',
      'refresh.project_email': 'Échanger par e-mail',
      'refresh.project_stage': 'Étape actuelle',
      'stage.brief': 'Brief', 'stage.quote': 'Devis', 'stage.proof': 'BAT', 'stage.production': 'Production',
      'stage.stock': 'Stock', 'stage.fulfillment': 'Expédition', 'stage.complete': 'Terminé',
      'quote.review_needed': 'Un devis attend votre décision.',
      'quote.review': 'Consulter le devis',
      'quote.back': 'Tous les documents',
      'quote.version': 'Version {{version}}',
      'quote.published_at': 'Publié le {{date}}',
      'quote.accept': 'Accepter le devis',
      'quote.request_changes': 'Demander une modification',
      'quote.comment': 'Précisions pour votre interlocuteur',
      'quote.decision_help': 'Consultez le PDF avant de confirmer. Votre décision concerne uniquement cette version du devis.',
      'quote.confirm': 'J’ai consulté cette version du devis.',
      'quote.readonly': 'Un administrateur ou un approbateur de votre entreprise peut valider ce devis.',
      'quote.history': 'Versions et décisions',
      'quote.no_history': 'Aucune version publiée pour le moment.',
      'quote.accepted': 'Devis accepté',
      'quote.changes_requested': 'Modification demandée',
      'quote.decision_by': '{{name}} · {{date}}',
      'quote.comment_required': 'Précisez la modification souhaitée.',
      'quote.confirm_required': 'Confirmez que vous avez consulté le PDF.',
      'quote.save_failed': 'La décision n’a pas été enregistrée. Réessayez.',
      'quote.version_conflict': 'Une nouvelle version est disponible. Consultez-la avant de prendre votre décision.',
      'document_status.published': 'À consulter',
      'document_status.accepted': 'Accepté',
      'document_status.changes_requested': 'Modification demandée',
      'notifications.document_published_title': 'Nouveau document',
      'notifications.document_published_body': 'Une nouvelle version est disponible dans votre espace.',
      'notifications.quote_decided_title': 'Décision sur le devis',
      'notifications.quote_decided_body': 'Une décision a été enregistrée sur votre devis.',
      'notifications.unavailable': 'Les notifications ne sont pas encore disponibles pour votre compte.',
      'tab.overview': 'Vue d’ensemble',
      'tab.all_feminine': 'Toutes',
      'beneficiaries.all': 'Bénéficiaires',
      'beneficiaries.groups': 'Groupes',
      'beneficiaries.integrations': 'Intégrations',
      'tab.campaign_types': 'Nouvelle campagne',
      'tab.my_campaigns': 'Mes campagnes',
      'tab.calendar': 'Calendrier',
      'tab.audience': 'Audience',
      'tab.projects_products': 'Projets et produits',
      'tab.distribution': 'Distribution',
      'tab.budget': 'Budget',
      'tab.performance': 'Performance',
      'tab.in_progress': 'En cours',
      'tab.production': 'Production',
      'tab.archives': 'Archives',
      'tab.brief': 'Brief',
      'tab.quote': 'Devis',
      'tab.proof': 'BAT',
      'tab.stock': 'Stock',
      'tab.shipments': 'Expéditions',
      'tab.to_review': 'À valider',
      'tab.history': 'Historique',
      'tab.review': 'Vérification',
      'tab.compare': 'Comparer',
      'tab.decision': 'Décision',
      'tab.inventory': 'Inventaire',
      'tab.forecast': 'Prévisions',
      'tab.reorders': 'Réassorts',
      'tab.tracking': 'Suivi',
      'tab.delivery_orders': 'Commandes',
      'tab.delivery_campaigns': 'Campagnes',
      'tab.delivery_other': 'Autres envois',
      'tab.recipients': 'Destinataires',
      'tab.validation': 'Validation',
      'tab.all_masculine': 'Tous',
      'tab.quotes_orders': 'Devis et bons',
      'tab.invoices': 'Factures',
      'tab.production_logistics': 'Production et logistique',
      'tab.members': 'Membres',
      'tab.roles': 'Rôles',
      'tab.approvals': 'Approbations',
      'campaign.planning': 'Planning',
      'campaign.start_short': 'Début',
      'campaign.end_short': 'Fin',
      'campaign.recipients_label': 'destinataires',
      'campaign.eligible_label': 'éligibles',
      'campaign.excluded_label': 'exclus',
      'campaign.mode_label': 'Mode',
      'campaign.activations': '{{redeemed}} activations sur {{issued}} invitations.',
      'campaign.products': 'Produits',
      'campaign.deliveries': 'Livraisons',
      'campaign.back': '← Campagnes',
      'dashboard.campaign_activity': '{{active}} actives · {{planning}} en préparation',
      'dashboard.view_campaigns': 'Voir les campagnes',
      'dashboard.authorised_budget': 'Budget autorisé',
      'dashboard.money_activity': '{{spent}} engagés · {{available}} disponibles',
      'dashboard.action_queue': 'File d’actions',
      'dashboard.adaptive_label': 'Pilotage adaptatif',
      'project.brief': 'Brief',
      'project.no_brief': 'Aucun brief.',
      'project.quote': 'Devis',
      'project.no_quote': 'Aucun devis',
      'project.proof': 'BAT',
      'project.no_proof': 'Aucun BAT',
      'project.open_proof_studio': 'Ouvrir le studio BAT',
      'project.production': 'Production',
      'project.stock': 'Stock',
      'project.current_stage': 'Étape actuelle : {{stage}}',
      'project.fulfilment': 'Fulfillment',
      'project.back': '← Projets',
      'proof_studio.back': '← Tous les BAT',
      'proof_studio.eyebrow': 'Studio de validation',
      'proof_studio.open_correction_one': 'correction ouverte',
      'proof_studio.open_corrections_other': 'corrections ouvertes',
      'proof_studio.marker_label': 'Correction {{index}}, page {{page}} : {{category}}',
      'proof_studio.place_correction': 'Placer une correction sur le BAT',
      'proof_studio.refresh_preview': 'Rafraîchir l’aperçu sécurisé',
      'proof_studio.load_preview': 'Charger l’aperçu sécurisé',
      'proof_studio.temporary_preview_help': 'L’URL temporaire est demandée uniquement après cette action.',
      'proof_studio.zoom_label': 'Zoom du BAT',
      'proof_studio.zoom_out': 'Réduire le zoom',
      'proof_studio.zoom_in': 'Agrandir le zoom',
      'proof_studio.displayed_page_label': 'Page affichée du BAT',
      'proof_studio.previous_page': 'Page précédente',
      'proof_studio.previewed_page': 'Page aperçue',
      'proof_studio.next_page': 'Page suivante',
      'proof_studio.page_announcement': 'Page {{page}} affichée.',
      'proof_studio.page_thread_announcement': 'Page {{page}} affichée pour la correction sélectionnée.',
      'proof_studio.readonly_annotate': 'Consultation uniquement : votre rôle ne permet pas d’annoter ce BAT.',
      'proof_studio.no_corrections': 'Aucune correction sur cette version.',
      'proof_studio.current_version': 'Version actuelle',
      'proof_studio.review_preview': 'Aperçu de validation',
      'proof_studio.review_help': 'Cliquez sur l’aperçu pour préremplir un repère, ou utilisez le formulaire de coordonnées accessible.',
      'proof_studio.collaboration_thread': 'Fil collaboratif',
      'proof_studio.structured_corrections': 'Corrections structurées',
      'proof_studio.add_correction': 'Ajouter une correction',
      'proof_studio.page': 'Page',
      'proof_studio.position_x': 'Position X (%)',
      'proof_studio.position_y': 'Position Y (%)',
      'proof_studio.category': 'Catégorie',
      'proof_studio.placement': 'Placement',
      'proof_studio.artwork': 'Visuel',
      'proof_studio.colour': 'Couleur',
      'proof_studio.text': 'Texte',
      'proof_studio.size': 'Taille',
      'proof_studio.other': 'Autre',
      'proof_studio.expected_correction': 'Correction attendue',
      'proof_studio.submit_correction': 'Ajouter la correction',
      'proof_studio.status_open': 'Ouverte',
      'proof_studio.status_resolved': 'Résolue',
      'proof_studio.reply': 'Répondre',
      'proof_studio.send': 'Envoyer',
      'proof_studio.resolve': 'Marquer résolue',
      'proof_studio.reopen': 'Rouvrir',
      'proof_studio.thread_label': 'Afficher la correction {{index}} sur la page {{page}}',
      'proof_studio.comparison_title': 'Comparer les versions',
      'proof_studio.comparison_empty': 'Deux versions immuables sont nécessaires pour lancer une comparaison.',
      'proof_studio.version_choice': 'Version {{version}} · {{date}}',
      'proof_studio.previews_unloaded': 'Les deux aperçus temporaires ne sont pas encore chargés.',
      'proof_studio.load_comparison': 'Charger la comparaison sécurisée',
      'proof_studio.visual_check': 'Contrôle visuel',
      'proof_studio.comparison_heading': 'Comparer deux versions immuables',
      'proof_studio.comparison_help': 'Chaque côté correspond à une version publiée distincte.',
      'proof_studio.left_version': 'Version gauche',
      'proof_studio.right_version': 'Version droite',
      'proof_studio.mode': 'Mode',
      'proof_studio.side_by_side': 'Côte à côte',
      'proof_studio.overlay': 'Superposition',
      'proof_studio.right_opacity': 'Opacité de la version droite',
      'proof_studio.immutable_id': 'Identifiant immuable',
      'proof_studio.signatory': 'Signataire : {{name}}',
      'proof_studio.audit_eyebrow': 'Piste d’audit',
      'proof_studio.audit_heading': 'Historique immuable',
      'proof_studio.audit_help': 'Versions, empreintes et décisions conservées sans réécriture.',
      'proof_studio.published_versions': 'Versions publiées',
      'proof_studio.signed_decisions': 'Décisions signées',
      'proof_studio.no_decision': 'Aucune décision.',
      'proof_studio.final_decision': 'Décision finale',
      'proof_studio.sign_version': 'Signer la version {{version}}',
      'proof_studio.decision_binding': 'La décision sera liée à cette version publiée et à son empreinte immuable.',
      'proof_studio.approval_blocked': 'Approbation bloquée',
      'proof_studio.resolve_open_one': 'Résolvez les {{count}} correction ouverte sur cette version avant l’approbation finale.',
      'proof_studio.resolve_open_other': 'Résolvez les {{count}} corrections ouvertes sur cette version avant l’approbation finale.',
      'proof_studio.open_count_unknown': 'Le nombre de corrections ouvertes n’est pas confirmé. Rechargez le BAT avant toute approbation.',
      'proof_studio.back_corrections': 'Revenir aux corrections',
      'proof_studio.open_signature': 'Ouvrir le panneau de signature',
      'proof_studio.readonly_sign': 'Votre rôle ne permet pas de signer ce BAT.',
      'proof_studio.version_conflict': 'La version a changé. Le studio a été rechargé.',
      'proof_studio.correction_failed': 'La correction n’a pas été ajoutée.',
      'proof_studio.approval_open_blocked': 'L’approbation reste bloquée tant que les corrections ouvertes ne sont pas résolues.',
      'team.disable': 'Désactiver'
    }),
    en: Object.freeze({
      'project_status.draft': 'Draft',
      'project_status.quote_requested': 'Quote requested',
      'project_status.in_progress': 'In progress',
      'project_status.completed': 'Completed',
      'project_status.cancelled': 'Cancelled',
      'project_status.archived': 'Archived',
      'dashboard.action_campaign': 'Review campaign',
      'dashboard.greeting_simple': 'Hi {{name}}',
      'dashboard.next_step': 'What’s next?',
      'dashboard.new_order': 'New order',
      'dashboard.inventory': 'Inventory',
      'dashboard.start_project': 'Start a project',
      'dashboard.review_artwork': 'Review proofs',
      'dashboard.recent_projects_title': 'Recent projects',
      'dashboard.delivery_action': 'Arrange a delivery',
      'project.storage_help': 'Once production has been received, find available items and plan restocks from inventory.',
      'project.delivery_help': 'Prepare a site delivery or send to multiple recipients using your available items.',
      'project.campaign_help': 'Organise distribution by magic link: recipients choose their gifts and enter their address. A shared delivery is also possible.',
      'dashboard.studio': 'Studio',
      'dashboard.new_campaign': 'New campaign',
      'dashboard.reorder': 'Reorder',
      'dashboard.invite_team': 'Invite team',
      'dashboard.recent_orders': 'Recent orders',
      'dashboard.order_quantity': '{{quantity}} items',
      'dashboard.review_quote': 'Review quote',
      'dashboard.review_proof': 'Review design',
      'dashboard.quote_pending': 'Confirm quote',
      'dashboard.proof_pending': 'Approve design',
      'dashboard.orders_empty': 'Your workspace is ready. Start a new order to follow its progress here.',
      'access.unavailable_title': 'Portal temporarily unavailable',
      'access.unavailable_body': 'Please try again in a few moments.',
      'nav.open': 'Open navigation',
      'nav.close': 'Close navigation',
      'refresh.projects_empty': 'Your workspace is ready. Start a new project to follow its progress here.',
      'refresh.activity_empty': 'Project milestones will appear here as your work moves forward.',
      'refresh.documents_empty': 'Your quotes, invoices and project documents will appear here once published.',
      'refresh.project_history': 'Project history',
      'refresh.project_email': 'Discuss by email',
      'refresh.project_stage': 'Current stage',
      'stage.brief': 'Brief', 'stage.quote': 'Quote', 'stage.proof': 'Proof', 'stage.production': 'Production',
      'stage.stock': 'Stock', 'stage.fulfillment': 'Shipping', 'stage.complete': 'Complete',
      'quote.review_needed': 'A quote is awaiting your decision.',
      'quote.review': 'Review quote',
      'quote.back': 'All documents',
      'quote.version': 'Version {{version}}',
      'quote.published_at': 'Published on {{date}}',
      'quote.accept': 'Accept quote',
      'quote.request_changes': 'Request a change',
      'quote.comment': 'Details for your contact',
      'quote.decision_help': 'Read the PDF before confirming. Your decision applies only to this version of the quote.',
      'quote.confirm': 'I have reviewed this version of the quote.',
      'quote.readonly': 'An administrator or approver in your company can approve this quote.',
      'quote.history': 'Versions and decisions',
      'quote.no_history': 'No published version yet.',
      'quote.accepted': 'Quote accepted',
      'quote.changes_requested': 'Change requested',
      'quote.decision_by': '{{name}} · {{date}}',
      'quote.comment_required': 'Describe the change you need.',
      'quote.confirm_required': 'Confirm that you have reviewed the PDF.',
      'quote.save_failed': 'Your decision was not saved. Try again.',
      'quote.version_conflict': 'A new version is available. Review it before making your decision.',
      'document_status.published': 'Ready to review',
      'document_status.accepted': 'Accepted',
      'document_status.changes_requested': 'Change requested',
      'notifications.document_published_title': 'New document',
      'notifications.document_published_body': 'A new version is available in your workspace.',
      'notifications.quote_decided_title': 'Quote decision',
      'notifications.quote_decided_body': 'A decision has been recorded on your quote.',
      'notifications.unavailable': 'Notifications are not available for your account yet.',
      'tab.overview': 'Overview',
      'tab.all_feminine': 'All',
      'beneficiaries.all': 'Beneficiaries',
      'beneficiaries.groups': 'Groups',
      'beneficiaries.integrations': 'Integrations',
      'tab.campaign_types': 'New campaign',
      'tab.my_campaigns': 'My campaigns',
      'tab.calendar': 'Calendar',
      'tab.audience': 'Audience',
      'tab.projects_products': 'Projects and products',
      'tab.distribution': 'Distribution',
      'tab.budget': 'Budget',
      'tab.performance': 'Performance',
      'tab.in_progress': 'In progress',
      'tab.production': 'Production',
      'tab.archives': 'Archives',
      'tab.brief': 'Brief',
      'tab.quote': 'Quote',
      'tab.proof': 'Proof',
      'tab.stock': 'Stock',
      'tab.shipments': 'Shipments',
      'tab.to_review': 'To review',
      'tab.history': 'History',
      'tab.review': 'Review',
      'tab.compare': 'Compare',
      'tab.decision': 'Decision',
      'tab.inventory': 'Inventory',
      'tab.forecast': 'Forecast',
      'tab.reorders': 'Reorders',
      'tab.tracking': 'Tracking',
      'tab.delivery_orders': 'Orders',
      'tab.delivery_campaigns': 'Campaigns',
      'tab.delivery_other': 'Other shipments',
      'tab.recipients': 'Recipients',
      'tab.validation': 'Validation',
      'tab.all_masculine': 'All',
      'tab.quotes_orders': 'Quotes and POs',
      'tab.invoices': 'Invoices',
      'tab.production_logistics': 'Production and logistics',
      'tab.members': 'Members',
      'tab.roles': 'Roles',
      'tab.approvals': 'Approvals',
      'campaign.planning': 'Schedule',
      'campaign.start_short': 'Start',
      'campaign.end_short': 'End',
      'campaign.recipients_label': 'recipients',
      'campaign.eligible_label': 'eligible',
      'campaign.excluded_label': 'excluded',
      'campaign.mode_label': 'Mode',
      'campaign.activations': '{{redeemed}} activations out of {{issued}} invitations.',
      'campaign.products': 'Products',
      'campaign.deliveries': 'Deliveries',
      'campaign.back': '← Campaigns',
      'dashboard.campaign_activity': '{{active}} active · {{planning}} being prepared',
      'dashboard.view_campaigns': 'View campaigns',
      'dashboard.authorised_budget': 'Authorised budget',
      'dashboard.money_activity': '{{spent}} committed · {{available}} available',
      'dashboard.action_queue': 'Action queue',
      'dashboard.adaptive_label': 'Adaptive overview',
      'project.brief': 'Brief',
      'project.no_brief': 'No brief.',
      'project.quote': 'Quote',
      'project.no_quote': 'No quote',
      'project.proof': 'Proof',
      'project.no_proof': 'No proof',
      'project.open_proof_studio': 'Open proof studio',
      'project.production': 'Production',
      'project.stock': 'Stock',
      'project.current_stage': 'Current stage: {{stage}}',
      'project.fulfilment': 'Fulfilment',
      'project.back': '← Projects',
      'proof_studio.back': '← All proofs',
      'proof_studio.eyebrow': 'Proof review studio',
      'proof_studio.open_correction_one': 'open correction',
      'proof_studio.open_corrections_other': 'open corrections',
      'proof_studio.marker_label': 'Correction {{index}}, page {{page}}: {{category}}',
      'proof_studio.place_correction': 'Place a correction on the proof',
      'proof_studio.refresh_preview': 'Refresh secure preview',
      'proof_studio.load_preview': 'Load secure preview',
      'proof_studio.temporary_preview_help': 'The temporary URL is requested only after this action.',
      'proof_studio.zoom_label': 'Proof zoom',
      'proof_studio.zoom_out': 'Zoom out',
      'proof_studio.zoom_in': 'Zoom in',
      'proof_studio.displayed_page_label': 'Displayed proof page',
      'proof_studio.previous_page': 'Previous page',
      'proof_studio.previewed_page': 'Previewed page',
      'proof_studio.next_page': 'Next page',
      'proof_studio.page_announcement': 'Page {{page}} displayed.',
      'proof_studio.page_thread_announcement': 'Page {{page}} displayed for the selected correction.',
      'proof_studio.readonly_annotate': 'View only: your role does not allow you to annotate this proof.',
      'proof_studio.no_corrections': 'No corrections on this version.',
      'proof_studio.current_version': 'Current version',
      'proof_studio.review_preview': 'Review preview',
      'proof_studio.review_help': 'Click the preview to prefill a marker, or use the accessible coordinate form.',
      'proof_studio.collaboration_thread': 'Collaborative thread',
      'proof_studio.structured_corrections': 'Structured corrections',
      'proof_studio.add_correction': 'Add a correction',
      'proof_studio.page': 'Page',
      'proof_studio.position_x': 'X position (%)',
      'proof_studio.position_y': 'Y position (%)',
      'proof_studio.category': 'Category',
      'proof_studio.placement': 'Placement',
      'proof_studio.artwork': 'Artwork',
      'proof_studio.colour': 'Colour',
      'proof_studio.text': 'Text',
      'proof_studio.size': 'Size',
      'proof_studio.other': 'Other',
      'proof_studio.expected_correction': 'Expected correction',
      'proof_studio.submit_correction': 'Add correction',
      'proof_studio.status_open': 'Open',
      'proof_studio.status_resolved': 'Resolved',
      'proof_studio.reply': 'Reply',
      'proof_studio.send': 'Send',
      'proof_studio.resolve': 'Mark as resolved',
      'proof_studio.reopen': 'Reopen',
      'proof_studio.thread_label': 'Show correction {{index}} on page {{page}}',
      'proof_studio.comparison_title': 'Compare versions',
      'proof_studio.comparison_empty': 'Two immutable versions are required to start a comparison.',
      'proof_studio.version_choice': 'Version {{version}} · {{date}}',
      'proof_studio.previews_unloaded': 'The two temporary previews have not been loaded yet.',
      'proof_studio.load_comparison': 'Load secure comparison',
      'proof_studio.visual_check': 'Visual check',
      'proof_studio.comparison_heading': 'Compare two immutable versions',
      'proof_studio.comparison_help': 'Each side corresponds to a distinct published version.',
      'proof_studio.left_version': 'Left version',
      'proof_studio.right_version': 'Right version',
      'proof_studio.mode': 'Mode',
      'proof_studio.side_by_side': 'Side by side',
      'proof_studio.overlay': 'Overlay',
      'proof_studio.right_opacity': 'Right version opacity',
      'proof_studio.immutable_id': 'Immutable identifier',
      'proof_studio.signatory': 'Signed by: {{name}}',
      'proof_studio.audit_eyebrow': 'Audit trail',
      'proof_studio.audit_heading': 'Immutable history',
      'proof_studio.audit_help': 'Versions, fingerprints and decisions are retained without rewriting.',
      'proof_studio.published_versions': 'Published versions',
      'proof_studio.signed_decisions': 'Signed decisions',
      'proof_studio.no_decision': 'No decision.',
      'proof_studio.final_decision': 'Final decision',
      'proof_studio.sign_version': 'Sign version {{version}}',
      'proof_studio.decision_binding': 'The decision will be linked to this published version and its immutable fingerprint.',
      'proof_studio.approval_blocked': 'Approval blocked',
      'proof_studio.resolve_open_one': 'Resolve the {{count}} open correction on this version before final approval.',
      'proof_studio.resolve_open_other': 'Resolve the {{count}} open corrections on this version before final approval.',
      'proof_studio.open_count_unknown': 'The number of open corrections is not confirmed. Reload the proof before approval.',
      'proof_studio.back_corrections': 'Return to corrections',
      'proof_studio.open_signature': 'Open signature panel',
      'proof_studio.readonly_sign': 'Your role does not allow you to sign this proof.',
      'proof_studio.version_conflict': 'The version changed. The studio has been reloaded.',
      'proof_studio.correction_failed': 'The correction was not added.',
      'proof_studio.approval_open_blocked': 'Approval remains blocked until all open corrections are resolved.',
      'team.disable': 'Disable'
    })
  });

  function portalFallbackLanguage(locale) {
    return /^fr(?:[-_]|$)/iu.test(String(locale || '')) ? 'fr' : 'en';
  }

  var PORTAL_NAVIGATION = Object.freeze({
    dashboard: Object.freeze({
      list: Object.freeze([['overview', 'tab.overview']]), detail: Object.freeze([])
    }),
    catalogue: Object.freeze({
      list: Object.freeze([['all', 'tab.all_masculine']]), detail: Object.freeze([])
    }),
    brand: Object.freeze({
      list: Object.freeze([['assets', 'brand.assets']]), detail: Object.freeze([])
    }),
    favorites: Object.freeze({
      list: Object.freeze([['all', 'tab.all_masculine']]), detail: Object.freeze([])
    }),
    designs: Object.freeze({
      list: Object.freeze([['all', 'tab.all_masculine']]), detail: Object.freeze([])
    }),
    'my-products': Object.freeze({
      list: Object.freeze([['all', 'tab.all_masculine']]), detail: Object.freeze([])
    }),
    beneficiaries: Object.freeze({
      list: Object.freeze([['all', 'beneficiaries.all'], ['groups', 'beneficiaries.groups'], ['integrations', 'beneficiaries.integrations']]), detail: Object.freeze([])
    }),
    integrations: Object.freeze({
      list: Object.freeze([['hris', 'integrations.hris'], ['sales', 'integrations.sales']]), detail: Object.freeze([])
    }),
    campaigns: Object.freeze({
      list: Object.freeze([['types', 'tab.campaign_types'], ['all', 'tab.my_campaigns'], ['calendar', 'tab.calendar']]),
      detail: Object.freeze([['overview', 'tab.overview'], ['audience', 'tab.audience'], ['projects', 'tab.projects_products'], ['distribution', 'tab.distribution'], ['budget', 'tab.budget'], ['performance', 'tab.performance'], ['gifts', 'tab.gifts'], ['recipients', 'tab.recipients'], ['delivery', 'tab.delivery'], ['messages', 'tab.messages'], ['automations', 'tab.automations']])
    }),
    orders: Object.freeze({
      list: Object.freeze([['all', 'tab.all_feminine']]),
      detail: Object.freeze([['overview', 'tab.overview']])
    }),
    account: Object.freeze({
      list: Object.freeze([['personal', 'account.personal'], ['shipping', 'account.shipping'], ['billing', 'account.billing'], ['invoices', 'account.invoices']]),
      detail: Object.freeze([])
    }),
    projects: Object.freeze({
      list: Object.freeze([['current', 'tab.in_progress'], ['production', 'tab.production'], ['archives', 'tab.archives']]),
      detail: Object.freeze([['overview', 'tab.overview'], ['brief', 'tab.brief'], ['quote', 'tab.quote'], ['proof', 'tab.proof'], ['production', 'tab.production'], ['stock', 'tab.stock'], ['fulfillment', 'tab.shipments']])
    }),
    proofs: Object.freeze({
      list: Object.freeze([['review', 'tab.to_review'], ['history', 'tab.history']]),
      detail: Object.freeze([['review', 'tab.review'], ['compare', 'tab.compare'], ['history', 'tab.history'], ['decision', 'tab.decision']])
    }),
    stock: Object.freeze({
      list: Object.freeze([['inventory', 'tab.inventory'], ['forecast', 'tab.forecast'], ['reorders', 'tab.reorders']]), detail: Object.freeze([])
    }),
    shipments: Object.freeze({
      list: Object.freeze([['all', 'tab.all_feminine'], ['orders', 'tab.delivery_orders'], ['campaigns', 'tab.delivery_campaigns'], ['other', 'tab.delivery_other'], ['tracking', 'tab.tracking']]),
      detail: Object.freeze([['overview', 'tab.overview'], ['recipients', 'tab.recipients'], ['validation', 'tab.validation'], ['tracking', 'tab.tracking']])
    }),
    documents: Object.freeze({
      list: Object.freeze([['all', 'tab.all_masculine'], ['quotes', 'tab.quotes_orders'], ['invoices', 'tab.invoices'], ['production', 'tab.production_logistics']]),
      detail: Object.freeze([['overview', 'tab.overview'], ['history', 'tab.history']])
    }),
    team: Object.freeze({
      list: Object.freeze([['members', 'tab.members'], ['roles', 'tab.roles'], ['approvals', 'tab.approvals']]), detail: Object.freeze([])
    })
  });
  var PORTAL_ROUTES = Object.freeze(Object.keys(PORTAL_NAVIGATION));
  var SHIPMENT_STATES = [
    'draft', 'validating', 'submitted', 'awaiting_cost_approval', 'revision_requested',
    'approved', 'picking', 'partially_shipped', 'shipped', 'delivered', 'rejected',
    'cancelled', 'expired'
  ];
  var BACKEND_CODE_KEYS = Object.freeze({
    project: Object.freeze({
      draft: 'project_status.draft', quote_requested: 'project_status.quote_requested', in_progress: 'project_status.in_progress',
      completed: 'project_status.completed', archived: 'project_status.archived',
      requested: 'project_status.requested', reviewing: 'project_status.reviewing', quoted: 'project_status.quoted',
      accepted: 'project_status.accepted', rejected: 'project_status.rejected', cancelled: 'project_status.cancelled'
    }),
    parcel: Object.freeze({
      draft: 'parcel_status.draft', created: 'parcel_status.draft', ready: 'parcel_status.ready',
      shipped: 'parcel_status.shipped', dispatched: 'parcel_status.shipped', delivered: 'parcel_status.delivered',
      cancelled: 'parcel_status.cancelled'
    }),
    import: Object.freeze({
      staging: 'import_status.staging', validating: 'import_status.validating', valid: 'import_status.valid',
      invalid: 'import_status.invalid', imported: 'import_status.imported', abandoned: 'import_status.abandoned',
      purged: 'import_status.purged'
    }),
    document: Object.freeze({
      quote: 'document_kind.quote', purchase_order: 'document_kind.purchase_order', invoice: 'document_kind.invoice',
      proof: 'document_kind.proof', production: 'document_kind.production', packing_slip: 'document_kind.packing_slip',
      shipping: 'document_kind.shipping', contract: 'document_kind.contract', other: 'document_kind.other'
    }),
    import_error: Object.freeze({
      HEADER_DUPLICATE: 'import_error.header_duplicate', STALE_TEMPLATE: 'import_error.stale_template',
      HEADER_UNKNOWN: 'import_error.header_unknown', HEADER_MISSING: 'import_error.header_missing',
      HEADER_ORDER_INVALID: 'import_error.header_order_invalid', CSV_MALFORMED: 'import_error.csv_malformed',
      CSV_TOO_LARGE: 'import_error.csv_too_large', CSV_INVALID_UTF8: 'import_error.csv_invalid_utf8',
      ROWS_REQUIRED: 'import_error.rows_required', ROW_LIMIT_EXCEEDED: 'import_error.row_limit_exceeded',
      COLUMN_COUNT_MISMATCH: 'import_error.column_count_mismatch', FIELD_TOO_LONG: 'import_error.field_too_long',
      FIELD_CONTROL_INVALID: 'import_error.field_control_invalid', COUNTRY_INVALID: 'import_error.country_invalid',
      SKU_MISMATCH: 'import_error.sku_mismatch', ITEMS_REQUIRED: 'import_error.items_required',
      DUPLICATE_RECIPIENT: 'import_error.duplicate_recipient', FILE_VERIFICATION_FAILED: 'import_error.file_verification_failed',
      DIAGNOSTICS_TRUNCATED: 'import_error.diagnostics_truncated', INVALID_FORMAT: 'import_error.invalid_format',
      TOO_LONG: 'import_error.too_long',
      REQUIRED: 'import_error.required', POSTAL_CODE_INVALID: 'import_error.postal_code_invalid',
      EMAIL_INVALID: 'import_error.email_invalid', COUNTRY_CODE_INVALID: 'import_error.country_code_invalid',
      QUANTITY_INVALID: 'import_error.quantity_invalid', UNKNOWN_SKU: 'import_error.unknown_sku',
      DUPLICATE: 'import_error.duplicate', INVALID: 'import_error.invalid'
    }),
    import_field: Object.freeze({
      recipient_reference: 'import_field.recipient_reference', recipient_name: 'import_field.recipient_name',
      recipient_company: 'import_field.recipient_company', recipient_email: 'import_field.recipient_email',
      recipient_phone: 'import_field.recipient_phone', address_line_1: 'import_field.address_line_1',
      address_line_2: 'import_field.address_line_2', postal_code: 'import_field.postal_code', city: 'import_field.city',
      region: 'import_field.region', country_code: 'import_field.country_code', quantity: 'import_field.quantity',
      sku: 'import_field.sku', header: 'import_field.header', csv: 'import_field.csv', row: 'import_field.row',
      file: 'import_field.file', items: 'import_field.items', recipient: 'import_field.recipient'
    })
  });
  var NOTIFICATION_CODE_KEYS = Object.freeze({
    title: Object.freeze({
      'portal.notifications.proof_title': 'notifications.proof_title',
      'proof.title': 'notifications.proof_title',
      'document.version_published.title': 'notifications.document_published_title',
      'quote.decided.title': 'notifications.quote_decided_title'
    }),
    body: Object.freeze({
      'portal.notifications.proof_body': 'notifications.proof_body',
      'proof.body': 'notifications.proof_body',
      'document.version_published.body': 'notifications.document_published_body',
      'quote.decided.body': 'notifications.quote_decided_body'
    })
  });

  function backendCodeKey(family, code) {
    var raw = String(code || '');
    var direct = BACKEND_CODE_KEYS[family]?.[raw];
    if (direct) return direct;
    if (family === 'import_field') {
      var itemField = raw.match(/^item_[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}_(sku|qty)$/i);
      if (itemField) return itemField[1].toLowerCase() === 'sku' ? 'import_field.item_sku' : 'import_field.item_quantity';
    }
    return 'code.unknown';
  }

  function notificationCodeKey(kind, code) {
    var safeKind = kind === 'body' ? 'body' : 'title';
    return NOTIFICATION_CODE_KEYS[safeKind][String(code || '')]
      || (safeKind === 'body' ? 'notifications.unknown_body' : 'notifications.unknown_title');
  }

  function safeCanonicalInteger(value, minimum) {
    return Number.isSafeInteger(value) && value >= minimum;
  }

  function canonicalActions(value) {
    if (!Array.isArray(value) || value.some(function (action) { return typeof action !== 'string' || !action; })) {
      throw new TypeError('Invalid canonical actions');
    }
    return value.slice();
  }

  var DOCUMENT_KINDS = Object.freeze(['quote', 'purchase_order', 'invoice', 'proof', 'production', 'packing_slip', 'shipping', 'contract', 'other']);
  var DOCUMENT_STATUSES = Object.freeze(['draft', 'issued', 'approved', 'paid', 'void', 'expired', 'replaced', 'published', 'accepted', 'changes_requested']);
  var GLOBAL_SEARCH_TYPES = Object.freeze(['campaign', 'project', 'proof', 'shipment', 'inventory', 'document']);
  var SAFE_RESOURCE_KEYS = Object.freeze(['id', 'title', 'document_kind', 'status', 'amount_minor', 'currency', 'version', 'current_version_id', 'document_date', 'campaign', 'project', 'proof_id', 'shipment_id', 'created_at', 'updated_at', 'allowed_actions']);

  function safePortalText(value, maximum, nullable) {
    if (nullable && (value === null || value === undefined)) return null;
    return typeof value === 'string' && value.length > 0 && value.length <= maximum
      && !/[\u0000-\u001f\u007f-\u009f]/u.test(value) ? value : false;
  }

  function normalizeDocumentRelation(value) {
    if (value === null || value === undefined) return null;
    if (!value || typeof value !== 'object' || Array.isArray(value)
      || Object.keys(value).some(function (key) { return !['id', 'title'].includes(key); })
      || !safePortalResourceId(value.id) || !safePortalText(value.title, 300, false)) throw new TypeError('Invalid canonical document');
    return { id: value.id, title: value.title };
  }

  function normalizeDocumentResource(resource) {
    if (!resource || typeof resource !== 'object' || Array.isArray(resource)
      || Object.keys(resource).some(function (key) { return !SAFE_RESOURCE_KEYS.includes(key); })
      || !safePortalResourceId(resource.id) || !safePortalText(resource.title, 300, false)
      || !DOCUMENT_KINDS.includes(resource.document_kind) || !DOCUMENT_STATUSES.includes(resource.status)
      || !safeCanonicalInteger(resource.version, 1)
      || typeof resource.created_at !== 'string' || !Number.isFinite(Date.parse(resource.created_at))
      || typeof resource.updated_at !== 'string' || !Number.isFinite(Date.parse(resource.updated_at))
      || !(resource.document_date === null || (typeof resource.document_date === 'string' && /^\d{4}-\d{2}-\d{2}$/u.test(resource.document_date)))
      || !Array.isArray(resource.allowed_actions) || resource.allowed_actions.some(function (action) { return !['download', 'decide'].includes(action); })
      || (resource.current_version_id != null && !safePortalResourceId(resource.current_version_id))
      || !((resource.amount_minor === null && resource.currency === null)
        || (safeCanonicalInteger(resource.amount_minor, 0) && ['EUR', 'USD', 'GBP'].includes(resource.currency)))) {
      throw new TypeError('Invalid canonical document');
    }
    if (resource.proof_id !== null && !safePortalResourceId(resource.proof_id)) throw new TypeError('Invalid canonical document');
    if (resource.shipment_id !== null && !safePortalResourceId(resource.shipment_id)) throw new TypeError('Invalid canonical document');
    return {
      id: resource.id, title: resource.title, document_kind: resource.document_kind, status: resource.status,
      amount_minor: resource.amount_minor, currency: resource.currency, version: resource.version,
      document_date: resource.document_date, campaign: normalizeDocumentRelation(resource.campaign),
      project: normalizeDocumentRelation(resource.project), proof_id: resource.proof_id, shipment_id: resource.shipment_id,
      created_at: resource.created_at, updated_at: resource.updated_at, allowed_actions: canonicalActions(resource.allowed_actions),
      ...(resource.current_version_id !== undefined ? { current_version_id: resource.current_version_id } : {}),
    };
  }

  function normalizeDocumentVersion(item, documentId) {
    if (!item || !safePortalResourceId(item.id) || item.document_id !== documentId
      || !safeCanonicalInteger(item.version_number, 1) || !/^[a-f0-9]{64}$/u.test(String(item.sha256 || ''))
      || !Number.isFinite(Date.parse(item.published_at)) || !safePortalText(item.filename, 255, false)) {
      throw new TypeError('Invalid canonical document version');
    }
    return { id: item.id, document_id: item.document_id, version_number: item.version_number,
      sha256: item.sha256, published_at: item.published_at, filename: item.filename };
  }

  function normalizeDocumentDecision(item, documentId) {
    if (!item || !safePortalResourceId(item.id) || item.document_id !== documentId
      || !safePortalResourceId(item.document_version_id) || !['accepted', 'changes_requested'].includes(item.decision)
      || !(item.comment === null || typeof item.comment === 'string' && item.comment.length <= 2000)
      || !safePortalText(item.actor_name, 200, false) || !Number.isFinite(Date.parse(item.created_at))) {
      throw new TypeError('Invalid canonical document decision');
    }
    return { id: item.id, document_id: item.document_id, document_version_id: item.document_version_id,
      decision: item.decision, comment: item.comment, actor_name: item.actor_name, created_at: item.created_at };
  }

  function buildDocumentDecision(documentResource, currentVersion, input) {
    if (!documentResource || !canAction(documentResource, 'decide') || documentResource.document_kind !== 'quote'
      || documentResource.status !== 'published' || !safeCanonicalInteger(documentResource.version, 1)
      || !currentVersion || currentVersion.id !== documentResource.current_version_id
      || currentVersion.document_id !== documentResource.id) throw new TypeError('The displayed quote version is stale');
    var decision = String(input?.decision || '');
    var comment = String(input?.comment || '').trim();
    if (!['accepted', 'changes_requested'].includes(decision) || comment.length > 2000
      || (decision === 'changes_requested' && !comment) || input?.confirmed !== true) throw new TypeError('A valid quote decision is required');
    return { document_version_id: currentVersion.id, decision: decision, comment: comment || null };
  }

  function filterDocumentResources(items, view) {
    var source = Array.isArray(items) ? items : [];
    if (view === 'quotes') return source.filter(function (item) { return ['quote', 'purchase_order'].includes(item.document_kind); });
    if (view === 'invoices') return source.filter(function (item) { return item.document_kind === 'invoice'; });
    if (view === 'production') return source.filter(function (item) { return ['production', 'packing_slip', 'shipping'].includes(item.document_kind); });
    return source;
  }

  function normalizeGlobalSearchResult(resource) {
    var keys = ['type', 'id', 'title', 'subtitle', 'status', 'href', 'timestamp'];
    if (!resource || typeof resource !== 'object' || Array.isArray(resource)
      || Object.keys(resource).length !== keys.length || Object.keys(resource).some(function (key) { return !keys.includes(key); })
      || !GLOBAL_SEARCH_TYPES.includes(resource.type) || !safePortalResourceId(resource.id)
      || !safePortalText(resource.title, 240, false)
      || !(resource.subtitle === null || safePortalText(resource.subtitle, 240, false))
      || !(resource.status === null || safePortalText(resource.status, 80, false))
      || typeof resource.href !== 'string' || !/^#(?:campaigns|projects|proofs|shipments|stock|documents)(?:\/|$)/u.test(resource.href) || !parsePortalRoute(resource.href).valid
      || typeof resource.timestamp !== 'string' || !Number.isFinite(Date.parse(resource.timestamp))) {
      throw new TypeError('Invalid canonical search result');
    }
    return { type: resource.type, id: resource.id, title: resource.title, subtitle: resource.subtitle, status: resource.status, href: resource.href, timestamp: resource.timestamp };
  }

  function normalizeGlobalSearchPage(page) {
    if (!page || typeof page !== 'object' || Array.isArray(page) || !Array.isArray(page.items)
      || page.items.length > 20 || page.next_cursor !== null) throw new TypeError('Invalid canonical search page');
    return { items: page.items.map(normalizeGlobalSearchResult), next_cursor: null };
  }

  function normalizeSafeNotification(resource) {
    var allowedKeys = ['id', 'version', 'notification_type', 'title_key', 'body_key', 'read_at', 'created_at', 'aggregate_type', 'aggregate_id', 'href', 'allowed_actions'];
    if (!resource || typeof resource !== 'object' || Array.isArray(resource)
      || Object.keys(resource).some(function (key) { return !allowedKeys.includes(key); })
      || !safePortalResourceId(resource.id) || !Number.isSafeInteger(resource.version) || resource.version < 1
      || !safePortalText(resource.notification_type, 120, false) || !safePortalText(resource.title_key, 160, false)
      || !safePortalText(resource.body_key, 160, false) || typeof resource.created_at !== 'string'
      || !Number.isFinite(Date.parse(resource.created_at))
      || !(resource.read_at === null || typeof resource.read_at === 'string' && Number.isFinite(Date.parse(resource.read_at)))) {
      throw new TypeError('Invalid canonical notification');
    }
    var hasAggregate = resource.aggregate_type != null || resource.aggregate_id != null || resource.href != null;
    if (hasAggregate && (!GLOBAL_SEARCH_TYPES.includes(resource.aggregate_type) || !safePortalResourceId(resource.aggregate_id)
      || typeof resource.href !== 'string' || !/^#(?:campaigns|projects|proofs|shipments|stock|documents)(?:\/|$)/u.test(resource.href) || !parsePortalRoute(resource.href).valid)) {
      throw new TypeError('Invalid canonical notification');
    }
    var result = {
      id: resource.id, version: resource.version, notification_type: resource.notification_type,
      title_key: resource.title_key, body_key: resource.body_key, read_at: resource.read_at,
      created_at: resource.created_at, allowed_actions: canonicalActions(resource.allowed_actions).filter(function (action) { return action === 'mark_read'; }),
    };
    if (hasAggregate) Object.assign(result, { aggregate_type: resource.aggregate_type, aggregate_id: resource.aggregate_id, href: resource.href });
    return result;
  }

  function createGlobalSearchDialogController(options) {
    options = options || {};
    var trigger = options.trigger;
    var dialog = options.dialog;
    var input = options.input;
    if (!trigger || !dialog || !input || typeof options.onSearch !== 'function') throw new TypeError('Search dialog dependencies are required');
    var click = function (event) { event?.preventDefault?.(); dialog.showModal(); input.focus(); };
    var keydown = async function (event) {
      if (event.key === 'Escape') { event.preventDefault(); dialog.close(); return; }
      if (event.key !== 'Enter') return;
      event.preventDefault();
      await options.onSearch(input.value);
    };
    trigger.addEventListener('click', click);
    input.addEventListener('keydown', keydown);
    return Object.freeze({
      destroy: function () {
        trigger.removeEventListener?.('click', click);
        input.removeEventListener?.('keydown', keydown);
      }
    });
  }

  function normalizeInventoryResource(resource) {
    if (!resource || typeof resource !== 'object' || Array.isArray(resource)
      || typeof resource.item_id !== 'string' || !resource.item_id
      || !safeCanonicalInteger(resource.position_version, 1)
      || typeof resource.sku !== 'string' || !resource.sku || resource.sku.length > 120 || /[\u0000-\u001f\u007f]/u.test(resource.sku)
      || typeof resource.title !== 'string' || !resource.title || resource.title.length > 300 || /[\u0000-\u001f\u007f]/u.test(resource.title)
      || !['on_hand', 'reserved', 'available', 'incoming'].every(function (field) {
        return safeCanonicalInteger(resource[field], 0);
      })
      || resource.available !== resource.on_hand - resource.reserved) {
      throw new TypeError('Invalid canonical inventory');
    }
    var base = {
      item_id: resource.item_id,
      position_version: resource.position_version,
      sku: resource.sku,
      title: resource.title,
      on_hand: resource.on_hand,
      reserved: resource.reserved,
      available: resource.available,
      incoming: resource.incoming,
      allowed_actions: canonicalActions(resource.allowed_actions || []),
    };
    if (!Object.prototype.hasOwnProperty.call(resource, 'version')) return base;
    var nullableInteger = function (value) { return value === null || safeCanonicalInteger(value, 0); };
    var variant = resource.variant == null ? null : resource.variant;
    var imageUrl = resource.image_url == null ? null : resource.image_url;
    var incomingEta = resource.incoming_eta == null ? null : resource.incoming_eta;
    if (!safeCanonicalInteger(resource.version, 1)
      || !safePortalResourceId(resource.warehouse_id)
      || typeof resource.warehouse_name !== 'string' || !resource.warehouse_name.trim()
      || resource.warehouse_name.length > 200 || /[\u0000-\u001f\u007f]/u.test(resource.warehouse_name)
      || !(variant === null || (typeof variant === 'string' && variant.length > 0 && variant.length <= 240 && !/[\u0000-\u001f\u007f]/u.test(variant)))
      || !(imageUrl === null || (typeof imageUrl === 'string' && (/^https:\/\/[a-z0-9.-]+(?::[0-9]+)?(?:\/[^\s]*)?$/iu.test(imageUrl) || /^\/(?!\/)[^\s]*$/u.test(imageUrl))))
      || !(incomingEta === null || (typeof incomingEta === 'string' && /^\d{4}-\d{2}-\d{2}$/u.test(incomingEta)))
      || !nullableInteger(resource.alert_threshold)
      || !safeCanonicalInteger(resource.recent_consumption_30d, 0)
      || !nullableInteger(resource.estimated_kit_coverage)
      || !['out', 'critical', 'watch', 'healthy', 'unknown'].includes(resource.stockout_risk)) {
      throw new TypeError('Invalid canonical inventory');
    }
    return Object.assign({}, base, {
      version: resource.version,
      warehouse_id: resource.warehouse_id,
      warehouse_name: resource.warehouse_name,
      variant: variant,
      image_url: imageUrl,
      incoming_eta: incomingEta,
      alert_threshold: resource.alert_threshold,
      recent_consumption_30d: resource.recent_consumption_30d,
      estimated_kit_coverage: resource.estimated_kit_coverage,
      stockout_risk: resource.stockout_risk,
    });
  }

  function canInventoryAction(resource, action) {
    return Boolean(resource && Array.isArray(resource.allowed_actions) && resource.allowed_actions.includes(action));
  }

  function filterInventoryResources(items, search, filter, locale) {
    var query = String(search || '').trim().toLocaleLowerCase(locale || 'fr');
    var risk = filter || 'all';
    return (Array.isArray(items) ? items : []).filter(function (item) {
      var matchesText = !query || [item.sku, item.title, item.variant, item.warehouse_name].some(function (value) {
        return String(value || '').toLocaleLowerCase(locale || 'fr').includes(query);
      });
      return matchesText && (risk === 'all' || item.stockout_risk === risk);
    });
  }

  function inventoryCsv(items, translate) {
    var t = typeof translate === 'function' ? translate : function (key, fallback) { return fallback; };
    var headings = [
      ['stock.warehouse', 'Entrepôt'], ['stock.sku', 'SKU'], ['stock.title', 'Produit'], ['stock.variant', 'Variante'],
      ['stock.available', 'Disponible'], ['stock.reserved', 'Réservé'], ['stock.incoming', 'Entrant'], ['stock.eta', 'ETA'],
      ['stock.threshold', 'Seuil'], ['stock.consumption_30d', 'Consommation 30j'], ['stock.kit_coverage', 'Couverture kits'],
      ['stock.risk', 'Risque'],
    ].map(function (entry) { return t(entry[0], entry[1]); });
    var safeCell = function (value) {
      var text = value == null ? '' : String(value);
      if (/^[\s\u0000-\u001f\u007f]*[=+\-@]/u.test(text)) text = "'" + text;
      return '"' + text.replace(/"/g, '""') + '"';
    };
    var rows = (Array.isArray(items) ? items : []).map(function (item) {
      return [item.warehouse_name, item.sku, item.title, item.variant, item.available, item.reserved, item.incoming, item.incoming_eta,
        item.alert_threshold, item.recent_consumption_30d, item.estimated_kit_coverage, item.stockout_risk].map(safeCell).join(';');
    });
    return [headings.join(';')].concat(rows).join('\n');
  }

  function normalizeInventoryReorder(resource) {
    if (!resource || typeof resource !== 'object' || Array.isArray(resource)
      || typeof resource.id !== 'string' || !resource.id
      || typeof resource.inventory_item_id !== 'string' || !resource.inventory_item_id
      || typeof resource.sku !== 'string' || !resource.sku
      || typeof resource.title !== 'string' || !resource.title
      || !safeCanonicalInteger(resource.quantity, 1)
      || !(resource.note === null || (typeof resource.note === 'string' && resource.note.length <= 1200 && !/[\u0000-\u001f\u007f]/u.test(resource.note)))
      || !['requested', 'under_review', 'approved', 'ordered', 'received', 'rejected', 'cancelled'].includes(resource.status)
      || !safeCanonicalInteger(resource.version, 1) || typeof resource.created_at !== 'string' || !Number.isFinite(Date.parse(resource.created_at))) {
      throw new TypeError('Invalid canonical inventory reorder');
    }
    return {
      id: resource.id, inventory_item_id: resource.inventory_item_id, sku: resource.sku, title: resource.title,
      quantity: resource.quantity, note: resource.note, status: resource.status, version: resource.version,
      created_at: resource.created_at, allowed_actions: canonicalActions(resource.allowed_actions || []),
    };
  }

  function normalizeShipmentLine(line, revisionId) {
    if (!line || typeof line !== 'object' || Array.isArray(line)
      || typeof line.id !== 'string' || !line.id
      || typeof line.revision_id !== 'string' || line.revision_id !== revisionId
      || typeof line.item_id !== 'string' || !line.item_id
      || typeof line.sku !== 'string' || !line.sku
      || !safeCanonicalInteger(line.default_quantity, 1)
      || !safeCanonicalInteger(line.sort_order, 0)
      || !safeCanonicalInteger(line.canonical_demand, 0)
      || !safeCanonicalInteger(line.shortage, 0) || line.shortage > line.canonical_demand) {
      throw new TypeError('Invalid canonical shipment line');
    }
    return {
      id: line.id, revision_id: line.revision_id, item_id: line.item_id, sku: line.sku,
      default_quantity: line.default_quantity, sort_order: line.sort_order,
      canonical_demand: line.canonical_demand, shortage: line.shortage,
    };
  }

  function normalizeShipmentSummary(resource) {
    if (!resource || typeof resource !== 'object' || Array.isArray(resource)
      || typeof resource.id !== 'string' || !resource.id
      || !safeCanonicalInteger(resource.version, 1)
      || !SHIPMENT_STATES.includes(resource.state)) throw new TypeError('Invalid canonical shipment');
    var result = {
      id: resource.id,
      version: resource.version,
      state: resource.state,
      reservation_expires_at: resource.reservation_expires_at ?? null,
      allowed_actions: canonicalActions(resource.allowed_actions || []),
    };
    for (var field of ['label', 'warehouse_id', 'project_id', 'project_title', 'campaign_id', 'campaign_title', 'current_revision_id', 'current_cost_proposal_id', 'currency']) {
      if (Object.prototype.hasOwnProperty.call(resource, field)) result[field] = resource[field];
    }
    for (var idField of ['warehouse_id', 'project_id', 'campaign_id']) {
      if (result[idField] != null && !safePortalResourceId(result[idField])) throw new TypeError('Invalid canonical shipment context');
    }
    for (var dateField of ['created_at', 'updated_at', 'submitted_at', 'approved_at', 'shipped_at', 'delivered_at']) {
      if (!Object.prototype.hasOwnProperty.call(resource, dateField)) continue;
      var dateValue = resource[dateField];
      if (dateValue !== null && (typeof dateValue !== 'string' || !Number.isFinite(Date.parse(dateValue)))) {
        throw new TypeError('Invalid canonical shipment date');
      }
      result[dateField] = dateValue;
    }
    for (var textField of ['project_title', 'campaign_title']) {
      if (result[textField] != null && (typeof result[textField] !== 'string' || !result[textField]
        || result[textField].length > (textField === 'project_title' ? 300 : 200) || /[\u0000-\u001f\u007f]/u.test(result[textField]))) {
        throw new TypeError('Invalid canonical shipment context');
      }
    }
    if (Object.prototype.hasOwnProperty.call(resource, 'cost_minor')) {
      if (resource.cost_minor !== null && !safeCanonicalInteger(resource.cost_minor, 0)) throw new TypeError('Invalid canonical shipment cost');
      result.cost_minor = resource.cost_minor;
    }
    return result;
  }

  function normalizeShipmentDetail(resource) {
    var result = normalizeShipmentSummary(resource);
    if (typeof resource.current_revision_id !== 'string' || !resource.current_revision_id
      || !Array.isArray(resource.lines) || resource.lines.length > 200) {
      throw new TypeError('Invalid canonical shipment detail');
    }
    result.current_revision_id = resource.current_revision_id;
    result.lines = resource.lines.map(function (line) { return normalizeShipmentLine(line, resource.current_revision_id); });
    return result;
  }

  function normalizeRevisionPage(page, shipmentId) {
    if (!page || !Array.isArray(page.items) || !(page.next_cursor === null || typeof page.next_cursor === 'string')) {
      throw new TypeError('Invalid canonical revision page');
    }
    return {
      items: page.items.map(function (revision) {
        if (!revision || typeof revision !== 'object' || Array.isArray(revision)
          || typeof revision.id !== 'string' || !revision.id || revision.shipment_id !== shipmentId
          || !safeCanonicalInteger(revision.revision_number, 1) || typeof revision.is_material !== 'boolean'
          || !/^[a-f0-9]{64}$/.test(String(revision.snapshot_sha256 || ''))) {
          throw new TypeError('Invalid canonical revision');
        }
        return {
          id: revision.id, shipment_id: revision.shipment_id, revision_number: revision.revision_number,
          is_material: revision.is_material, snapshot_sha256: revision.snapshot_sha256,
          ...(typeof revision.reason === 'string' ? { reason: revision.reason } : {}),
          ...(typeof revision.created_at === 'string' ? { created_at: revision.created_at } : {}),
        };
      }),
      next_cursor: page.next_cursor,
    };
  }

  function normalizeDestinationLinePage(page, revisionId) {
    if (!page || !Array.isArray(page.items) || !(page.next_cursor === null || typeof page.next_cursor === 'string')) {
      throw new TypeError('Invalid canonical destination line page');
    }
    return {
      items: page.items.map(function (line) {
        if (!line || typeof line !== 'object' || Array.isArray(line) || line.revision_id !== revisionId
          || !['id', 'destination_id', 'shipment_line_id', 'item_id', 'sku'].every(function (field) {
            return typeof line[field] === 'string' && line[field];
          })
          || !safeCanonicalInteger(line.quantity, 1) || !safeCanonicalInteger(line.allocated_quantity, 0)
          || !safeCanonicalInteger(line.remaining_quantity, 0)
          || line.allocated_quantity > line.quantity || line.remaining_quantity !== line.quantity - line.allocated_quantity) {
          throw new TypeError('Invalid canonical destination line');
        }
        return {
          id: line.id, revision_id: line.revision_id, destination_id: line.destination_id,
          shipment_line_id: line.shipment_line_id, item_id: line.item_id, sku: line.sku,
          quantity: line.quantity, allocated_quantity: line.allocated_quantity, remaining_quantity: line.remaining_quantity,
        };
      }),
      next_cursor: page.next_cursor,
    };
  }

  function normalizeTrackingPage(page, shipmentId) {
    if (!page || !Array.isArray(page.items) || !(page.next_cursor === null || typeof page.next_cursor === 'string')) {
      throw new TypeError('Invalid canonical tracking page');
    }
    return {
      items: page.items.map(function (parcel) {
        if (!parcel || typeof parcel !== 'object' || Array.isArray(parcel)
          || typeof parcel.id !== 'string' || !parcel.id
          || (parcel.shipment_id !== undefined && parcel.shipment_id !== shipmentId)
          || typeof parcel.status !== 'string' || !parcel.status) throw new TypeError('Invalid canonical parcel');
        var result = { id: parcel.id, shipment_id: shipmentId, status: parcel.status };
        ['carrier', 'tracking_number', 'tracking_url', 'shipped_at', 'delivered_at'].forEach(function (field) {
          if (parcel[field] === null || typeof parcel[field] === 'string') result[field] = parcel[field];
        });
        return result;
      }),
      next_cursor: page.next_cursor,
    };
  }

  function normalizeCampaignResource(campaign) {
    var statuses = ['draft', 'planning', 'active', 'paused', 'completed', 'archived'];
    var modes = ['bulk', 'redemption', 'mixed'];
    if (!campaign || typeof campaign !== 'object' || Array.isArray(campaign)
      || !safePortalResourceId(campaign.id) || typeof campaign.name !== 'string' || !campaign.name.trim()
      || typeof campaign.objective !== 'string' || !campaign.objective.trim()
      || !statuses.includes(campaign.status) || !modes.includes(campaign.distribution_mode)
      || !campaign.owner || !safePortalResourceId(campaign.owner.id) || typeof campaign.owner.display_name !== 'string'
      || !Number.isSafeInteger(campaign.budget_minor) || campaign.budget_minor < 0
      || !/^[A-Z]{3}$/.test(String(campaign.currency || ''))
      || !['project_count', 'audience_count', 'redeemed_count', 'version'].every(function (field) {
        return Number.isSafeInteger(campaign[field]) && campaign[field] >= (field === 'version' ? 1 : 0);
      }) || !Array.isArray(campaign.allowed_actions)) throw new TypeError('Invalid canonical campaign');
    return {
      id: campaign.id, name: campaign.name, objective: campaign.objective, status: campaign.status,
      owner: { id: campaign.owner.id, display_name: campaign.owner.display_name },
      starts_at: campaign.starts_at ?? null, ends_at: campaign.ends_at ?? null,
      budget_minor: campaign.budget_minor, currency: campaign.currency, distribution_mode: campaign.distribution_mode,
      project_count: campaign.project_count, audience_count: campaign.audience_count, redeemed_count: campaign.redeemed_count,
      version: campaign.version, created_at: campaign.created_at, updated_at: campaign.updated_at,
      allowed_actions: campaign.allowed_actions.slice(),
      ...Object.fromEntries(['brief', 'projects', 'products', 'related_resources', 'activity'].filter(function (field) {
        return Object.prototype.hasOwnProperty.call(campaign, field);
      }).map(function (field) { return [field, structuredClone(campaign[field])]; }))
    };
  }

  function campaignCalendarModel(campaigns) {
    if (!Array.isArray(campaigns)) throw new TypeError('Invalid canonical campaigns');
    return campaigns.filter(function (campaign) { return campaign.starts_at || campaign.ends_at; }).map(function (campaign) {
      return {
        id: campaign.id, name: campaign.name, starts_at: campaign.starts_at, ends_at: campaign.ends_at,
        status: campaign.status, deep_link: '#campaigns/' + campaign.id + '/overview'
      };
    }).sort(function (left, right) {
      return Date.parse(left.starts_at || left.ends_at) - Date.parse(right.starts_at || right.ends_at);
    });
  }

  function normalizeProductCapabilities(value) {
    var foundation = value?.foundation === true;
    return {
      foundation: foundation,
      campaign_proof: foundation && value?.campaign_proof === true,
      operations: foundation && value?.operations === true,
      enterprise: foundation && value?.enterprise === true,
      intelligence: foundation && value?.intelligence === true,
    };
  }

  function productCapabilityForRoute(route) {
    if (['campaigns', 'beneficiaries', 'projects', 'orders', 'proofs'].includes(route)) return 'campaign_proof';
    if (['stock', 'shipments'].includes(route)) return 'operations';
    if (['documents', 'team'].includes(route)) return 'enterprise';
    return 'foundation';
  }

  function buildCampaignMutation(input, expectedVersion) {
    if (!input || !Number.isSafeInteger(expectedVersion) || expectedVersion < 0) return null;
    var uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;
    var name = String(input.name || '').trim();
    var objective = String(input.objective || '').trim();
    var ownerId = String(input.owner_id || '').toLowerCase();
    var startsAt = String(input.starts_at || '');
    var endsAt = String(input.ends_at || '');
    var budgetMinor = typeof input.budget_minor === 'number' ? input.budget_minor : Number(String(input.budget_minor || ''));
    var currency = String(input.currency || '');
    var distributionMode = String(input.distribution_mode || '');
    if (!name || name.length > 200 || !objective || objective.length > 1200 || !uuidPattern.test(ownerId)
      || !/^\d{4}-\d{2}-\d{2}$/u.test(startsAt) || !/^\d{4}-\d{2}-\d{2}$/u.test(endsAt)
      || !Number.isSafeInteger(budgetMinor) || budgetMinor < 0 || !['EUR', 'USD', 'GBP'].includes(currency)
      || !['bulk', 'redemption', 'mixed'].includes(distributionMode)) return null;
    var starts = new Date(startsAt + 'T00:00:00.000Z');
    var ends = new Date(endsAt + 'T23:59:59.999Z');
    if (!Number.isFinite(starts.getTime()) || !Number.isFinite(ends.getTime()) || starts > ends
      || starts.toISOString().slice(0, 10) !== startsAt || ends.toISOString().slice(0, 10) !== endsAt) return null;
    return {
      name: name, objective: objective, owner_id: ownerId,
      starts_at: starts.toISOString(), ends_at: ends.toISOString(), budget_minor: budgetMinor,
      currency: currency, distribution_mode: distributionMode, expected_version: expectedVersion,
    };
  }

  function projectDossierModel(project) {
    if (!project || typeof project !== 'object' || Array.isArray(project) || !safePortalResourceId(project.id)
      || !['brief', 'quote', 'proof', 'production', 'stock', 'fulfillment', 'complete'].includes(project.stage)
      || !Number.isSafeInteger(project.version) || project.version < 1 || !Array.isArray(project.allowed_actions)) {
      throw new TypeError('Invalid canonical project dossier');
    }
    return {
      ...structuredClone(project),
      tabs: {
        overview: '#projects/' + project.id + '/overview',
        brief: '#projects/' + project.id + '/brief',
        quote: '#projects/' + project.id + '/quote',
        proof: '#projects/' + project.id + '/proof',
        production: '#projects/' + project.id + '/production',
        stock: '#projects/' + project.id + '/stock',
        fulfillment: '#projects/' + project.id + '/fulfillment'
      },
      allowed_actions: project.allowed_actions.slice()
    };
  }

  function createPortalStore(options) {
    options = options || {};
    var wizard = window.TodayMerchShipmentWizard;
    return {
      route: 'dashboard',
      context: {
        locale: String(options.locale || 'fr'),
        actor: null,
        company: null,
        capabilities: {},
        product_capabilities: normalizeProductCapabilities(null),
        backend_mode: null
      },
      resources: {
        campaigns: [], projects: [], proofs: [], inventory: [], shipments: [], documents: [], team: [], notifications: [], search: []
      },
      ui: { activeTabs: { documents: 'all', team: 'members' }, searchBusy: false, searchError: '', moduleUnavailable: null },
      campaignOwners: [],
      campaignEditor: null,
      inventoryReorders: [],
      proofDetail: null,
      proofVersions: [],
      proofDecisions: [],
      proofAnnotations: [],
      proofPreviewUrls: {},
      proofZoom: 100,
      proofSelectedPage: 1,
      proofPageAnnouncement: '',
      proofComparison: null,
      inventoryView: 'inventory',
      inventorySearch: '',
      inventoryFilter: 'all',
      reorderItem: null,
      request: { busy: false, error: null, request_id: '' },
      wizard: typeof wizard?.createState === 'function' ? wizard.createState() : {
        shipment_id: null, version: 0, step: 1, dirty: false, saving: false, kit_lines: [],
        recipient_mode: 'single', destination: null, import: null, validation: null, submission: null
      }
    };
  }

  function fallbackPortalRoute(valid) {
    return {
      section: 'dashboard', resourceId: null, tab: 'overview', isDetail: false,
      valid: valid === true, canonicalHash: '#dashboard'
    };
  }

  function safePortalResourceId(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu.test(String(value || ''));
  }

  function parsePortalRoute(hash) {
    var source = String(hash || '');
    if (!source || source === '#') return fallbackPortalRoute(true);
    var raw = source.replace(/^#/, '');
    if (!raw || /[?&=%@\\]|\s/u.test(raw)) return fallbackPortalRoute(false);
    var segments = raw.split('/');
    if (segments.length > 3 || segments.some(function (part) { return !part; })) return fallbackPortalRoute(false);
    var section = segments[0];
    var configuration = PORTAL_NAVIGATION[section];
    if (!configuration) return fallbackPortalRoute(false);
    var listTabs = configuration.list.map(function (tab) { return tab[0]; });
    var detailTabs = configuration.detail.map(function (tab) { return tab[0]; });
    if (segments.length === 1) {
      return {
        section: section, resourceId: null, tab: listTabs[0], isDetail: false,
        valid: true, canonicalHash: '#' + section
      };
    }
    if (segments.length === 2 && listTabs.includes(segments[1])) {
      return {
        section: section, resourceId: null, tab: segments[1], isDetail: false,
        valid: true, canonicalHash: '#' + section + '/' + segments[1]
      };
    }
    if (!detailTabs.length || !safePortalResourceId(segments[1])) return fallbackPortalRoute(false);
    var tab = segments.length === 3 ? segments[2] : detailTabs[0];
    if (!detailTabs.includes(tab)) return fallbackPortalRoute(false);
    return {
      section: section, resourceId: segments[1], tab: tab, isDetail: true,
      valid: true, canonicalHash: '#' + section + '/' + segments[1] + '/' + tab
    };
  }

  function contextTabsForRoute(route) {
    route = route && typeof route === 'object' ? route : fallbackPortalRoute(false);
    var configuration = PORTAL_NAVIGATION[route.section] || PORTAL_NAVIGATION.dashboard;
    var tabs = route.isDetail ? configuration.detail : configuration.list;
    if (route.section === 'shipments' && !route.isDetail) tabs = tabs.filter(function (tab) { return tab[0] !== 'tracking'; });
    if (route.section === 'campaigns' && route.isDetail) tabs = tabs.filter(function (tab) {
      return !['gifts', 'recipients', 'delivery', 'messages', 'automations'].includes(tab[0]);
    });
    return tabs.map(function (tab) {
      var prefix = '#' + route.section + (route.isDetail ? '/' + route.resourceId : '');
      var defaultTab = tabs[0] && tabs[0][0];
      return {
        id: tab[0], label: PORTAL_V1_FALLBACK_DICTIONARIES.fr[tab[1]] || tab[1], labelKey: tab[1], current: tab[0] === route.tab || (route.section === 'shipments' && !route.isDetail && route.tab === 'tracking' && tab[0] === 'all'),
        hash: !route.isDetail && tab[0] === defaultTab ? '#' + route.section : prefix + '/' + tab[0]
      };
    });
  }

  function routeFromHash(hash) {
    return parsePortalRoute(hash).section;
  }

  function legacyEntryAvailable(bootstrap) {
    return bootstrap?.backend_mode === 'legacy_readonly';
  }

  function legacyReadonlyRequested(locationLike) {
    return String(locationLike?.search || '') === '?portal=legacy-readonly';
  }

  function canonicalBootstrapCompanyName(company, fallback) {
    var unavailable = fallback === undefined ? 'Entreprise' : fallback;
    var raw = typeof company?.name === 'string' ? company.name : '';
    if (/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/u.test(raw)) return unavailable;
    var normalized = raw.trim().replace(/\s+/gu, ' ');
    return normalized && normalized.length <= 200 ? normalized : unavailable;
  }

  function portalMemberLabel(member) {
    return ['display_name', 'email_normalized', 'email'].map(function (key) {
      var value = typeof member?.[key] === 'string' ? member[key].trim() : '';
      return safePortalText(value, key === 'display_name' ? 200 : 254, false) || '';
    }).find(Boolean) || '';
  }

  function pendingPortalInvitation(invitation, now) {
    return !!invitation && !invitation.used_at && !invitation.revoked_at
      && typeof invitation.expires_at === 'string' && Date.parse(invitation.expires_at) > now;
  }

  function buildProofDecision(proof, input) {
    input = input || {};
    var current = proof?.current_version;
    var currentId = String(proof?.current_version_id || '');
    var sha256 = String(current?.sha256 || '').toLowerCase();
    if (!proof || !Number.isSafeInteger(proof.version) || proof.version < 1
      || !current || String(current.id || '') !== currentId || !/^[a-f0-9]{64}$/.test(sha256)) {
      throw new TypeError('The displayed proof version is stale');
    }
    var decision = String(input.decision || '');
    var signedName = String(input.signed_name || '').trim();
    var comment = String(input.comment || '').trim();
    if (!['approved', 'changes_requested'].includes(decision) || !signedName || signedName.length > 160) {
      throw new TypeError('A valid proof decision and signer are required');
    }
    if (decision === 'approved' && proof.unresolved_annotation_count !== 0) {
      throw new TypeError('Approval requires a confirmed zero unresolved annotation count');
    }
    if (decision === 'changes_requested' && !comment) throw new TypeError('A correction comment is required');
    return {
      expected_version: proof.version,
      proof_version_id: currentId,
      sha256: sha256,
      decision: decision,
      signed_name: signedName,
      comment: comment || null
    };
  }

  function normalizeProofResource(proof) {
    if (!proof || typeof proof !== 'object' || Array.isArray(proof)) return proof;
    var normalized = Object.assign({}, proof);
    var versions = Array.isArray(proof.versions) ? proof.versions : [];
    var current = proof.current_version && typeof proof.current_version === 'object'
      ? proof.current_version : versions.find(function (version) { return version.id === proof.current_version_id; });
    if (!current && proof.current_version_id) {
      current = {
        id: proof.current_version_id,
        version_number: proof.version_number,
        sha256: proof.sha256
      };
    }
    if (current) normalized.current_version = Object.assign({}, current);
    return normalized;
  }

  function normalizeProofVersionPage(page, proofId) {
    if (!page || typeof page !== 'object' || Array.isArray(page) || !Array.isArray(page.items)
      || !(page.next_cursor === null || typeof page.next_cursor === 'string')) {
      throw new TypeError('Invalid canonical proof version page');
    }
    return {
      items: page.items.map(function (version) {
        if (!version || typeof version !== 'object' || Array.isArray(version)
          || typeof version.id !== 'string' || !version.id || version.proof_id !== proofId
          || !Number.isSafeInteger(version.version_number) || version.version_number < 1
          || !/^[a-f0-9]{64}$/.test(String(version.sha256 || ''))
          || typeof version.published_at !== 'string' || !version.published_at) {
          throw new TypeError('Invalid canonical proof version');
        }
        return {
          id: version.id,
          proof_id: version.proof_id,
          version_number: version.version_number,
          sha256: version.sha256,
          published_at: version.published_at,
        };
      }),
      next_cursor: page.next_cursor,
    };
  }

  function normalizeProofDecisionPage(page, proofId) {
    if (!page || typeof page !== 'object' || Array.isArray(page) || !Array.isArray(page.items)
      || !(page.next_cursor === null || typeof page.next_cursor === 'string')) {
      throw new TypeError('Invalid canonical proof decision page');
    }
    return {
      items: page.items.map(function (decision) {
        if (!decision || typeof decision !== 'object' || Array.isArray(decision)
          || typeof decision.id !== 'string' || !decision.id || decision.proof_id !== proofId
          || typeof decision.proof_version_id !== 'string' || !decision.proof_version_id
          || !/^[a-f0-9]{64}$/.test(String(decision.sha256 || ''))
          || !['approved', 'changes_requested'].includes(decision.decision)
          || typeof decision.signed_name !== 'string' || !decision.signed_name || decision.signed_name.length > 160
          || !(decision.comment === null || typeof decision.comment === 'string')
          || typeof decision.decided_at !== 'string' || !decision.decided_at) {
          throw new TypeError('Invalid canonical proof decision');
        }
        return {
          id: decision.id,
          proof_id: decision.proof_id,
          proof_version_id: decision.proof_version_id,
          sha256: decision.sha256,
          decision: decision.decision,
          signed_name: decision.signed_name,
          comment: decision.comment,
          decided_at: decision.decided_at,
        };
      }),
      next_cursor: page.next_cursor,
    };
  }

  function safeProofReviewText(value, maximum) {
    var text = typeof value === 'string' ? value.trim() : '';
    if (!text || text.length > maximum || /[\u0000-\u001f\u007f]/u.test(text)) {
      throw new TypeError('Invalid canonical proof annotation');
    }
    return text;
  }

  function safeProofReviewAuthor(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)
      || Object.keys(value).some(function (key) { return key !== 'display_name'; })) {
      throw new TypeError('Invalid canonical proof annotation');
    }
    var displayName = safeProofReviewText(value.display_name, 120);
    if (displayName.includes('@') || /^[0-9a-f]{8}-[0-9a-f-]{27,}$/iu.test(displayName)) {
      throw new TypeError('Invalid canonical proof annotation');
    }
    return { display_name: displayName };
  }

  function normalizeProofAnnotationPage(page, proofId, proofVersionId, proofSha256) {
    if (!page || typeof page !== 'object' || Array.isArray(page) || !Array.isArray(page.items)
      || !(page.next_cursor === null || typeof page.next_cursor === 'string') || !/^[a-f0-9]{64}$/u.test(String(proofSha256 || ''))) {
      throw new TypeError('Invalid canonical proof annotation page');
    }
    var categories = ['artwork', 'color', 'placement', 'text', 'size', 'other'];
    var actions = ['comment', 'resolve', 'reopen'];
    return {
      items: page.items.map(function (annotation) {
        if (!annotation || typeof annotation !== 'object' || Array.isArray(annotation)
          || typeof annotation.id !== 'string' || !annotation.id
          || annotation.proof_id !== proofId || annotation.proof_version_id !== proofVersionId
          || annotation.sha256 !== proofSha256
          || !Number.isSafeInteger(annotation.page) || annotation.page < 1
          || !Number.isFinite(annotation.x) || annotation.x < 0 || annotation.x > 1
          || !Number.isFinite(annotation.y) || annotation.y < 0 || annotation.y > 1
          || !categories.includes(annotation.category)
          || !['open', 'resolved'].includes(annotation.status)
          || !Number.isSafeInteger(annotation.version) || annotation.version < 1
          || typeof annotation.created_at !== 'string' || !annotation.created_at
          || typeof annotation.updated_at !== 'string' || !annotation.updated_at
          || !Array.isArray(annotation.comments) || annotation.comments.length > 500
          || !Array.isArray(annotation.allowed_actions)
          || annotation.allowed_actions.some(function (action) { return !actions.includes(action); })) {
          throw new TypeError('Invalid canonical proof annotation');
        }
        var result = {
          id: annotation.id,
          proof_id: annotation.proof_id,
          proof_version_id: annotation.proof_version_id,
          sha256: annotation.sha256,
          page: annotation.page,
          x: annotation.x,
          y: annotation.y,
          category: annotation.category,
          comment: safeProofReviewText(annotation.comment, 2000),
          author: safeProofReviewAuthor(annotation.author),
          status: annotation.status,
          version: annotation.version,
          created_at: annotation.created_at,
          updated_at: annotation.updated_at,
          comments: annotation.comments.map(function (comment) {
            if (!comment || typeof comment !== 'object' || Array.isArray(comment)
              || typeof comment.id !== 'string' || !comment.id
              || comment.annotation_id !== annotation.id
              || typeof comment.created_at !== 'string' || !comment.created_at) {
              throw new TypeError('Invalid canonical proof annotation');
            }
            return {
              id: comment.id,
              annotation_id: comment.annotation_id,
              comment: safeProofReviewText(comment.comment, 2000),
              author: safeProofReviewAuthor(comment.author),
              created_at: comment.created_at,
            };
          }),
          allowed_actions: annotation.allowed_actions.slice(),
        };
        return result;
      }),
      next_cursor: page.next_cursor,
    };
  }

  function proofReviewBinding(proof) {
    var current = proof?.current_version;
    var currentId = String(proof?.current_version_id || '');
    var checksum = String(current?.sha256 || '').toLowerCase();
    if (!proof || !Number.isSafeInteger(proof.version) || proof.version < 1
      || !current || String(current.id || '') !== currentId || !/^[a-f0-9]{64}$/u.test(checksum)) {
      throw new TypeError('Invalid proof annotation binding');
    }
    return { currentId: currentId, checksum: checksum };
  }

  function normalizedAnnotationCoordinate(value, percentValue) {
    if (Number.isFinite(value)) return value;
    if (typeof percentValue !== 'string' || !/^(?:0|[1-9][0-9]?|100)(?:\.\d{1,4})?$/u.test(percentValue.trim())) return Number.NaN;
    return Number(percentValue) / 100;
  }

  function buildProofAnnotation(proof, input) {
    input = input || {};
    var binding = proofReviewBinding(proof);
    var page = typeof input.page === 'string' && /^[1-9][0-9]*$/u.test(input.page.trim()) ? Number(input.page) : input.page;
    var x = normalizedAnnotationCoordinate(input.x, input.x_percent);
    var y = normalizedAnnotationCoordinate(input.y, input.y_percent);
    if (!Number.isSafeInteger(page) || page < 1 || !Number.isFinite(x) || x < 0 || x > 1
      || !Number.isFinite(y) || y < 0 || y > 1
      || !['artwork', 'color', 'placement', 'text', 'size', 'other'].includes(input.category)) {
      throw new TypeError('Invalid proof annotation');
    }
    return {
      expected_version: proof.version,
      proof_version_id: binding.currentId,
      sha256: binding.checksum,
      page: page,
      x: x,
      y: y,
      category: input.category,
      comment: safeProofReviewText(input.comment, 2000),
    };
  }

  function buildProofAnnotationComment(proof, annotation, comment) {
    var binding = proofReviewBinding(proof);
    if (!annotation || !Number.isSafeInteger(annotation.version) || annotation.version < 1
      || annotation.proof_version_id !== binding.currentId || annotation.sha256 !== binding.checksum
      || !canAction(annotation, 'comment')) throw new TypeError('Invalid proof annotation comment');
    return {
      expected_version: annotation.version,
      proof_version_id: binding.currentId,
      sha256: binding.checksum,
      comment: safeProofReviewText(comment, 2000),
    };
  }

  function buildProofComparison(versions, leftId, rightId) {
    if (!Array.isArray(versions) || leftId === rightId) throw new TypeError('Invalid proof comparison');
    var left = versions.find(function (version) { return version?.id === leftId; });
    var right = versions.find(function (version) { return version?.id === rightId; });
    if (!left || !right || left.proof_id !== right.proof_id) throw new TypeError('Invalid proof comparison');
    var normalized = normalizeProofVersionPage({ items: [left, right], next_cursor: null }, left.proof_id).items;
    return { left: normalized[0], right: normalized[1], mode: 'side-by-side', opacity: 50 };
  }

  function buildProofPageModel(annotations, selectedPage) {
    if (!Array.isArray(annotations) || !Number.isSafeInteger(selectedPage) || selectedPage < 1 || selectedPage > 10000
      || annotations.some(function (annotation) { return !annotation || typeof annotation.id !== 'string' || !Number.isSafeInteger(annotation.page) || annotation.page < 1 || annotation.page > 10000; })) {
      throw new TypeError('Invalid proof page');
    }
    var pages = Array.from(new Set([selectedPage].concat(annotations.map(function (annotation) { return annotation.page; })))).sort(function (left, right) { return left - right; });
    return {
      selected_page: selectedPage,
      available_pages: pages,
      visible_marker_ids: annotations.filter(function (annotation) { return annotation.page === selectedPage; }).map(function (annotation) { return annotation.id; }),
      annotations: annotations.slice(),
    };
  }

  function normalizeProofPreview(value, nowMs) {
    var now = Number.isFinite(nowMs) ? nowMs : Date.now();
    var expiresAt = typeof value?.expires_at === 'string' ? value.expires_at : '';
    var expires = Date.parse(expiresAt);
    var sanitizeSignedUrl = window.TodayMerchPortalApi?.sanitizeSignedUrl;
    var url = typeof sanitizeSignedUrl === 'function' ? sanitizeSignedUrl(value?.signed_url) : '';
    if (!url || !Number.isFinite(expires) || new Date(expires).toISOString() !== expiresAt
      || expires <= now || expires - now > 300000) throw new TypeError('Invalid proof preview');
    return { url: url, expires_at: expiresAt };
  }

  function activeProofPreviewUrl(preview, nowMs) {
    var now = Number.isFinite(nowMs) ? nowMs : Date.now();
    if (!preview || typeof preview.url !== 'string' || typeof preview.expires_at !== 'string') return null;
    var expires = Date.parse(preview.expires_at);
    return Number.isFinite(expires) && expires > now ? preview.url : null;
  }

  function proofPreviewUrlForPage(url, page) {
    var target = new URL(url);
    target.hash = 'page=' + page;
    return target.toString();
  }

  function canonicalCostProposal(shipment) {
    if (!shipment || typeof shipment.current_cost_proposal_id !== 'string' || !shipment.current_cost_proposal_id
      || !Number.isSafeInteger(shipment.cost_minor) || shipment.cost_minor < 0) return null;
    return {
      id: shipment.current_cost_proposal_id,
      amount_minor: shipment.cost_minor,
      currency: shipment.currency || 'EUR'
    };
  }

  function shipmentLineMetrics(line) {
    line = line || {};
    var hasDemand = Number.isSafeInteger(line.canonical_demand) && line.canonical_demand >= 0;
    var hasShortage = Number.isSafeInteger(line.shortage) && line.shortage >= 0;
    if (hasDemand && hasShortage) {
      return { canonical: true, demand: line.canonical_demand, shortage: line.shortage };
    }
    return { canonical: false, demand: null, shortage: null };
  }

  function buildWizardDraftBody(state, includeDestination) {
    var wizard = window.TodayMerchShipmentWizard;
    if (typeof wizard?.serializeKitDraft !== 'function') throw new TypeError('Shipment wizard is unavailable');
    var draft = wizard.serializeKitDraft(state);
    var body = { label: draft.label, lines: draft.lines };
    if (includeDestination === true) {
      if (state?.recipient_mode !== 'single' || typeof wizard.serializeDraft !== 'function') {
        throw new TypeError('A complete single destination is required');
      }
      body.destinations = wizard.serializeDraft(state).destinations;
    }
    return body;
  }

  function sameWizardKit(left, right) {
    if (String(left?.label || '').trim() !== String(right?.label || '').trim()
      || !Array.isArray(left?.kit_lines) || !Array.isArray(right?.kit_lines)
      || left.kit_lines.length !== right.kit_lines.length) return false;
    return left.kit_lines.every(function (line, index) {
      var other = right.kit_lines[index];
      return other && line.line_id === other.line_id && line.item_id === other.item_id
        && line.sku === other.sku && line.quantity === other.quantity;
    });
  }

  function sameWizardDestination(left, right) {
    if (left === right) return true;
    if (!left || !right || typeof left !== 'object' || typeof right !== 'object') return false;
    var fields = [
      'destination_id', 'recipient_reference', 'recipient_name', 'recipient_company', 'recipient_email',
      'recipient_phone', 'address_line_1', 'address_line_2', 'postal_code', 'city', 'region', 'country_code'
    ];
    if (!fields.every(function (field) { return String(left[field] || '') === String(right[field] || ''); })) return false;
    var leftQuantities = left.quantities || {};
    var rightQuantities = right.quantities || {};
    var keys = Array.from(new Set(Object.keys(leftQuantities).concat(Object.keys(rightQuantities))));
    return keys.every(function (key) { return String(leftQuantities[key] ?? '') === String(rightQuantities[key] ?? ''); });
  }

  function canAction(resource, action) {
    return Array.isArray(resource?.allowed_actions) && resource.allowed_actions.includes(action);
  }

  function safeDashboardUrl(value) {
    if (typeof value !== 'string' || !value || /[\s\\\u0000-\u001f\u007f]/u.test(value)) return '';
    if (/^\/(?!\/)/u.test(value)) return value;
    try {
      var url = new URL(value);
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch (error) { return ''; }
  }

  function recentDashboardProjects(projects) {
    return (Array.isArray(projects) ? projects : []).filter(function (project) {
      return project && safePortalResourceId(project.id);
    }).slice().sort(function (left, right) {
      var leftTime = Date.parse(left.updated_at || left.created_at || '') || 0;
      var rightTime = Date.parse(right.updated_at || right.created_at || '') || 0;
      return rightTime - leftTime;
    }).slice(0, 5);
  }

  function buildConnectedDashboardModel(resources) {
    resources = resources || {};
    var projects = Array.isArray(resources.projects) ? resources.projects : [];
    var proofs = Array.isArray(resources.proofs) ? resources.proofs : [];
    var shipments = Array.isArray(resources.shipments) ? resources.shipments : [];
    var inventory = Array.isArray(resources.inventory) ? resources.inventory : [];
    var documents = Array.isArray(resources.documents) ? resources.documents : [];
    var activeProjectStatuses = ['draft', 'quote_requested', 'in_progress'];
    var actionableProofs = proofs.filter(function (item) { return canAction(item, 'decide'); }).slice().sort(function (left, right) {
      var leftPublished = Date.parse(String(left?.published_at || ''));
      var rightPublished = Date.parse(String(right?.published_at || ''));
      if (Number.isFinite(leftPublished) && Number.isFinite(rightPublished) && leftPublished !== rightPublished) {
        return rightPublished - leftPublished;
      }
      if (Number.isFinite(leftPublished) !== Number.isFinite(rightPublished)) return Number.isFinite(rightPublished) ? 1 : -1;
      return String(left?.id || '').localeCompare(String(right?.id || ''));
    });
    var costApprovals = shipments.filter(function (item) { return canAction(item, 'approve_cost'); });
    var outOfStock = inventory.filter(function (item) {
      return Number.isSafeInteger(item?.available) && item.available === 0;
    });
    var priorityProof = actionableProofs[0] || null;
    var priorityProject = priorityProof ? projects.find(function (item) { return item.id === priorityProof.project_id; }) || null : null;
    var actions = actionableProofs.slice(0, 2).map(function (item) {
      return { kind: 'proof', id: item.id, route: 'proofs' };
    }).concat(costApprovals.slice(0, 2).map(function (item) {
      return { kind: 'cost', id: item.id, route: 'shipments' };
    }), outOfStock.slice(0, 2).map(function (item) {
      return { kind: 'stock', id: item.item_id, route: 'stock' };
    })).slice(0, 5);

    return {
      metrics: {
        active_projects: projects.filter(function (item) { return activeProjectStatuses.includes(item?.status); }).length,
        pending_proofs: actionableProofs.length,
        cost_approvals: costApprovals.length,
        out_of_stock: outOfStock.length,
      },
      priority_proof: priorityProof,
      priority_project: priorityProject,
      actions: actions,
      projects: projects.slice(0, 4),
      recent_projects: recentDashboardProjects(projects),
      shipments: shipments.slice(0, 3),
      inventory: inventory.slice(0, 3),
      documents: documents.slice(0, 3),
    };
  }

  function selectDefaultWarehouse(warehouses, capabilities) {
    if (capabilities?.shipments_manage !== true || !Array.isArray(warehouses)) return null;
    var defaults = warehouses.filter(function (warehouse) {
      return warehouse?.is_default === true && typeof warehouse.id === 'string' && warehouse.id.trim() !== '';
    });
    return defaults.length === 1 ? defaults[0].id : null;
  }

  function createSubmissionGuard() {
    var inflight = new Map();
    return {
      run: function (key, task) {
        if (inflight.has(key)) return inflight.get(key);
        var request;
        try { request = Promise.resolve(task()); } catch (error) { request = Promise.reject(error); }
        var guarded = request.finally(function () { inflight.delete(key); });
        inflight.set(key, guarded);
        return guarded;
      }
    };
  }

  function formatMinor(amountMinor, currency, locale) {
    if (!Number.isSafeInteger(amountMinor) || !/^[A-Z]{3}$/.test(String(currency || ''))) return '';
    try {
      return new Intl.NumberFormat(locale || undefined, { style: 'currency', currency: currency }).format(amountMinor / 100);
    } catch (error) {
      return (amountMinor / 100).toFixed(2) + ' ' + currency;
    }
  }

  async function recoverPortalError(error, reloadCanonical) {
    if (error?.status === 403 && error?.code === 'ACTION_FORBIDDEN') {
      await reloadCanonical();
      return 'permissions_refreshed';
    }
    if (error?.status === 409 && error?.code === 'VERSION_CONFLICT') {
      await reloadCanonical();
      return 'version_conflict';
    }
    return 'unhandled';
  }

  function normalizePortalMode(bootstrap, nowMs) {
    var mode = String(bootstrap?.backend_mode || '');
    if (!['legacy', 'postgres', 'migration_locked', 'legacy_readonly'].includes(mode)) {
      throw new TypeError('Invalid portal backend mode');
    }
    var result = { mode: mode, snapshot: null, snapshot_verifiable: false };
    if (mode !== 'legacy_readonly') return result;
    var snapshotAt = String(bootstrap?.summary?.snapshot_at || '');
    var snapshotSha = String(bootstrap?.summary?.snapshot_sha256 || '');
    var timestamp = Date.parse(snapshotAt);
    var now = Number.isFinite(nowMs) ? nowMs : Date.now();
    if (!Number.isFinite(timestamp) || timestamp > now || !/^[a-f0-9]{64}$/.test(snapshotSha)) return result;
    try {
      if (new Date(timestamp).toISOString() !== snapshotAt) return result;
    } catch (error) { return result; }
    result.snapshot = {
      at: snapshotAt,
      sha256: snapshotSha,
      age_seconds: Math.floor((now - timestamp) / 1000),
    };
    result.snapshot_verifiable = true;
    return result;
  }

  function waitForImportPoll(delayMs, signal) {
    if (signal?.aborted) return Promise.reject(signal.reason || new DOMException('Import polling aborted', 'AbortError'));
    return new Promise(function (resolve, reject) {
      var timeout = setTimeout(done, delayMs);
      function done() {
        signal?.removeEventListener?.('abort', aborted);
        resolve();
      }
      function aborted() {
        clearTimeout(timeout);
        signal?.removeEventListener?.('abort', aborted);
        reject(signal.reason || new DOMException('Import polling aborted', 'AbortError'));
      }
      signal?.addEventListener?.('abort', aborted, { once: true });
    });
  }

  function canonicalPolledImport(resource, expectedId) {
    if (!resource || typeof resource !== 'object' || Array.isArray(resource)
      || typeof resource.id !== 'string' || !resource.id || (expectedId && resource.id !== expectedId)
      || !Number.isSafeInteger(resource.version) || resource.version < 1
      || !['validating', 'valid', 'invalid'].includes(resource.status)) {
      var invalid = new TypeError('Invalid canonical import status');
      invalid.code = 'IMPORT_RESPONSE_INVALID';
      throw invalid;
    }
    return resource;
  }

  async function pollCanonicalImport(options) {
    options = options || {};
    var maximum = Number.isSafeInteger(options.maxAttempts) && options.maxAttempts >= 1 && options.maxAttempts <= 10
      ? options.maxAttempts : 6;
    var delay = Number.isSafeInteger(options.delayMs) && options.delayMs >= 10 && options.delayMs <= 5000
      ? options.delayMs : 250;
    if (typeof options.read !== 'function') throw new TypeError('An import status reader is required');
    var controller = options.controller || new AbortController();
    var signal = options.signal || controller.signal;
    var sleep = typeof options.sleep === 'function' ? options.sleep : waitForImportPoll;
    var current = canonicalPolledImport(options.initial);
    if (current.status !== 'validating') return current;
    for (var attempt = 0; attempt < maximum; attempt += 1) {
      await sleep(delay, signal);
      current = canonicalPolledImport(await options.read({ signal: signal, attempt: attempt + 1 }), current.id);
      if (current.status !== 'validating') return current;
    }
    var timeout = new Error('Canonical import polling timed out');
    timeout.code = 'IMPORT_POLL_TIMEOUT';
    throw timeout;
  }

  function PortalV1App(root) {
    this.root = root;
    this.surface = root.closest?.('.b2b-account') || root;
    this.shell = root.querySelector('[data-portal-v1-shell]');
    this.legacyShell = root.querySelector('[data-portal-legacy-shell]');
    this.view = root.querySelector('[data-portal-view]');
    this.navigation = root.querySelector('[data-portal-navigation]');
    this.primaryHeader = root.querySelector('[data-portal-primary-header]');
    this.navigationIndicator = root.querySelector('[data-portal-menu-indicator]');
    this.navigationBackdrop = root.querySelector('[data-portal-menu-backdrop]');
    this.subnavigation = root.querySelector('[data-portal-subnavigation]');
    this.contextTabs = root.querySelector('[data-portal-context-tabs]');
    this.companyContexts = root.querySelectorAll('[data-portal-company], [data-portal-legacy-company]');
    this.userControl = root.querySelector('[data-portal-user]');
    this.legacyEntry = root.querySelector('[data-portal-legacy-entry]');
    this.mobileToggle = root.querySelector('[data-portal-mobile-toggle]');
    this.dialog = root.querySelector('[data-portal-proof-dialog]');
    this.dialogForm = root.querySelector('[data-portal-proof-form]');
    this.searchTrigger = root.querySelector('[data-portal-search]');
    this.searchDialog = root.querySelector('[data-portal-search-dialog]');
    this.searchInput = root.querySelector('[data-portal-global-search-input]');
    this.searchResults = root.querySelector('[data-portal-global-search-results]');
    this.searchClose = root.querySelector('[data-portal-search-close]');
    this.notificationsTrigger = root.querySelector('[data-portal-notifications]');
    this.notificationsDialog = root.querySelector('[data-portal-notifications-dialog]');
    this.notificationsList = root.querySelector('[data-portal-notifications-list]');
    this.notificationsClose = root.querySelector('[data-portal-notifications-close]');
    this.dictionary = this.readDictionary();
    this.store = createPortalStore({ locale: this.dictionary.locale || document.documentElement.lang || 'fr' });
    this.guard = createSubmissionGuard();
    this.api = null;
    this.proofInDialog = null;
    this.proofPreviewExpiryTimers = new Map();
    this.resumedShipmentId = null;
    this.resumedShipmentBaseline = null;
    this.importPollController = null;
    this.searchController = null;
    this.customerAuthMounted = false;
  }

  PortalV1App.prototype.readDictionary = function () {
    var element = this.root.querySelector('[data-portal-v1-i18n]');
    try { return JSON.parse(element?.textContent || '{}') || {}; } catch (error) { return {}; }
  };

  PortalV1App.prototype.t = function (key, fallback, values) {
    var language = portalFallbackLanguage(this.dictionary.locale || document.documentElement.lang);
    var dictionaryValue = this.dictionary[key];
    var hasDictionaryValue = typeof dictionaryValue === 'string'
      && dictionaryValue.trim() !== ''
      && !/^translation missing:/iu.test(dictionaryValue);
    var template = hasDictionaryValue
      ? dictionaryValue
      : PORTAL_V1_FALLBACK_DICTIONARIES[language][key] || fallback || key;
    return String(template).replace(/\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g, function (match, name) {
      return values && values[name] != null ? values[name] : match;
    });
  };

  PortalV1App.prototype.backendLabel = function (family, code) {
    var fallback = this.t('code.unknown', 'Indisponible');
    return this.t(backendCodeKey(family, code), fallback);
  };

  PortalV1App.prototype.notificationLabel = function (kind, code) {
    var fallbackKey = kind === 'body' ? 'notifications.unknown_body' : 'notifications.unknown_title';
    return this.t(notificationCodeKey(kind, code), this.t(fallbackKey, kind === 'body' ? 'Une mise à jour est disponible.' : 'Notification'));
  };

  PortalV1App.prototype.applyNavigationBadges = function (badges) {
    var safeRoutes = ['campaigns', 'projects', 'proofs', 'stock', 'shipments', 'documents', 'team'];
    var source = badges && typeof badges === 'object' && !Array.isArray(badges) ? badges : {};
    var self = this;
    safeRoutes.forEach(function (route) {
      var link = self.navigation?.querySelector('[data-portal-route="' + route + '"]');
      if (!link) return;
      link.querySelector('[data-portal-navigation-badge]')?.remove();
      var value = source[route];
      if (!Number.isSafeInteger(value) || value <= 0 || value > 9999) return;
      var badge = document.createElement('span');
      badge.dataset.portalNavigationBadge = route;
      badge.textContent = value > 99 ? '99+' : String(value);
      badge.setAttribute('aria-label', String(value));
      link.append(badge);
    });
  };

  PortalV1App.prototype.applyNotificationBadge = function (notifications) {
    if (!this.notificationsTrigger) return;
    this.notificationsTrigger.querySelector('[data-portal-notification-badge]')?.remove();
    var unread = (Array.isArray(notifications) ? notifications : []).filter(function (item) { return item.read_at === null; }).length;
    if (!unread) return;
    var badge = document.createElement('span');
    badge.dataset.portalNotificationBadge = '';
    badge.textContent = unread > 99 ? '99+' : String(unread);
    badge.setAttribute('aria-label', String(unread));
    this.notificationsTrigger.append(badge);
  };

  PortalV1App.prototype.setRequest = function (busy, error) {
    this.store.request = {
      busy: busy === true,
      error: error || null,
      request_id: error?.request_id || ''
    };
    this.view?.setAttribute('aria-busy', busy ? 'true' : 'false');
  };

  PortalV1App.prototype.navigationAccessBlocked = function () {
    return this.root?.classList?.contains?.('is-access-blocked')
      || this.surface?.classList?.contains?.('is-access-blocked');
  };

  PortalV1App.prototype.updateNavigationGeometry = function () {
    var headerRect = this.primaryHeader?.getBoundingClientRect?.();
    if (headerRect) this.root?.style?.setProperty('--portal-header-bottom', Math.max(0, headerRect.bottom) + 'px');
    if (!this.navigationIndicator) return;
    var currentLink = this.navigation?.querySelector('[data-portal-route][aria-current="page"]');
    var currentGroup = currentLink?.closest?.('[data-portal-menu-group]');
    var entry = (this.openNavigationGroup || currentGroup)?.querySelector('[data-portal-menu-trigger]') || currentLink;
    var label = entry?.querySelector('.portal-v1__menu-label');
    var labelRect = label?.getBoundingClientRect();
    var navigationRect = this.navigation?.getBoundingClientRect();
    var visible = !this.navigationAccessBlocked() && labelRect?.width > 0 && navigationRect?.width > 0;
    this.navigationIndicator.setAttribute('data-visible', visible ? 'true' : 'false');
    if (!visible) return;
    var x = labelRect.left - navigationRect.left + this.navigation.scrollLeft - this.navigation.clientLeft;
    this.navigation.style.setProperty('--portal-menu-indicator-x', x + 'px');
    this.navigation.style.setProperty('--portal-menu-indicator-width', labelRect.width + 'px');
  };

  PortalV1App.prototype.scheduleNavigationGeometry = function () {
    if (this.navigationGeometryFrame) return;
    if (typeof window.requestAnimationFrame !== 'function') {
      this.updateNavigationGeometry();
      return;
    }
    var self = this;
    this.navigationGeometryFrame = window.requestAnimationFrame(function () {
      self.navigationGeometryFrame = null;
      self.updateNavigationGeometry();
    });
  };

  PortalV1App.prototype.updateNavigationPresentation = function () {
    if (this.navigationBackdrop) {
      var open = !!this.openNavigationGroup || this.root?.classList?.contains?.('is-navigation-open');
      this.navigationBackdrop.hidden = !open || this.navigationAccessBlocked();
    }
    if (this.navigationAccessBlocked()) this.navigationIndicator?.setAttribute('data-visible', 'false');
    this.scheduleNavigationGeometry();
  };

  PortalV1App.prototype.supportsNavigationHover = function (event) {
    return !this.navigationAccessBlocked()
      && window.matchMedia?.('(min-width: 1181px) and (hover: hover) and (pointer: fine)').matches === true
      && (!event || event.pointerType === 'mouse');
  };

  PortalV1App.prototype.cancelNavigationHoverTimers = function () {
    if (this.navigationHoverOpenTimer != null) window.clearTimeout(this.navigationHoverOpenTimer);
    if (this.navigationHoverCloseTimer != null) window.clearTimeout(this.navigationHoverCloseTimer);
    this.navigationHoverOpenTimer = null;
    this.navigationHoverCloseTimer = null;
  };

  PortalV1App.prototype.navigationHasKeyboardFocus = function () {
    return this.navigationInputMode === 'keyboard' && this.openNavigationGroup?.contains(document.activeElement);
  };

  PortalV1App.prototype.queueNavigationHoverOpen = function (group, event) {
    if (!group || group.hidden || !this.supportsNavigationHover(event)) return;
    if (!this.navigationHasKeyboardFocus()) this.navigationInputMode = 'pointer';
    this.cancelNavigationHoverTimers();
    this.navigationHoverGroup = group;
    if (this.navigationHoverSuppressedGroup === group || this.openNavigationGroup === group) return;
    var self = this;
    this.navigationHoverOpenTimer = window.setTimeout(function () {
      self.navigationHoverOpenTimer = null;
      if (self.navigationHoverGroup !== group || self.navigationHoverSuppressedGroup === group
        || !self.supportsNavigationHover() || self.navigationHasKeyboardFocus()) return;
      self.openNavigationMenu(group);
    }, 90);
  };

  PortalV1App.prototype.queueNavigationHoverClose = function (event) {
    if (!this.supportsNavigationHover(event)) return;
    this.cancelNavigationHoverTimers();
    var self = this;
    this.navigationHoverCloseTimer = window.setTimeout(function () {
      self.navigationHoverCloseTimer = null;
      if (self.navigationHoverGroup || self.navigationHasKeyboardFocus()) return;
      self.closeNavigationMenus();
    }, 180);
  };

  PortalV1App.prototype.closeNavigationMenus = function (restoreFocus) {
    this.cancelNavigationHoverTimers();
    if (restoreFocus) this.navigationHoverSuppressedGroup = this.navigationHoverGroup || null;
    var trigger = this.openNavigationGroup?.querySelector('[data-portal-menu-trigger]');
    this.navigation?.querySelectorAll('[data-portal-menu-group]').forEach(function (group) {
      group.removeAttribute('data-open');
      group.querySelector('[data-portal-menu-trigger]')?.setAttribute('aria-expanded', 'false');
      var panel = group.querySelector('[data-portal-menu-panel]');
      if (panel) panel.hidden = true;
    });
    this.openNavigationGroup = null;
    this.updateNavigationPresentation();
    if (restoreFocus) trigger?.focus({ preventScroll: true });
  };

  PortalV1App.prototype.setMobileNavigationOpen = function (open) {
    this.cancelNavigationHoverTimers();
    open = open === true && !this.navigationAccessBlocked();
    var classAction = open === true ? 'add' : 'remove';
    this.root.classList[classAction]('is-navigation-open');
    this.surface?.classList[classAction]('is-navigation-open');
    this.mobileToggle?.setAttribute('aria-expanded', open ? 'true' : 'false');
    this.mobileToggle?.setAttribute('aria-label', this.t(open ? 'nav.close' : 'nav.open'));
    if (!open) this.closeNavigationMenus();
    else this.updateNavigationPresentation();
  };

  PortalV1App.prototype.openNavigationMenu = function (group, focusFirst) {
    if (!group || group.hidden || !this.navigation?.contains(group) || this.navigationAccessBlocked()) return;
    var panel = group.querySelector('[data-portal-menu-panel]');
    var trigger = group.querySelector('[data-portal-menu-trigger]');
    var links = Array.from(panel?.querySelectorAll('[data-portal-route]') || []).filter(function (link) { return !link.hidden; });
    if (!panel || !trigger || !links.length) return;
    this.closeNavigationMenus();
    this.openNavigationGroup = group;
    group.setAttribute('data-open', 'true');
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    this.updateNavigationPresentation();
    if (focusFirst) links[0].focus({ preventScroll: true });
  };

  PortalV1App.prototype.applyNavigationAvailability = function () {
    var self = this;
    var sidebar = this.navigation?.hasAttribute?.('data-portal-sidebar-navigation')
      || this.navigation?.hasAttribute?.('data-portal-storefront-navigation');
    if (sidebar) this.navigation.querySelectorAll('[data-portal-route]').forEach(function (link) {
      var simpleMode = self.root.dataset.portalMode === 'orders', route = link.dataset.portalRoute;
      link.hidden = simpleMode && ['dashboard', 'orders', 'account', 'stock'].includes(route)
        ? self.store.context.product_capabilities?.foundation !== true || route === 'stock' && self.store.context.capabilities?.inventory_read !== true
        : self.store.context.product_capabilities?.[productCapabilityForRoute(route)] !== true;
    });
    var sectionSelector = sidebar ? '[data-portal-navigation-section]' : '[data-portal-menu-group]';
    this.navigation?.querySelectorAll(sectionSelector).forEach(function (group) {
      var links = Array.from(group.querySelectorAll('[data-portal-route]'));
      group.hidden = !links.some(function (link) { return !link.hidden; });
      if (group.hidden && self.openNavigationGroup === group) self.closeNavigationMenus();
    });
    this.scheduleNavigationGeometry();
  };

  PortalV1App.prototype.syncNavigationCurrent = function (section) {
    if (this.root?.dataset?.portalMode === 'orders') {
      var accountOpen = section === 'account';
      this.shell?.toggleAttribute('data-portal-account-open', accountOpen);
      this.shell?.toggleAttribute('data-portal-orders-list', section === 'orders' && !this.store.routeState?.isDetail);

    }
    this.navigation?.querySelectorAll('[data-portal-route]').forEach(function (link) {
      if (link.dataset.portalRoute === section) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    this.navigation?.querySelectorAll('[data-portal-menu-group]').forEach(function (group) {
      if (group.querySelector('[data-portal-route][aria-current="page"]')) group.setAttribute('data-current', 'true');
      else group.removeAttribute('data-current');
    });
    this.scheduleNavigationGeometry();
  };

  PortalV1App.prototype.bindSidebarNavigation = function () {
    var self = this;
    if (this.root.dataset.portalMode === 'orders') {
      window.addEventListener('scroll', function () { self.scheduleNavigationGeometry(); }, { passive: true, capture: true });
      if (typeof window.ResizeObserver === 'function' && this.primaryHeader) {
        this.navigationResizeObserver = new window.ResizeObserver(function () { self.scheduleNavigationGeometry(); });
        this.navigationResizeObserver.observe(this.primaryHeader);
      }
      document.fonts?.ready?.then(function () { self.scheduleNavigationGeometry(); });
    }
    var collapseToggle = this.root.querySelector('[data-portal-sidebar-toggle]');
    var accountSidebar = this.root.querySelector('[data-portal-account-navigation]');
    var lastSidebarFocus = null;
    collapseToggle?.addEventListener('click', function () {
      var collapsed = !self.root.classList.contains('is-sidebar-collapsed');
      [self.root, self.surface].filter(Boolean).forEach(function (surface) {
        surface.classList.toggle('is-sidebar-collapsed', collapsed);
      });
      collapseToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      collapseToggle.setAttribute('aria-label', self.t(collapsed ? 'nav.open' : 'nav.close'));
      self.navigation.querySelectorAll('[data-portal-route]').forEach(function (link) {
        if (collapsed) link.setAttribute('title', link.querySelector('.portal-v1__rail-label, .tm-portal-nav__label')?.textContent || '');
        else link.removeAttribute('title');
      });
    });
    (accountSidebar || this.navigation).addEventListener('click', function (event) {
      if (event.target.closest('[data-portal-route], .portal-account-sidebar__logo')) self.setMobileNavigationOpen(false);
    });
    this.navigationBackdrop?.addEventListener('click', function () {
      self.setMobileNavigationOpen(false);
      self.mobileToggle?.focus({ preventScroll: true });
    });
    document.addEventListener('focusin', function (event) {
      lastSidebarFocus = self.navigation.contains(event.target) || accountSidebar?.contains(event.target) || event.target === collapseToggle || event.target === self.mobileToggle
        ? event.target : null;
      if (self.root.classList.contains('is-navigation-open') && !self.primaryHeader?.contains(event.target)
        && !self.navigation.contains(event.target) && !accountSidebar?.contains(event.target) && event.target !== collapseToggle) {
        self.setMobileNavigationOpen(false);
      }
    });
    var compact = window.matchMedia(this.navigation.hasAttribute('data-portal-storefront-navigation')
      ? '(max-width: 1023px)' : '(max-width: 760px)');
    compact.addEventListener('change', function () {
      var active = document.activeElement;
      var navigationFocused = self.navigation.contains(active) || accountSidebar?.contains(active) || collapseToggle === active || self.mobileToggle === active
        || (active === document.body && lastSidebarFocus !== null);
      lastSidebarFocus = null;
      self.setMobileNavigationOpen(false);
      if (navigationFocused) {
        var target = compact.matches ? self.mobileToggle : self.navigation.querySelector('[aria-current="page"]');
        target?.focus({ preventScroll: true });
      }
    });
    this.applyNavigationAvailability();
    this.updateNavigationPresentation();
  };

  PortalV1App.prototype.bindNavigationMenus = function () {
    if (!this.navigation || this.navigationMenusBound) return;
    this.navigationMenusBound = true;
    if (this.navigation.hasAttribute?.('data-portal-sidebar-navigation') || this.navigation.hasAttribute?.('data-portal-storefront-navigation')) {
      this.bindSidebarNavigation();
      return;
    }
    var self = this;
    var pointerNavigationTrigger = null;
    var lastNavigationFocus = null;
    this.navigation.querySelectorAll('[data-portal-menu-group]').forEach(function (group) {
      group.addEventListener('pointerenter', function (event) { self.queueNavigationHoverOpen(group, event); });
      group.addEventListener('pointerleave', function (event) {
        if (!self.supportsNavigationHover(event)) return;
        if (self.navigationHoverGroup === group) self.navigationHoverGroup = null;
        if (self.navigationHoverSuppressedGroup === group) self.navigationHoverSuppressedGroup = null;
        self.queueNavigationHoverClose(event);
      });
    });
    this.primaryHeader?.addEventListener('pointerleave', function (event) {
      if (!self.supportsNavigationHover(event)) return;
      self.navigationHoverGroup = null;
      self.navigationHoverSuppressedGroup = null;
      self.queueNavigationHoverClose(event);
    });
    this.navigationBackdrop?.addEventListener('pointerenter', function (event) {
      if (!self.supportsNavigationHover(event)) return;
      self.navigationHoverGroup = null;
      self.queueNavigationHoverClose(event);
    });
    this.navigationBackdrop?.addEventListener('pointerdown', function (event) {
      // Keep the backdrop in place until click so the workspace never receives the gesture.
      self.cancelNavigationHoverTimers();
      event.preventDefault();
      event.stopPropagation();
    });
    this.navigationBackdrop?.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var nextFocus = self.root.classList.contains('is-navigation-open') ? self.mobileToggle
        : self.openNavigationGroup?.querySelector('[data-portal-menu-trigger]');
      pointerNavigationTrigger = null;
      lastNavigationFocus = null;
      self.setMobileNavigationOpen(false);
      nextFocus?.focus({ preventScroll: true });
    });
    this.navigation.addEventListener('pointerdown', function (event) {
      pointerNavigationTrigger = event.target.closest?.('[data-portal-menu-trigger]') || null;
      self.navigationPointerType = event.pointerType;
      self.navigationInputMode = 'pointer';
      if (pointerNavigationTrigger && self.supportsNavigationHover(event)) {
        self.queueNavigationHoverOpen(pointerNavigationTrigger.closest('[data-portal-menu-group]'), event);
      }
    });
    this.navigation.addEventListener('click', function (event) {
      var trigger = event.target.closest?.('[data-portal-menu-trigger]');
      if (trigger && self.navigation.contains(trigger)) {
        event.preventDefault();
        var group = trigger.closest('[data-portal-menu-group]');
        var mouseClick = event.detail !== 0 && (event.pointerType || self.navigationPointerType || 'mouse') === 'mouse';
        if (mouseClick && self.supportsNavigationHover()) {
          pointerNavigationTrigger = null;
          return;
        }
        self.navigationInputMode = event.detail === 0 ? 'keyboard' : 'pointer';
        if (self.openNavigationGroup === group) self.closeNavigationMenus();
        else self.openNavigationMenu(group);
      } else if (event.target.closest?.('[data-portal-route]')) {
        self.setMobileNavigationOpen(false);
      }
      pointerNavigationTrigger = null;
    });
    this.navigation.addEventListener('keydown', function (event) {
      var pendingHover = self.navigationHoverOpenTimer != null;
      self.navigationInputMode = 'keyboard';
      self.cancelNavigationHoverTimers();
      pointerNavigationTrigger = null;
      if (event.key === 'Escape' && pendingHover) {
        event.preventDefault();
        self.closeNavigationMenus(true);
      }
      var trigger = event.target.closest?.('[data-portal-menu-trigger]');
      if (event.key === 'ArrowDown' && trigger) {
        event.preventDefault();
        self.openNavigationMenu(trigger.closest('[data-portal-menu-group]'), true);
      }
    });
    function closeOutsideNavigation(event) {
      if (self.navigationBackdrop?.contains(event.target)) return;
      if (self.navigation.contains(event.target)) {
        if (event.type === 'focusin') {
          lastNavigationFocus = event.target;
          if (self.openNavigationGroup && !self.openNavigationGroup.contains(event.target)
            && event.target !== pointerNavigationTrigger) self.closeNavigationMenus();
        }
        return;
      }
      pointerNavigationTrigger = null;
      if (self.mobileToggle?.contains(event.target)) {
        if (event.type === 'focusin') lastNavigationFocus = event.target;
        return;
      }
      lastNavigationFocus = null;
      if (self.root.querySelector('[data-portal-primary-header]')?.contains(event.target)) {
        self.closeNavigationMenus();
        return;
      }
      self.setMobileNavigationOpen(false);
    }
    document.addEventListener('pointerdown', closeOutsideNavigation);
    document.addEventListener('focusin', closeOutsideNavigation);
    document.addEventListener('pointercancel', function () {
      pointerNavigationTrigger = null;
      var leavingHover = self.navigationHoverCloseTimer != null;
      self.cancelNavigationHoverTimers();
      if (leavingHover && !self.navigationHoverGroup && !self.navigationHasKeyboardFocus()) self.closeNavigationMenus();
    });
    document.addEventListener('keydown', function (event) {
      var pendingHover = self.navigationHoverOpenTimer != null;
      self.navigationInputMode = 'keyboard';
      if (pendingHover) window.clearTimeout(self.navigationHoverOpenTimer);
      self.navigationHoverOpenTimer = null;
      if (event.key === 'Escape' && (self.openNavigationGroup || pendingHover)) {
        event.preventDefault();
        self.closeNavigationMenus(true);
      }
    });
    var lastViewportWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      var leavingHover = self.navigationHoverCloseTimer != null;
      self.cancelNavigationHoverTimers();
      self.scheduleNavigationGeometry();
      if (window.innerWidth === lastViewportWidth) {
        if (leavingHover && !self.navigationHoverGroup && !self.navigationHasKeyboardFocus()) self.closeNavigationMenus();
        return;
      }
      lastViewportWidth = window.innerWidth;
      var activeElement = document.activeElement;
      var focusedNavigation = self.navigation.contains(activeElement) || self.mobileToggle?.contains(activeElement)
        || (activeElement === document.body && lastNavigationFocus !== null);
      var previousTrigger = self.openNavigationGroup?.querySelector('[data-portal-menu-trigger]')
        || lastNavigationFocus?.closest?.('[data-portal-menu-group]')?.querySelector('[data-portal-menu-trigger]');
      self.setMobileNavigationOpen(false);
      if (!focusedNavigation) return;
      var mobile = window.matchMedia?.('(max-width: 1180px)').matches;
      var nextFocus = mobile ? self.mobileToggle : previousTrigger || self.navigation.querySelector('[data-portal-route="dashboard"]');
      lastNavigationFocus = null;
      nextFocus?.focus({ preventScroll: true });
    });
    window.addEventListener('scroll', function () { self.scheduleNavigationGeometry(); }, { passive: true, capture: true });
    if (typeof window.ResizeObserver === 'function') {
      this.navigationResizeObserver = new window.ResizeObserver(function () { self.scheduleNavigationGeometry(); });
      if (this.primaryHeader) this.navigationResizeObserver.observe(this.primaryHeader);
      this.navigationResizeObserver.observe(this.navigation);
    }
    document.fonts?.ready?.then(function () { self.scheduleNavigationGeometry(); });
    this.applyNavigationAvailability();
    this.updateNavigationPresentation();
  };

  PortalV1App.prototype.bind = function () {
    if (this.bound) return;
    this.bound = true;
    var self = this;
    this.bindNavigationMenus();
    window.addEventListener('hashchange', function () { void self.navigate(parsePortalRoute(window.location.hash)); });
    this.mobileToggle?.addEventListener('click', function () {
      var open = !self.root.classList.contains('is-navigation-open');
      self.setMobileNavigationOpen(open);
      if (open && self.root.querySelector('[data-portal-account-navigation]')) {
        var activeLink = self.navigation.querySelector('[aria-current="page"]') || self.navigation.querySelector('[data-portal-route]');
        activeLink?.focus({ preventScroll: true });
      }
    });
    if (this.searchTrigger && this.searchDialog && this.searchInput) {
      this.searchTrigger.addEventListener('click', function () { self.setMobileNavigationOpen(false); });
      this.searchController?.destroy?.();
      this.searchController = createGlobalSearchDialogController({
        trigger: this.searchTrigger,
        dialog: this.searchDialog,
        input: this.searchInput,
        onSearch: function (query) { return self.performGlobalSearch(query); },
      });
      this.searchClose?.addEventListener('click', function () { self.searchDialog.close(); });
      this.searchDialog.addEventListener('close', function () {
        var target = self.searchTrigger?.getClientRects?.().length === 0 ? self.mobileToggle : self.searchTrigger;
        target?.focus?.({ preventScroll: true });
      });
    }
    this.notificationsTrigger?.addEventListener('click', async function () {
      if (!self.notificationsDialog || !self.notificationsList) return;
      self.setMobileNavigationOpen(false);
      self.notificationsDialog.showModal();
      if (self.store.context.product_capabilities?.enterprise !== true) {
        self.notificationsList.innerHTML = '<p role="status">' + escapeHtml(self.t('notifications.unavailable')) + '</p>';
        return;
      }
      self.notificationsList.innerHTML = '<p role="status">' + escapeHtml(self.t('search.loading', 'Chargement…')) + '</p>';
      try {
        var page = await self.api.listAll('/client/v1/notifications', { maximumPages: 1 });
        self.store.resources.notifications = page.items.map(normalizeSafeNotification);
        self.applyNotificationBadge(self.store.resources.notifications);
        self.notificationsList.innerHTML = self.renderNotifications();
      } catch (error) {
        self.notificationsList.innerHTML = '<p role="alert">' + escapeHtml(self.t('errors.generic', 'Action impossible.')) + '</p>';
      }
    });
    this.notificationsClose?.addEventListener('click', function () { self.notificationsDialog?.close(); });
    this.notificationsDialog?.addEventListener('close', function () { self.notificationsTrigger?.focus?.(); });
    this.root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.openNavigationGroup) {
        event.preventDefault();
        self.closeNavigationMenus(true);
        return;
      }
      var inventoryTab = event.target.closest?.('[role="tab"][data-portal-inventory-view]');
      if (inventoryTab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        var tabs = Array.from(inventoryTab.closest('[role="tablist"]')?.querySelectorAll('[role="tab"][data-portal-inventory-view]') || []);
        var current = tabs.indexOf(inventoryTab);
        if (current >= 0 && tabs.length) {
          event.preventDefault();
          var next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1
            : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          self.store.inventoryView = tabs[next].dataset.portalInventoryView;
          self.renderRoute('stock');
          self.view?.querySelector('[data-portal-inventory-view="' + self.store.inventoryView + '"]')?.focus({ preventScroll: true });
          return;
        }
      }
      if (event.key !== 'Escape' || !self.root.classList.contains('is-navigation-open')) return;
      event.preventDefault();
      self.setMobileNavigationOpen(false);
      self.mobileToggle?.focus();
    });
    this.root.addEventListener('click', function (event) { void self.handleClick(event); });
    this.root.addEventListener('change', function (event) {
      if (event.target.matches('[data-portal-inventory-filter]')) {
        self.store.inventoryFilter = event.target.value;
        self.renderRoute('stock');
      }
      if (event.target.matches('[data-portal-wizard-file]')) self.wizardFile = event.target.files?.[0] || null;
      if (event.target.matches('[data-proof-selected-page], [data-proof-annotation-form] [name="page"]')) {
        var selectedPage = typeof event.target.value === 'string' && /^[1-9][0-9]*$/u.test(event.target.value.trim()) ? Number(event.target.value) : Number.NaN;
        if (!Number.isSafeInteger(selectedPage) || selectedPage < 1 || selectedPage > 10000) return;
        self.store.proofSelectedPage = selectedPage;
        self.store.proofPageAnnouncement = self.t('proof_studio.page_announcement', undefined, { page: selectedPage });
        self.renderRoute('proofs');
      }
      if (event.target.matches('[data-proof-comparison-version]')) {
        var side = event.target.dataset.proofComparisonVersion;
        var current = self.store.proofComparison;
        var leftId = side === 'left' ? event.target.value : current?.left?.id;
        var rightId = side === 'right' ? event.target.value : current?.right?.id;
        try { self.store.proofComparison = buildProofComparison(self.store.proofVersions, leftId, rightId); } catch (error) { return; }
        self.renderRoute('proofs');
      }
      if (event.target.matches('[data-proof-comparison-mode]') && self.store.proofComparison) {
        self.store.proofComparison.mode = event.target.value === 'overlay' ? 'overlay' : 'side-by-side';
        self.renderRoute('proofs');
      }
      if (event.target.matches('[data-proof-comparison-opacity]') && self.store.proofComparison) {
        self.store.proofComparison.opacity = Math.max(10, Math.min(90, Number(event.target.value) || 50));
        self.renderRoute('proofs');
      }
      if (event.target.matches('[name="recipient_mode"]')) {
        self.store.wizard = window.TodayMerchShipmentWizard.reduce(self.store.wizard, {
          type: 'recipient.changed', mode: event.target.value, destination: self.store.wizard.destination
        });
        self.renderWizard();
      }
    });
    this.root.addEventListener('input', function (event) {
      if (!event.target.matches('[data-portal-inventory-search]')) return;
      self.store.inventorySearch = event.target.value.slice(0, 120);
      self.renderRoute('stock');
      self.view?.querySelector('[data-portal-inventory-search]')?.focus({ preventScroll: true });
    });
    this.root.addEventListener('submit', function (event) {
      if (event.target.matches('[data-portal-wizard-form]')) {
        event.preventDefault();
        void self.advanceWizard();
      }
      if (event.target.matches('[data-portal-cost-form]')) {
        event.preventDefault();
        void self.submitCostDecision(event);
      }
      if (event.target.matches('[data-portal-shipment-cancel-form]')) {
        event.preventDefault();
        void self.cancelShipment(event.target);
      }
      if (event.target.matches('[data-portal-invite-form]')) {
        event.preventDefault();
        void self.submitTeamInvite(event.target);
      }
      if (event.target.matches('[data-portal-member-form]')) {
        event.preventDefault();
        void self.submitTeamMember(event.target, event.submitter);
      }
      if (event.target.matches('[data-portal-invitation-form]')) {
        event.preventDefault();
        void self.revokeTeamInvitation(event.target);
      }
      if (event.target.matches('[data-portal-approval-rule-form]')) {
        event.preventDefault();
        void self.submitApprovalRule(event.target);
      }
      if (event.target.matches('[data-portal-campaign-form]')) {
        event.preventDefault();
        void self.submitCampaignForm(event.target);
      }
      if (event.target.matches('[data-proof-annotation-form]')) {
        event.preventDefault();
        void self.submitProofAnnotation(event.target);
      }
      if (event.target.matches('[data-proof-comment-form]')) {
        event.preventDefault();
        void self.submitProofComment(event.target);
      }
      if (event.target.matches('[data-portal-quote-decision-form]')) {
        event.preventDefault();
        void self.submitDocumentDecision(event.target, event.submitter);
      }
      if (event.target.matches('[data-portal-reorder-form]')) {
        event.preventDefault();
        void self.submitInventoryReorder(event.target);
      }
    });
    this.dialogForm?.addEventListener('submit', function (event) { void self.submitProof(event); });
    this.dialog?.addEventListener('close', function () {
      self.proofInDialog?.trigger?.focus?.();
      self.proofInDialog = null;
    });
  };

  PortalV1App.prototype.submitCampaignForm = async function (form) {
    var campaign = this.store.campaignEditor && this.store.campaignEditor !== 'create'
      ? this.store.campaignEditor : null;
    var expectedVersion = campaign ? campaign.version : 0;
    var input = Object.fromEntries(new FormData(form).entries());
    var payload = buildCampaignMutation(input, expectedVersion);
    var errorTarget = form.querySelector('[data-campaign-error]');
    if (!payload) {
      if (errorTarget) errorTarget.textContent = this.t('errors.validation', 'Vérifiez les champs signalés.');
      return;
    }
    var body = { ...payload };
    delete body.expected_version;
    form.setAttribute('aria-busy', 'true');
    form.querySelectorAll('button, input, textarea, select').forEach(function (control) { control.disabled = true; });
    try {
      var result = await this.api.mutate(campaign ? '/client/v1/campaigns/' + encodeURIComponent(campaign.id) : '/client/v1/campaigns', {
        operation: campaign ? 'campaign.update' : 'campaign.create',
        resource: campaign ? campaign.id : 'campaign',
        expectedVersion: expectedVersion,
        method: campaign ? 'PATCH' : 'POST',
        body: body,
      });
      this.view?.querySelector('[data-portal-campaign-dialog]')?.close();
      this.store.campaignEditor = null;
      var nextRoute = parsePortalRoute('#campaigns/' + encodeURIComponent(result.id) + '/overview');
      window.history?.pushState?.(null, '', window.location.pathname + window.location.search + nextRoute.canonicalHash);
      await this.navigate(nextRoute);
    } catch (error) {
      var fields = error?.field_errors && typeof error.field_errors === 'object'
        ? Object.keys(error.field_errors).join(', ') : '';
      if (errorTarget) errorTarget.textContent = fields
        ? this.t('campaign.save_field_error', 'Vérifiez : {{fields}}', { fields: fields })
        : this.t('campaign.save_error', 'La campagne n’a pas été enregistrée.');
    } finally {
      form.removeAttribute('aria-busy');
      form.querySelectorAll('button, input, textarea, select').forEach(function (control) { control.disabled = false; });
    }
  };

  PortalV1App.prototype.bootstrap = async function () {
    this.unmountCustomerAuth();
    if (!window.TodayMerchPortalApi?.PortalApi) throw new Error('Portal transport is unavailable');
    if (!window.TodayMerchPortalAccess?.bootstrap) throw new Error('Portal access is unavailable');
    var self = this;
    this.api = new window.TodayMerchPortalApi.PortalApi({
      baseUrl: this.root.dataset.apiBase,
      onUnauthorized: function () { self.renderError({ status: 401, code: 'AUTHENTICATION_REQUIRED' }); }
    });
    var initialRoute = parsePortalRoute(window.location.hash);
    var wantsInitialOrders = this.root.dataset.portalMode === 'orders' && initialRoute.valid === true && initialRoute.section === 'dashboard' && !initialRoute.isDetail;
    var bootstrap = await window.TodayMerchPortalAccess.bootstrap(this.api, { initialOrders: wantsInitialOrders });
    if (bootstrap?.portal_version !== 1 || !['legacy', 'postgres', 'migration_locked', 'legacy_readonly'].includes(bootstrap.backend_mode)) {
      throw new Error('Invalid portal bootstrap');
    }
    if (bootstrap.backend_mode === 'postgres' && !canonicalBootstrapCompanyName(bootstrap.company, '')) {
      var companyId = bootstrap.company?.id;
      if (!safePortalResourceId(companyId)) throw { status: 503, code: 'PORTAL_RESPONSE_INVALID' };
      var company = await this.api.request('/client/v1/company');
      if (company?.id !== companyId || !canonicalBootstrapCompanyName(company, '')) {
        throw { status: 503, code: 'PORTAL_RESPONSE_INVALID' };
      }
      bootstrap = Object.assign({}, bootstrap, { company: company });
    }
    var companyName = canonicalBootstrapCompanyName(bootstrap.company);
    if (bootstrap.company) bootstrap.company = Object.assign({}, bootstrap.company, { name: companyName });
    this.companyContexts.forEach(function (element) { element.textContent = companyName; });
    if (this.userControl) this.userControl.setAttribute('aria-label', this.t('nav.account_for', 'Compte de {{company}}', { company: companyName }));
    if (this.root.dataset.portalMode === 'orders' && bootstrap.backend_mode !== 'postgres') {
      throw { status: 503, code: 'PORTAL_UNAVAILABLE' };
    }
    if (bootstrap.backend_mode === 'legacy') {
      this.root.setAttribute('data-portal-legacy-readonly', '');
      this.shell.hidden = true;
      if (this.legacyShell) this.legacyShell.hidden = false;
      new ClientPortal(this.root, { readOnly: true, companyName: companyName }).init();
      return;
    }
    if (this.root.dataset.portalMode !== 'orders' && legacyEntryAvailable(bootstrap) && legacyReadonlyRequested(window.location)) {
      this.root.setAttribute('data-portal-legacy-readonly', '');
      this.shell.hidden = true;
      if (this.legacyShell) this.legacyShell.hidden = false;
      new ClientPortal(this.root, { readOnly: true, companyName: companyName }).init();
      return;
    }
    this.root.removeAttribute('data-portal-legacy-readonly');
    this.root.classList.remove('is-access-blocked');
    this.surface?.classList.remove('is-access-blocked');
    this.accessWasAuthenticated = false;
    var capabilities = bootstrap.capabilities || {};
    var productCapabilities = normalizeProductCapabilities(bootstrap.product_capabilities);
    var portalMode = normalizePortalMode(bootstrap);
    var warehouses = [];
    if (this.root.dataset.portalMode !== 'orders' && bootstrap.backend_mode === 'postgres' && productCapabilities.operations === true && capabilities.shipments_manage === true) {
      try {
        warehouses = (await this.api.listAll('/client/v1/warehouses')).items;
      } catch (error) {
        if (this.api.locked || error?.status === 401) throw error;
        warehouses = [];
      }
    }
    if (this.api.locked) throw { status: 401, code: 'AUTHENTICATION_REQUIRED' };
    this.store.context = {
      locale: this.store.context.locale,
      actor: bootstrap.actor || null,
      company: bootstrap.company || null,
      capabilities: capabilities,
      product_capabilities: productCapabilities,
      backend_mode: bootstrap.backend_mode,
      default_warehouse_id: selectDefaultWarehouse(warehouses, capabilities),
      portal_mode: portalMode,
    };
    this.store.summary = bootstrap.summary || {};
    this.store.dashboard = Object.fromEntries([
      'action_queue', 'navigation_badges', 'campaign_summary', 'project_summary',
      'stock_risks', 'shipping_exceptions', 'activity', 'money'
    ].filter(function (key) { return Object.prototype.hasOwnProperty.call(bootstrap, key); })
      .map(function (key) { return [key, structuredClone(bootstrap[key])]; }));
    this.applyNavigationBadges(this.store.dashboard.navigation_badges);
    if (this.legacyEntry) this.legacyEntry.hidden = this.root.dataset.portalMode === 'orders' || !legacyEntryAvailable(bootstrap);
    this.shell.hidden = false;
    if (this.legacyShell) this.legacyShell.hidden = true;
    this.bind();
    this.applyNavigationAvailability();
    if (wantsInitialOrders && bootstrap.initial_orders) this.portalInitialOrders = { api: this.api, page: bootstrap.initial_orders };
    await this.navigate(parsePortalRoute(window.location.hash));
    delete this.portalInitialOrders;
  };

  PortalV1App.prototype.catalogueUrl = function () {
    var root = String(this.root.dataset.localeRoot || '/').replace(/\/?$/, '/');
    if (!/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?$/.test(root)) root = '/';
    return root + '?view=shop&portal=1';
  };

  var PORTAL_ROUTE_CACHE_TTL = 30000;
  function routeCacheFields(section) {
    return section === 'orders' || section === 'dashboard' ? ['ordersV1', 'journeyProjects']
      : section === 'account' ? ['accountV1']
        : section === 'stock' ? ['inventoryPage', 'inventoryNextCursor', 'inventoryReadonlyCursors', 'inventoryLoadingMore', 'inventoryLoadMoreError', 'inventoryView'] : [];
  }
  function routeCacheData(store, section) {
    var result = {};
    routeCacheFields(section).forEach(function (key) { if (Object.hasOwn(store, key)) result[key] = structuredClone(store[key]); });
    if (section === 'stock') result.inventory = structuredClone(store.resources.inventory || []);
    return result;
  }
  function applyRouteCacheData(store, section, data) {
    routeCacheFields(section).forEach(function (key) { if (Object.hasOwn(data, key)) store[key] = structuredClone(data[key]); });
    if (section === 'stock') store.resources.inventory = structuredClone(data.inventory || []);
  }
  function cacheActorId(context) {
    var actor = context?.actor;
    return actor?.membership_id || actor?.membershipId || actor?.id || '';
  }
  function samePortalIdentity(verified, context) {
    return cacheActorId(verified) && cacheActorId(verified) === cacheActorId(context)
      && verified.company?.id === context.company?.id && verified.actor?.role === context.actor?.role
      && JSON.stringify(verified.capabilities) === JSON.stringify(context.capabilities)
      && JSON.stringify(verified.product_capabilities) === JSON.stringify(context.product_capabilities);
  }
  function cacheRouteAllowed(app, state) {
    return app.root?.dataset?.portalMode === 'orders' && !app.journeyPersonal && !state?.commercialId
      && app.store.context.backend_mode === 'postgres' && !!cacheActorId(app.store.context) && !!app.store.context.company?.id
      && ['dashboard', 'orders', 'account', 'stock'].includes(state?.section)
      && (state.section !== 'stock' || app.store.context.capabilities?.inventory_read === true && app.store.context.product_capabilities?.foundation === true);
  }
  PortalV1App.prototype.clearRouteCache = function () {
    this.portalRouteCache = new Map();
    this.portalCacheRevision = (this.portalCacheRevision || 0) + 1;
    this.portalRouteVersions = new Map();
    this.portalDisplayedRoute = null;
    this.portalPreloaded = false;
    if (this.store) {
      ['orders', 'account', 'stock'].forEach(function (section) { routeCacheFields(section).forEach(function (key) { delete this.store[key]; }, this); }, this);
      if (this.store.resources) this.store.resources.inventory = [];
    }
    window.TodayMerchPortalAccount?.clearSession?.(this);
    window.TodayMerchPortalBeneficiaries?.clearSession?.(this);
    delete this.store?.journeyProjects;
    this.journeyCustomer = null;
    this.portalJourneyData = null;
    this.portalJourneyLoadedAt = 0;
  };
  PortalV1App.prototype.invalidateRouteCache = function (sections) {
    if (!Array.isArray(sections)) { this.clearRouteCache(); return; }
    this.portalRouteVersions ||= new Map();
    new Set(sections).forEach(function (section) { this.portalRouteVersions.set(section, (this.portalRouteVersions.get(section) || 0) + 1); }, this);
    this.portalRouteCache?.forEach(function (entry, key) { if (sections.includes(entry.section)) this.portalRouteCache.delete(key); }, this);
    if (sections.includes(this.portalDisplayedRoute?.section)) this.portalDisplayedRoute = null;
  };
  PortalV1App.prototype.bindPortalCacheSession = function () {
    if (this.portalCacheSessionBound) return;
    this.portalCacheSessionBound = true;
    var self = this;
    if (typeof window.BroadcastChannel === 'function') {
      this.portalAuthChannel = new window.BroadcastChannel('todaymerch.portal-auth.v1');
      this.portalAuthChannel.onmessage = function (event) {
        if (event.data?.type !== 'logout') return;
        window.TodayMerchPortalAccess?.invalidateCustomerAuth?.();
        self.clearRouteCache();
        self.api?.lock?.();
        self.renderError({ status: 401, code: 'AUTHENTICATION_REQUIRED' });
      };
    }
    // Returning to an authenticated page validates the principal while keeping
    // unsaved forms private and intact when the same person is still signed in.
    if (this.root.dataset.portalLocalPreview === 'true') return;
    var suspended = false, verifying = null;
    var verify = function () {
      if (verifying) return verifying;
      verifying = (async function () {
        try {
          if (self.api?.locked) { await self.bootstrap(); return; }
          var read = self.api.requestUncached || self.api.request;
          var verified = await read.call(self.api, '/client/v1/dashboard', { cache: 'no-store' });
          var same = samePortalIdentity(verified, self.store.context);
          if (!same) { self.clearRouteCache(); self.api?.clearCache?.(); await self.bootstrap(); }
        } catch (error) {
          self.clearRouteCache(); self.api?.clearCache?.(); self.renderError(error);
        } finally {
          if (self.view) self.view.hidden = false;
          suspended = false; verifying = null;
        }
      })();
      return verifying;
    };
    document.addEventListener?.('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        window.TodayMerchPortalAccount?.captureDrafts?.(self);
        suspended = true;
        if (self.view) self.view.hidden = true;
      } else if (suspended) void verify();
    });
    window.addEventListener?.('pageshow', function (event) {
      if (!event.persisted) return;
      if (self.view) self.view.hidden = true;
      void verify();
    });
  };

  PortalV1App.prototype.prepareRouteCache = function () {
    if (this.root?.dataset?.portalMode !== 'orders') return;
    if (!cacheActorId(this.store.context) || !this.store.context.company?.id) {
      if (this.portalCacheScope || this.api?.cacheScope) { this.clearRouteCache(); this.api?.setCacheScope?.(''); this.portalCacheScope = ''; }
      return;
    }
    this.bindPortalCacheSession();
    var actor = this.store.context.actor;
    var scope = JSON.stringify([this.store.context.company.id, cacheActorId(this.store.context), actor.role || '', this.store.context.locale || '', this.store.context.capabilities, this.store.context.product_capabilities]);
    if (this.portalCacheScope !== scope || this.portalCacheApi !== this.api) {
      var replacingIdentity = !!this.portalCacheScope;
      this.portalCacheUnsubscribe?.();
      this.clearRouteCache();
      if (replacingIdentity && this.view) this.view.innerHTML = '';
      this.portalCacheScope = scope;
      this.portalCacheApi = this.api;
      this.api.setCacheScope?.(scope);
      var self = this;
      this.api.validateCacheIdentity = async function () {
        var verified = await self.api.requestUncached('/client/v1/dashboard', { cache: 'no-store' });
        return samePortalIdentity(verified, self.store.context);
      };
      this.portalCacheUnsubscribe = this.api.addCacheInvalidationListener?.(function (prefixes) {
        if (!prefixes) { self.clearRouteCache(); if (self.api?.locked) self.renderError({ status: 401, code: 'AUTHENTICATION_REQUIRED' }); return; }
        var sections = [];
        prefixes.forEach(function (prefix) {
          if (/\/orders(?:\/|$)/.test(prefix)) sections.push('dashboard', 'orders');
          if (/\/account(?:\/|$)/.test(prefix)) sections.push('account');
          if (/\/inventory(?:\/|$)/.test(prefix) || prefix === '/client/v1/account') sections.push('stock');
        });
        self.invalidateRouteCache(sections);
      });
    }
  };
  PortalV1App.prototype.rememberRoute = function (state, store, loadedAt) {
    if (!cacheRouteAllowed(this, state)) return;
    this.portalRouteCache ||= new Map();
    this.portalRouteCache.delete(state.canonicalHash);
    this.portalRouteCache.set(state.canonicalHash, { section: state.section, data: routeCacheData(store, state.section), loadedAt: loadedAt });
    while (this.portalRouteCache.size > 30) this.portalRouteCache.delete(this.portalRouteCache.keys().next().value);
  };
  PortalV1App.prototype.createRouteLoader = function (state, refresh) {
    var app = Object.create(this), owner = this;
    app.store = structuredClone(this.store);
    app.store.route = state.section; app.store.routeState = state;
    app.applyNotificationBadge = function () {};
    app.portalBackgroundRefresh = refresh === true;
    // Refresh all previously loaded order pages, rather than collapsing a paged list.
    var wantedOrders = state.section === 'orders' && !state.isDetail ? app.store.ordersV1?.items?.length || 0 : 0;
    if (refresh && this.api?.request) {
      app.api = Object.create(this.api);
      app.api.request = async function (path, options) {
        var result = await owner.api.request(path, Object.assign({}, options, { cache: 'reload' }));
        if (!/^\/client\/v1\/orders\?limit=20$/.test(path) || wantedOrders <= (result.items?.length || 0)) return result;
        var items = result.items.slice(), cursor = result.next_cursor, visited = new Set(), ids = new Set(items.map(function (item) { return item.id; }));
        for (var page = 1; cursor && items.length < wantedOrders && page < 20; page++) {
          if (visited.has(cursor)) throw { status: 503, code: 'PORTAL_RESPONSE_INVALID' };
          visited.add(cursor);
          var next = await owner.api.request(path + '&cursor=' + encodeURIComponent(cursor), { cache: 'reload' });
          if (!Array.isArray(next.items)) throw { status: 503, code: 'PORTAL_RESPONSE_INVALID' };
          next.items.forEach(function (item) { if (!ids.has(item.id)) { ids.add(item.id); items.push(item); } });
          cursor = next.next_cursor;
        }
        return Object.assign({}, result, { items: items, next_cursor: cursor });
      };
    }
    return app;
  };
  PortalV1App.prototype.preloadPortalRoutes = function () {
    if (this.portalPreloaded || !cacheRouteAllowed(this, this.store.routeState)) return;
    this.portalPreloaded = true;
    var self = this, scope = this.portalCacheScope, revision = this.portalCacheRevision;
    var paths = ['#dashboard', '#orders', '#account/personal', '#account/invoices', '#stock'];
    var run = async function () {
      await Promise.all(paths.map(async function (path) {
        if (self.api?.locked || self.portalCacheScope !== scope || self.portalCacheRevision !== revision) return;
        var state = parsePortalRoute(path);
        if (!cacheRouteAllowed(self, state) || self.portalRouteCache?.has(state.canonicalHash)) return;
        var app = self.createRouteLoader(state, false), sectionVersion = self.portalRouteVersions?.get(state.section) || 0;
        try {
          await app.loadRoute(state.section);
          if (self.api?.locked || self.portalCacheScope !== scope || self.portalCacheRevision !== revision) return;
          if ((self.portalRouteVersions?.get(state.section) || 0) === sectionVersion) self.rememberRoute(state, app.store, Date.now());
        } catch (error) { if (self.api?.locked || [401, 403, 423].includes(error?.status)) { if (self.portalCacheScope === scope) self.renderError(error); return; } }
      }));
    };
    if (window.requestIdleCallback) window.requestIdleCallback(function () { void run(); }, { timeout: 500 });
    else window.setTimeout?.(function () { void run(); }, 0);
  };

  PortalV1App.prototype.navigate = async function (route) {
    var self = this;
    var navigationSequence = (this.navigationSequence || 0) + 1;
    this.navigationSequence = navigationSequence;
    window.TodayMerchPortalAccount?.captureDrafts?.(this);
    this.prepareRouteCache();
    if (this.api?.getAccessToken && this.api?.validateCachedAccess) {
      try {
        if (!await this.api.validateCachedAccess()) { await this.bootstrap(); return; }
      } catch (error) { this.renderError(error); return; }
      if (this.navigationSequence !== navigationSequence || this.api?.locked) return;
    }
    this.scrollPositions = this.scrollPositions || new Map();
    if (this.store.routeState?.canonicalHash) this.scrollPositions.set(this.store.routeState.canonicalHash, window.scrollY || 0);
    if (this.portalDisplayedRoute && this.portalDisplayedRoute.canonicalHash === this.store.routeState?.canonicalHash) {
      this.rememberRoute(this.store.routeState, this.store, this.portalDisplayedRoute.loadedAt);
    }
    var routeState = route && typeof route === 'object' ? route : parsePortalRoute('#' + String(route || ''));
    if (!routeState.valid) {
      routeState = fallbackPortalRoute(false);
      if (window.location.hash !== routeState.canonicalHash) window.history?.replaceState?.(null, '', window.location.pathname + window.location.search + routeState.canonicalHash);
    }
    var section = PORTAL_ROUTES.includes(routeState.section) ? routeState.section : 'dashboard';
    if (section === 'catalogue') { window.location.replace(this.catalogueUrl()); return; }
    var cached = cacheRouteAllowed(this, routeState) ? this.portalRouteCache?.get(routeState.canonicalHash) : null;
    this.store.route = section;
    this.store.routeState = routeState;
    this.setMobileNavigationOpen(false);
    this.syncNavigationCurrent(section);
    this.renderContextNavigation(routeState);
    var finishView = function (focus) {
      if (focus) self.view?.querySelector('[data-portal-route-heading]')?.focus({ preventScroll: true });
      window.requestAnimationFrame(function () {
        if (self.navigationSequence !== navigationSequence) return;
        window.scrollTo?.({ top: self.scrollPositions.get(routeState.canonicalHash) || 0, behavior: 'instant' });
      });
    };
    if (cached && !this.api?.locked) {
      applyRouteCacheData(this.store, section, cached.data);
      this.store.ui.moduleUnavailable = null;
      this.renderRoute(section);
      this.setRequest(false);
      this.portalDisplayedRoute = { canonicalHash: routeState.canonicalHash, section: section, loadedAt: cached.loadedAt };
      finishView(true);
      window.TodayMerchProjectPortal?.refreshAfterRender?.(this, routeState);
      if (Date.now() - cached.loadedAt < PORTAL_ROUTE_CACHE_TTL) { this.preloadPortalRoutes(); return; }
      this.view?.setAttribute('data-portal-refreshing', '');
    } else this.setRequest(true);
    var revision = this.portalCacheRevision, sectionVersion = this.portalRouteVersions?.get(section) || 0;
    try {
      if (this.root.dataset.portalMode === 'orders' && ['campaigns', 'beneficiaries', 'integrations'].includes(section) && this.root.dataset.portalModuleManifest) {
        if (!window.TodayMerchPortalModules?.ensure) throw { code: 'PORTAL_MODULE_UNAVAILABLE' };
        await window.TodayMerchPortalModules.ensure(this, routeState);
        if (this.navigationSequence !== navigationSequence || this.api?.locked) return;
        if (this.portalCacheRevision !== revision) return;
      }
      var routeApp = this.createRouteLoader(routeState, !!cached);
      await routeApp.loadRoute(section);
      if (this.navigationSequence !== navigationSequence || this.api?.locked) return;
      if (this.portalCacheRevision !== revision || (this.portalRouteVersions?.get(section) || 0) !== sectionVersion) {
        if (!cached) await this.navigate(routeState);
        return;
      }
      if (cached && section === 'account' && window.TodayMerchPortalAccount?.shouldDeferRefresh?.(this)) return;
      // Filters can change while the refresh is in flight. Canonical data comes
      // from the response; current interaction state stays with the visible view.
      if (cached && section === 'orders' && this.store.ordersV1 && routeApp.store.ordersV1) {
        Object.keys(this.store.ordersV1).filter(function (key) { return !['items', 'detail', 'nextCursor', 'loadingMore', 'moreError'].includes(key); }).forEach(function (key) { routeApp.store.ordersV1[key] = structuredClone(self.store.ordersV1[key]); });
      }
      if (cached && section === 'stock' && this.store.inventoryPage) routeApp.store.inventoryPage = structuredClone(this.store.inventoryPage);
      var unchanged = cached && JSON.stringify(routeCacheData(this.store, section)) === JSON.stringify(routeCacheData(routeApp.store, section));
      var active = cached ? document.activeElement : null;
      var focusName = active && this.view?.contains?.(active) ? active.id || active.getAttribute?.('name') : null;
      var focusSelection = focusName && typeof active.selectionStart === 'number' ? [active.selectionStart, active.selectionEnd] : null;
      if (cacheRouteAllowed(this, routeState)) {
        applyRouteCacheData(this.store, section, routeCacheData(routeApp.store, section));
        this.store.ui.moduleUnavailable = routeApp.store.ui.moduleUnavailable;
      } else this.store = routeApp.store;
      this.rememberRoute(routeState, this.store, Date.now());
      this.portalDisplayedRoute = { canonicalHash: routeState.canonicalHash, section: section, loadedAt: Date.now() };
      if (!unchanged) {
        this.renderRoute(section);
        if (focusName) {
          var replacement = Array.from(this.view?.querySelectorAll?.('[id], [name]') || []).find(function (node) { return node.id === focusName || node.getAttribute('name') === focusName; });
          replacement?.focus?.({ preventScroll: true });
          if (focusSelection) replacement?.setSelectionRange?.(focusSelection[0], focusSelection[1]);
        }
      }
      this.applyNotificationBadge(this.store.resources.notifications);
      if (!cached) finishView(true);
      this.setRequest(false);
      window.TodayMerchProjectPortal?.refreshAfterRender?.(this, routeState);
      this.preloadPortalRoutes();
    } catch (error) {
      if (this.navigationSequence !== navigationSequence && !this.api?.locked) return;
      if (cached && !this.api?.locked && ![401, 403, 423].includes(error?.status)) {
        this.setRequest(false, error);
        if (!this.view?.querySelector('[data-portal-refresh-error]')) this.view?.insertAdjacentHTML?.('beforeend', '<p role="status" data-portal-refresh-error>La mise à jour est indisponible. Les dernières informations restent affichées. <button type="button" data-portal-retry>Réessayer</button></p>');
      } else { this.renderError(error); this.setRequest(false, error); }
    } finally {
      if (this.navigationSequence === navigationSequence) this.view?.removeAttribute?.('data-portal-refreshing');
    }
  };

  PortalV1App.prototype.renderContextNavigation = function (route) {
    if (!this.subnavigation || !this.contextTabs) return;
    if (route.section === 'integrations') {
      this.subnavigation.hidden = true;
      this.contextTabs.innerHTML = '';
      return;
    }
    var tabs = contextTabsForRoute(route);
    this.subnavigation.hidden = ['dashboard', 'stock'].includes(route.section) || tabs.length < 2;
    if (route.resourceId) this.subnavigation.setAttribute('data-resource-id', route.resourceId);
    else this.subnavigation.removeAttribute('data-resource-id');
    this.contextTabs.innerHTML = tabs.map(function (tab) {
      return '<a href="' + escapeHtml(tab.hash) + '" data-portal-context-tab="' + escapeHtml(tab.id) + '"'
        + (tab.current ? ' aria-current="page"' : '') + '>' + escapeHtml(this.t(tab.labelKey, tab.labelKey)) + '</a>';
    }, this).join('');
    var current = this.contextTabs.querySelector('[aria-current="page"]');
    current?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
  };

  PortalV1App.prototype.loadRoute = async function (route) {
    var self = this;
    if (['migration_locked', 'legacy_readonly'].includes(this.store.context.backend_mode)) return;
    var productCapability = productCapabilityForRoute(route);
    if (this.store.context.product_capabilities?.[productCapability] !== true) {
      this.store.ui.moduleUnavailable = productCapability;
      return;
    }
    this.store.ui.moduleUnavailable = null;
    if (route === 'catalogue') return;
    async function list(path) { return (await self.api.listAll('/client/v1/' + path)).items; }
    if (route === 'dashboard') {
      var productCapabilities = this.store.context.product_capabilities;
      var values = await Promise.all([
        productCapabilities.campaign_proof ? list('projects') : [],
        productCapabilities.campaign_proof ? list('proofs') : [],
        productCapabilities.operations ? list('inventory') : [],
        productCapabilities.operations ? list('shipments') : [],
        productCapabilities.enterprise ? list('notifications') : [],
        productCapabilities.enterprise ? list('documents') : [],
      ]);
      values[1] = values[1].map(normalizeProofResource);
      values[2] = values[2].map(normalizeInventoryResource);
      values[3] = values[3].map(normalizeShipmentSummary);
      values[4] = values[4].map(normalizeSafeNotification);
      values[5] = values[5].map(normalizeDocumentResource);
      var recentProjects = recentDashboardProjects(values[0]);
      var recentDetails = await Promise.all(recentProjects.map(async function (project) {
        try {
          var detail = projectDossierModel(await self.api.request('/client/v1/projects/' + encodeURIComponent(project.id)));
          return detail.id === project.id ? detail : project;
        } catch (error) {
          if (self.api.locked || error?.status === 401) throw error;
          return project;
        }
      }));
      values[0] = values[0].map(function (project) {
        return recentDetails.find(function (detail) { return detail.id === project.id; }) || project;
      });
      ['projects', 'proofs', 'inventory', 'shipments', 'notifications', 'documents'].forEach(function (key, index) { self.store.resources[key] = values[index]; });
      this.applyNotificationBadge(this.store.resources.notifications);
      return;
    }
    if (route === 'campaigns') {
      if (window.TodayMerchPortalCampaignTypes?.isLanding?.(this)) return;
      var owners = await this.api.listAll('/client/v1/members');
      this.store.campaignOwners = owners.items.filter(function (member) {
        return member?.active !== false && safePortalResourceId(member?.id);
      }).map(function (member) { return { ...member, display_name: portalMemberLabel(member) }; });
      if (this.store.routeState?.isDetail) {
        var campaignId = this.store.routeState.resourceId;
        var campaignValues = await Promise.all([
          this.api.request('/client/v1/campaigns/' + campaignId),
          this.api.request('/client/v1/campaigns/' + campaignId + '/audience'),
          this.api.listAll('/client/v1/campaigns/' + campaignId + '/projects'),
          this.api.request('/client/v1/campaigns/' + campaignId + '/redemptions'),
          this.api.request('/client/v1/campaigns/' + campaignId + '/performance')
        ]);
        this.store.campaignDetail = normalizeCampaignResource(campaignValues[0]);
        this.store.campaignDetail.audience = campaignValues[1];
        this.store.campaignDetail.projects = campaignValues[2].items;
        this.store.campaignDetail.redemptions = campaignValues[3];
        this.store.campaignDetail.performance = campaignValues[4];
      } else this.store.resources.campaigns = (await list('campaigns')).map(normalizeCampaignResource);
      return;
    }
    if (route === 'projects') {
      if (this.store.routeState?.isDetail) {
        this.store.projectDetail = projectDossierModel(await this.api.request('/client/v1/projects/' + this.store.routeState.resourceId));
        this.store.projectDocuments = this.store.context.product_capabilities?.enterprise
          ? (await list('documents?project_id=' + encodeURIComponent(this.store.projectDetail.id))).map(normalizeDocumentResource)
            .filter(function (item) { return item.project?.id === self.store.projectDetail.id; }) : [];
      }
      else this.store.resources.projects = await list('projects');
    }
    if (route === 'proofs') {
      if (this.store.routeState?.isDetail) {
        var proofId = this.store.routeState.resourceId;
        var previousProofId = this.store.proofDetail?.id || null;
        var base = '/client/v1/proofs/' + encodeURIComponent(proofId);
        var detail = normalizeProofResource(await this.api.request(base));
        if (!detail || detail.id !== proofId || !detail.current_version_id) throw new TypeError('Invalid canonical proof detail');
        var proofPages = await Promise.all([
          this.api.listAll(base + '/versions'),
          this.api.listAll(base + '/decisions'),
          this.api.listAll(base + '/versions/' + encodeURIComponent(detail.current_version_id) + '/annotations')
        ]);
        this.store.proofDetail = detail;
        if (previousProofId !== proofId) {
          this.store.proofSelectedPage = 1;
          this.store.proofPageAnnouncement = this.t('proof_studio.page_announcement', undefined, { page: 1 });
        }
        this.store.proofVersions = normalizeProofVersionPage(proofPages[0], proofId).items;
        this.store.proofDecisions = normalizeProofDecisionPage(proofPages[1], proofId).items;
        this.store.proofAnnotations = normalizeProofAnnotationPage(proofPages[2], proofId, detail.current_version_id, detail.current_version?.sha256).items;
        this.store.proofPreviewUrls = Object.fromEntries(Object.entries(this.store.proofPreviewUrls || {}).filter(function (entry) {
          return self.store.proofVersions.some(function (version) { return version.id === entry[0]; });
        }));
        if (!this.store.proofComparison || this.store.proofComparison.left?.proof_id !== proofId) {
          this.store.proofComparison = this.store.proofVersions.length > 1
            ? buildProofComparison(this.store.proofVersions, this.store.proofVersions[0].id, this.store.proofVersions[1].id) : null;
        }
      } else {
        this.store.resources.proofs = (await list('proofs')).map(normalizeProofResource);
        this.store.proofDetail = null;
      }
    }
    if (route === 'stock') {
      this.store.inventoryView = this.store.routeState?.tab || 'inventory';
      this.store.inventoryLoadingMore = false;
      this.store.inventoryLoadMoreError = false;
      var inventoryValues = await Promise.all([this.api.listAll('/client/v1/inventory'), this.api.listAll('/client/v1/inventory/reorders')]);
      this.store.resources.inventory = inventoryValues[0].items.map(normalizeInventoryResource);
      this.store.inventoryNextCursor = inventoryValues[0].next_cursor;
      this.store.inventoryReorders = inventoryValues[1].items.map(normalizeInventoryReorder);
      this.store.inventoryReordersNextCursor = inventoryValues[1].next_cursor;
    }
    if (route === 'shipments') {
      if (this.store.routeState?.isDetail) {
        this.store.activeShipment = await this.readShipment(this.store.routeState.resourceId);
        return;
      }
      if (this.loadDeliveryList && await this.loadDeliveryList()) return;
      var shipmentValues = await Promise.all([list('shipments'), list('inventory')]);
      this.store.resources.shipments = shipmentValues[0].map(normalizeShipmentSummary);
      this.store.resources.inventory = shipmentValues[1].map(normalizeInventoryResource);
    }
    if (route === 'documents') {
      if (this.store.routeState?.isDetail) {
        var documentId = this.store.routeState.resourceId;
        var documentBase = '/client/v1/documents/' + encodeURIComponent(documentId);
        var documentValues = await Promise.all([
          this.api.request(documentBase), this.api.listAll(documentBase + '/versions'), this.api.listAll(documentBase + '/decisions')
        ]);
        this.store.documentDetail = normalizeDocumentResource(documentValues[0]);
        if (this.store.documentDetail.id !== documentId) throw new TypeError('Invalid canonical document');
        this.store.documentVersions = documentValues[1].items.map(function (item) { return normalizeDocumentVersion(item, documentId); });
        this.store.documentDecisions = documentValues[2].items.map(function (item) { return normalizeDocumentDecision(item, documentId); });
      } else this.store.resources.documents = (await list('documents')).map(normalizeDocumentResource);
    }
    if (route === 'team') {
      var teamValues = await Promise.all([
        this.api.listAll('/client/v1/members'), this.api.listAll('/client/v1/approval-rules'),
        this.api.listAll('/client/v1/member-scopes'), this.api.listAll('/client/v1/budget-caps'),
        this.api.listAll('/client/v1/approval-decisions')
      ]);
      var team = teamValues[0];
      this.store.resources.team = team.items;
      this.store.resources.team.members = team.items;
      this.store.resources.team.approvalRules = teamValues[1].items;
      this.store.resources.team.memberScopes = teamValues[2].items;
      this.store.resources.team.budgetCaps = teamValues[3].items;
      this.store.resources.team.approvalDecisions = teamValues[4].items;
      this.store.companyResource = await this.api.request('/client/v1/company');
      if (this.store.context.capabilities.manage_invitations === true) {
        this.store.invitations = (await this.api.listAll('/client/v1/invitations')).items;
      } else this.store.invitations = [];
    }
  };

  PortalV1App.prototype.renderRoute = function (route) {
    if (!this.view) return;
    if (['migration_locked', 'legacy_readonly'].includes(this.store.context.backend_mode)) {
      this.view.innerHTML = this.renderPortalMode();
      return;
    }
    if (this.store.ui.moduleUnavailable) {
      this.view.innerHTML = this.renderModuleUnavailable(route);
      return;
    }
    if (route === 'dashboard') this.view.innerHTML = this.renderDashboard();
    if (route === 'campaigns') this.view.innerHTML = this.renderCampaigns();
    if (route === 'projects') this.view.innerHTML = this.renderProjects();
    if (route === 'proofs') this.view.innerHTML = this.renderProofs();
    if (route === 'stock') this.view.innerHTML = this.renderInventory();
    if (route === 'shipments') this.view.innerHTML = this.renderShipments();
    if (route === 'documents') this.view.innerHTML = this.renderDocuments();
    if (route === 'team') this.view.innerHTML = this.renderTeam();
  };

  PortalV1App.prototype.renderModuleUnavailable = function (route) {
    return this.heading('page.' + route, route)
      + '<section class="portal-v1__section portal-v1__mode" role="status" data-portal-module-unavailable="'
      + escapeHtml(this.store.ui.moduleUnavailable) + '"><h2>'
      + escapeHtml(this.t('module.unavailable_title', 'Module indisponible')) + '</h2><p>'
      + escapeHtml(this.t('module.unavailable_body', 'Ce module n’est pas activé pour votre entreprise.'))
      + '</p></section>';
  };

  PortalV1App.prototype.renderCampaigns = function () {
    var self = this;
    var route = this.store.routeState || {};
    var editor = this.store.campaignEditor;
    if (route.isDetail && this.store.campaignDetail) {
      var campaign = this.store.campaignDetail;
      var tab = route.tab || 'overview';
      var money = formatMinor(campaign.budget_minor, campaign.currency, this.store.context.locale);
      var actions = campaign.allowed_actions.filter(function (action) { return action.startsWith('transition_'); }).map(function (action) {
        return '<button type="button" data-campaign-action="' + escapeHtml(action) + '">' + escapeHtml(action.replace(/^transition_/, '').replace('_', ' ')) + '</button>';
      }).join('');
      if (campaign.allowed_actions.includes('update')) {
        actions = '<button type="button" data-campaign-edit="' + escapeHtml(campaign.id) + '">'
          + escapeHtml(this.t('campaign.edit', 'Modifier la campagne')) + '</button>' + actions;
      }
      var content = '';
      if (tab === 'overview') content = '<div class="portal-v1__dossier-grid"><section><h2>' + escapeHtml(this.t('campaign.objective', 'Objectif')) + '</h2><p>' + escapeHtml(campaign.objective) + '</p><h3>' + escapeHtml(this.t('campaign.owner', 'Responsable')) + '</h3><p>' + escapeHtml(campaign.owner.display_name) + '</p></section><section><h2>' + escapeHtml(this.t('campaign.planning')) + '</h2><dl><div><dt>' + escapeHtml(this.t('campaign.start_short')) + '</dt><dd>' + escapeHtml(formatDate(campaign.starts_at, self.store.context.locale) || '—') + '</dd></div><div><dt>' + escapeHtml(this.t('campaign.end_short')) + '</dt><dd>' + escapeHtml(formatDate(campaign.ends_at, self.store.context.locale) || '—') + '</dd></div></dl></section></div>';
      if (tab === 'audience') content = '<section><h2>' + escapeHtml(this.t('tab.audience')) + '</h2><div class="portal-v1__metric-strip"><span><strong>' + escapeHtml(campaign.audience?.recipient_count || 0) + '</strong> ' + escapeHtml(this.t('campaign.recipients_label')) + '</span><span><strong>' + escapeHtml(campaign.audience?.eligible_count || 0) + '</strong> ' + escapeHtml(this.t('campaign.eligible_label')) + '</span><span><strong>' + escapeHtml(campaign.audience?.excluded_count || 0) + '</strong> ' + escapeHtml(this.t('campaign.excluded_label')) + '</span></div></section>';
      if (tab === 'projects') content = '<section><h2>' + escapeHtml(this.t('tab.projects_products')) + '</h2><div class="portal-v1__list">' + (campaign.projects || []).map(function (project) { return '<article><h3><a href="#projects/' + escapeHtml(project.id) + '/overview">' + escapeHtml(project.title) + '</a></h3><p>' + escapeHtml(project.stage) + '</p></article>'; }).join('') + '</div></section>';
      if (tab === 'distribution') content = '<section><h2>' + escapeHtml(this.t('tab.distribution')) + '</h2><p>' + escapeHtml(this.t('campaign.mode_label')) + ' : <strong>' + escapeHtml(campaign.distribution_mode) + '</strong></p><p>' + escapeHtml(this.t('campaign.activations', undefined, { redeemed: campaign.redemptions?.redeemed_count || 0, issued: campaign.redemptions?.issued_count || 0 })) + '</p></section>';
      if (tab === 'budget') content = '<section><h2>' + escapeHtml(this.t('tab.budget')) + '</h2><p class="portal-v1__big-number">' + escapeHtml(money) + '</p></section>';
      if (tab === 'performance') content = '<section><h2>' + escapeHtml(this.t('tab.performance')) + '</h2><dl class="portal-v1__facts"><div><dt>' + escapeHtml(this.t('page.projects', 'Projets')) + '</dt><dd>' + escapeHtml(campaign.performance?.project_count || 0) + '</dd></div><div><dt>' + escapeHtml(this.t('campaign.products')) + '</dt><dd>' + escapeHtml(campaign.performance?.product_quantity || 0) + '</dd></div><div><dt>' + escapeHtml(this.t('campaign.deliveries')) + '</dt><dd>' + escapeHtml(campaign.performance?.delivered_count || 0) + '</dd></div></dl></section>';
      return '<header class="portal-v1__page-heading"><div><a href="#campaigns/all">' + escapeHtml(this.t('campaign.back')) + '</a><h1 tabindex="-1" data-portal-route-heading>' + escapeHtml(campaign.name) + '</h1><p><span class="portal-v1__status-pill">' + escapeHtml(campaign.status) + '</span> · ' + escapeHtml(money) + '</p></div><div class="portal-v1__actions">' + actions + '</div></header><div class="portal-v1__dossier" data-campaign-detail="' + escapeHtml(campaign.id) + '">' + content + '</div>' + this.renderCampaignDialog(editor);
    }
    var items = this.store.resources.campaigns;
    if (route.tab === 'calendar') {
      return this.heading('page.campaigns', 'Calendrier des campagnes') + '<ol class="portal-v1__calendar">' + campaignCalendarModel(items).map(function (item) { return '<li><time>' + escapeHtml(formatDate(item.starts_at || item.ends_at, self.store.context.locale)) + '</time><a href="' + escapeHtml(item.deep_link) + '"><strong>' + escapeHtml(item.name) + '</strong><span>' + escapeHtml(item.status) + '</span></a></li>'; }).join('') + '</ol>';
    }
    var createAction = this.store.context.capabilities.campaigns_create === true
      ? '<button type="button" class="is-primary" data-campaign-create>' + escapeHtml(this.t('campaign.create', 'Créer une campagne')) + '</button>' : '';
    return '<header class="portal-v1__page-heading"><div><h1 tabindex="-1" data-portal-route-heading>'
      + escapeHtml(this.t('page.campaigns', 'Campagnes')) + '</h1><p>'
      + escapeHtml(this.t('campaign.intro', 'Planifiez, pilotez et mesurez chaque programme merch.'))
      + '</p></div><div class="portal-v1__actions">' + createAction + '</div></header>'
      + '<div class="portal-v1__campaign-grid">' + (items.length ? items.map(function (item) {
        return '<article data-campaign="' + escapeHtml(item.id) + '"><div><span class="portal-v1__status-pill">' + escapeHtml(item.status) + '</span><h2><a href="#campaigns/' + escapeHtml(item.id) + '/overview">' + escapeHtml(item.name) + '</a></h2><p>' + escapeHtml(item.objective) + '</p></div><dl><div><dt>' + escapeHtml(self.t('page.projects', 'Projets')) + '</dt><dd>' + item.project_count + '</dd></div><div><dt>' + escapeHtml(self.t('tab.audience')) + '</dt><dd>' + item.audience_count + '</dd></div><div><dt>' + escapeHtml(self.t('tab.budget')) + '</dt><dd>' + escapeHtml(formatMinor(item.budget_minor, item.currency, self.store.context.locale)) + '</dd></div></dl></article>';
      }).join('') : '<p class="portal-v1__empty">' + escapeHtml(this.t('campaign.empty', 'Aucune campagne.')) + '</p>') + '</div>'
      + this.renderCampaignDialog(editor);
  };

  PortalV1App.prototype.renderCampaignDialog = function (campaign) {
    var editing = campaign && campaign !== 'create';
    var owners = this.store.campaignOwners.slice();
    if (editing && !owners.some(function (owner) { return owner.id === campaign.owner.id; })) {
      owners.push({ id: campaign.owner.id, display_name: campaign.owner.display_name });
    }
    var ownerOptions = owners.map(function (owner) {
      return '<option value="' + escapeHtml(owner.id) + '"' + (editing && owner.id === campaign.owner.id ? ' selected' : '') + '>'
        + escapeHtml(owner.display_name) + '</option>';
    }).join('');
    return '<dialog class="portal-v1__dialog portal-v1__campaign-dialog" data-portal-campaign-dialog aria-labelledby="PortalCampaignDialogTitle">'
      + '<form class="portal-v1__dialog-form portal-v1__campaign-form" data-portal-campaign-form novalidate><header><h2 id="PortalCampaignDialogTitle">'
      + escapeHtml(this.t(editing ? 'campaign.edit' : 'campaign.create', editing ? 'Modifier la campagne' : 'Créer une campagne'))
      + '</h2><button type="button" data-campaign-close aria-label="' + escapeHtml(this.t('stock.close', 'Fermer')) + '">×</button></header>'
      + '<label><span>' + escapeHtml(this.t('campaign.name', 'Nom')) + '</span><input name="name" maxlength="200" required value="' + escapeHtml(editing ? campaign.name : '') + '"></label>'
      + '<label><span>' + escapeHtml(this.t('campaign.objective', 'Objectif')) + '</span><textarea name="objective" maxlength="1200" required>' + escapeHtml(editing ? campaign.objective : '') + '</textarea></label>'
      + '<label><span>' + escapeHtml(this.t('campaign.owner', 'Responsable')) + '</span><select name="owner_id" required><option value="">—</option>' + ownerOptions + '</select></label>'
      + '<div class="portal-v1__form-grid"><label><span>' + escapeHtml(this.t('campaign.starts_at', 'Date de début')) + '</span><input type="date" name="starts_at" required value="' + escapeHtml(editing ? String(campaign.starts_at || '').slice(0, 10) : '') + '"></label>'
      + '<label><span>' + escapeHtml(this.t('campaign.ends_at', 'Date de fin')) + '</span><input type="date" name="ends_at" required value="' + escapeHtml(editing ? String(campaign.ends_at || '').slice(0, 10) : '') + '"></label></div>'
      + '<div class="portal-v1__form-grid"><label><span>' + escapeHtml(this.t('campaign.budget_minor', 'Budget en unités mineures')) + '</span><input type="number" name="budget_minor" min="0" step="1" required value="' + escapeHtml(editing ? campaign.budget_minor : 0) + '"></label>'
      + '<label><span>' + escapeHtml(this.t('campaign.currency', 'Devise')) + '</span><select name="currency"><option value="EUR"' + (editing && campaign.currency === 'EUR' ? ' selected' : '') + '>EUR</option><option value="USD"' + (editing && campaign.currency === 'USD' ? ' selected' : '') + '>USD</option><option value="GBP"' + (editing && campaign.currency === 'GBP' ? ' selected' : '') + '>GBP</option></select></label></div>'
      + '<label><span>' + escapeHtml(this.t('campaign.distribution_mode', 'Mode de distribution')) + '</span><select name="distribution_mode"><option value="bulk"' + (editing && campaign.distribution_mode === 'bulk' ? ' selected' : '') + '>bulk</option><option value="redemption"' + (editing && campaign.distribution_mode === 'redemption' ? ' selected' : '') + '>redemption</option><option value="mixed"' + (editing && campaign.distribution_mode === 'mixed' ? ' selected' : '') + '>mixed</option></select></label>'
      + '<p role="alert" data-campaign-error></p><div class="portal-v1__dialog-actions"><button type="button" data-campaign-close>'
      + escapeHtml(this.t('action.cancel', 'Annuler')) + '</button><button type="submit" class="is-primary">'
      + escapeHtml(this.t('campaign.save', 'Enregistrer')) + '</button></div></form></dialog>';
  };

  PortalV1App.prototype.closeCampaignEditor = function () {
    var trigger = this.campaignTrigger;
    var dialog = this.view?.querySelector('[data-portal-campaign-dialog]');
    if (dialog?.open) dialog.close();
    this.store.campaignEditor = null;
    this.renderRoute('campaigns');
    var view = this.view;
    window.requestAnimationFrame(function () {
      var selector = trigger?.kind === 'edit' && safePortalResourceId(trigger.id)
        ? '[data-campaign-edit="' + CSS.escape(trigger.id) + '"]'
        : '[data-campaign-create]';
      view?.querySelector(selector)?.focus({ preventScroll: true });
    });
    this.campaignTrigger = null;
  };

  PortalV1App.prototype.heading = function (key, fallback, description) {
    return '<header class="portal-v1__page-heading"><div><h1 tabindex="-1" data-portal-route-heading>'
      + escapeHtml(this.t(key, fallback)) + '</h1>' + (description ? '<p>' + escapeHtml(description) + '</p>' : '') + '</div></header>';
  };

  PortalV1App.prototype.renderPortalMode = function () {
    var mode = this.store.context.portal_mode || normalizePortalMode({
      backend_mode: this.store.context.backend_mode,
      summary: this.store.summary,
    });
    if (mode.mode === 'migration_locked') {
      return this.heading('portal_mode.migration_title', 'Migration en cours')
        + '<section class="portal-v1__section portal-v1__mode" role="status"><p>'
        + escapeHtml(this.t('portal_mode.migration_body', 'Les modifications sont temporairement indisponibles.'))
        + '</p></section>';
    }
    var evidence = '<p class="portal-v1__warning">'
      + escapeHtml(this.t('portal_mode.snapshot_unverifiable', 'Instantané non vérifiable')) + '</p>';
    if (mode.snapshot_verifiable && mode.snapshot) {
      var locale = this.store.context.locale || undefined;
      var date;
      try {
        date = new Intl.DateTimeFormat(locale, { dateStyle: 'long', timeStyle: 'short' }).format(new Date(mode.snapshot.at));
      } catch (error) { date = mode.snapshot.at; }
      var ageSeconds = mode.snapshot.age_seconds;
      var ageKey = ageSeconds < 3600 ? 'portal_mode.age_minutes' : ageSeconds < 86400 ? 'portal_mode.age_hours' : 'portal_mode.age_days';
      var ageValue = ageSeconds < 3600 ? Math.floor(ageSeconds / 60) : ageSeconds < 86400
        ? Math.floor(ageSeconds / 3600) : Math.floor(ageSeconds / 86400);
      var ageFallback = ageKey.endsWith('minutes') ? '{{count}} min' : ageKey.endsWith('hours') ? '{{count}} h' : '{{count}} j';
      evidence = '<dl class="portal-v1__mode-evidence"><div><dt>'
        + escapeHtml(this.t('portal_mode.snapshot_at_label', 'Instantané')) + '</dt><dd>'
        + escapeHtml(this.t('portal_mode.snapshot_at', 'Snapshot finalisé le {{date}}', { date: date })) + '</dd></div><div><dt>'
        + escapeHtml(this.t('portal_mode.snapshot_age_label', 'Ancienneté')) + '</dt><dd>'
        + escapeHtml(this.t('portal_mode.snapshot_age', 'Âge : {{age}}', { age: this.t(ageKey, ageFallback, { count: ageValue }) }))
        + '</dd></div><div><dt>' + escapeHtml(this.t('portal_mode.snapshot_hash', 'Empreinte SHA-256')) + '</dt><dd><code>'
        + escapeHtml(mode.snapshot.sha256) + '</code></dd></div></dl>';
    }
    return this.heading('portal_mode.readonly_title', 'Portail en lecture seule')
      + '<section class="portal-v1__section portal-v1__mode" role="status"><p>'
      + escapeHtml(this.t('portal_mode.readonly_body', 'Les modifications sont indisponibles pendant la migration.'))
      + '</p>' + evidence + '</section>';
  };

  PortalV1App.prototype.renderDashboard = function () {
    var model = buildConnectedDashboardModel(this.store.resources);
    var greetingName = safePortalText(this.store.context.actor?.first_name, 120, false)
      || safePortalText(this.root.dataset.customerFirstName, 120, false) || '';
    var now = new Date();
    var dateLabel;
    try {
      dateLabel = new Intl.DateTimeFormat(this.store.context.locale || undefined, { weekday: 'long', day: 'numeric', month: 'short' }).format(now);
    } catch (error) { dateLabel = formatDate(now, this.store.context.locale); }
    var header = '<header class="portal-v1__dashboard-header"><div><time class="portal-v1__dashboard-date" datetime="'
      + now.toISOString() + '">' + escapeHtml(dateLabel) + '</time><h1 tabindex="-1" data-portal-route-heading>'
      + escapeHtml(this.t('dashboard.greeting_simple', undefined, { name: greetingName }).trim()) + '</h1></div></header>';
    return '<div class="portal-v1__dashboard portal-v1__dashboard--simple">' + header
      + this.renderDashboardQuickActions() + this.renderDashboardRecentOrders(model.recent_projects) + '</div>';
  };

  PortalV1App.prototype.renderDashboardQuickActions = function () {
    var capabilities = this.store.context.capabilities || {};
    var modules = this.store.context.product_capabilities || {};
    var quoteUrl = this.catalogueUrl();
    var icon = function (path) {
      return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
    };
    var actions = '<a class="portal-v1__dashboard-pill is-primary" data-dashboard-new-project href="' + escapeHtml(quoteUrl) + '">'
      + icon('<path d="M12 5v14M5 12h14"/>') + escapeHtml(this.t('dashboard.new_order')) + '</a>';
    if (modules.campaign_proof === true && capabilities.campaigns_create === true) {
      actions += '<button class="portal-v1__dashboard-pill" type="button" data-dashboard-create-campaign>'
        + icon('<rect x="4" y="5" width="16" height="16" rx="2"/><path d="M16 3v4M8 3v4M4 11h16"/>')
        + escapeHtml(this.t('dashboard.new_campaign')) + '</button>';
    }
    if (modules.operations === true) {
      actions += '<a class="portal-v1__dashboard-pill" href="#stock">'
        + icon('<path d="m12 3 9 5v8l-9 5-9-5V8l9-5ZM3 8l9 5 9-5M12 13v8M7.5 5.5l9 5"/>')
        + escapeHtml(this.t('dashboard.inventory')) + '</a>';
    }
    return '<section class="portal-v1__dashboard-quick-actions" aria-labelledby="PortalDashboardNext"><p id="PortalDashboardNext">'
      + escapeHtml(this.t('dashboard.next_step')) + '</p><div class="portal-v1__dashboard-pills">' + actions + '</div></section>';
  };

  PortalV1App.prototype.renderDashboardRecentOrders = function (projects) {
    var self = this;
    var proofs = this.store.resources.proofs || [];
    var documents = this.store.resources.documents || [];
    var rows = projects.map(function (project) {
      var projectHref = '#projects/' + encodeURIComponent(project.id) + '/overview';
      var products = Array.isArray(project.products) ? project.products : [];
      var image = products.map(function (product) { return safeDashboardUrl(product?.image_url); }).find(Boolean) || '';
      var quantity = products.length && products.every(function (product) { return Number.isSafeInteger(product?.quantity) && product.quantity > 0; })
        ? products.reduce(function (sum, product) { return sum + product.quantity; }, 0) : null;
      if (!Number.isSafeInteger(quantity)) quantity = null;
      var quote = documents.find(function (document) {
        return document.project?.id === project.id && safePortalResourceId(document.id) && document.document_kind === 'quote'
          && document.status === 'published' && canAction(document, 'decide') && ['admin', 'approver'].includes(self.store.context.actor?.role);
      });
      var proof = proofs.find(function (proof) { return proof.project_id === project.id && safePortalResourceId(proof.id) && canAction(proof, 'decide'); });
      var status = ['completed', 'cancelled', 'archived'].includes(project.status) || !project.stage
        ? self.backendLabel('project', project.status) : self.t('stage.' + project.stage);
      var actionHref = '';
      var actionLabel = '';
      if (quote) {
        status = self.t('dashboard.quote_pending');
        actionHref = '#documents/' + encodeURIComponent(quote.id) + '/overview';
        actionLabel = self.t('dashboard.review_quote');
      } else if (proof) {
        status = self.t('dashboard.proof_pending');
        actionHref = '#proofs/' + encodeURIComponent(proof.id) + '/review';
        actionLabel = self.t('dashboard.review_proof');
      }
      var dateValue = project.updated_at || project.created_at;
      var date = dateValue && Number.isFinite(Date.parse(dateValue)) ? '<time class="portal-v1__order-date" datetime="'
        + escapeHtml(dateValue) + '">' + escapeHtml(formatDate(dateValue, self.store.context.locale)) + '</time>' : '';
      var thumbnail = '<span class="portal-v1__order-thumbnail' + (image ? '' : ' portal-v1__order-thumbnail--empty') + '" aria-hidden="true">'
        + (image ? '<img src="' + escapeHtml(image) + '" alt="" width="240" height="180" loading="lazy">' : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 7h7l2 2h9v11H3Z"/><path d="M3 7V4h6l2 3"/></svg>') + '</span>';
      return '<li class="portal-v1__order-row" data-dashboard-project="' + escapeHtml(project.id) + '">' + thumbnail
        + '<div class="portal-v1__order-copy"><strong><a href="' + escapeHtml(projectHref) + '">' + escapeHtml(project.title) + '</a></strong>'
        + '<p class="portal-v1__order-meta"><span' + (actionHref ? ' class="is-actionable"' : '') + '>' + escapeHtml(status) + '</span>'
        + (quantity !== null ? '<span> · ' + escapeHtml(self.t('dashboard.order_quantity', undefined, { quantity: quantity })) + '</span>' : '') + '</p></div>'
        + (actionHref ? '<a class="portal-v1__order-action" href="' + escapeHtml(actionHref) + '">' + escapeHtml(actionLabel) + '<span aria-hidden="true"> →</span></a>' : date) + '</li>';
    }).join('');
    return '<section class="portal-v1__recent-orders" aria-labelledby="PortalDashboardOrders"><div class="portal-v1__dashboard-section-heading"><h2 id="PortalDashboardOrders">'
      + escapeHtml(this.t('dashboard.recent_projects_title')) + '</h2></div>' + (rows ? '<ol class="portal-v1__order-list">' + rows + '</ol>'
        : '<p class="portal-v1__dashboard-empty">' + escapeHtml(this.t('dashboard.orders_empty')) + '</p>') + '</section>';
  };

  PortalV1App.prototype.renderAdaptiveDashboard = function () {
    var self = this;
    var dashboard = this.store.dashboard || {};
    var campaign = dashboard.campaign_summary;
    var queue = [];
    var money = dashboard.money;
    if (!campaign && !queue.length && !money) return '';
    var campaignTotal = campaign ? ['draft', 'planning', 'active', 'paused', 'completed', 'archived']
      .reduce(function (total, key) { return total + (Number.isSafeInteger(campaign[key]) ? campaign[key] : 0); }, 0) : 0;
    var campaignCard = campaign ? '<article data-dashboard-campaign-summary><span>' + escapeHtml(this.t('page.campaigns', 'Campagnes')) + '</span><strong>' + campaignTotal
      + '</strong><p>' + escapeHtml(this.t('dashboard.campaign_activity', undefined, { active: campaign.active || 0, planning: campaign.planning || 0 }))
      + '</p><a href="#campaigns">' + escapeHtml(this.t('dashboard.view_campaigns')) + '</a></article>' : '';
    var moneyCard = money && Number.isSafeInteger(money.committed_minor) && Number.isSafeInteger(money.spent_minor)
      && Number.isSafeInteger(money.available_minor) && /^[A-Z]{3}$/.test(String(money.currency || ''))
      ? '<article data-dashboard-money><span>' + escapeHtml(this.t('dashboard.authorised_budget')) + '</span><strong>' + escapeHtml(formatMinor(money.committed_minor, money.currency, this.store.context.locale))
        + '</strong><p>' + escapeHtml(this.t('dashboard.money_activity', undefined, {
          spent: formatMinor(money.spent_minor, money.currency, this.store.context.locale),
          available: formatMinor(money.available_minor, money.currency, this.store.context.locale)
        })) + '</p></article>' : '';
    var actionRows = queue.map(function (item) {
      return '<li><div><strong>' + escapeHtml(item.title) + '</strong><span>' + escapeHtml(item.reason) + '</span></div><a href="'
        + escapeHtml(item.deep_link) + '">' + escapeHtml(self.t('action.open', 'Ouvrir')) + '</a></li>';
    }).join('');
    var actionCard = queue.length ? '<article class="portal-v1__adaptive-actions" data-dashboard-action-queue><div><span>' + escapeHtml(this.t('dashboard.action_queue')) + '</span><strong>'
      + queue.length + '</strong></div><ol>' + actionRows + '</ol></article>' : '';
    return '<section class="portal-v1__adaptive-dashboard" aria-label="' + escapeHtml(this.t('dashboard.adaptive_label')) + '">' + campaignCard + moneyCard + actionCard + '</section>';
  };

  PortalV1App.prototype.renderDashboardProof = function (model) {
    var proof = model.priority_proof;
    if (!proof) {
      return '<section class="portal-v1__proof-feature portal-v1__proof-feature--empty"><div><h2>'
        + escapeHtml(this.t('dashboard.proof_clear', 'Aucun BAT n’attend votre validation')) + '</h2><p>'
        + escapeHtml(this.t('dashboard.proof_clear_body', 'Les prochaines maquettes à vérifier apparaîtront ici.'))
        + '</p><a href="#proofs">' + escapeHtml(this.t('dashboard.view_proofs', 'Voir les BAT')) + '</a></div></section>';
    }
    var current = proof.current_version || {};
    var projectTitle = model.priority_project?.title || this.t('dashboard.project_unlinked', 'Projet non associé');
    var version = current.version_number || proof.version_number || '—';
    var published = proof.published_at ? '<span>' + escapeHtml(this.t('dashboard.published_at', 'Publié le {{date}}', {
      date: formatDate(proof.published_at, this.store.context.locale)
    })) + '</span>' : '';
    return '<section class="portal-v1__proof-feature" data-dashboard-priority-proof="' + escapeHtml(proof.id) + '"><div class="portal-v1__proof-feature-copy"><h2>'
      + escapeHtml(proof.title || this.t('proof.title', 'BAT')) + '</h2><p>' + escapeHtml(projectTitle) + '</p><div class="portal-v1__proof-meta"><span>'
      + escapeHtml(this.t('proof.version', 'Version {{version}}', { version: version })) + '</span>' + published + '</div><div class="portal-v1__proof-feature-actions">'
      + '<button type="button" class="is-primary" data-portal-proof-decision="' + escapeHtml(proof.id) + '">'
      + escapeHtml(this.t('action.decide', 'Valider le BAT')) + '</button><a href="#proofs">'
      + escapeHtml(this.t('dashboard.view_all', 'Tout afficher')) + '</a></div></div><div class="portal-v1__proof-visual" aria-hidden="true">'
      + '<svg viewBox="0 0 120 148" fill="none"><path d="M28 8h48l20 20v112H28z"/><path d="M76 8v22h20M44 68l11 11 24-30M44 102h36M44 118h25"/></svg>'
      + '<span>BAT</span><strong>V' + escapeHtml(version) + '</strong></div></section>';
  };

  PortalV1App.prototype.renderDashboardActions = function (model) {
    var self = this;
    var actionCount = 0;
    var represented = new Set();
    var rows = model.actions.map(function (action) {
      var resource;
      var title;
      var detail;
      var control;
      if (action.kind === 'proof') {
        resource = self.store.resources.proofs.find(function (item) { return item.id === action.id; });
        if (!resource) return '';
        title = resource.title || self.t('proof.title', 'BAT');
        detail = self.t('dashboard.action_proof', 'Votre validation est requise');
        control = '<a href="#proofs/' + escapeHtml(resource.id) + '/review">' + escapeHtml(self.t('action.open', 'Ouvrir')) + '</a>';
      } else if (action.kind === 'cost') {
        resource = self.store.resources.shipments.find(function (item) { return item.id === action.id; });
        if (!resource) return '';
        title = resource.label || self.t('shipment.title', 'Expédition');
        detail = Number.isSafeInteger(resource.cost_minor)
          ? self.t('dashboard.action_cost', 'Coût proposé : {{cost}}', { cost: formatMinor(resource.cost_minor, resource.currency || 'EUR', self.store.context.locale) })
          : self.t('dashboard.costs', 'Coût à approuver');
        control = '<button type="button" data-portal-shipment="' + escapeHtml(resource.id) + '">' + escapeHtml(self.t('action.open', 'Ouvrir')) + '</button>';
      } else {
        resource = self.store.resources.inventory.find(function (item) { return item.item_id === action.id; });
        if (!resource) return '';
        title = resource.title;
        detail = self.t('dashboard.action_stock', '{{sku}} est épuisé', { sku: resource.sku });
        control = '<a href="#stock">' + escapeHtml(self.t('dashboard.view_stock', 'Voir le stock')) + '</a>';
      }
      represented.add(String(action.id));
      actionCount += 1;
      return '<li data-dashboard-action="' + action.kind + '" data-resource-id="' + escapeHtml(action.id) + '"><span class="portal-v1__action-mark" aria-hidden="true"></span><div><strong>'
        + escapeHtml(title) + '</strong><span>' + escapeHtml(detail) + '</span></div>' + control + '</li>';
    }).filter(Boolean).join('');
    var quoteRows = (this.store.resources.documents || []).filter(function (item) { return item.document_kind === 'quote' && canAction(item, 'decide'); }).map(function (item) {
      represented.add(String(item.id));
      actionCount += 1;
      return '<li data-dashboard-action="quote" data-resource-id="' + escapeHtml(item.id) + '"><span class="portal-v1__action-mark" aria-hidden="true"></span><div><strong>'
        + escapeHtml(item.title) + '</strong><span>' + escapeHtml(self.t('quote.review_needed')) + '</span></div><a href="#documents/'
        + escapeHtml(item.id) + '/overview">' + escapeHtml(self.t('quote.review')) + '</a></li>';
    }).join('');
    var queueRows = (this.store.dashboard?.action_queue || []).map(function (item) {
      var route = parsePortalRoute(item.deep_link);
      if (!route.valid || (route.resourceId && represented.has(route.resourceId))) return '';
      if (route.resourceId) represented.add(route.resourceId);
      actionCount += 1;
      var reason = item.resource_type === 'campaign' && route.section === 'campaigns'
        ? self.t('dashboard.action_campaign') : item.reason;
      return '<li data-dashboard-action="queued"><span class="portal-v1__action-mark" aria-hidden="true"></span><div><strong>'
        + escapeHtml(item.title) + '</strong><span>' + escapeHtml(reason) + '</span></div><a href="'
        + escapeHtml(route.canonicalHash) + '">' + escapeHtml(self.t('action.open', 'Ouvrir')) + '</a></li>';
    }).join('');
    rows = quoteRows + rows + queueRows;
    return '<section class="portal-v1__dashboard-section portal-v1__dashboard-actions"><div class="portal-v1__dashboard-section-heading"><h2>'
      + escapeHtml(this.t('dashboard.actions_title', 'Actions à traiter')) + '</h2><span>' + actionCount + '</span></div>'
      + (rows ? '<ol>' + rows + '</ol>' : '<p class="portal-v1__dashboard-empty">'
        + escapeHtml(this.t('dashboard.empty', 'Aucune action n’est requise pour le moment.')) + '</p>') + '</section>';
  };

  PortalV1App.prototype.renderDashboardProjects = function (projects) {
    var self = this;
    var rows = projects.map(function (item) {
      var href = '#projects/' + encodeURIComponent(item.id) + '/overview';
      return '<tr data-dashboard-project="' + escapeHtml(item.id) + '"><th scope="row"><a href="' + escapeHtml(href) + '">'
        + escapeHtml(item.title) + '</a></th><td><span class="portal-v1__project-status"><i aria-hidden="true"></i>'
        + escapeHtml(self.backendLabel('project', item.status)) + '</span></td><td><a href="' + escapeHtml(href) + '" aria-label="'
        + escapeHtml(self.t('dashboard.open_project', 'Ouvrir {{project}}', { project: item.title })) + '">'
        + escapeHtml(self.t('action.open', 'Ouvrir')) + '</a></td></tr>';
    }).join('');
    return '<section class="portal-v1__dashboard-section"><div class="portal-v1__dashboard-section-heading"><h2>'
      + escapeHtml(this.t('dashboard.projects_title', 'Vos projets')) + '</h2><a href="#projects">'
      + escapeHtml(this.t('dashboard.view_all', 'Tout afficher')) + '</a></div>'
      + (rows ? '<div class="portal-v1__dashboard-table"><table><thead><tr><th scope="col">'
        + escapeHtml(this.t('dashboard.project_column', 'Projet')) + '</th><th scope="col">'
        + escapeHtml(this.t('dashboard.status_column', 'Statut')) + '</th><th scope="col"><span class="visually-hidden">'
        + escapeHtml(this.t('dashboard.action_column', 'Action')) + '</span></th></tr></thead><tbody>' + rows + '</tbody></table></div>'
        : '<p class="portal-v1__dashboard-empty">' + escapeHtml(this.t('refresh.projects_empty')) + '</p>') + '</section>';
  };

  PortalV1App.prototype.renderDashboardActivity = function () {
    var self = this;
    var activity = Array.isArray(this.store.dashboard?.activity) ? this.store.dashboard.activity : [];
    var rows = activity.slice(0, 5).map(function (item) {
      var route = parsePortalRoute(item.deep_link || item.href);
      var title = escapeHtml(item.title || self.t('notifications.unknown_title', 'Mise à jour'));
      return '<li><div>' + (route.valid && (item.deep_link || item.href) ? '<a href="' + escapeHtml(route.canonicalHash) + '">' + title + '</a>' : '<strong>' + title + '</strong>')
        + (item.description ? '<p>' + escapeHtml(item.description) + '</p>' : '') + '</div><time>'
        + escapeHtml(formatDate(item.occurred_at || item.created_at, self.store.context.locale)) + '</time></li>';
    }).join('');
    if (!rows) rows = (this.store.resources.notifications || []).slice(0, 5).map(function (item) {
      return '<li><div><a href="' + escapeHtml(item.href || '#dashboard') + '">' + escapeHtml(self.notificationLabel('title', item.title_key))
        + '</a><p>' + escapeHtml(self.notificationLabel('body', item.body_key)) + '</p></div><time>'
        + escapeHtml(formatDate(item.created_at, self.store.context.locale)) + '</time></li>';
    }).join('');
    return '<section class="portal-v1__dashboard-section portal-v1__recent-activity"><div class="portal-v1__dashboard-section-heading"><h2>'
      + escapeHtml(this.t('dashboard.activity_title', 'Activité récente')) + '</h2></div>' + (rows ? '<ol>' + rows + '</ol>'
        : '<p class="portal-v1__dashboard-empty">' + escapeHtml(this.t('refresh.activity_empty')) + '</p>') + '</section>';
  };

  PortalV1App.prototype.renderDashboardDocuments = function (documents) {
    var self = this;
    var rows = documents.map(function (item) {
      var action = canAction(item, 'download')
        ? '<button type="button" data-portal-document-download="' + escapeHtml(item.id) + '">' + escapeHtml(self.t('action.download', 'Télécharger')) + '</button>'
        : '<a href="#documents">' + escapeHtml(self.t('action.open', 'Ouvrir')) + '</a>';
      return '<tr data-dashboard-document="' + escapeHtml(item.id) + '"><th scope="row">' + escapeHtml(item.title) + '</th><td>'
        + escapeHtml(self.backendLabel('document', item.document_kind)) + '</td><td>' + action + '</td></tr>';
    }).join('');
    return '<section class="portal-v1__dashboard-section"><div class="portal-v1__dashboard-section-heading"><h2>'
      + escapeHtml(this.t('dashboard.documents_title', 'Documents')) + '</h2><a href="#documents">'
      + escapeHtml(this.t('dashboard.view_all', 'Tout afficher')) + '</a></div>'
      + (rows ? '<div class="portal-v1__dashboard-table"><table><thead><tr><th scope="col">'
        + escapeHtml(this.t('dashboard.document_column', 'Document')) + '</th><th scope="col">'
        + escapeHtml(this.t('dashboard.type_column', 'Type')) + '</th><th scope="col"><span class="visually-hidden">'
        + escapeHtml(this.t('dashboard.action_column', 'Action')) + '</span></th></tr></thead><tbody>' + rows + '</tbody></table></div>'
        : '<p class="portal-v1__dashboard-empty">' + escapeHtml(this.t('page.documents_empty', 'Aucun document.')) + '</p>') + '</section>';
  };

  PortalV1App.prototype.renderDashboardOperations = function (shipments, inventory, notifications) {
    var self = this;
    var shipmentRows = shipments.map(function (item) {
      var cost = Number.isSafeInteger(item.cost_minor) ? '<span>' + escapeHtml(formatMinor(item.cost_minor, item.currency || 'EUR', self.store.context.locale)) + '</span>' : '';
      return '<li data-dashboard-operation-shipment="' + escapeHtml(item.id) + '"><div>' + self.stateBadge(item.state) + '<strong>'
        + escapeHtml(item.label || self.t('shipment.title', 'Expédition')) + '</strong>' + cost + '</div><button type="button" data-portal-shipment="'
        + escapeHtml(item.id) + '">' + escapeHtml(self.t('action.open', 'Ouvrir')) + '</button></li>';
    }).join('');
    var stockRows = inventory.map(function (item) {
      return '<li data-dashboard-stock="' + escapeHtml(item.item_id) + '"><div><strong>' + escapeHtml(item.title) + '</strong><span>'
        + escapeHtml(item.sku) + '</span></div><dl><div><dt>' + escapeHtml(self.t('stock.available', 'Disponible')) + '</dt><dd>'
        + escapeHtml(item.available) + '</dd></div><div><dt>' + escapeHtml(self.t('stock.incoming', 'À venir')) + '</dt><dd>'
        + escapeHtml(item.incoming) + '</dd></div></dl></li>';
    }).join('');
    var activityRows = (Array.isArray(notifications) ? notifications : []).slice(0, 4).map(function (item) {
      return '<li data-dashboard-notification="' + escapeHtml(item.id) + '"><div><strong>'
        + escapeHtml(self.notificationLabel('title', item.title_key)) + '</strong><span>'
        + escapeHtml(self.notificationLabel('body', item.body_key)) + '</span></div></li>';
    }).join('');
    return '<aside class="portal-v1__operations" aria-label="' + escapeHtml(this.t('dashboard.operations_title', 'Opérations')) + '"><div class="portal-v1__dashboard-section-heading"><h2>'
      + escapeHtml(this.t('dashboard.operations_title', 'Opérations')) + '</h2></div><section><div class="portal-v1__operations-heading"><h3>'
      + escapeHtml(this.t('page.shipments', 'Expéditions')) + '</h3><a href="#shipments">'
      + escapeHtml(this.t('dashboard.view_all', 'Tout afficher')) + '</a></div>'
      + (shipmentRows ? '<ul class="portal-v1__operation-list">' + shipmentRows + '</ul>' : '<p class="portal-v1__dashboard-empty">'
        + escapeHtml(this.t('shipment.empty', 'Aucune expédition.')) + '</p>') + '</section><section><div class="portal-v1__operations-heading"><h3>'
      + escapeHtml(this.t('page.stock', 'Stock')) + '</h3><a href="#stock">' + escapeHtml(this.t('dashboard.view_all', 'Tout afficher')) + '</a></div>'
      + (stockRows ? '<ul class="portal-v1__operation-list portal-v1__operation-list--stock">' + stockRows + '</ul>' : '<p class="portal-v1__dashboard-empty">'
        + escapeHtml(this.t('stock.empty', 'Aucun stock.')) + '</p>') + '</section>'
      + (activityRows ? '<section><div class="portal-v1__operations-heading"><h3>'
        + escapeHtml(this.t('dashboard.activity_title', 'Activité récente')) + '</h3></div><ol class="portal-v1__operation-list portal-v1__operation-list--activity">'
        + activityRows + '</ol></section>' : '') + '</aside>';
  };

  PortalV1App.prototype.renderNotifications = function () {
    var self = this;
    var items = this.store.resources.notifications.slice(0, 6).map(normalizeSafeNotification);
    return '<section class="portal-v1__section"><h2>' + escapeHtml(this.t('notifications.title', 'Notifications')) + '</h2>'
      + (items.length ? '<ol class="portal-v1__list">' + items.map(function (item) {
        var title = escapeHtml(self.notificationLabel('title', item.title_key));
        var control = item.href ? '<a href="' + escapeHtml(item.href) + '" data-portal-notification-link>' + title + '</a>' : '<strong>' + title + '</strong>';
        var markRead = item.allowed_actions.includes('mark_read') ? '<button type="button" data-portal-notification-read="' + escapeHtml(item.id)
          + '" data-version="' + escapeHtml(item.version) + '">' + escapeHtml(self.t('notifications.mark_read', 'Marquer comme lue')) + '</button>' : '';
        return '<li>' + control + '<span>' + escapeHtml(self.notificationLabel('body', item.body_key)) + '</span><time datetime="'
          + escapeHtml(item.created_at) + '">' + escapeHtml(formatDate(item.created_at, self.store.context.locale)) + '</time>' + markRead + '</li>';
      }).join('') + '</ol>' : '<p class="portal-v1__empty">' + escapeHtml(this.t('notifications.empty', 'Aucune notification.')) + '</p>') + '</section>';
  };

  PortalV1App.prototype.renderProjects = function () {
    var self = this;
    var route = this.store.routeState || {};
    if (route.isDetail && this.store.projectDetail) {
      var dossier = this.store.projectDetail;
      var tab = route.tab || 'overview';
      var body = '<section><h2>' + escapeHtml(this.t('project.brief')) + '</h2><p>' + escapeHtml(dossier.brief || this.t('project.no_brief')) + '</p></section>';
      if (tab === 'quote') {
        var quotes = (this.store.projectDocuments || []).filter(function (item) { return item.document_kind === 'quote'; });
        body = '<section><h2>' + escapeHtml(this.t('project.quote')) + '</h2>' + (quotes.length ? '<div class="portal-v1__list">'
          + quotes.map(function (item) { return '<article><div><h3>' + escapeHtml(item.title) + '</h3><p>'
            + escapeHtml(self.t('document_status.' + item.status, item.status)) + '</p></div><a class="portal-v1__button" href="#documents/'
            + escapeHtml(item.id) + '/overview">' + escapeHtml(self.t('quote.review')) + '</a></article>'; }).join('') + '</div>'
          : '<p>' + escapeHtml(this.t('project.no_quote')) + '</p>') + '</section>';
      }
      if (tab === 'proof') body = '<section><h2>' + escapeHtml(this.t('project.proof')) + '</h2><p>' + escapeHtml(dossier.proof?.title || this.t('project.no_proof')) + '</p>' + (dossier.proof?.deep_link ? '<a href="' + escapeHtml(dossier.proof.deep_link) + '">' + escapeHtml(this.t('project.open_proof_studio')) + '</a>' : '') + '</section>';
      if (tab === 'production') body = '<section><h2>' + escapeHtml(this.t('project.production')) + '</h2><progress max="100" value="' + escapeHtml(dossier.production_progress || 0) + '"></progress><p>' + escapeHtml(dossier.production_progress || 0) + ' %</p></section>';
      if (tab === 'stock') body = '<section><h2>' + escapeHtml(this.t('project.stock')) + '</h2><p>' + escapeHtml(this.t('project.current_stage', undefined, { stage: this.t('stage.' + dossier.stage) })) + '</p><p>' + escapeHtml(this.t('project.storage_help')) + '</p><a href="#stock">' + escapeHtml(this.t('dashboard.view_stock')) + '</a></section>';
      if (tab === 'fulfillment') {
        body = '<section><h2>' + escapeHtml(this.t('project.fulfilment')) + '</h2><p>' + escapeHtml(this.t('project.delivery_help')) + '</p><a href="#shipments">' + escapeHtml(this.t('dashboard.delivery_action')) + '</a></section>';
        if (this.store.context.product_capabilities?.campaign_proof) body += '<section><h2>' + escapeHtml(this.t('page.campaigns', 'Campagnes')) + '</h2><p>' + escapeHtml(this.t('project.campaign_help')) + '</p><a href="#campaigns">' + escapeHtml(this.t('dashboard.view_campaigns')) + '</a></section>';
      }
      if (tab === 'overview') body += '<section class="portal-v1__project-history"><h2>' + escapeHtml(this.t('refresh.project_history')) + '</h2>'
        + ((dossier.activity || []).length ? '<ol class="portal-v1__timeline">' + dossier.activity.map(function (item) {
          return '<li><strong>' + escapeHtml(item.title) + '</strong><time>' + escapeHtml(formatDate(item.occurred_at, self.store.context.locale)) + '</time></li>';
        }).join('') + '</ol>' : '<p>' + escapeHtml(this.t('refresh.activity_empty')) + '</p>') + '</section>';
      var contactUrl = String(this.root.dataset.contactUrl || localizedPath('pages/contact'));
      return '<header class="portal-v1__page-heading"><div><a href="#projects">' + escapeHtml(this.t('project.back')) + '</a><h1 tabindex="-1" data-portal-route-heading>' + escapeHtml(dossier.title) + '</h1><p><span class="portal-v1__status-pill">' + escapeHtml(this.t('stage.' + dossier.stage)) + '</span></p></div><div class="portal-v1__actions"><a href="' + escapeHtml(contactUrl) + '">'
        + escapeHtml(this.t('refresh.project_email')) + '</a></div></header><div class="portal-v1__dossier" data-project-dossier="' + escapeHtml(dossier.id) + '">' + body + '</div>';
    }
    var items = this.store.resources.projects;
    if (route.tab === 'archives') items = items.filter(function (item) { return ['completed', 'cancelled', 'archived'].includes(item.status); });
    else if (route.tab === 'production') items = items.filter(function (item) { return ['quote_requested', 'in_progress'].includes(item.status); });
    else items = items.filter(function (item) { return !['completed', 'cancelled', 'archived'].includes(item.status); });
    return this.heading('page.projects', 'Projets') + '<div class="portal-v1__page-action"><a href="' + escapeHtml(this.catalogueUrl()) + '">'
      + escapeHtml(this.t('dashboard.new_project', 'Nouveau projet')) + '</a></div><div class="portal-v1__list">' + (items.length ? items.map(function (item) {
      return '<article><div><h2><a href="#projects/' + escapeHtml(item.id) + '/overview">' + escapeHtml(item.title) + '</a></h2><p>' + escapeHtml(self.backendLabel('project', item.status)) + '</p></div></article>';
    }).join('') : '<p class="portal-v1__empty">' + escapeHtml(this.t('refresh.projects_empty')) + '</p>') + '</div>';
  };

  PortalV1App.prototype.renderProofs = function () {
    var self = this;
    if (this.store.routeState?.isDetail && this.store.proofDetail) return this.renderProofStudio();
    var items = this.store.resources.proofs;
    return this.heading('page.proofs', 'BAT') + '<div class="portal-v1__list">' + (items.length ? items.map(function (item) {
      var current = item.current_version || {};
      var versions = Array.isArray(item.history_versions) ? item.history_versions : [];
      var decisions = Array.isArray(item.history_decisions) ? item.history_decisions : [];
      var historyLoaded = item.proof_history_loaded === true;
      return '<article class="portal-v1__proof"><div><h2><a href="#proofs/' + escapeHtml(item.id) + '/review">' + escapeHtml(item.title || self.t('proof.title', 'BAT')) + '</a></h2>'
        + '<p>' + escapeHtml(self.t('proof.version', 'Version {{version}}', { version: current.version_number || '—' })) + '</p></div><div class="portal-v1__actions">'
        + (!historyLoaded ? '<button type="button" data-portal-proof-history="' + escapeHtml(item.id) + '">' + escapeHtml(self.t('proof.history', 'Historique des versions')) + '</button>' : '')
        + (item.current_version_id ? '<button type="button" data-portal-proof-download="' + escapeHtml(item.id) + '" data-version-id="' + escapeHtml(item.current_version_id) + '">' + escapeHtml(self.t('action.download', 'Télécharger')) + '</button>' : '')
        + (canAction(item, 'decide') ? '<button type="button" class="is-primary" data-portal-proof-decision="' + escapeHtml(item.id) + '">' + escapeHtml(self.t('action.decide', 'Décider')) + '</button>' : '')
        + '</div>'
        + (historyLoaded ? '<section class="portal-v1__proof-history"><h3 tabindex="-1" data-portal-proof-history-heading="' + escapeHtml(item.id) + '">'
          + escapeHtml(self.t('proof.history', 'Historique des versions')) + '</h3><p>' + escapeHtml(self.t('proof.immutable_history', 'Les versions publiées restent disponibles dans l’historique immuable.')) + '</p>'
          + (versions.length ? '<ol class="portal-v1__timeline">' + versions.map(function (version) {
            var label = self.t('proof.version', 'Version {{version}}', { version: version.version_number || version.version || '—' });
            return '<li><strong>' + escapeHtml(label) + '</strong>'
              + (String(version.id || '') === String(item.current_version_id || '') ? '<span>' + escapeHtml(self.t('proof.current', 'Version actuelle')) + '</span>' : '')
              + '<time>' + escapeHtml(version.published_at) + '</time></li>';
          }).join('') + '</ol>' : '<p class="portal-v1__empty">' + escapeHtml(self.t('proof.history_empty', 'Aucune version publiée.')) + '</p>')
          + (item.versions_next_cursor ? '<button type="button" data-portal-proof-page="versions" data-proof-id="' + escapeHtml(item.id)
            + '" data-cursor="' + escapeHtml(item.versions_next_cursor) + '">' + escapeHtml(self.t('action.load_more', 'Charger la suite')) + '</button>' : '')
          + '<h3>' + escapeHtml(self.t('proof.decisions', 'Décisions')) + '</h3>'
          + (decisions.length ? '<ol class="portal-v1__timeline">' + decisions.map(function (decision) {
            return '<li><strong>' + escapeHtml(self.t('proof.decision_' + decision.decision, decision.decision === 'approved' ? 'Approuvé' : 'Corrections demandées'))
              + '</strong><span>' + escapeHtml(decision.signed_name) + '</span>'
              + (decision.comment ? '<p>' + escapeHtml(decision.comment) + '</p>' : '')
              + '<time>' + escapeHtml(decision.decided_at) + '</time></li>';
          }).join('') + '</ol>' : '<p class="portal-v1__empty">' + escapeHtml(self.t('proof.decisions_empty', 'Aucune décision.')) + '</p>')
          + (item.decisions_next_cursor ? '<button type="button" data-portal-proof-page="decisions" data-proof-id="' + escapeHtml(item.id)
            + '" data-cursor="' + escapeHtml(item.decisions_next_cursor) + '">' + escapeHtml(self.t('action.load_more', 'Charger la suite')) + '</button>' : '')
          + '</section>' : '')
        + '</article>';
    }).join('') : '<p class="portal-v1__empty">' + escapeHtml(this.t('proof.empty', 'Aucun BAT.')) + '</p>') + '</div>';
  };

  PortalV1App.prototype.renderProofStudio = function () {
    var proof = this.store.proofDetail;
    var current = proof.current_version || {};
    var tab = this.store.routeState?.tab || 'review';
    var openCount = Number.isSafeInteger(proof.unresolved_annotation_count) && proof.unresolved_annotation_count >= 0
      ? proof.unresolved_annotation_count : null;
    var body = tab === 'compare' ? this.renderProofComparison() : tab === 'history'
      ? this.renderProofAudit() : tab === 'decision' ? this.renderProofDecisionPanel(openCount) : this.renderProofReview();
    var versionNumber = current.version_number || proof.version_number || '—';
    var openCorrections = this.t(openCount === 1 ? 'proof_studio.open_correction_one' : 'proof_studio.open_corrections_other');
    return '<div class="portal-v1__proof-studio" data-proof-studio="' + escapeHtml(proof.id) + '"><header class="portal-v1__proof-studio-header">'
      + '<div><a href="#proofs">' + escapeHtml(this.t('proof_studio.back')) + '</a><span class="portal-v1__eyebrow">' + escapeHtml(this.t('proof_studio.eyebrow')) + '</span><h1 tabindex="-1" data-portal-route-heading>'
      + escapeHtml(proof.title || this.t('proof.title', 'BAT')) + '</h1><p>' + escapeHtml(this.t('proof.version', 'Version {{version}}', { version: versionNumber }))
      + ' · <span class="portal-v1__status-pill">' + escapeHtml(proof.status || 'review') + '</span></p></div><div class="portal-v1__proof-studio-summary">'
      + '<span><strong>' + escapeHtml(openCount === null ? '—' : openCount) + '</strong> ' + escapeHtml(openCorrections) + '</span>'
      + (proof.current_version_id ? '<button type="button" data-portal-proof-download="' + escapeHtml(proof.id) + '" data-version-id="'
        + escapeHtml(proof.current_version_id) + '">' + escapeHtml(this.t('action.download', 'Télécharger')) + '</button>' : '')
      + '</div></header>' + body + '</div>';
  };

  PortalV1App.prototype.renderProofReview = function () {
    var self = this;
    var proof = this.store.proofDetail;
    var current = proof.current_version || {};
    var annotations = this.store.proofAnnotations;
    var pageModel = buildProofPageModel(annotations, this.store.proofSelectedPage);
    var previewEntry = this.store.proofPreviewUrls[current.id];
    var previewUrl = activeProofPreviewUrl(previewEntry, Date.now());
    var markers = annotations.map(function (annotation, index) {
      if (!pageModel.visible_marker_ids.includes(annotation.id)) return '';
      return '<button type="button" class="portal-v1__proof-marker is-' + escapeHtml(annotation.status) + '" style="left:'
        + escapeHtml(annotation.x * 100) + '%;top:' + escapeHtml(annotation.y * 100) + '%" data-proof-marker="' + escapeHtml(annotation.id)
        + '" aria-label="' + escapeHtml(self.t('proof_studio.marker_label', undefined, { index: index + 1, page: annotation.page, category: annotation.category })) + '">' + (index + 1) + '</button>';
    }).join('');
    var preview = previewUrl
      ? '<div class="portal-v1__proof-preview-viewport"><div class="portal-v1__proof-preview-canvas" style="--proof-zoom:' + escapeHtml(this.store.proofZoom / 100)
        + '"><iframe data-proof-preview-frame title="' + escapeHtml(this.t('proof.preview_title', 'Aperçu du BAT, version {{version}}, page {{page}}', { version: current.version_number || '—', page: pageModel.selected_page })) + '" src="' + escapeHtml(proofPreviewUrlForPage(previewUrl, pageModel.selected_page))
        + '"></iframe><button type="button" data-proof-preview-surface aria-label="' + escapeHtml(this.t('proof_studio.place_correction')) + '"></button>' + markers + '</div></div>'
      : '<button type="button" class="portal-v1__proof-preview-placeholder" data-proof-preview-placeholder data-proof-preview-load="' + escapeHtml(current.id)
        + '"><span aria-hidden="true">⌁</span><strong>' + escapeHtml(this.t(previewEntry ? 'proof_studio.refresh_preview' : 'proof_studio.load_preview'))
        + '</strong><small>' + escapeHtml(this.t('proof_studio.temporary_preview_help')) + '</small></button>';
    var zoom = previewUrl ? '<div class="portal-v1__proof-zoom" aria-label="' + escapeHtml(this.t('proof_studio.zoom_label')) + '"><button type="button" data-proof-zoom="out" aria-label="' + escapeHtml(this.t('proof_studio.zoom_out')) + '">−</button>'
      + '<output>' + escapeHtml(this.store.proofZoom) + ' %</output><button type="button" data-proof-zoom="in" aria-label="' + escapeHtml(this.t('proof_studio.zoom_in')) + '">+</button></div>' : '';
    var pageControls = '<div class="portal-v1__proof-page-controls" aria-label="' + escapeHtml(this.t('proof_studio.displayed_page_label')) + '"><button type="button" data-proof-page-step="-1" aria-label="' + escapeHtml(this.t('proof_studio.previous_page')) + '"'
      + (pageModel.selected_page === 1 ? ' disabled' : '') + '>←</button><label><span>' + escapeHtml(this.t('proof_studio.previewed_page')) + '</span><input type="number" min="1" max="10000" value="'
      + pageModel.selected_page + '" inputmode="numeric" data-proof-selected-page></label><button type="button" data-proof-page-step="1" aria-label="' + escapeHtml(this.t('proof_studio.next_page')) + '">→</button>'
      + '<p role="status" aria-live="polite" data-proof-selected-page-status>' + escapeHtml(this.store.proofPageAnnouncement || this.t('proof_studio.page_announcement', undefined, { page: pageModel.selected_page })) + '</p></div>';
    var form = canAction(proof, 'annotate') ? this.renderProofAnnotationForm(pageModel.selected_page) : '<p class="portal-v1__readonly" data-proof-readonly>' + escapeHtml(this.t('proof_studio.readonly_annotate')) + '</p>';
    var threads = annotations.length ? '<ol class="portal-v1__proof-thread-list" data-proof-thread-list>' + annotations.map(function (annotation, index) {
      return '<li>' + self.renderProofAnnotationThread(annotation, index) + '</li>';
    }).join('') + '</ol>'
      : '<p class="portal-v1__empty">' + escapeHtml(this.t('proof_studio.no_corrections')) + '</p>';
    return '<div class="portal-v1__proof-review-layout"><section class="portal-v1__proof-stage" aria-labelledby="ProofPreviewHeading"><div class="portal-v1__proof-stage-heading"><div><span>' + escapeHtml(this.t('proof_studio.current_version')) + '</span><h2 id="ProofPreviewHeading">' + escapeHtml(this.t('proof_studio.review_preview')) + '</h2></div>'
      + zoom + '</div>' + pageControls + preview + '<p class="portal-v1__proof-help">' + escapeHtml(this.t('proof_studio.review_help')) + '</p>'
      + form + '</section><aside class="portal-v1__proof-threads" aria-labelledby="ProofThreadsHeading"><div><span>' + escapeHtml(this.t('proof_studio.collaboration_thread')) + '</span><h2 id="ProofThreadsHeading">' + escapeHtml(this.t('proof_studio.structured_corrections')) + '</h2></div>'
      + threads + '</aside></div>';
  };

  PortalV1App.prototype.renderProofAnnotationForm = function (selectedPage) {
    var correctionHint = escapeHtml(this.t('proof.correction_placeholder', 'Décrivez précisément le changement attendu'));
    return '<form class="portal-v1__proof-annotation-form" data-proof-annotation-form><fieldset><legend>' + escapeHtml(this.t('proof_studio.add_correction')) + '</legend><div class="portal-v1__proof-coordinate-grid">'
      + '<label><span>' + escapeHtml(this.t('proof_studio.page')) + '</span><input name="page" type="number" min="1" max="10000" value="' + escapeHtml(selectedPage) + '" required inputmode="numeric"></label>'
      + '<label><span>' + escapeHtml(this.t('proof_studio.position_x')) + '</span><input name="x_percent" type="number" min="0" max="100" step="0.01" value="50" required inputmode="decimal"></label>'
      + '<label><span>' + escapeHtml(this.t('proof_studio.position_y')) + '</span><input name="y_percent" type="number" min="0" max="100" step="0.01" value="50" required inputmode="decimal"></label></div>'
      + '<label><span>' + escapeHtml(this.t('proof_studio.category')) + '</span><select name="category" required><option value="placement">' + escapeHtml(this.t('proof_studio.placement')) + '</option><option value="artwork">' + escapeHtml(this.t('proof_studio.artwork')) + '</option><option value="color">' + escapeHtml(this.t('proof_studio.colour')) + '</option><option value="text">' + escapeHtml(this.t('proof_studio.text')) + '</option><option value="size">' + escapeHtml(this.t('proof_studio.size')) + '</option><option value="other">' + escapeHtml(this.t('proof_studio.other')) + '</option></select></label>'
      + '<label><span>' + escapeHtml(this.t('proof_studio.expected_correction')) + '</span><small id="ProofCorrectionHint">' + correctionHint + '</small><textarea name="comment" maxlength="2000" required aria-describedby="ProofCorrectionHint"></textarea></label>'
      + '<p role="alert" data-proof-form-error></p><button type="submit" class="is-primary">' + escapeHtml(this.t('proof_studio.submit_correction')) + '</button></fieldset></form>';
  };

  PortalV1App.prototype.renderProofAnnotationThread = function (annotation, index) {
    var self = this;
    var status = this.t(annotation.status === 'open' ? 'proof_studio.status_open' : 'proof_studio.status_resolved');
    var replies = annotation.comments.map(function (comment) {
      return '<li><div><strong>' + escapeHtml(comment.author.display_name) + '</strong><time>' + escapeHtml(formatDate(comment.created_at, self.store.context.locale))
        + '</time></div><p>' + escapeHtml(comment.comment) + '</p></li>';
    }).join('');
    var commentForm = canAction(annotation, 'comment') ? '<form data-proof-comment-form data-annotation-id="' + escapeHtml(annotation.id)
      + '"><label><span>' + escapeHtml(this.t('proof_studio.reply')) + '</span><textarea name="comment" maxlength="2000" required></textarea></label><p role="alert" data-proof-form-error></p><button type="submit">' + escapeHtml(this.t('proof_studio.send')) + '</button></form>' : '';
    var stateAction = canAction(annotation, 'resolve') ? '<button type="button" data-proof-annotation-action="resolve" data-annotation-id="' + escapeHtml(annotation.id) + '">' + escapeHtml(this.t('proof_studio.resolve')) + '</button>'
      : canAction(annotation, 'reopen') ? '<button type="button" data-proof-annotation-action="reopen" data-annotation-id="' + escapeHtml(annotation.id) + '">' + escapeHtml(this.t('proof_studio.reopen')) + '</button>' : '';
    return '<article class="portal-v1__proof-thread is-' + escapeHtml(annotation.status) + '" data-proof-annotation="' + escapeHtml(annotation.id) + '" tabindex="-1"><header><button type="button" class="portal-v1__proof-thread-number" data-proof-thread-select="' + escapeHtml(annotation.id)
      + '" data-proof-thread-page="' + annotation.page + '" aria-label="' + escapeHtml(this.t('proof_studio.thread_label', undefined, { index: index + 1, page: annotation.page })) + '">' + (index + 1)
      + '</button><div><strong>' + escapeHtml(annotation.category) + '</strong><span>' + escapeHtml(status) + ' · page ' + annotation.page + ' · '
      + escapeHtml(Math.round(annotation.x * 10000) / 100) + ' %, ' + escapeHtml(Math.round(annotation.y * 10000) / 100) + ' %</span></div>' + stateAction + '</header>'
      + '<blockquote><p>' + escapeHtml(annotation.comment) + '</p><footer>' + escapeHtml(annotation.author.display_name) + '</footer></blockquote>'
      + (replies ? '<ol class="portal-v1__proof-replies">' + replies + '</ol>' : '') + commentForm + '</article>';
  };

  PortalV1App.prototype.renderProofComparison = function () {
    var comparison = this.store.proofComparison;
    var versions = this.store.proofVersions;
    if (!comparison) return '<section class="portal-v1__proof-panel" data-proof-comparison><h2>' + escapeHtml(this.t('proof_studio.comparison_title')) + '</h2><p>' + escapeHtml(this.t('proof_studio.comparison_empty')) + '</p></section>';
    var self = this;
    function choices(selected) {
      return versions.map(function (version) { return '<option value="' + escapeHtml(version.id) + '"' + (version.id === selected ? ' selected' : '') + '>'
        + escapeHtml(self.t('proof_studio.version_choice', undefined, { version: version.version_number, date: formatDate(version.published_at, self.store.context.locale) })) + '</option>'; }).join('');
    }
    var leftUrl = activeProofPreviewUrl(this.store.proofPreviewUrls[comparison.left.id], Date.now());
    var rightUrl = activeProofPreviewUrl(this.store.proofPreviewUrls[comparison.right.id], Date.now());
    var frames = leftUrl && rightUrl ? '<div class="portal-v1__proof-comparison-view is-' + escapeHtml(comparison.mode) + '" style="--proof-overlay-opacity:'
      + escapeHtml(comparison.opacity / 100) + '"><iframe data-proof-comparison-frame title="' + escapeHtml(this.t('proof.version', 'Version {{version}}', { version: comparison.left.version_number })) + '" src="' + escapeHtml(leftUrl)
      + '"></iframe><iframe data-proof-comparison-frame title="' + escapeHtml(this.t('proof.version', 'Version {{version}}', { version: comparison.right.version_number })) + '" src="' + escapeHtml(rightUrl) + '"></iframe></div>'
      : '<div class="portal-v1__proof-comparison-placeholder"><p>' + escapeHtml(this.t('proof_studio.previews_unloaded')) + '</p><button type="button" data-proof-comparison-load>' + escapeHtml(this.t('proof_studio.load_comparison')) + '</button></div>';
    return '<section class="portal-v1__proof-panel" data-proof-comparison><header><span>' + escapeHtml(this.t('proof_studio.visual_check')) + '</span><h2>' + escapeHtml(this.t('proof_studio.comparison_heading')) + '</h2><p>' + escapeHtml(this.t('proof_studio.comparison_help')) + '</p></header>'
      + '<div class="portal-v1__proof-comparison-controls"><label><span>' + escapeHtml(this.t('proof_studio.left_version')) + '</span><select data-proof-comparison-version="left">' + choices(comparison.left.id) + '</select></label>'
      + '<label><span>' + escapeHtml(this.t('proof_studio.right_version')) + '</span><select data-proof-comparison-version="right">' + choices(comparison.right.id) + '</select></label><fieldset><legend>' + escapeHtml(this.t('proof_studio.mode')) + '</legend>'
      + '<label><input type="radio" name="proof_compare_mode" value="side-by-side" data-proof-comparison-mode' + (comparison.mode === 'side-by-side' ? ' checked' : '') + '> ' + escapeHtml(this.t('proof_studio.side_by_side')) + '</label>'
      + '<label><input type="radio" name="proof_compare_mode" value="overlay" data-proof-comparison-mode' + (comparison.mode === 'overlay' ? ' checked' : '') + '> ' + escapeHtml(this.t('proof_studio.overlay')) + '</label></fieldset>'
      + (comparison.mode === 'overlay' ? '<label><span>' + escapeHtml(this.t('proof_studio.right_opacity')) + '</span><input type="range" min="10" max="90" value="' + escapeHtml(comparison.opacity) + '" data-proof-comparison-opacity></label>' : '')
      + '</div>' + frames + '</section>';
  };

  PortalV1App.prototype.renderProofAudit = function () {
    var self = this;
    var versions = this.store.proofVersions.map(function (version) {
      return '<li><div><strong>' + escapeHtml(self.t('proof.version', 'Version {{version}}', { version: version.version_number })) + '</strong><time>' + escapeHtml(formatDate(version.published_at, self.store.context.locale))
        + '</time></div><dl><div><dt>' + escapeHtml(self.t('proof_studio.immutable_id')) + '</dt><dd><code>' + escapeHtml(version.id) + '</code></dd></div><div><dt>SHA-256</dt><dd><code>' + escapeHtml(version.sha256) + '</code></dd></div></dl></li>';
    }).join('');
    var decisions = this.store.proofDecisions.map(function (decision) {
      return '<li><div><strong>' + escapeHtml(self.t(decision.decision === 'approved' ? 'proof.decision_approved' : 'proof.decision_changes_requested', decision.decision)) + '</strong><time>'
        + escapeHtml(formatDate(decision.decided_at, self.store.context.locale)) + '</time></div><p>' + escapeHtml(self.t('proof_studio.signatory', undefined, { name: decision.signed_name })) + '</p>'
        + (decision.comment ? '<p>' + escapeHtml(decision.comment) + '</p>' : '') + '<code>SHA-256 ' + escapeHtml(decision.sha256) + '</code></li>';
    }).join('');
    return '<section class="portal-v1__proof-panel portal-v1__proof-audit"><header><span>' + escapeHtml(this.t('proof_studio.audit_eyebrow')) + '</span><h2>' + escapeHtml(this.t('proof_studio.audit_heading')) + '</h2><p>' + escapeHtml(this.t('proof_studio.audit_help')) + '</p></header><div class="portal-v1__proof-audit-grid"><section><h3>' + escapeHtml(this.t('proof_studio.published_versions')) + '</h3><ol>'
      + versions + '</ol></section><section><h3>' + escapeHtml(this.t('proof_studio.signed_decisions')) + '</h3>' + (decisions ? '<ol>' + decisions + '</ol>' : '<p class="portal-v1__empty">' + escapeHtml(this.t('proof_studio.no_decision')) + '</p>') + '</section></div></section>';
  };

  PortalV1App.prototype.renderProofDecisionPanel = function (openCount) {
    var proof = this.store.proofDetail;
    var current = proof.current_version || {};
    var blocked = openCount !== 0;
    var countKnown = Number.isSafeInteger(openCount) && openCount >= 0;
    var blockedCopy = countKnown
      ? this.t(openCount === 1 ? 'proof_studio.resolve_open_one' : 'proof_studio.resolve_open_other', undefined, { count: openCount })
      : this.t('proof_studio.open_count_unknown');
    return '<section class="portal-v1__proof-panel portal-v1__proof-decision-panel"><header><span>' + escapeHtml(this.t('proof_studio.final_decision')) + '</span><h2>' + escapeHtml(this.t('proof_studio.sign_version', undefined, { version: current.version_number || '—' }))
      + '</h2><p>' + escapeHtml(this.t('proof_studio.decision_binding')) + '</p></header>'
      + (blocked ? '<div class="portal-v1__proof-decision-blocked" role="alert"><strong>' + escapeHtml(this.t('proof_studio.approval_blocked')) + '</strong><p>' + escapeHtml(blockedCopy) + '</p><a href="#proofs/'
        + escapeHtml(proof.id) + '/review">' + escapeHtml(this.t('proof_studio.back_corrections')) + '</a></div>' : '')
      + (canAction(proof, 'decide') ? '<button type="button" class="' + (blocked ? '' : 'is-primary') + '" data-portal-proof-decision="' + escapeHtml(proof.id) + '">'
        + escapeHtml(blocked ? this.t('proof.request_changes', 'Demander des corrections') : this.t('proof_studio.open_signature')) + '</button>'
        : '<p class="portal-v1__readonly" data-proof-readonly>' + escapeHtml(this.t('proof_studio.readonly_sign')) + '</p>')
      + '</section>';
  };

  PortalV1App.prototype.configureProofDecisionDialog = function (proof) {
    if (!this.dialogForm) return;
    var approval = this.dialogForm.querySelector('button[value="approved"]');
    var changes = this.dialogForm.querySelector('button[value="changes_requested"]');
    if (approval) approval.disabled = proof?.unresolved_annotation_count !== 0;
    if (changes) changes.disabled = !canAction(proof, 'decide');
  };

  PortalV1App.prototype.loadProofHistory = async function (proofId) {
    var existing = this.store.resources.proofs.find(function (item) { return item.id === proofId; });
    if (!existing || existing.proof_history_loaded === true) return;
    this.setRequest(true);
    try {
      var base = '/client/v1/proofs/' + encodeURIComponent(proofId);
      var values = await Promise.all([
        this.api.request(base),
        this.api.listAll(base + '/versions', { maximumPages: 1 }),
        this.api.listAll(base + '/decisions', { maximumPages: 1 })
      ]);
      var detail = normalizeProofResource(values[0]);
      if (!detail || detail.id !== proofId) throw new TypeError('Invalid canonical proof detail');
      var versions = normalizeProofVersionPage(values[1], proofId);
      var decisions = normalizeProofDecisionPage(values[2], proofId);
      var safeDetail = Object.assign({}, existing, detail, {
        proof_history_loaded: true,
        history_versions: versions.items,
        versions_next_cursor: versions.next_cursor,
        history_decisions: decisions.items,
        decisions_next_cursor: decisions.next_cursor,
      });
      delete safeDetail.versions;
      delete safeDetail.decisions;
      this.store.resources.proofs = this.store.resources.proofs.map(function (item) {
        return item.id === proofId ? safeDetail : item;
      });
      this.renderRoute('proofs');
      window.requestAnimationFrame(function () {
        var heading = Array.from(document.querySelectorAll('[data-portal-proof-history-heading]')).find(function (candidate) {
          return candidate.dataset.portalProofHistoryHeading === proofId;
        });
        heading?.focus({ preventScroll: true });
      });
      this.setRequest(false);
    } catch (error) {
      this.renderError(error);
      this.setRequest(false, error);
    }
  };

  PortalV1App.prototype.loadProofPage = async function (kind, proofId, cursor) {
    var proof = this.store.resources.proofs.find(function (item) { return item.id === proofId; });
    if (!proof || !['versions', 'decisions'].includes(kind) || !cursor) return;
    this.setRequest(true);
    try {
      var page = await this.api.listAll('/client/v1/proofs/' + encodeURIComponent(proofId) + '/' + kind
        + '?cursor=' + encodeURIComponent(cursor), { maximumPages: 1 });
      page = kind === 'versions' ? normalizeProofVersionPage(page, proofId) : normalizeProofDecisionPage(page, proofId);
      var field = kind === 'versions' ? 'history_versions' : 'history_decisions';
      var cursorField = kind + '_next_cursor';
      proof[field] = (Array.isArray(proof[field]) ? proof[field] : []).concat(page.items);
      proof[cursorField] = page.next_cursor;
      this.renderRoute('proofs');
      this.root.querySelector('[data-portal-proof-page="' + kind + '"]')?.focus?.({ preventScroll: true });
      this.setRequest(false);
    } catch (error) {
      this.renderError(error);
      this.setRequest(false, error);
    }
  };

  PortalV1App.prototype.renderInventory = function () {
    var self = this;
    var allItems = this.store.resources.inventory;
    var filter = this.store.inventoryFilter || 'all';
    var items = filterInventoryResources(allItems, this.store.inventorySearch, filter, this.store.context.locale);
    var activeView = this.store.inventoryView || 'inventory';
    var navigation = '<div class="portal-v1__inventory-tabs" role="tablist" aria-label="' + escapeHtml(this.t('stock.views_label', 'Vues du stock')) + '">'
      + [['inventory', 'stock.view_inventory', 'Inventaire'], ['forecast', 'stock.view_forecast', 'Prévisions'], ['reorders', 'stock.view_reorders', 'Réassorts']].map(function (entry) {
        var selected = activeView === entry[0];
        return '<button type="button" role="tab" id="PortalInventoryTab-' + entry[0] + '" data-portal-inventory-view="' + entry[0]
          + '" aria-controls="PortalInventoryPanel-' + entry[0] + '" aria-selected="' + selected + '" tabindex="' + (selected ? '0' : '-1') + '">'
          + escapeHtml(self.t(entry[1], entry[2])) + '</button>';
      }).join('') + '</div>';
    var controls = '<div class="portal-v1__inventory-controls"><label><span>' + escapeHtml(this.t('stock.search', 'Rechercher'))
      + '</span><input type="search" maxlength="120" data-portal-inventory-search value="'
      + escapeHtml(this.store.inventorySearch || '') + '"></label><label><span>' + escapeHtml(this.t('stock.risk', 'Risque')) + '</span><select data-portal-inventory-filter>'
      + [['all', 'Tous'], ['out', 'Rupture'], ['critical', 'Critique'], ['watch', 'À surveiller'], ['healthy', 'Sain'], ['unknown', 'Inconnu']].map(function (entry) {
        return '<option value="' + entry[0] + '"' + (filter === entry[0] ? ' selected' : '') + '>'
          + escapeHtml(self.t('stock.filter_' + entry[0], entry[1])) + '</option>';
      }).join('') + '</select></label><button type="button" data-portal-inventory-export>'
      + escapeHtml(this.t('stock.export', 'Exporter la vue CSV')) + '</button></div>';
    var rows = items.map(function (item) {
      var image = item.image_url ? '<img src="' + escapeHtml(item.image_url) + '" alt="' + escapeHtml(item.title) + '">' : '';
      var actions = '<div class="portal-v1__inventory-actions">'
        + (item.allowed_actions.includes('create_shipment') ? '<button type="button" data-portal-inventory-shipment="' + escapeHtml(item.item_id)
          + '" data-portal-inventory-warehouse="' + escapeHtml(item.warehouse_id) + '">' + escapeHtml(self.t('stock.create_shipment', 'Créer une expédition')) + '</button>' : '')
        + (item.allowed_actions.includes('request_reorder') ? '<button type="button" class="is-primary" data-portal-inventory-reorder="' + escapeHtml(item.item_id)
          + '" data-portal-inventory-warehouse="' + escapeHtml(item.warehouse_id) + '">' + escapeHtml(self.t('stock.request_reorder', 'Demander un réassort')) + '</button>' : '') + '</div>';
      return '<tr><th scope="row"><span class="portal-v1__product">' + image + '<span><strong>' + escapeHtml(item.title)
        + '</strong><small>' + escapeHtml(item.sku) + (item.variant ? ' · ' + escapeHtml(item.variant) : '') + '</small><small>'
        + escapeHtml(item.warehouse_name) + '</small></span></span></th>'
        + '<td>' + escapeHtml(item.available) + '</td><td>' + escapeHtml(item.reserved) + '</td><td>' + escapeHtml(item.incoming)
        + (item.incoming_eta ? '<small>' + escapeHtml(formatDate(item.incoming_eta, self.store.context.locale)) + '</small>' : '') + '</td><td><span class="portal-v1__risk portal-v1__risk--'
        + escapeHtml(item.stockout_risk) + '">' + escapeHtml(self.t('stock.filter_' + item.stockout_risk, item.stockout_risk)) + '</span></td><td>' + actions + '</td></tr>';
    }).join('');
    var cards = items.map(function (item) {
      var image = item.image_url ? '<img src="' + escapeHtml(item.image_url) + '" alt="' + escapeHtml(item.title) + '">' : '';
      return '<article><div class="portal-v1__product">' + image + '<span><h2>' + escapeHtml(item.title) + '</h2><p>'
        + escapeHtml(item.sku) + (item.variant ? ' · ' + escapeHtml(item.variant) : '') + '</p><small>' + escapeHtml(item.warehouse_name) + '</small></span></div><dl>'
        + ['available', 'reserved', 'incoming'].map(function (key) {
          return '<div><dt>' + escapeHtml(self.t('stock.' + key, key)) + '</dt><dd>' + escapeHtml(item[key]) + '</dd></div>';
        }).join('') + '</dl><span class="portal-v1__risk portal-v1__risk--' + escapeHtml(item.stockout_risk) + '">'
        + escapeHtml(self.t('stock.filter_' + item.stockout_risk, item.stockout_risk)) + '</span><div class="portal-v1__inventory-actions">'
        + (item.allowed_actions.includes('create_shipment') ? '<button type="button" data-portal-inventory-shipment="' + escapeHtml(item.item_id)
          + '" data-portal-inventory-warehouse="' + escapeHtml(item.warehouse_id) + '">' + escapeHtml(self.t('stock.create_shipment', 'Créer une expédition')) + '</button>' : '')
        + (item.allowed_actions.includes('request_reorder') ? '<button type="button" class="is-primary" data-portal-inventory-reorder="' + escapeHtml(item.item_id)
          + '" data-portal-inventory-warehouse="' + escapeHtml(item.warehouse_id) + '">' + escapeHtml(self.t('stock.request_reorder', 'Demander un réassort')) + '</button>' : '') + '</div></article>';
    }).join('');
    var inventory = items.length ? '<div class="portal-v1__stock-table"><table><caption>'
      + escapeHtml(this.t('stock.caption', 'Stock client par référence')) + '</caption><thead><tr><th scope="col">' + escapeHtml(this.t('stock.product_sku', 'Produit / SKU'))
      + '</th><th scope="col">' + escapeHtml(this.t('stock.available', 'Disponible')) + '</th><th scope="col">' + escapeHtml(this.t('stock.reserved', 'Réservé')) + '</th>'
      + '<th scope="col">' + escapeHtml(this.t('stock.incoming_eta', 'Entrant / ETA')) + '</th><th scope="col">' + escapeHtml(this.t('stock.risk_column', 'Risque'))
      + '</th><th scope="col">' + escapeHtml(this.t('stock.decisions', 'Décisions')) + '</th></tr></thead><tbody>' + rows + '</tbody></table></div><div class="portal-v1__stock-cards">' + cards + '</div>'
      : '<p class="portal-v1__empty">' + escapeHtml(this.t('stock.empty', 'Aucun stock ne correspond aux filtres.')) + '</p>';
    var forecast = '<div class="portal-v1__forecast"><p class="portal-v1__hint">' + escapeHtml(this.t('stock.forecast_hint', 'Signaux factuels uniquement : consommation débitée sur 30 jours, réception ouverte la plus proche et couverture calculée depuis la composition canonique du kit.')) + '</p>'
      + (items.length ? items.map(function (item) { return '<article><div><strong>' + escapeHtml(item.title) + '</strong><small>' + escapeHtml(item.sku) + ' · ' + escapeHtml(item.warehouse_name) + '</small></div><dl><div><dt>'
        + escapeHtml(self.t('stock.consumption_30d', 'Consommation 30j')) + '</dt><dd>' + escapeHtml(item.recent_consumption_30d) + '</dd></div><div><dt>'
        + escapeHtml(self.t('stock.kit_coverage', 'Couverture kits')) + '</dt><dd>' + escapeHtml(item.estimated_kit_coverage == null ? self.t('stock.not_calculable', 'Non calculable') : item.estimated_kit_coverage)
        + '</dd></div><div><dt>' + escapeHtml(self.t('stock.next_receipt', 'Prochaine réception')) + '</dt><dd>'
        + escapeHtml(item.incoming_eta ? formatDate(item.incoming_eta, self.store.context.locale) : self.t('stock.none', 'Aucune')) + '</dd></div></dl></article>'; }).join('')
        : '<p class="portal-v1__empty">' + escapeHtml(this.t('stock.no_signal', 'Aucun signal.')) + '</p>') + '</div>';
    var reorders = '<div class="portal-v1__reorders">' + (this.store.inventoryReorders.length ? this.store.inventoryReorders.map(function (request) {
      return '<article><div><strong>' + escapeHtml(request.title) + '</strong><small>' + escapeHtml(request.sku) + ' · ' + escapeHtml(formatDate(request.created_at, self.store.context.locale))
        + '</small></div><p>' + escapeHtml(self.t('stock.units', '{{quantity}} unités', { quantity: request.quantity })) + '</p><span class="portal-v1__risk">' + escapeHtml(request.status) + '</span></article>';
    }).join('') : '<p class="portal-v1__empty">' + escapeHtml(this.t('stock.no_reorders', 'Aucune demande de réassort.')) + '</p>') + '</div>';
    var dialogItem = this.store.reorderItem;
    var dialog = dialogItem ? '<dialog class="portal-v1__dialog" data-portal-reorder-dialog aria-labelledby="PortalReorderTitle"><form method="dialog" class="portal-v1__dialog-form" data-portal-reorder-form><header><h2 id="PortalReorderTitle">'
      + escapeHtml(this.t('stock.reorder_title', 'Réassort · {{title}}', { title: dialogItem.title })) + '</h2><button type="button" data-portal-reorder-close aria-label="'
      + escapeHtml(this.t('stock.close', 'Fermer')) + '">×</button></header><label class="portal-v1__field"><span>' + escapeHtml(this.t('stock.quantity', 'Quantité')) + '</span><input type="number" name="quantity" min="1" max="2147483647" step="1" inputmode="numeric" required></label>'
      + '<label class="portal-v1__field"><span>' + escapeHtml(this.t('stock.optional_note', 'Note facultative')) + '</span><textarea name="note" maxlength="1200" rows="4"></textarea></label><p class="portal-v1__form-error" data-portal-reorder-error role="alert" tabindex="-1"></p><div class="portal-v1__dialog-actions"><button type="button" data-portal-reorder-close>'
      + escapeHtml(this.t('stock.cancel', 'Annuler')) + '</button><button type="submit" class="is-primary">' + escapeHtml(this.t('stock.submit_reorder', 'Envoyer la demande')) + '</button></div></form></dialog>' : '';
    var panels = [['inventory', inventory], ['forecast', forecast], ['reorders', reorders]].map(function (entry) {
      return '<section role="tabpanel" id="PortalInventoryPanel-' + entry[0] + '" aria-labelledby="PortalInventoryTab-' + entry[0] + '"'
        + (activeView === entry[0] ? '' : ' hidden') + '>' + entry[1] + '</section>';
    }).join('');
    return this.heading('page.stock', 'Stock', this.t('stock.intro', 'Décidez depuis les quantités disponibles, les entrées confirmées et la consommation réelle.')) + navigation
      + (activeView !== 'reorders' ? controls : '') + panels + dialog;
  };

  PortalV1App.prototype.submitInventoryReorder = async function (form) {
    var item = this.store.reorderItem;
    if (!item || !item.allowed_actions.includes('request_reorder')) return false;
    var quantity = Number(form.elements.quantity?.value);
    var note = String(form.elements.note?.value || '').trim();
    var errorTarget = form.querySelector('[data-portal-reorder-error]');
    if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 2147483647 || note.length > 1200 || /[\u0000-\u001f\u007f]/u.test(note)) {
      errorTarget.textContent = this.t('stock.reorder_invalid', 'Saisissez une quantité positive et une note valide.');
      errorTarget.focus?.();
      return false;
    }
    try {
      await this.api.mutate('/client/v1/inventory/' + encodeURIComponent(item.item_id) + '/reorders', {
        operation: 'inventory.reorder.create', resource: item.item_id, expectedVersion: item.version,
        body: { quantity: quantity, note: note || null },
      });
      this.store.reorderItem = null;
      await this.navigate('stock');
      return true;
    } catch (error) {
      errorTarget.textContent = error?.code === 'VERSION_CONFLICT'
        ? this.t('stock.reorder_conflict', 'Le stock a changé. Rechargez la vue.')
        : this.t('stock.reorder_failed', 'La demande n’a pas pu être envoyée.');
      errorTarget.focus?.();
      return false;
    }
  };

  PortalV1App.prototype.stateBadge = function (state) {
    var valid = SHIPMENT_STATES.includes(state) ? state : 'draft';
    return '<span class="portal-v1__state portal-v1__state--' + valid + '"><span aria-hidden="true">●</span>'
      + escapeHtml(this.t('state.' + valid, valid.replace(/_/g, ' '))) + '</span>';
  };

  PortalV1App.prototype.renderShipments = function () {
    if (this.store.routeState?.isDetail && this.store.activeShipment?.id === this.store.routeState.resourceId) return this.renderShipmentDetail(this.store.activeShipment);
    var self = this;
    var items = this.store.resources.shipments;
    var canCreate = this.store.context.capabilities.shipments_manage === true;
    var action = canCreate ? '<button type="button" class="portal-v1__primary" data-portal-new-shipment>' + escapeHtml(this.t('action.new_shipment', 'Nouvelle expédition')) + '</button>' : '';
    return this.heading('page.shipments', 'Expéditions') + '<div class="portal-v1__page-action">' + action + '</div>'
      + '<div class="portal-v1__list">' + (items.length ? items.map(function (item) {
        var cost = Number.isSafeInteger(item.cost_minor) ? '<p>' + escapeHtml(formatMinor(item.cost_minor, item.currency || 'EUR', self.store.context.locale)) + '</p>' : '';
        return '<article><div>' + self.stateBadge(item.state) + '<h2>' + escapeHtml(item.label || item.id) + '</h2>' + cost
          + (item.reservation_expires_at ? '<p>' + escapeHtml(self.t('shipment.reserved_until', 'Réservation jusqu’au {{date}}', { date: formatDate(item.reservation_expires_at, self.store.context.locale) })) + '</p>' : '')
          + '</div><button type="button" data-portal-shipment="' + escapeHtml(item.id) + '">' + escapeHtml(self.t('action.open', 'Ouvrir')) + '</button></article>';
      }).join('') : '<p class="portal-v1__empty">' + escapeHtml(this.t('shipment.empty', 'Aucune expédition.')) + '</p>') + '</div>';
  };

  PortalV1App.prototype.readShipment = async function (shipmentId) {
      var base = '/client/v1/shipments/' + encodeURIComponent(shipmentId);
      var canReadRecipients = this.store.context.capabilities.shipments_recipients_read === true;
      var values = await Promise.all([
        this.api.request(base),
        this.api.listAll(base + '/revisions', { maximumPages: 1 }),
        this.api.listAll(base + '/tracking', { maximumPages: 1 }),
        canReadRecipients
          ? this.api.listAll(base + '/destination-lines', { maximumPages: 1 })
          : Promise.resolve({ items: [], next_cursor: null })
      ]);
      var detail = normalizeShipmentDetail(values[0]);
      if (detail.id !== shipmentId) throw new TypeError('Invalid canonical shipment identity');
      var revisions = normalizeRevisionPage(values[1], detail.id);
      var tracking = normalizeTrackingPage(values[2], detail.id);
      var destinationLines = normalizeDestinationLinePage(values[3], detail.current_revision_id);
      return Object.assign({}, detail, {
        revisions: revisions.items,
        revisions_next_cursor: revisions.next_cursor,
        parcels: tracking.items,
        tracking_next_cursor: tracking.next_cursor,
        destination_lines: destinationLines.items,
        destination_lines_next_cursor: destinationLines.next_cursor
      });
  };

  PortalV1App.prototype.openShipment = async function (shipmentId) {
    if (!shipmentId) return;
    this.setRequest(true);
    try {
      var shipment = await this.readShipment(shipmentId);
      this.store.activeShipment = shipment;
      this.view.innerHTML = this.renderShipmentDetail(shipment);
      window.requestAnimationFrame(function () { document.querySelector('[data-portal-route-heading]')?.focus({ preventScroll: true }); });
      this.setRequest(false);
    } catch (error) {
      this.renderError(error);
      this.setRequest(false, error);
    }
  };

  PortalV1App.prototype.loadShipmentPage = async function (kind, cursor) {
    var shipment = this.store.activeShipment;
    if (!shipment?.id || !['revisions', 'tracking', 'destination-lines'].includes(kind) || !cursor) return;
    if (kind === 'destination-lines' && this.store.context.capabilities.shipments_recipients_read !== true) return;
    var base = '/client/v1/shipments/' + encodeURIComponent(shipment.id) + '/' + kind;
    var page = await this.api.listAll(base + '?cursor=' + encodeURIComponent(cursor), { maximumPages: 1 });
    if (kind === 'revisions') {
      page = normalizeRevisionPage(page, shipment.id);
      shipment.revisions = page.items;
      shipment.revisions_next_cursor = page.next_cursor;
    } else if (kind === 'tracking') {
      page = normalizeTrackingPage(page, shipment.id);
      shipment.parcels = page.items;
      shipment.tracking_next_cursor = page.next_cursor;
    } else {
      page = normalizeDestinationLinePage(page, shipment.current_revision_id);
      shipment.destination_lines = page.items;
      shipment.destination_lines_next_cursor = page.next_cursor;
    }
    this.view.innerHTML = this.renderShipmentDetail(shipment);
    window.requestAnimationFrame(function () {
      document.querySelector('[data-portal-shipment-page="' + kind + '"]')?.focus({ preventScroll: true });
    });
  };

  PortalV1App.prototype.renderShipmentDetail = function (shipment) {
    var self = this;
    var lines = Array.isArray(shipment.lines) ? shipment.lines : [];
    var destinationLines = Array.isArray(shipment.destination_lines) ? shipment.destination_lines : [];
    var revisions = Array.isArray(shipment.revisions) ? shipment.revisions : [];
    var parcels = Array.isArray(shipment.parcels) ? shipment.parcels : [];
    var proposal = canonicalCostProposal(shipment);
    var expiry = shipment.reservation_expires_at ? '<p>' + escapeHtml(this.t('shipment.reserved_until', 'Réservation jusqu’au {{date}}', {
      date: formatDate(shipment.reservation_expires_at, this.store.context.locale)
    })) + '</p>' : '';
    var demand = lines.length ? '<section class="portal-v1__detail-section" data-portal-shipment-demand><h2>' + escapeHtml(this.t('shipment.demand', 'Demande')) + '</h2><div class="portal-v1__detail-list">'
      + lines.map(function (line) {
        var metrics = shipmentLineMetrics(line);
        var inventoryItem = self.store.resources.inventory.find(function (item) {
          return item.item_id === line.item_id && item.warehouse_id === shipment.warehouse_id;
        });
        var values = metrics.canonical
          ? '<dl><div><dt>' + escapeHtml(self.t('shipment.canonical_demand', 'Demande canonique')) + '</dt><dd>' + escapeHtml(metrics.demand)
            + '</dd></div><div><dt>' + escapeHtml(self.t('stock.available', 'Disponible')) + '</dt><dd>' + escapeHtml(inventoryItem?.available ?? '—')
            + '</dd></div><div><dt>' + escapeHtml(self.t('shipment.shortage', 'Manquant')) + '</dt><dd>' + escapeHtml(metrics.shortage) + '</dd></div></dl>'
          : '<p class="portal-v1__empty" data-portal-canonical-demand>'
            + escapeHtml(self.t('shipment.demand_unavailable', 'Demande canonique indisponible.')) + '</p>';
        return '<article><div><strong>' + escapeHtml(line.title || line.sku || line.item_id || '—') + '</strong>'
          + (line.title && line.sku && line.sku !== line.title ? '<small>' + escapeHtml(line.sku) + '</small>' : '') + '</div>' + values + '</article>';
      }).join('') + '</div></section>' : '';
    var destinationDetail = this.store.context.capabilities.shipments_recipients_read === true
      ? '<section class="portal-v1__detail-section" data-portal-destination-lines data-portal-shipment-exceptions><h2>'
      + escapeHtml(this.t('shipment.destination_lines', 'Détail des allocations destinataires')) + '</h2>'
      + (destinationLines.length ? '<div class="portal-v1__detail-list">' + destinationLines.map(function (line) {
        var quantity = Number.isSafeInteger(line.quantity) && line.quantity >= 0 ? line.quantity : '—';
        var allocated = Number.isSafeInteger(line.allocated_quantity) && line.allocated_quantity >= 0 ? line.allocated_quantity : '—';
        var remaining = Number.isSafeInteger(line.remaining_quantity) && line.remaining_quantity >= 0 ? line.remaining_quantity : '—';
        return '<article><div><strong>' + escapeHtml(line.sku || line.item_id || '—') + '</strong></div><dl><div><dt>'
          + escapeHtml(self.t('shipment.quantity', 'Quantité')) + '</dt><dd>' + escapeHtml(quantity) + '</dd></div><div><dt>'
          + escapeHtml(self.t('shipment.allocated', 'Alloué')) + '</dt><dd>' + escapeHtml(allocated) + '</dd></div><div><dt>'
          + escapeHtml(self.t('shipment.remaining', 'Restant')) + '</dt><dd>' + escapeHtml(remaining) + '</dd></div></dl></article>';
      }).join('') + '</div>' : '<p class="portal-v1__empty">—</p>')
      + (shipment.destination_lines_next_cursor ? '<button type="button" data-portal-shipment-page="destination-lines" data-cursor="'
        + escapeHtml(shipment.destination_lines_next_cursor) + '">' + escapeHtml(this.t('action.continue', 'Page suivante')) + '</button>' : '') + '</section>'
      : '';
    var history = '<section class="portal-v1__detail-section" data-portal-parcel-timeline><h2>' + escapeHtml(this.t('shipment.revisions', 'Chronologie opérationnelle')) + '</h2>'
      + (revisions.length ? '<ol class="portal-v1__timeline">' + revisions.map(function (revision) {
        return '<li><strong>' + escapeHtml(String(revision.label || revision.revision_number || revision.version || '—')) + '</strong><p>'
          + escapeHtml(revision.reason || self.t('shipment.revision_reason', 'Révision enregistrée')) + '</p></li>';
      }).join('') + '</ol>' : '<p class="portal-v1__empty">—</p>')
      + (shipment.revisions_next_cursor ? '<button type="button" data-portal-shipment-page="revisions" data-cursor="'
        + escapeHtml(shipment.revisions_next_cursor) + '">' + escapeHtml(this.t('action.continue', 'Page suivante')) + '</button>' : '') + '</section>';
    var tracking = '<section class="portal-v1__detail-section" data-portal-parcel-timeline><h2>' + escapeHtml(this.t('shipment.parcels', 'Colis et suivi')) + '</h2>'
      + (parcels.length ? '<div class="portal-v1__detail-list">' + parcels.map(function (parcel) {
        var safeTrackingUrl = window.TodayMerchPortalApi.sanitizeSignedUrl(parcel.tracking_url);
        var link = safeTrackingUrl ? '<a href="' + escapeHtml(safeTrackingUrl) + '" target="_blank" rel="noopener noreferrer">'
          + escapeHtml(parcel.tracking_number || self.t('shipment.tracking', 'Suivi')) + '</a>' : escapeHtml(parcel.tracking_number || '—');
        return '<article><div><strong>' + escapeHtml(parcel.carrier || self.t('shipment.carrier', 'Transporteur')) + '</strong><p>' + link
          + '</p></div><span>' + escapeHtml(self.backendLabel('parcel', parcel.status)) + '</span></article>';
      }).join('') + '</div>' : '<p class="portal-v1__empty">—</p>')
      + (shipment.tracking_next_cursor ? '<button type="button" data-portal-shipment-page="tracking" data-cursor="'
        + escapeHtml(shipment.tracking_next_cursor) + '">' + escapeHtml(this.t('action.continue', 'Page suivante')) + '</button>' : '') + '</section>';
    var cost = '';
    if (proposal) {
      cost = '<section class="portal-v1__detail-section" data-portal-shipment-cost><h2>' + escapeHtml(this.t('shipment.cost', 'Coût et approbation')) + '</h2><p class="portal-v1__cost">'
        + escapeHtml(formatMinor(proposal.amount_minor, proposal.currency || shipment.currency || 'EUR', this.store.context.locale)) + '</p>'
        + ((canAction(shipment, 'approve_cost') || canAction(shipment, 'reject_cost')) ? '<form data-portal-cost-form><label class="portal-v1__field"><span>' + escapeHtml(this.t('proof.comment', 'Commentaire'))
        + '</span><textarea name="comment" rows="3" maxlength="2000" aria-describedby="PortalCostError"></textarea></label>'
        + '<p id="PortalCostError" class="portal-v1__form-error" data-portal-cost-error role="alert"></p><div class="portal-v1__actions">'
        + (canAction(shipment, 'reject_cost') ? '<button type="submit" name="decision" value="rejected">' + escapeHtml(this.t('action.reject_cost', 'Refuser')) + '</button>' : '')
        + (canAction(shipment, 'approve_cost') ? '<button type="submit" name="decision" value="approved" class="is-primary">' + escapeHtml(this.t('action.approve_cost', 'Approuver')) + '</button>' : '')
        + '</div></form>' : '') + '</section>';
    }
    var workflowActions = '';
    if (['edit', 'import', 'submit', 'cancel'].some(function (action) { return canAction(shipment, action); })) {
      workflowActions = '<section class="portal-v1__detail-section portal-v1__shipment-actions"><h2>'
        + escapeHtml(this.t('shipment.actions', 'Actions')) + '</h2><div class="portal-v1__actions">'
        + (canAction(shipment, 'edit') ? '<button type="button" data-portal-shipment-resume>' + escapeHtml(this.t('action.resume', 'Reprendre')) + '</button>' : '')
        + (canAction(shipment, 'import') ? '<button type="button" data-portal-shipment-import>' + escapeHtml(this.t('action.import', 'Importer un CSV')) + '</button>' : '')
        + (canAction(shipment, 'submit') ? '<button type="button" class="is-primary" data-portal-shipment-submit>' + escapeHtml(this.t('action.submit', 'Envoyer')) + '</button>' : '')
        + '</div>'
        + (canAction(shipment, 'cancel') ? '<form data-portal-shipment-cancel-form><label class="portal-v1__field"><span>'
          + escapeHtml(this.t('shipment.cancel_reason', 'Motif d’annulation')) + '</span><textarea name="reason" rows="3" maxlength="500" required aria-describedby="PortalShipmentCancelError"></textarea></label>'
          + '<p id="PortalShipmentCancelError" class="portal-v1__form-error" data-portal-shipment-cancel-error role="alert"></p><button type="submit">'
          + escapeHtml(this.t('action.cancel_shipment', 'Annuler l’expédition')) + '</button></form>' : '') + '</section>';
    }
    var contextTitle = shipment.campaign_title && shipment.campaign_title === shipment.project_title
      ? shipment.project_title
      : shipment.campaign_title && shipment.project_title
      ? this.t('shipment.context_campaign_project', '{{campaign}} · {{project}}', { campaign: shipment.campaign_title, project: shipment.project_title })
      : shipment.project_title
        ? this.t('shipment.context_project_only', 'Projet · {{project}}', { project: shipment.project_title })
        : this.t('shipment.context_unlinked', 'Expédition directe');
    var context = '<section class="portal-v1__shipment-context" data-portal-shipment-context><span>'
      + escapeHtml(this.t('shipment.context_label', 'Campagne / projet')) + '</span><strong>' + escapeHtml(contextTitle) + '</strong></section>';
    var headingTitle = shipment.label || this.t('shipment.detail', 'Détail de l’expédition');
    return '<button type="button" class="portal-v1__back" data-portal-shipments-back>' + escapeHtml(this.t('action.back', 'Retour')) + '</button>'
      + '<header class="portal-v1__page-heading"><div><h1 tabindex="-1" data-portal-route-heading>' + escapeHtml(headingTitle) + '</h1></div></header>'
      + context + '<section class="portal-v1__shipment-summary">' + this.stateBadge(shipment.state) + expiry + '</section>'
      + '<div class="portal-v1__shipment-detail-grid"><div>' + tracking + demand + destinationDetail
      + '</div><aside>' + workflowActions + cost + history + '</aside></div>';
  };

  PortalV1App.prototype.submitCostDecision = function (event) {
    var self = this;
    var form = event.target.closest?.('[data-portal-cost-form]') || event.target;
    var shipment = this.store.activeShipment;
    var proposal = canonicalCostProposal(shipment);
    var decision = event.submitter?.value || '';
    var comment = String(form.elements.comment?.value || '').trim();
    var errorTarget = form.querySelector('[data-portal-cost-error]');
    if (!shipment || !proposal || !['approved', 'rejected'].includes(decision) || (decision === 'rejected' && !comment)) {
      if (errorTarget) errorTarget.textContent = this.t('errors.validation', 'Ajoutez un commentaire pour refuser ce coût.');
      return Promise.resolve(false);
    }
    return this.guard.run('shipment-cost:' + shipment.id + ':' + shipment.version, async function () {
      form.setAttribute('aria-busy', 'true');
      form.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
      try {
        await self.api.mutate('/client/v1/shipments/' + encodeURIComponent(shipment.id) + '/cost-decision', {
          operation: 'shipment.cost.decision', resource: shipment.id, expectedVersion: shipment.version,
          body: { proposal_id: proposal.id, decision: decision, comment: comment || null }
        });
        await self.openShipment(shipment.id);
        return true;
      } catch (error) {
        if (error?.status === 409 && error?.code === 'VERSION_CONFLICT') {
          try { await self.openShipment(shipment.id); } catch (reloadError) { /* localized failure below */ }
        }
        if (errorTarget) errorTarget.textContent = self.t(error?.code === 'VERSION_CONFLICT' ? 'errors.version_conflict' : 'errors.generic', 'Décision non envoyée.');
        return false;
      } finally {
        form.removeAttribute('aria-busy');
        form.querySelectorAll('button').forEach(function (button) { button.disabled = false; });
      }
    });
  };

  PortalV1App.prototype.resumeShipment = function (mode) {
    var shipment = this.store.activeShipment;
    var action = mode === 'csv' ? 'import' : 'edit';
    if (!shipment || !canAction(shipment, action)
      || typeof window.TodayMerchShipmentWizard?.resumeFromCanonical !== 'function') return false;
    try {
      this.store.wizard = window.TodayMerchShipmentWizard.resumeFromCanonical(shipment, {
        step: mode === 'csv' ? 2 : 1,
        recipient_mode: mode === 'csv' ? 'csv' : 'single',
      });
      this.store.wizard.warehouse_id = shipment.warehouse_id || this.store.context.default_warehouse_id;
      this.resumedShipmentId = shipment.id;
      this.resumedShipmentBaseline = {
        label: this.store.wizard.label,
        kit_lines: structuredClone(this.store.wizard.kit_lines),
      };
      this.renderWizard();
      return true;
    } catch (error) {
      this.renderError(error);
      return false;
    }
  };

  PortalV1App.prototype.submitActiveShipment = function () {
    var self = this;
    var shipment = this.store.activeShipment;
    if (!shipment || !canAction(shipment, 'submit')) return Promise.resolve(false);
    return this.guard.run('shipment-submit:' + shipment.id + ':' + shipment.version, async function () {
      try {
        await self.api.mutate('/client/v1/shipments/' + encodeURIComponent(shipment.id) + '/submit', {
          operation: 'shipment.submit', resource: shipment.id, expectedVersion: shipment.version, body: {}
        });
        await self.openShipment(shipment.id);
        return true;
      } catch (error) {
        if (error?.status === 409) await self.openShipment(shipment.id);
        else self.renderError(error);
        return false;
      }
    });
  };

  PortalV1App.prototype.cancelShipment = function (form) {
    var self = this;
    var shipment = this.store.activeShipment;
    var reason = String(form.elements.reason?.value || '').trim();
    var target = form.querySelector('[data-portal-shipment-cancel-error]');
    if (!shipment || !canAction(shipment, 'cancel') || !reason || reason.length > 500) {
      if (target) target.textContent = this.t('errors.validation', 'Vérifiez les champs signalés.');
      return Promise.resolve(false);
    }
    return this.guard.run('shipment-cancel:' + shipment.id + ':' + shipment.version, async function () {
      form.setAttribute('aria-busy', 'true');
      form.querySelectorAll('button, textarea').forEach(function (control) { control.disabled = true; });
      try {
        await self.api.mutate('/client/v1/shipments/' + encodeURIComponent(shipment.id) + '/cancel', {
          operation: 'shipment.cancel', resource: shipment.id, expectedVersion: shipment.version, body: { reason: reason }
        });
        await self.openShipment(shipment.id);
        return true;
      } catch (error) {
        if (error?.status === 409) await self.openShipment(shipment.id);
        else if (target) target.textContent = self.t('errors.generic', 'Action impossible.');
        return false;
      } finally {
        form.removeAttribute('aria-busy');
        form.querySelectorAll('button, textarea').forEach(function (control) { control.disabled = false; });
      }
    });
  };

  PortalV1App.prototype.renderDocuments = function () {
    var self = this;
    if (this.store.routeState?.isDetail && this.store.documentDetail) return this.renderDocumentDetail();
    var items = (this.store.resources.documents || []).map(normalizeDocumentResource);
    var active = this.store.routeState?.section === 'documents' ? this.store.routeState.tab : this.store.ui?.activeTabs?.documents;
    if (!['all', 'quotes', 'invoices', 'production'].includes(active)) active = 'all';
    var tabs = [
      ['all', this.t('documents.all', 'Tous')], ['quotes', this.t('documents.quotes', 'Devis et PO')],
      ['invoices', this.t('documents.invoices', 'Factures')], ['production', this.t('documents.production', 'Production et logistique')]
    ];
    var filtered = filterDocumentResources(items, active);
    var list = filtered.length ? '<div class="portal-v1__list">' + filtered.map(function (item) {
      var relation = item.project?.title || item.campaign?.title || '';
      var money = item.amount_minor === null ? '' : formatMinor(item.amount_minor, item.currency, self.store.context.locale);
      var metadata = [self.backendLabel('document', item.document_kind), self.t('document_status.' + item.status, item.status), item.document_date ? formatDate(item.document_date, self.store.context.locale) : '', relation, money].filter(Boolean).join(' · ');
      var action = item.allowed_actions.includes('download')
        ? '<button type="button" data-portal-document-download="' + escapeHtml(item.id) + '">' + escapeHtml(self.t('documents.download', self.t('action.download', 'Télécharger'))) + '</button>' : '';
      if (item.current_version_id) action = '<a class="portal-v1__button" href="#documents/' + escapeHtml(item.id) + '/overview">'
        + escapeHtml(self.t(item.document_kind === 'quote' ? 'quote.review' : 'action.open', 'Ouvrir')) + '</a>';
      return '<article><div><h2>' + escapeHtml(item.title) + '</h2><p>' + escapeHtml(metadata) + '</p></div>' + action + '</article>';
    }).join('') + '</div>' : '<p class="portal-v1__empty">' + escapeHtml(this.t('refresh.documents_empty')) + '</p>';
    return this.heading('page.documents', 'Documents')
      + '<div class="portal-v1__tabs" role="tablist" aria-label="' + escapeHtml(this.t('documents.tabs_label', 'Vues des documents')) + '">'
      + tabs.map(function (tab) {
        return '<a id="PortalDocumentsTab-' + tab[0] + '" href="' + (tab[0] === 'all' ? '#documents' : '#documents/' + tab[0])
          + '" role="tab" aria-controls="PortalDocumentsPanel-' + tab[0] + '" aria-selected="' + (tab[0] === active ? 'true' : 'false')
          + '" tabindex="' + (tab[0] === active ? '0' : '-1') + '">' + escapeHtml(tab[1]) + '</a>';
      }).join('') + '</div>'
      + tabs.map(function (tab) {
        return '<section id="PortalDocumentsPanel-' + tab[0] + '" role="tabpanel" aria-labelledby="PortalDocumentsTab-' + tab[0] + '"'
          + (tab[0] === active ? '' : ' hidden') + '>' + (tab[0] === active ? list : '') + '</section>';
      }).join('');
  };

  PortalV1App.prototype.renderDocumentDetail = function () {
    var self = this;
    var documentResource = this.store.documentDetail;
    var versions = this.store.documentVersions || [];
    var decisions = this.store.documentDecisions || [];
    var current = versions.find(function (item) { return item.id === documentResource.current_version_id; });
    var actorRole = this.store.context.actor?.role;
    var canDecide = ['admin', 'approver'].includes(actorRole) && canAction(documentResource, 'decide')
      && documentResource.document_kind === 'quote' && documentResource.status === 'published' && !!current;
    var actions = current && canAction(documentResource, 'download') ? '<button class="is-primary" type="button" data-portal-document-version-download="'
      + escapeHtml(current.id) + '">' + escapeHtml(this.t('documents.download', 'Télécharger le PDF')) + '</button>' : '';
    var form = canDecide ? '<form class="portal-v1__quote-decision" data-portal-quote-decision-form><h2>'
      + escapeHtml(this.t('quote.review')) + '</h2><p>' + escapeHtml(this.t('quote.decision_help')) + '</p>'
      + '<label class="portal-v1__field"><span>' + escapeHtml(this.t('quote.comment')) + '</span><textarea name="comment" maxlength="2000" rows="4"></textarea></label>'
      + '<label class="portal-v1__quote-confirm"><input type="checkbox" name="confirmed" required><span>' + escapeHtml(this.t('quote.confirm')) + '</span></label>'
      + '<p class="portal-v1__form-error" data-portal-quote-error role="alert" tabindex="-1"></p><div class="portal-v1__actions">'
      + '<button type="submit" class="is-primary" name="decision" value="accepted">' + escapeHtml(this.t('quote.accept')) + '</button>'
      + '<button type="submit" name="decision" value="changes_requested">' + escapeHtml(this.t('quote.request_changes')) + '</button></div></form>'
      : documentResource.document_kind === 'quote' && documentResource.status === 'published'
        ? '<p class="portal-v1__readonly">' + escapeHtml(this.t('quote.readonly')) + '</p>' : '';
    var history = '<section class="portal-v1__quote-history"><h2>' + escapeHtml(this.t('quote.history')) + '</h2>'
      + (versions.length ? '<ol class="portal-v1__timeline">' + versions.map(function (version) {
        var versionDecisions = decisions.filter(function (item) { return item.document_version_id === version.id; });
        return '<li><div><strong>' + escapeHtml(self.t('quote.version', undefined, { version: version.version_number })) + '</strong><p>'
          + escapeHtml(self.t('quote.published_at', undefined, { date: formatDate(version.published_at, self.store.context.locale) })) + '</p>'
          + versionDecisions.map(function (decision) { return '<div class="portal-v1__quote-history-decision"><strong>' + escapeHtml(self.t('quote.' + decision.decision)) + '</strong><p>'
            + escapeHtml(self.t('quote.decision_by', undefined, { name: decision.actor_name, date: formatDate(decision.created_at, self.store.context.locale) })) + '</p>'
            + (decision.comment ? '<p>' + escapeHtml(decision.comment) + '</p>' : '') + '</div>'; }).join('') + '</div>'
          + (canAction(documentResource, 'download') ? '<button type="button" data-portal-document-version-download="' + escapeHtml(version.id) + '">'
            + escapeHtml(self.t('action.download', 'Télécharger')) + '</button>' : '') + '</li>';
      }).join('') + '</ol>' : '<p>' + escapeHtml(this.t('quote.no_history')) + '</p>') + '</section>';
    var summary = '<section class="portal-v1__quote-summary"><span class="portal-v1__status-pill">'
      + escapeHtml(this.t('document_status.' + documentResource.status, documentResource.status)) + '</span>'
      + (Number.isSafeInteger(documentResource.amount_minor) ? '<p class="portal-v1__quote-amount">'
        + escapeHtml(formatMinor(documentResource.amount_minor, documentResource.currency, this.store.context.locale)) + '</p>' : '')
      + (current ? '<p>' + escapeHtml(this.t('quote.version', undefined, { version: current.version_number })) + '</p>' : '')
      + '<div class="portal-v1__actions">' + actions + '</div></section>';
    return '<header class="portal-v1__page-heading"><div><a href="#documents">' + escapeHtml(this.t('quote.back'))
      + '</a><h1 tabindex="-1" data-portal-route-heading>' + escapeHtml(documentResource.title) + '</h1>'
      + (documentResource.project ? '<p><a href="#projects/' + escapeHtml(documentResource.project.id) + '/quote">'
        + escapeHtml(documentResource.project.title) + '</a></p>' : '') + '</div></header><div class="portal-v1__quote-detail" data-portal-document="'
      + escapeHtml(documentResource.id) + '">' + (this.store.routeState?.tab === 'history' ? history : summary + form + history) + '</div>';
  };

  PortalV1App.prototype.submitDocumentDecision = async function (form, submitter) {
    var self = this;
    var documentResource = this.store.documentDetail;
    var current = (this.store.documentVersions || []).find(function (item) { return item.id === documentResource?.current_version_id; });
    var errorTarget = form.querySelector('[data-portal-quote-error]');
    var decision = submitter?.value;
    var comment = String(form.querySelector('[name="comment"]')?.value || '').trim();
    var confirmed = form.querySelector('[name="confirmed"]')?.checked === true;
    if (!['admin', 'approver'].includes(this.store.context.actor?.role)) return;
    if (!confirmed || (decision === 'changes_requested' && !comment)) {
      if (errorTarget) { errorTarget.textContent = this.t(!confirmed ? 'quote.confirm_required' : 'quote.comment_required'); errorTarget.focus?.(); }
      return;
    }
    var payload;
    try { payload = buildDocumentDecision(documentResource, current, { decision: decision, comment: comment, confirmed: confirmed }); }
    catch (error) { if (errorTarget) errorTarget.textContent = this.t('quote.version_conflict'); return; }
    return this.guard.run('quote-decision:' + documentResource.id + ':' + documentResource.version, async function () {
      form.setAttribute('aria-busy', 'true');
      form.querySelectorAll('button, textarea, input').forEach(function (control) { control.disabled = true; });
      try {
        await self.api.mutate('/client/v1/documents/' + encodeURIComponent(documentResource.id) + '/decisions', {
          operation: 'document.decide', resource: documentResource.id, expectedVersion: documentResource.version, body: payload
        });
        if (self.store.routeState?.section !== 'documents' || self.store.routeState?.resourceId !== documentResource.id) return;
        await self.loadRoute('documents');
        self.renderRoute('documents');
        self.view.querySelector('[data-portal-route-heading]')?.focus({ preventScroll: true });
      } catch (error) {
        if (error?.status === 409) {
          if (self.store.routeState?.section !== 'documents' || self.store.routeState?.resourceId !== documentResource.id) return;
          await self.loadRoute('documents');
          self.renderRoute('documents');
          self.view.insertAdjacentHTML('afterbegin', '<p class="portal-v1__warning" role="alert">' + escapeHtml(self.t('quote.version_conflict')) + '</p>');
        } else if (errorTarget) errorTarget.textContent = self.t('quote.save_failed');
      } finally {
        form.removeAttribute('aria-busy');
        form.querySelectorAll('button, textarea, input').forEach(function (control) { control.disabled = false; });
      }
    });
  };

  PortalV1App.prototype.renderTeam = function () {
    var self = this;
    var teamResource = this.store.resources.team || [];
    var items = Array.isArray(teamResource.members) ? teamResource.members : teamResource;
    var capabilities = this.store.capabilities || this.store.context.capabilities || {};
    var canInvite = capabilities.manage_invitations === true;
    var canAdminEnterprise = capabilities.enterprise_admin === true;
    var roles = Array.isArray(capabilities.invitable_roles)
      ? capabilities.invitable_roles.filter(function (role) { return ['viewer', 'requester', 'approver', 'admin'].includes(role); }) : [];
    var members = items.map(function (item) {
      var actions = Array.isArray(item.allowed_actions) ? item.allowed_actions : [];
      var controls = actions.length ? '<form data-portal-member-form data-member-id="' + escapeHtml(item.id) + '" data-version="' + escapeHtml(item.version) + '">'
        + (actions.includes('change_role') ? '<label><span>' + escapeHtml(self.t('team.role', 'Rôle')) + '</span><select name="role">'
          + ['viewer', 'requester', 'approver', 'admin'].map(function (role) { return '<option value="' + role + '"' + (role === item.role ? ' selected' : '') + '>'
            + escapeHtml(self.t('role.' + role, role)) + '</option>'; }).join('') + '</select></label>' : '<input type="hidden" name="role" value="' + escapeHtml(item.role) + '">')
        + '<div class="portal-v1__actions">' + (actions.includes('change_role') ? '<button type="submit" name="action" value="change_role">' + escapeHtml(self.t('action.save', 'Enregistrer')) + '</button>' : '')
        + (actions.includes('deactivate') ? '<button type="submit" name="action" value="deactivate">' + escapeHtml(self.t('team.revoke', 'Retirer')) + '</button>' : '')
        + (actions.includes('reactivate') ? '<button type="submit" name="action" value="reactivate">' + escapeHtml(self.t('action.reactivate', 'Réactiver')) + '</button>' : '') + '</div></form>' : '';
      return '<article><div><h2>' + escapeHtml(portalMemberLabel(item) || self.t('team.member', 'Membre')) + '</h2><p>'
        + escapeHtml(self.t('role.' + item.role, item.role)) + '</p></div>' + controls + '</article>';
    }).join('') || '<p class="portal-v1__empty">' + escapeHtml(this.t('team.empty', 'Aucun membre.')) + '</p>';
    var invitations = Array.isArray(teamResource.invitations) ? teamResource.invitations : Array.isArray(this.store.invitations) ? this.store.invitations : [];
    var now = Date.now();
    invitations = invitations.filter(function (invitation) { return pendingPortalInvitation(invitation, now); });
    var invitationList = '<section class="portal-v1__team-invitations"><h2>' + escapeHtml(this.t('team.invitations', 'Invitations')) + '</h2>'
      + (invitations.length ? invitations.map(function (invitation) {
        return '<article><div><strong>' + escapeHtml(portalMemberLabel(invitation) || self.t('team.invitation', 'Invitation')) + '</strong><p>'
          + escapeHtml(self.t('role.' + invitation.role, invitation.role)) + '</p></div>'
          + (canAction(invitation, 'revoke') ? '<form data-portal-invitation-form data-invitation-id="' + escapeHtml(invitation.id) + '" data-version="' + escapeHtml(invitation.version)
            + '"><button type="submit">' + escapeHtml(self.t('team.revoke', 'Révoquer')) + '</button></form>' : '') + '</article>';
      }).join('') : '<p class="portal-v1__empty">—</p>') + '</section>';
    var inviteForm = canInvite && roles.length && Number.isSafeInteger(this.store.companyResource?.version)
      ? '<form class="portal-v1__team-invite" data-portal-invite-form><h2>' + escapeHtml(this.t('action.invite', 'Inviter un membre')) + '</h2>'
        + '<label><span>' + escapeHtml(this.t('team.email', 'E-mail')) + '</span><input name="email" type="email" autocomplete="off" required></label>'
        + '<label><span>' + escapeHtml(this.t('team.role', 'Rôle')) + '</span><select name="role">' + roles.map(function (role) {
          return '<option value="' + role + '">' + escapeHtml(self.t('role.' + role, role)) + '</option>';
        }).join('') + '</select></label><p data-portal-team-error role="alert"></p><button type="submit" class="is-primary">'
        + escapeHtml(this.t('action.invite', 'Inviter')) + '</button></form>'
      : '<p class="portal-v1__readonly">' + escapeHtml(this.t('team.readonly', 'Vous pouvez consulter l’équipe, mais pas modifier ses accès.')) + '</p>';
    var summaries = [
      ['viewer', this.t('team.right_viewer', 'Viewer : consulte sans modifier.')],
      ['requester', this.t('team.right_requester', 'Requester : prépare les demandes et expéditions autorisées.')],
      ['approver', this.t('team.right_approver', 'Approver : valide les BAT, coûts et activations autorisés.')],
      ['admin', this.t('team.right_admin', 'Admin : gère l’équipe, les règles, portées et plafonds.')]
    ].map(function (entry) { return '<li><strong>' + escapeHtml(self.t('role.' + entry[0], entry[0])) + '</strong> — ' + escapeHtml(entry[1]) + '</li>'; }).join('');
    var scopes = Array.isArray(teamResource.memberScopes) ? teamResource.memberScopes : [];
    var caps = Array.isArray(teamResource.budgetCaps) ? teamResource.budgetCaps : [];
    var rules = Array.isArray(teamResource.approvalRules) ? teamResource.approvalRules : [];
    var decisions = Array.isArray(teamResource.approvalDecisions) ? teamResource.approvalDecisions : [];
    var scopesHtml = scopes.length ? '<ul>' + scopes.map(function (scope) {
      return '<li><strong>' + escapeHtml(scope.scope_title || scope.scope_type) + '</strong><span>' + escapeHtml(scope.scope_type) + '</span></li>';
    }).join('') + '</ul>' : '<p class="portal-v1__empty">—</p>';
    var capsHtml = caps.length ? '<ul>' + caps.map(function (cap) {
      return '<li><strong>' + escapeHtml(formatMinor(cap.cap_minor, cap.currency, self.store.context.locale)) + '</strong><span>' + escapeHtml(cap.scope_type) + '</span></li>';
    }).join('') + '</ul>' : '<p class="portal-v1__empty">—</p>';
    var decisionsHtml = decisions.length ? '<ol class="portal-v1__timeline">' + decisions.map(function (decision) {
      return '<li><strong>' + escapeHtml(decision.action + ' · ' + decision.decision) + '</strong><time datetime="' + escapeHtml(decision.created_at) + '">'
        + escapeHtml(formatDate(decision.created_at, self.store.context.locale)) + '</time></li>';
    }).join('') + '</ol>' : '<p class="portal-v1__empty">—</p>';
    var rulesHtml = rules.length ? rules.map(function (rule) {
      var threshold = rule.threshold_minor === null ? '' : ' · ' + formatMinor(rule.threshold_minor, rule.currency, self.store.context.locale);
      return '<article><div><strong>' + escapeHtml(rule.action) + '</strong><p>' + escapeHtml(rule.scope_type + ' · ' + rule.approver_role + threshold) + '</p></div>'
        + (Array.isArray(rule.allowed_actions) && rule.allowed_actions.includes('disable')
          ? '<button type="button" data-portal-approval-rule-disable="' + escapeHtml(rule.id) + '" data-version="' + escapeHtml(rule.version) + '">' + escapeHtml(self.t('team.disable')) + '</button>' : '') + '</article>';
    }).join('') : '<p class="portal-v1__empty">—</p>';
    var createRule = canAdminEnterprise ? '<details class="portal-v1__enterprise-create"><summary data-portal-approval-rule-create>'
      + escapeHtml(this.t('team.add_rule', 'Ajouter une règle')) + '</summary><form data-portal-approval-rule-form>'
      + '<input type="hidden" name="scope_type" value="company"><label><span>' + escapeHtml(this.t('dashboard.action_column', 'Action')) + '</span><select name="action">'
      + ['campaign.activate', 'proof.approve', 'shipment.cost', 'inventory.reorder'].map(function (action) { return '<option value="' + action + '">' + escapeHtml(action) + '</option>'; }).join('')
      + '</select></label><label><span>' + escapeHtml(this.t('team.role', 'Rôle')) + '</span><select name="approver_role"><option value="approver">Approver</option><option value="admin">Admin</option></select></label>'
      + '<label><span>' + escapeHtml(this.t('team.budget_caps', 'Seuil financier facultatif')) + '</span><input name="threshold_minor" type="number" min="0" step="1" inputmode="numeric"></label>'
      + '<label><span>' + escapeHtml(this.t('campaign.currency', 'Devise')) + '</span><select name="currency"><option value="">—</option><option value="EUR">EUR</option><option value="USD">USD</option><option value="GBP">GBP</option></select></label>'
      + '<p data-portal-team-error role="alert"></p><button type="submit" class="is-primary">' + escapeHtml(this.t('action.submit', 'Enregistrer')) + '</button></form></details>' : '';
    var active = this.store.routeState?.section === 'team' ? this.store.routeState.tab : this.store.ui?.activeTabs?.team;
    if (!['members', 'roles', 'approvals'].includes(active)) active = 'members';
    var tabs = [['members', this.t('team.members', 'Membres')], ['roles', this.t('team.roles', 'Rôles')], ['approvals', this.t('team.approvals', 'Approbations')]];
    var panels = {
      members: '<div class="portal-v1__team">' + members + invitationList + inviteForm + '</div>',
      roles: '<div class="portal-v1__team-governance"><section><h2>' + escapeHtml(this.t('team.rights_summary', 'Résumé des droits')) + '</h2><ul>' + summaries + '</ul></section>'
        + '<section><h2>' + escapeHtml(this.t('team.scopes', 'Portées')) + '</h2>' + scopesHtml + '</section>'
        + '<section><h2>' + escapeHtml(this.t('team.budget_caps', 'Plafonds')) + '</h2>' + capsHtml + '</section></div>',
      approvals: '<div class="portal-v1__team-governance"><section><h2>' + escapeHtml(this.t('team.approvals', 'Approbations')) + '</h2>'
        + createRule + rulesHtml + '</section>'
        + '<section><h2>' + escapeHtml(this.t('team.decision_log', 'Journal')) + '</h2>' + decisionsHtml + '</section></div>'
    };
    return this.heading('page.team', 'Équipe')
      + '<div class="portal-v1__tabs" role="tablist" aria-label="' + escapeHtml(this.t('team.tabs_label', 'Vues équipe')) + '">'
      + tabs.map(function (tab) { return '<a id="PortalTeamTab-' + tab[0] + '" href="' + (tab[0] === 'members' ? '#team' : '#team/' + tab[0])
        + '" role="tab" aria-controls="PortalTeamPanel-' + tab[0] + '" aria-selected="' + (tab[0] === active ? 'true' : 'false')
        + '" tabindex="' + (tab[0] === active ? '0' : '-1') + '">' + escapeHtml(tab[1]) + '</a>'; }).join('') + '</div>'
      + tabs.map(function (tab) { return '<section id="PortalTeamPanel-' + tab[0] + '" role="tabpanel" aria-labelledby="PortalTeamTab-' + tab[0] + '"'
        + (tab[0] === active ? '' : ' hidden') + '>' + panels[tab[0]] + '</section>'; }).join('');
  };

  PortalV1App.prototype.renderGlobalSearch = function () {
    var self = this;
    var items = (this.store.resources.search || []).map(normalizeGlobalSearchResult);
    if (this.store.ui?.searchBusy) return '<p role="status">' + escapeHtml(this.t('search.loading', 'Recherche…')) + '</p>';
    if (this.store.ui?.searchError) return '<p role="alert">' + escapeHtml(this.store.ui.searchError) + '</p>';
    if (!items.length) return '<p class="portal-v1__empty">' + escapeHtml(this.t('search.empty', 'Aucun résultat')) + '</p>';
    return '<div role="listbox" aria-label="' + escapeHtml(this.t('search.results', 'Résultats')) + '">' + items.map(function (item) {
      return '<a role="option" href="' + escapeHtml(item.href) + '" data-portal-search-result><strong>' + escapeHtml(item.title) + '</strong>'
        + (item.subtitle ? '<span>' + escapeHtml(item.subtitle) + '</span>' : '') + (item.status ? '<small>' + escapeHtml(item.status) + '</small>' : '') + '</a>';
    }).join('') + '</div>';
  };

  PortalV1App.prototype.performGlobalSearch = async function (rawQuery) {
    var query = typeof rawQuery === 'string' && !/[\u0000-\u001f\u007f-\u009f]/u.test(rawQuery)
      ? rawQuery.trim().replace(/\s+/gu, ' ') : '';
    if (query.length < 2 || query.length > 80) {
      this.store.resources.search = [];
      this.store.ui.searchError = this.t('search.invalid', 'Saisissez entre 2 et 80 caractères.');
      if (this.searchResults) this.searchResults.innerHTML = this.renderGlobalSearch();
      return;
    }
    this.store.ui.searchBusy = true;
    this.store.ui.searchError = '';
    if (this.searchResults) this.searchResults.innerHTML = this.renderGlobalSearch();
    try {
      var page = normalizeGlobalSearchPage(await this.api.request('/client/v1/search?q=' + encodeURIComponent(query) + '&limit=20'));
      this.store.resources.search = page.items;
    } catch (error) {
      this.store.resources.search = [];
      this.store.ui.searchError = this.t('search.failed', 'La recherche est momentanément indisponible.');
    } finally {
      this.store.ui.searchBusy = false;
      if (this.searchResults) this.searchResults.innerHTML = this.renderGlobalSearch();
    }
  };

  PortalV1App.prototype.runTeamMutation = function (form, key, task) {
    var self = this;
    return this.guard.run(key, async function () {
      form.setAttribute('aria-busy', 'true');
      form.querySelectorAll('button, input, select').forEach(function (control) { control.disabled = true; });
      try {
        await task();
        await self.navigate(self.store.routeState?.section === 'team' ? self.store.routeState : 'team');
      } catch (error) {
        var recovery = await recoverPortalError(error, function () { return self.navigate('team'); });
        if (recovery === 'unhandled') {
          var target = form.querySelector('[data-portal-team-error]');
          if (target) target.textContent = self.t('errors.generic', 'Action impossible.')
            + (error?.request_id ? ' ' + self.t('errors.request_id', 'Référence : {{request_id}}', { request_id: error.request_id }) : '');
        }
      } finally {
        form.removeAttribute('aria-busy');
        form.querySelectorAll('button, input, select').forEach(function (control) { control.disabled = false; });
      }
    });
  };

  PortalV1App.prototype.submitTeamInvite = function (form) {
    var company = this.store.companyResource;
    var email = String(form.elements.email?.value || '').trim();
    var role = String(form.elements.role?.value || '');
    var roles = this.store.context.capabilities.invitable_roles || [];
    if (!Number.isSafeInteger(company?.version) || !email || !roles.includes(role)) return Promise.resolve(null);
    var self = this;
    return this.runTeamMutation(form, 'team-invite:' + company.version + ':' + email + ':' + role, function () {
      return self.api.mutate('/client/v1/invitations', {
        operation: 'team.invite', resource: company.id || 'company', expectedVersion: company.version,
        body: { email: email, role: role }
      });
    });
  };

  PortalV1App.prototype.submitApprovalRule = function (form) {
    if (this.store.context.capabilities.enterprise_admin !== true) return Promise.resolve(null);
    var action = String(form.elements.action?.value || '');
    var approverRole = String(form.elements.approver_role?.value || '');
    var thresholdRaw = String(form.elements.threshold_minor?.value || '').trim();
    var currencyRaw = String(form.elements.currency?.value || '').trim();
    var thresholdMinor = thresholdRaw === '' ? null : Number(thresholdRaw);
    var currency = thresholdMinor === null ? null : currencyRaw;
    if (!['campaign.activate', 'proof.approve', 'shipment.cost', 'inventory.reorder'].includes(action)
      || !['approver', 'admin'].includes(approverRole)
      || !(thresholdMinor === null || Number.isSafeInteger(thresholdMinor) && thresholdMinor >= 0
        && ['EUR', 'USD', 'GBP'].includes(currency))) {
      var target = form.querySelector('[data-portal-team-error]');
      if (target) target.textContent = this.t('errors.validation', 'Vérifiez les champs signalés.');
      return Promise.resolve(null);
    }
    var self = this;
    return this.runTeamMutation(form, 'approval-rule-create:' + action + ':' + approverRole + ':' + String(thresholdMinor), function () {
      return self.api.mutate('/client/v1/approval-rules', {
        operation: 'approval-rule.create', resource: 'approval-rule', expectedVersion: 0,
        body: { operation: 'create', scope_type: 'company', scope_id: null, action: action, approver_role: approverRole, threshold_minor: thresholdMinor, currency: currency, active: true }
      });
    });
  };

  PortalV1App.prototype.submitTeamMember = function (form, submitter) {
    var member = this.store.resources.team.find(function (item) { return item.id === form.dataset.memberId; });
    var action = submitter?.value || '';
    var requiredAction = action === 'change_role' ? 'change_role' : action === 'deactivate' ? 'deactivate' : action === 'reactivate' ? 'reactivate' : '';
    if (!member || !requiredAction || !canAction(member, requiredAction)) return Promise.resolve(null);
    var role = String(form.elements.role?.value || member.role);
    var active = action !== 'deactivate';
    var method = action === 'deactivate' ? 'DELETE' : 'PATCH';
    var self = this;
    return this.runTeamMutation(form, 'team-member:' + member.id + ':' + member.version + ':' + action + ':' + role, function () {
      return self.api.mutate('/client/v1/members/' + encodeURIComponent(member.id), {
        operation: 'team.member.' + action, resource: member.id, expectedVersion: member.version, method: method,
        body: { role: role, active: active }
      });
    });
  };

  PortalV1App.prototype.unmountCustomerAuth = function () {
    if (!this.customerAuthMounted) return;
    this.customerAuthMounted = false;
    try { window.TodayMerchPortalAccess?.unmountCustomerAuth?.(); } catch (error) { /* logout and fallback links remain available */ }
  };

  PortalV1App.prototype.mountCustomerAuth = function (container) {
    if (!container || !window.TodayMerchPortalAccess?.isCustomerAuthEnabled?.()) return false;
    var self = this;
    this.unmountCustomerAuth();
    var mounted = window.TodayMerchPortalAccess.mountCustomerAuth(container, {
      returnTo: window.TodayMerchPortalAccess.portalPath || this.root.dataset.accountUrl || window.location.pathname,
      onAuthenticated: async function () {
        self.unmountCustomerAuth();
        try { await self.bootstrap(); } catch (error) {
          if (self.api?.locked && (error?.status === 401 || ['AUTHENTICATION_REQUIRED', 'APP_PROXY_INVALID'].includes(error?.code))) return;
          if (self.shell) self.shell.hidden = false;
          self.renderError(error);
        }
      },
      onError: function (error) {
        var target = container.querySelector('[data-portal-auth-error]') || document.createElement('p');
        target.dataset.portalAuthError = '';
        target.setAttribute('role', 'alert');
        target.textContent = self.t('errors.generic', 'Réessayez.');
        if (!target.parentNode) container.append(target);
        if (error?.code === 'AUTHENTICATION_REQUIRED') self.api?.lock?.();
      },
    });
    this.customerAuthMounted = mounted === true;
    return this.customerAuthMounted;
  };

  PortalV1App.prototype.nativeCustomerLogoutUrl = function () {
    var candidate = this.root?.dataset?.logoutUrl || '/customer_authentication/logout';
    var url;
    try { url = new URL(candidate, window.location.origin); }
    catch (error) { url = new URL('/customer_authentication/logout', window.location.origin); }
    var path = url.pathname;
    if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?(?:account|customer_authentication)\/logout\/?$/iu.test(path)) {
      url = new URL('/customer_authentication/logout', window.location.origin);
    } else {
      url.search = '';
      url.hash = '';
    }
    url.searchParams.set('return_url', '/pages/espace-client');
    return url.pathname + url.search;
  };

  PortalV1App.prototype.logoutCustomerAuth = async function () {
    this.portalAuthChannel?.postMessage({ type: 'logout' });
    this.clearRouteCache();
    this.api?.clearCache?.();
    this.unmountCustomerAuth();
    await window.TodayMerchPortalAccess?.logout?.();
    this.api?.lock?.();
    var target = this.nativeCustomerLogoutUrl();
    if (typeof window.location?.assign === 'function') { window.location.assign(target); return; }
    window.location.href = target;
  };

  PortalV1App.prototype.revokeTeamInvitation = function (form) {
    var invitation = (this.store.invitations || []).find(function (item) { return item.id === form.dataset.invitationId; });
    if (!invitation || !canAction(invitation, 'revoke')) return Promise.resolve(null);
    var self = this;
    return this.runTeamMutation(form, 'team-invitation-revoke:' + invitation.id + ':' + invitation.version, function () {
      return self.api.mutate('/client/v1/invitations/' + encodeURIComponent(invitation.id), {
        operation: 'team.invitation.revoke', resource: invitation.id, expectedVersion: invitation.version, method: 'DELETE', body: {}
      });
    });
  };

  PortalV1App.prototype.renderError = function (error) {
    if (this.api?.locked || [401, 403, 423].includes(error?.status)) this.clearRouteCache();
    if (this.api?.locked) error = { status: 401, code: 'AUTHENTICATION_REQUIRED' };
    var access = window.TodayMerchPortalAccess;
    this.accessWasAuthenticated = this.accessWasAuthenticated || !!this.store.context.actor;
    var accessState = access?.classifyError(error, { authenticated: this.accessWasAuthenticated });
    if (accessState) {
      this.root.classList.add('is-access-blocked');
      this.surface?.classList.add('is-access-blocked');
      this.setMobileNavigationOpen(false);
      this.root.querySelectorAll('dialog').forEach(function (dialog) { dialog.close?.(); dialog.innerHTML = ''; });
      this.store = createPortalStore({ locale: this.store.context.locale });
      this.companyContexts?.forEach(function (element) { element.textContent = ''; });
      this.proofInDialog = null;
      this.proofPreviewExpiryTimers?.forEach(function (timer) { window.clearTimeout(timer); });
      this.proofPreviewExpiryTimers?.clear();
      var href = accessState.action === 'login' ? access.loginUrl()
        : accessState.action === 'logout' ? this.root.dataset.logoutUrl || '/account/logout'
          : accessState.action === 'contact' ? 'mailto:team@todaymerch.com' : access.portalPath;
      var inlineAuth = accessState.action === 'login' && access?.isCustomerAuthEnabled?.();
      var logoutAuth = accessState.action === 'logout' && access?.isCustomerAuthEnabled?.();
      var actionMarkup = inlineAuth ? '<div class="portal-v1__auth-mount" data-portal-auth-mount></div>'
        : logoutAuth ? '<button type="button" class="portal-v1__button" data-portal-auth-logout>' + escapeHtml(this.t(accessState.actionKey)) + '</button>'
          : '<a class="portal-v1__button" href="' + escapeHtml(href) + '">' + escapeHtml(this.t(accessState.actionKey)) + '</a>';
      this.view.innerHTML = '<section class="portal-v1__access-state" data-portal-access-state="' + escapeHtml(accessState.state)
        + '"><h1 tabindex="-1" data-portal-route-heading>' + escapeHtml(this.t(accessState.titleKey)) + '</h1><p>'
        + escapeHtml(this.t(accessState.bodyKey)) + '</p>' + actionMarkup + '</section>';
      if (inlineAuth && !this.mountCustomerAuth(this.view.querySelector('[data-portal-auth-mount]'))) {
        this.view.querySelector('[data-portal-auth-mount]')?.replaceWith(Object.assign(document.createElement('a'), { className: 'portal-v1__button', href: href, textContent: this.t(accessState.actionKey) }));
      }
      return;
    }
    if (!this.view) return;
    if (error?.invitation_accept_failed === true) {
      this.view.innerHTML = this.heading('invitation.accept_failed_title', 'Invitation non acceptée')
        + '<div class="portal-v1__error" role="alert"><p>'
        + escapeHtml(this.t('invitation.accept_failed_body', 'Vérifiez le lien ou demandez une nouvelle invitation.'))
        + '</p><a class="portal-v1__button" href="' + escapeHtml(access?.portalPath || this.root.dataset.accountUrl || '/') + '">'
        + escapeHtml(this.t('invitation.return_account', 'Retour au compte')) + '</a></div>';
      return;
    }
    var key = error?.code === 'VERSION_CONFLICT' ? 'errors.version_conflict' : error?.code === 'ACTION_FORBIDDEN' ? 'errors.forbidden' : 'errors.generic';
    this.view.innerHTML = this.heading('errors.title', 'Impossible de charger cette vue')
      + '<div class="portal-v1__error" role="alert"><p>' + escapeHtml(this.t(key, 'Réessayez.')) + '</p>'
      + (error?.request_id ? '<small>' + escapeHtml(this.t('errors.request_id', 'Référence : {{request_id}}', { request_id: error.request_id })) + '</small>' : '')
      + (this.bound ? '<button type="button" data-portal-retry>' + escapeHtml(this.t('action.retry', 'Réessayer')) + '</button>'
        : '<a class="portal-v1__button" href="' + escapeHtml(access?.portalPath || this.root.dataset.accountUrl || '/') + '">' + escapeHtml(this.t('action.retry', 'Réessayer')) + '</a>') + '</div>';
  };

  PortalV1App.prototype.handleClick = async function (event) {
    var authLogout = event.target.closest('[data-portal-auth-logout]');
    var nativeLogout = event.target.closest('a[href*="/account/logout"], a[href*="/customer_authentication/logout"]');
    if (nativeLogout && !window.TodayMerchPortalAccess?.isCustomerAuthEnabled?.()) {
      this.portalAuthChannel?.postMessage({ type: 'logout' });
      this.clearRouteCache();
      this.api?.lock?.();
      this.store = createPortalStore({ locale: this.store.context.locale });
      if (this.view) this.view.innerHTML = '';
      return;
    }
    if ((authLogout || nativeLogout) && window.TodayMerchPortalAccess?.isCustomerAuthEnabled?.()) {
      event.preventDefault();
      await this.logoutCustomerAuth();
      return;
    }
    if (event.target.closest('[data-portal-search-result]')) this.searchDialog?.close();
    if (event.target.closest('[data-portal-notification-link]')) this.notificationsDialog?.close();
    var documentVersionDownload = event.target.closest('[data-portal-document-version-download]');
    if (documentVersionDownload) {
      var downloadDocument = this.store.documentDetail;
      var versionId = documentVersionDownload.dataset.portalDocumentVersionDownload;
      if (!downloadDocument || !canAction(downloadDocument, 'download')
        || !(this.store.documentVersions || []).some(function (item) { return item.id === versionId; })) return;
      documentVersionDownload.disabled = true;
      try {
        await this.openDownload('/client/v1/documents/' + encodeURIComponent(downloadDocument.id) + '/versions/' + encodeURIComponent(versionId) + '/download');
      } catch (error) { this.renderError(error); }
      finally { documentVersionDownload.disabled = false; }
      return;
    }
    var dashboardCampaignCreate = event.target.closest('[data-dashboard-create-campaign]');
    var campaignCreate = event.target.closest('[data-campaign-create]') || dashboardCampaignCreate;
    var campaignEdit = event.target.closest('[data-campaign-edit]');
    if (campaignCreate || campaignEdit) {
      if (campaignCreate && (this.store.context.capabilities.campaigns_create !== true
        || this.store.context.product_capabilities?.campaign_proof !== true)) return;
      if (dashboardCampaignCreate) {
        event.preventDefault();
        dashboardCampaignCreate.disabled = true;
        try {
          await this.navigate(parsePortalRoute('#campaigns'));
          if (this.api?.locked || this.store.request.error || this.store.ui.moduleUnavailable
            || this.store.routeState?.section !== 'campaigns') return;
          window.history?.pushState?.(null, '', '#campaigns');
        } finally { dashboardCampaignCreate.disabled = false; }
        return;
      }
      var editable = campaignEdit && this.store.campaignDetail?.id === campaignEdit.dataset.campaignEdit
        && this.store.campaignDetail.allowed_actions.includes('update') ? this.store.campaignDetail : null;
      if (campaignEdit && !editable) return;
      this.campaignTrigger = campaignEdit
        ? { kind: 'edit', id: campaignEdit.dataset.campaignEdit }
        : { kind: 'create' };
      this.store.campaignEditor = editable || 'create';
      this.renderRoute('campaigns');
      var campaignDialog = this.view?.querySelector('[data-portal-campaign-dialog]');
      var campaignApp = this;
      campaignDialog?.addEventListener('cancel', function (cancelEvent) {
        cancelEvent.preventDefault();
        campaignApp.closeCampaignEditor();
      }, { once: true });
      campaignDialog?.showModal();
      campaignDialog?.querySelector('[name="name"]')?.focus();
      return;
    }
    if (event.target.closest('[data-campaign-close]')) {
      this.closeCampaignEditor();
      return;
    }
    var notificationRead = event.target.closest('[data-portal-notification-read]');
    if (notificationRead) {
      var notification = this.store.resources.notifications.find(function (item) { return item.id === notificationRead.dataset.portalNotificationRead; });
      if (!notification || !canAction(notification, 'mark_read')) return;
      var self = this;
      await this.guard.run('notification-read:' + notification.id + ':' + notification.version, async function () {
        notificationRead.disabled = true;
        try {
          var result = await self.api.mutate('/client/v1/notifications/' + encodeURIComponent(notification.id) + '/read', {
            operation: 'notification.read', resource: notification.id, expectedVersion: notification.version, body: {}
          });
          Object.assign(notification, { version: result.version, read_at: result.read_at, allowed_actions: [] });
          self.applyNotificationBadge(self.store.resources.notifications);
          if (self.notificationsList) self.notificationsList.innerHTML = self.renderNotifications();
        } finally { notificationRead.disabled = false; }
      });
      return;
    }
    var ruleDisable = event.target.closest('[data-portal-approval-rule-disable]');
    if (ruleDisable) {
      var team = this.store.resources.team || [];
      var rule = (team.approvalRules || []).find(function (item) { return item.id === ruleDisable.dataset.portalApprovalRuleDisable; });
      if (!rule || !canAction(rule, 'disable')) return;
      ruleDisable.disabled = true;
      try {
        await this.api.mutate('/client/v1/approval-rules/' + encodeURIComponent(rule.id), {
          operation: 'approval-rule.disable', resource: rule.id, expectedVersion: rule.version, method: 'PATCH',
          body: { operation: 'disable', id: rule.id }
        });
        await this.navigate({ section: 'team', tab: 'approvals', canonicalHash: '#team/approvals', valid: true });
      } catch (error) { this.renderError(error); } finally { ruleDisable.disabled = false; }
      return;
    }
    var inventoryView = event.target.closest('[data-portal-inventory-view]');
    if (inventoryView) {
      this.store.inventoryView = inventoryView.dataset.portalInventoryView;
      this.renderRoute('stock');
      this.view?.querySelector('[data-portal-inventory-view="' + this.store.inventoryView + '"]')?.focus({ preventScroll: true });
      return;
    }
    if (event.target.closest('[data-portal-inventory-export]')) {
      var csvItems = filterInventoryResources(this.store.resources.inventory, this.store.inventorySearch, this.store.inventoryFilter, this.store.context.locale);
      var csv = inventoryCsv(csvItems, this.t.bind(this));
      var blobUrl = URL.createObjectURL(new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' }));
      var download = document.createElement('a');
      download.href = blobUrl;
      download.download = 'todaymerch-stock.csv';
      download.click();
      URL.revokeObjectURL(blobUrl);
      return;
    }
    var shipmentPrefill = event.target.closest('[data-portal-inventory-shipment]');
    if (shipmentPrefill) {
      var shipmentItem = this.store.resources.inventory.find(function (item) {
        return item.item_id === shipmentPrefill.dataset.portalInventoryShipment
          && item.warehouse_id === shipmentPrefill.dataset.portalInventoryWarehouse;
      });
      if (shipmentItem && shipmentItem.allowed_actions.includes('create_shipment')) this.openWizard(shipmentItem);
      return;
    }
    var reorderButton = event.target.closest('[data-portal-inventory-reorder]');
    if (reorderButton) {
      var reorderItem = this.store.resources.inventory.find(function (item) {
        return item.item_id === reorderButton.dataset.portalInventoryReorder
          && item.warehouse_id === reorderButton.dataset.portalInventoryWarehouse;
      });
      if (!reorderItem || !reorderItem.allowed_actions.includes('request_reorder')) return;
      this.store.reorderItem = reorderItem;
      this.renderRoute('stock');
      var reorderDialog = this.view?.querySelector('[data-portal-reorder-dialog]');
      reorderDialog?.showModal();
      this.view?.querySelector('[data-portal-reorder-form] [name="quantity"]')?.focus();
      var self = this;
      reorderDialog?.addEventListener('cancel', function () {
        self.store.reorderItem = null;
        self.renderRoute('stock');
        window.requestAnimationFrame(function () {
          self.view?.querySelector('[data-portal-inventory-reorder="' + CSS.escape(reorderItem.item_id) + '"][data-portal-inventory-warehouse="'
            + CSS.escape(reorderItem.warehouse_id) + '"]')?.focus({ preventScroll: true });
        });
      }, { once: true });
      return;
    }
    if (event.target.closest('[data-portal-reorder-close]')) {
      var reorderItemId = this.store.reorderItem?.item_id;
      var reorderWarehouseId = this.store.reorderItem?.warehouse_id;
      this.view?.querySelector('[data-portal-reorder-dialog]')?.close();
      this.store.reorderItem = null;
      this.renderRoute('stock');
      var view = this.view;
      window.requestAnimationFrame(function () {
        if (reorderItemId && reorderWarehouseId) view?.querySelector('[data-portal-inventory-reorder="' + CSS.escape(reorderItemId)
          + '"][data-portal-inventory-warehouse="' + CSS.escape(reorderWarehouseId) + '"]')?.focus({ preventScroll: true });
      });
      return;
    }
    if (event.target.closest('[data-portal-proof-cancel]')) {
      event.preventDefault();
      this.dialog?.close('cancel');
      return;
    }
    var previewLoad = event.target.closest('[data-proof-preview-load]');
    if (previewLoad) {
      await this.loadProofPreview(previewLoad.dataset.proofPreviewLoad);
      return;
    }
    var pageStep = event.target.closest('[data-proof-page-step]');
    if (pageStep) {
      var nextPage = Math.max(1, Math.min(10000, this.store.proofSelectedPage + Number(pageStep.dataset.proofPageStep)));
      this.store.proofSelectedPage = nextPage;
      this.store.proofPageAnnouncement = this.t('proof_studio.page_announcement', undefined, { page: nextPage });
      this.renderRoute('proofs');
      return;
    }
    var threadSelection = event.target.closest('[data-proof-thread-select]');
    if (threadSelection) {
      var threadPage = Number(threadSelection.dataset.proofThreadPage);
      if (!Number.isSafeInteger(threadPage) || threadPage < 1 || threadPage > 10000) return;
      var selectedAnnotationId = threadSelection.dataset.proofThreadSelect;
      this.store.proofSelectedPage = threadPage;
      this.store.proofPageAnnouncement = this.t('proof_studio.page_thread_announcement', undefined, { page: threadPage });
      this.renderRoute('proofs');
      window.requestAnimationFrame(function () {
        document.querySelector('[data-proof-annotation="' + CSS.escape(selectedAnnotationId) + '"]')?.focus?.({ preventScroll: true });
      });
      return;
    }
    var previewSurface = event.target.closest('[data-proof-preview-surface]');
    if (previewSurface) {
      var bounds = previewSurface.getBoundingClientRect();
      var form = this.view?.querySelector('[data-proof-annotation-form]');
      if (form && bounds.width > 0 && bounds.height > 0) {
        form.elements.page.value = String(this.store.proofSelectedPage);
        form.elements.x_percent.value = String(Math.max(0, Math.min(100, ((event.clientX - bounds.left) / bounds.width) * 100)).toFixed(2));
        form.elements.y_percent.value = String(Math.max(0, Math.min(100, ((event.clientY - bounds.top) / bounds.height) * 100)).toFixed(2));
        form.elements.comment?.focus();
      }
      return;
    }
    var marker = event.target.closest('[data-proof-marker]');
    if (marker) {
      this.view?.querySelector('[data-proof-annotation="' + CSS.escape(marker.dataset.proofMarker) + '"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var zoom = event.target.closest('[data-proof-zoom]');
    if (zoom) {
      this.store.proofZoom = Math.max(50, Math.min(200, this.store.proofZoom + (zoom.dataset.proofZoom === 'in' ? 25 : -25)));
      this.renderRoute('proofs');
      return;
    }
    if (event.target.closest('[data-proof-comparison-load]')) {
      await this.loadProofComparison();
      return;
    }
    var annotationAction = event.target.closest('[data-proof-annotation-action]');
    if (annotationAction) {
      await this.mutateProofAnnotation(annotationAction.dataset.annotationId, annotationAction.dataset.proofAnnotationAction);
      return;
    }
    if (event.target.closest('[data-portal-shipment-resume]')) {
      this.resumeShipment('single');
      return;
    }
    if (event.target.closest('[data-portal-shipment-import]')) {
      this.resumeShipment('csv');
      return;
    }
    if (event.target.closest('[data-portal-shipment-submit]')) {
      await this.submitActiveShipment();
      return;
    }
    var campaignButton = event.target.closest('[data-campaign-action]');
    if (campaignButton) {
      var campaign = this.store.campaignDetail;
      var action = campaignButton.dataset.campaignAction;
      if (!campaign || !action?.startsWith('transition_') || !campaign.allowed_actions.includes(action)) return;
      var targetStatus = action.slice('transition_'.length);
      var self = this;
      await this.guard.run('campaign:' + campaign.id + ':' + campaign.version + ':' + targetStatus, async function () {
        campaignButton.disabled = true;
        try {
          await self.api.mutate('/client/v1/campaigns/' + encodeURIComponent(campaign.id) + '/transition', {
            operation: 'campaign.transition', resource: campaign.id, expectedVersion: campaign.version,
            body: { target_status: targetStatus }
          });
          await self.navigate(self.store.routeState);
        } catch (error) {
          self.renderError(error);
          self.setRequest(false, error);
        } finally {
          campaignButton.disabled = false;
        }
      });
      return;
    }
    var shipmentPage = event.target.closest('[data-portal-shipment-page]');
    if (shipmentPage) {
      await this.loadShipmentPage(shipmentPage.dataset.portalShipmentPage, shipmentPage.dataset.cursor);
      return;
    }
    var shipmentButton = event.target.closest('[data-portal-shipment]');
    if (shipmentButton) {
      await this.openShipment(shipmentButton.dataset.portalShipment);
      return;
    }
    if (event.target.closest('[data-portal-shipments-back]')) {
      await this.navigate('shipments');
      return;
    }
    var proofHistory = event.target.closest('[data-portal-proof-history]');
    if (proofHistory) {
      await this.loadProofHistory(proofHistory.dataset.portalProofHistory);
      return;
    }
    var proofPage = event.target.closest('[data-portal-proof-page]');
    if (proofPage) {
      await this.loadProofPage(proofPage.dataset.portalProofPage, proofPage.dataset.proofId, proofPage.dataset.cursor);
      return;
    }
    var proofButton = event.target.closest('[data-portal-proof-decision]');
    if (proofButton) {
      var proof = this.store.proofDetail?.id === proofButton.dataset.portalProofDecision ? this.store.proofDetail
        : this.store.resources.proofs.find(function (item) { return item.id === proofButton.dataset.portalProofDecision; });
      if (!proof || !canAction(proof, 'decide')) return;
      this.proofInDialog = { resource: proof, trigger: proofButton };
      this.dialogForm?.reset();
      this.configureProofDecisionDialog(proof);
      this.dialog?.showModal();
      return;
    }
    var proofDownload = event.target.closest('[data-portal-proof-download]');
    if (proofDownload) {
      await this.openDownload('/client/v1/proofs/' + encodeURIComponent(proofDownload.dataset.portalProofDownload)
        + '/versions/' + encodeURIComponent(proofDownload.dataset.versionId) + '/download');
      return;
    }
    var documentDownload = event.target.closest('[data-portal-document-download]');
    if (documentDownload) {
      await this.openDownload('/client/v1/documents/' + encodeURIComponent(documentDownload.dataset.portalDocumentDownload) + '/download');
      return;
    }
    if (event.target.closest('[data-portal-retry]')) { this.invalidateRouteCache([this.store.route]); this.api?.invalidateCache?.(); await this.navigate(this.store.routeState || this.store.route); }
    if (event.target.closest('[data-portal-new-shipment]')) this.openWizard();
    if (event.target.closest('[data-portal-wizard-back]')) {
      this.collectWizardStep();
      this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, {
        type: 'step.changed', step: Math.max(1, this.store.wizard.step - 1)
      });
      this.renderWizard();
    }
    if (event.target.closest('[data-portal-wizard-exit]')) await this.saveAndExitWizard();
    if (event.target.closest('[data-portal-import-replace]')) {
      this.wizardFile = null;
      this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, { type: 'import.replaced' });
      this.renderWizard();
      return;
    }
    if (event.target.closest('[data-portal-import-diagnostics-next]')) {
      await this.loadImportDiagnostics(this.store.wizard.import?.diagnostic_next_cursor || null);
      this.renderWizard();
      return;
    }
  };

  PortalV1App.prototype.openDownload = async function (path) {
    var data = await this.api.request(path);
    var safe = window.TodayMerchPortalApi.sanitizeSignedUrl(data.signed_url);
    if (!safe) throw new Error('Invalid download URL');
    window.open(safe, '_blank', 'noopener,noreferrer');
  };

  PortalV1App.prototype.loadProofPreview = async function (versionId) {
    var proof = this.store.proofDetail;
    if (!proof || !this.store.proofVersions.some(function (version) { return version.id === versionId; })) return;
    var data = await this.api.request('/client/v1/proofs/' + encodeURIComponent(proof.id) + '/versions/' + encodeURIComponent(versionId) + '/preview');
    var safe = window.TodayMerchPortalApi.sanitizeSignedUrl(data.signed_url);
    if (!safe) throw new Error('Invalid preview URL');
    var preview = normalizeProofPreview({ signed_url: safe, expires_at: data.expires_at }, Date.now());
    this.store.proofPreviewUrls[versionId] = preview;
    this.scheduleProofPreviewExpiry(versionId, preview.expires_at);
    this.renderRoute('proofs');
  };

  PortalV1App.prototype.scheduleProofPreviewExpiry = function (versionId, expiresAt) {
    var existing = this.proofPreviewExpiryTimers.get(versionId);
    if (existing !== undefined) window.clearTimeout(existing);
    var self = this;
    function expire() {
      var current = self.store.proofPreviewUrls[versionId];
      if (!current || current.expires_at !== expiresAt) {
        self.proofPreviewExpiryTimers.delete(versionId);
        return;
      }
      var remaining = Date.parse(expiresAt) - Date.now();
      if (remaining > 0) {
        self.proofPreviewExpiryTimers.set(versionId, window.setTimeout(expire, remaining + 10));
        return;
      }
      self.proofPreviewExpiryTimers.delete(versionId);
      if (self.store.route === 'proofs' && self.store.routeState?.isDetail) self.renderRoute('proofs');
    }
    var delay = Math.max(0, Date.parse(expiresAt) - Date.now());
    this.proofPreviewExpiryTimers.set(versionId, window.setTimeout(expire, delay + 10));
  };

  PortalV1App.prototype.loadProofComparison = async function () {
    var comparison = this.store.proofComparison;
    if (!comparison) return;
    await Promise.all([this.loadProofPreview(comparison.left.id), this.loadProofPreview(comparison.right.id)]);
    this.renderRoute('proofs');
  };

  PortalV1App.prototype.submitProofAnnotation = async function (form) {
    var proof = this.store.proofDetail;
    if (!proof || !canAction(proof, 'annotate')) return;
    var payload;
    try {
      payload = buildProofAnnotation(proof, {
        page: form.elements.page?.value,
        x_percent: form.elements.x_percent?.value,
        y_percent: form.elements.y_percent?.value,
        category: form.elements.category?.value,
        comment: form.elements.comment?.value,
      });
      this.store.proofSelectedPage = payload.page;
      this.store.proofPageAnnouncement = this.t('proof_studio.page_announcement', undefined, { page: payload.page });
    } catch (error) {
      form.querySelector('[data-proof-form-error]').textContent = this.t('proof.correction_invalid', 'Vérifiez la page, les coordonnées et le texte de la correction.');
      return;
    }
    var self = this;
    await this.guard.run('proof-annotation:' + proof.id + ':' + proof.version + ':' + payload.page + ':' + payload.x + ':' + payload.y + ':' + payload.comment, async function () {
      form.setAttribute('aria-busy', 'true');
      try {
        await self.api.mutate('/client/v1/proofs/' + encodeURIComponent(proof.id) + '/versions/' + encodeURIComponent(payload.proof_version_id) + '/annotations', {
          operation: 'proof.annotation.create', resource: proof.id, expectedVersion: payload.expected_version, body: payload
        });
        await self.navigate(self.store.routeState);
      } catch (error) {
        form.querySelector('[data-proof-form-error]').textContent = error?.code === 'VERSION_CONFLICT'
          ? self.t('proof_studio.version_conflict') : self.t('proof_studio.correction_failed');
      } finally { form.removeAttribute('aria-busy'); }
    });
  };

  PortalV1App.prototype.submitProofComment = async function (form) {
    var proof = this.store.proofDetail;
    var annotation = this.store.proofAnnotations.find(function (item) { return item.id === form.dataset.annotationId; });
    var payload;
    try { payload = buildProofAnnotationComment(proof, annotation, form.elements.comment?.value); }
    catch (error) { form.querySelector('[data-proof-form-error]').textContent = this.t('proof.reply_invalid', 'Ajoutez une réponse valide.'); return; }
    var self = this;
    await this.guard.run('proof-comment:' + annotation.id + ':' + annotation.version + ':' + payload.comment, async function () {
      form.setAttribute('aria-busy', 'true');
      try {
        await self.api.mutate('/client/v1/proofs/' + encodeURIComponent(proof.id) + '/versions/' + encodeURIComponent(payload.proof_version_id)
          + '/annotations/' + encodeURIComponent(annotation.id) + '/comments', {
          operation: 'proof.annotation.comment', resource: annotation.id, expectedVersion: payload.expected_version, body: payload
        });
        await self.navigate(self.store.routeState);
      } catch (error) { form.querySelector('[data-proof-form-error]').textContent = self.t('proof.reply_failed', 'La réponse n’a pas été envoyée.'); }
      finally { form.removeAttribute('aria-busy'); }
    });
  };

  PortalV1App.prototype.mutateProofAnnotation = async function (annotationId, action) {
    var proof = this.store.proofDetail;
    var annotation = this.store.proofAnnotations.find(function (item) { return item.id === annotationId; });
    if (!proof || !annotation || !['resolve', 'reopen'].includes(action) || !canAction(annotation, action)) return;
    var binding;
    try { binding = proofReviewBinding(proof); } catch (error) { return; }
    if (annotation.proof_version_id !== binding.currentId || annotation.sha256 !== binding.checksum) return;
    var body = { expected_version: annotation.version, proof_version_id: binding.currentId, sha256: binding.checksum };
    var self = this;
    await this.guard.run('proof-annotation-' + action + ':' + annotation.id + ':' + annotation.version, async function () {
      await self.api.mutate('/client/v1/proofs/' + encodeURIComponent(proof.id) + '/versions/' + encodeURIComponent(binding.currentId)
        + '/annotations/' + encodeURIComponent(annotation.id) + '/' + action, {
        operation: 'proof.annotation.' + action, resource: annotation.id, expectedVersion: annotation.version, body: body
      });
      await self.navigate(self.store.routeState);
    });
  };

  PortalV1App.prototype.submitProof = async function (event) {
    event.preventDefault();
    var proof = this.proofInDialog?.resource;
    if (!proof || !this.dialogForm) return;
    var form = new FormData(this.dialogForm);
    var payload;
    try {
      payload = buildProofDecision(proof, {
        decision: event.submitter?.value || form.get('decision'),
        signed_name: form.get('signed_name'),
        comment: form.get('comment')
      });
    } catch (error) {
      this.dialogForm.querySelector('[data-portal-proof-error]').textContent = /unresolved annotation count/iu.test(String(error?.message || ''))
        ? this.t('proof_studio.approval_open_blocked')
        : this.t('proof.comment_required', 'Ajoutez un commentaire pour demander des corrections.');
      return;
    }
    var self = this;
    await this.guard.run('proof:' + proof.id + ':' + proof.version, async function () {
      self.dialogForm.setAttribute('aria-busy', 'true');
      self.dialogForm.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
      try {
        await self.api.mutate('/client/v1/proofs/' + encodeURIComponent(proof.id) + '/decisions', {
          operation: 'proof.decide', resource: proof.id, expectedVersion: payload.expected_version, body: payload
        });
        self.dialog.close();
        await self.navigate(self.store.routeState?.section === 'proofs' ? self.store.routeState : 'proofs');
        window.requestAnimationFrame(function () {
          var refreshedTrigger = Array.from(self.root.querySelectorAll('[data-portal-proof-decision]')).find(function (button) {
            return button.dataset.portalProofDecision === proof.id;
          });
          (refreshedTrigger || self.root.querySelector('[data-portal-route-heading]'))?.focus({ preventScroll: true });
        });
      } catch (error) {
        var recovery = await recoverPortalError(error, function () { return self.loadRoute('proofs'); });
        self.dialogForm.querySelector('[data-portal-proof-error]').textContent = recovery === 'version_conflict'
          ? self.t('errors.version_conflict', 'La version a changé. Vérifiez le BAT et recommencez.')
          : self.t('errors.generic', 'La décision n’a pas été envoyée.');
      } finally {
        self.dialogForm.removeAttribute('aria-busy');
        self.dialogForm.querySelectorAll('button').forEach(function (button) { button.disabled = false; });
        self.configureProofDecisionDialog(proof);
      }
    });
  };

  PortalV1App.prototype.openWizard = function (prefillItem) {
    var warehouse = prefillItem?.warehouse_id || this.store.context.default_warehouse_id;
    if (!warehouse) {
      this.view.insertAdjacentHTML('afterbegin', '<div class="portal-v1__error" role="alert">'
        + escapeHtml(this.t('wizard.warehouse_unavailable', 'La création est momentanément indisponible : aucun entrepôt canonique n’est configuré.')) + '</div>');
      return;
    }
    this.wizardFile = null;
    this.resumedShipmentId = null;
    this.resumedShipmentBaseline = null;
    this.store.wizard = window.TodayMerchShipmentWizard.createState();
    this.store.wizard.warehouse_id = warehouse;
    if (prefillItem && prefillItem.allowed_actions.includes('create_shipment')) {
      this.store.wizard.kit_lines = [{
        item_id: prefillItem.item_id,
        line_id: window.crypto?.randomUUID?.() || prefillItem.item_id,
        sku: prefillItem.sku,
        quantity: 1,
      }];
      this.store.wizard.label = this.t('wizard.shipment_prefill_label', 'Expédition · {{title}}', { title: prefillItem.title });
      this.store.wizard.dirty = true;
    }
    this.renderWizard();
  };

  PortalV1App.prototype.renderWizard = function () {
    var state = this.store.wizard;
    var labels = ['kit', 'recipients', 'exceptions', 'validation', 'review'];
    var busy = state.saving || state.submission?.status === 'saving';
    var submitAllowed = state.step !== 5 || (
      state.submission?.status !== 'complete'
      && state.validation?.valid === true
      && Array.isArray(state.canonical?.allowed_actions)
      && state.canonical.allowed_actions.includes('submit')
    );
    var primaryLabel = state.step === 4 ? this.t('action.validate', 'Valider')
      : state.step === 5 ? this.t('action.submit', 'Envoyer la demande')
        : this.t('action.continue', 'Continuer');
    this.view.innerHTML = this.heading('wizard.title', 'Nouvelle expédition')
      + '<form class="portal-v1__wizard" data-portal-wizard data-portal-wizard-form' + (busy ? ' aria-busy="true"' : '') + '><p class="portal-v1__wizard-mobile-step">'
      + escapeHtml(this.t('wizard.mobile_step', 'Étape {{step}}/5', { step: state.step })) + '</p><ol class="portal-v1__stepper">'
      + labels.map(function (label, index) {
        var step = index + 1;
        return '<li' + (step === state.step ? ' aria-current="step"' : '') + '><span>' + escapeHtml(step) + '</span><strong>'
          + escapeHtml(this.t('wizard.' + label, label)) + '</strong></li>';
      }, this).join('') + '</ol><div class="portal-v1__wizard-body">' + this.renderWizardStep() + '</div>'
      + '<p class="portal-v1__form-error" id="PortalWizardError" data-portal-wizard-error role="alert" tabindex="-1"></p>'
      + '<div class="portal-v1__wizard-actions">'
      + (state.step > 1 ? '<button type="button" data-portal-wizard-back' + (busy ? ' disabled' : '') + '>' + escapeHtml(this.t('action.back', 'Retour')) + '</button>' : '')
      + '<button type="button" data-portal-wizard-exit' + (busy ? ' disabled' : '') + '>' + escapeHtml(this.t('action.save_exit', 'Enregistrer et quitter')) + '</button>'
      + (submitAllowed ? '<button type="submit" class="is-primary" data-portal-wizard-next' + (busy ? ' disabled' : '') + '>' + escapeHtml(primaryLabel) + '</button>' : '')
      + '</div></form>';
  };

  PortalV1App.prototype.renderWizardStep = function () {
    var state = this.store.wizard;
    if (state.step === 1) {
      var lines = state.kit_lines || [];
      var inventory = (this.store.resources.inventory || []).filter(function (item) {
        return !state.warehouse_id || !item.warehouse_id || item.warehouse_id === state.warehouse_id;
      });
      return '<h2>' + escapeHtml(this.t('wizard.kit', 'Kit')) + '</h2><p>'
        + escapeHtml(this.t('wizard.kit_help', 'Choisissez les articles et les quantités par destinataire.')) + '</p>'
        + '<label class="portal-v1__field"><span>' + escapeHtml(this.t('wizard.label', 'Nom de l’expédition')) + '</span>'
        + '<input name="label" data-portal-wizard-label required maxlength="300" value="' + escapeHtml(state.label || '') + '"></label>'
        + '<fieldset class="portal-v1__kit" data-portal-shipment-kit><legend>' + escapeHtml(this.t('wizard.kit', 'Sélection visuelle du kit')) + '</legend>'
        + (inventory.length ? inventory.map(function (item) {
          var line = lines.find(function (entry) { return entry.item_id === item.item_id; });
          var image = item.image_url ? '<img src="' + escapeHtml(item.image_url) + '" alt="' + escapeHtml(item.title) + '">' : '';
          return '<div class="portal-v1__kit-line"><label><input type="checkbox" data-portal-wizard-kit-select data-item-id="'
            + escapeHtml(item.item_id) + '" data-sku="' + escapeHtml(item.sku) + '" data-line-id="' + escapeHtml(line?.line_id || '') + '"'
            + (line ? ' checked' : '') + '>' + image + '<span><strong>' + escapeHtml(item.title) + '</strong><small>' + escapeHtml(item.sku)
            + ' · ' + escapeHtml(this.t('stock.available', 'Disponible')) + ' ' + escapeHtml(item.available) + '</small></span></label>'
            + '<label><span>' + escapeHtml(this.t('wizard.quantity', 'Quantité')) + '</span><input type="number" min="1" max="999999" inputmode="numeric" data-portal-wizard-kit-quantity data-item-id="'
            + escapeHtml(item.item_id) + '" value="' + escapeHtml(line?.quantity || 1) + '"></label></div>';
        }, this).join('') : '<p class="portal-v1__empty">' + escapeHtml(this.t('stock.empty', 'Aucun stock.')) + '</p>') + '</fieldset>';
    }

    if (state.step === 2) {
      var destination = state.destination || { country_code: 'FR' };
      var fields = [
        ['recipient_name', 'recipient_name', true], ['recipient_company', 'recipient_company', false],
        ['recipient_email', 'recipient_email', false, 'email'], ['recipient_phone', 'recipient_phone', false, 'tel'],
        ['address_line_1', 'address_line_1', true], ['address_line_2', 'address_line_2', false],
        ['postal_code', 'postal_code', true], ['city', 'city', true], ['region', 'region', false],
        ['country_code', 'country_code', true],
      ];
      var modes = '<fieldset class="portal-v1__recipient-mode"><legend>' + escapeHtml(this.t('wizard.recipients', 'Destinataires')) + '</legend>'
        + '<label><input type="radio" name="recipient_mode" value="single"' + (state.recipient_mode === 'single' ? ' checked' : '') + '><span>'
        + escapeHtml(this.t('wizard.single', 'Une adresse')) + '</span></label><label><input type="radio" name="recipient_mode" value="csv"'
        + (state.recipient_mode === 'csv' ? ' checked' : '') + '><span>' + escapeHtml(this.t('wizard.csv', 'Import CSV')) + '</span></label></fieldset>';
      if (state.recipient_mode === 'csv') {
        var imported = state.import || {};
        var errors = Array.isArray(imported.diagnostic_items) ? imported.diagnostic_items.slice(0, 50) : [];
        return '<h2 id="PortalWizardRecipientsTitle">' + escapeHtml(this.t('wizard.recipients', 'Destinataires')) + '</h2>' + modes
          + '<section class="portal-v1__csv" data-portal-wizard-import-limits role="region" aria-labelledby="PortalWizardRecipientsTitle"><p>' + escapeHtml(this.t('wizard.server_draft_notice', 'Le fichier est envoyé vers un stockage privé, sans copie locale.')) + '</p><p class="portal-v1__hint">'
          + escapeHtml(this.t('wizard.import_limits', 'Limites gelées : 500 destinataires, 200 références et 2 Mio par import.')) + '</p>'
          + (state.shipment_id ? '<a class="portal-v1__template" href="' + escapeHtml(String(this.root.dataset.apiBase || '').replace(/\/$/, '') + '/client/v1/shipments/' + encodeURIComponent(state.shipment_id) + '/import-template.csv')
            + '" download>' + escapeHtml(this.t('action.download_template', 'Télécharger le modèle')) + '</a>' : '')
          + '<label class="portal-v1__field"><span>' + escapeHtml(this.t('wizard.csv_file', 'Fichier CSV')) + '</span><input type="file" accept=".csv,text/csv" data-portal-wizard-file'
          + (!state.import ? ' required' : '') + '></label>'
          + (imported.status ? '<p class="portal-v1__import-state">' + escapeHtml(this.backendLabel('import', imported.status)) + '</p>' : '')
          + (errors.length ? '<ol class="portal-v1__import-errors">' + errors.map(function (entry) {
            var fields = Array.isArray(entry.field_errors) ? entry.field_errors : [];
            return '<li><strong>' + escapeHtml(String(entry.row_number)) + '</strong><span>'
              + escapeHtml(fields.map(function (item) { return this.backendLabel('import_field', item.field); }, this).join(', ')) + '</span><code>'
              + escapeHtml(fields.map(function (item) { return this.backendLabel('import_error', item.code); }, this).join(', ')) + '</code></li>';
          }, this).join('') + '</ol>' + (imported.diagnostic_next_cursor ? '<button type="button" data-portal-import-diagnostics-next>'
            + escapeHtml(this.t('action.continue', 'Page suivante')) + '</button>' : '')
            + '<button type="button" data-portal-import-replace>' + escapeHtml(this.t('action.replace_file', 'Remplacer le fichier')) + '</button>' : '') + '</section>';
      }
      return '<h2>' + escapeHtml(this.t('wizard.recipients', 'Destinataires')) + '</h2>' + modes + '<p>'
        + escapeHtml(this.t('wizard.address_retention', 'L’adresse est validée côté serveur et conservée uniquement selon la durée canonique du brouillon.')) + '</p><div class="portal-v1__address-grid">'
        + fields.map(function (field) {
          var name = field[0];
          var required = field[2];
          return '<label class="portal-v1__field"><span>' + escapeHtml(this.t('wizard.' + field[1], field[1])) + '</span><input name="' + name + '" type="'
            + (field[3] || 'text') + '" value="' + escapeHtml(destination[name] || '') + '"' + (required ? ' required' : '')
            + (name === 'country_code' ? ' minlength="2" maxlength="2" pattern="[A-Za-z]{2}"' : '') + '></label>';
        }, this).join('') + '</div>';
    }

    if (state.step === 3) {
      var importedCount = state.import?.row_count;
      var recipientCount = state.recipient_mode === 'csv' && safeCanonicalInteger(importedCount, 1) && importedCount <= 500
        ? importedCount : 1;
      var demand = [];
      try { demand = window.TodayMerchShipmentWizard.aggregateDemand({ kitLines: state.kit_lines, recipientCount: recipientCount }); } catch (error) { demand = []; }
      return '<section data-portal-shipment-exceptions><h2>' + escapeHtml(this.t('wizard.exceptions', 'Exceptions par destinataire')) + '</h2><p>'
        + escapeHtml(this.t('wizard.estimated_demand', 'Demande client estimée, sous réserve de validation canonique.')) + '</p><div class="portal-v1__demand">'
        + demand.map(function (line) {
          var current = state.destination?.quantities?.[line.line_id];
          return '<label><span><strong>' + escapeHtml(line.sku) + '</strong><small>' + escapeHtml(line.quantity) + '</small></span>'
            + (state.recipient_mode === 'single' ? '<input type="number" min="0" inputmode="numeric" data-portal-wizard-exception="' + escapeHtml(line.line_id)
              + '" value="' + escapeHtml(current == null ? '' : current) + '" placeholder='
              + '"' + escapeHtml(line.quantity) + '">' : '') + '</label>';
        }).join('') + '</div><p class="portal-v1__hint">' + escapeHtml(this.t('wizard.quantity_inherits', 'Vide conserve la quantité du kit.'))
        + ' ' + escapeHtml(this.t('wizard.quantity_zero_excludes', '0 exclut l’article.')) + '</p></section>';
    }

    if (state.step === 4) {
      return '<section data-portal-shipment-demand><h2>' + escapeHtml(this.t('wizard.validation', 'Validation stock et adresses')) + '</h2><p>'
        + escapeHtml(state.validation?.valid === true ? this.t('wizard.validation_valid', 'Stock et adresses validés.')
          : this.t('wizard.validation_required', 'Une validation canonique du stock et des adresses est requise avant envoi.')) + '</p></section>';
    }

    return '<h2>' + escapeHtml(this.t('wizard.review', 'Vérification')) + '</h2><div class="portal-v1__review"><dl>'
      + '<div><dt>' + escapeHtml(this.t('wizard.label', 'Expédition')) + '</dt><dd>' + escapeHtml(state.label) + '</dd></div>'
      + '<div><dt>' + escapeHtml(this.t('wizard.kit', 'Kit')) + '</dt><dd>' + escapeHtml(state.kit_lines.length) + '</dd></div>'
      + '<div><dt>' + escapeHtml(this.t('wizard.recipients', 'Destinataires')) + '</dt><dd>'
      + escapeHtml(state.recipient_mode === 'csv' ? String(state.import?.row_count || '—') : '1') + '</dd></div></dl><p>'
      + escapeHtml(this.t('wizard.review_notice', 'L’envoi déclenche la réservation canonique. Vérifiez les informations avant de continuer.')) + '</p>'
      + (state.submission?.status === 'complete' ? '<p class="portal-v1__success">' + escapeHtml(this.t('state.submitted', 'Demande envoyée.')) + '</p>' : '') + '</div>';
  };

  PortalV1App.prototype.collectWizardStep = function () {
    var form = this.view?.querySelector('[data-portal-wizard-form]');
    var state = this.store.wizard;
    if (!form) return state;
    form.querySelectorAll('[aria-invalid="true"]').forEach(function (field) { field.removeAttribute('aria-invalid'); });
    if (state.step === 1) {
      var label = form.querySelector('[data-portal-wizard-label]')?.value || '';
      var lines = Array.from(form.querySelectorAll('[data-portal-wizard-kit-select]:checked')).map(function (field) {
        var itemId = field.dataset.itemId;
        var quantityField = Array.from(form.querySelectorAll('[data-portal-wizard-kit-quantity]')).find(function (candidate) {
          return candidate.dataset.itemId === itemId;
        });
        var quantity = Number(quantityField?.value || 0);
        var lineId = field.dataset.lineId || window.crypto?.randomUUID?.();
        if (!lineId || !Number.isSafeInteger(quantity) || quantity < 1) throw new TypeError('Invalid kit line');
        return { line_id: lineId, item_id: itemId, sku: field.dataset.sku || '', quantity: quantity };
      });
      if (!label.trim() || !lines.length) throw new TypeError('A shipment label and one kit line are required');
      state = window.TodayMerchShipmentWizard.reduce(state, { type: 'label.changed', label: label });
      state = window.TodayMerchShipmentWizard.reduce(state, { type: 'kit.changed', lines: lines });
    } else if (state.step === 2) {
      var mode = form.querySelector('[name="recipient_mode"]:checked')?.value || state.recipient_mode;
      var destination = state.destination || {};
      if (mode === 'single') {
        destination = Object.assign({}, destination);
        [
          'recipient_name', 'recipient_company', 'recipient_email', 'recipient_phone', 'address_line_1',
          'address_line_2', 'postal_code', 'city', 'region', 'country_code'
        ].forEach(function (name) { destination[name] = form.elements[name]?.value || ''; });
      }
      state = window.TodayMerchShipmentWizard.reduce(state, { type: 'recipient.changed', mode: mode, destination: destination });
    } else if (state.step === 3 && state.recipient_mode === 'single') {
      var nextDestination = Object.assign({}, state.destination || {}, { quantities: {} });
      form.querySelectorAll('[data-portal-wizard-exception]').forEach(function (field) {
        nextDestination.quantities[field.dataset.portalWizardException] = field.value;
      });
      state = window.TodayMerchShipmentWizard.reduce(state, { type: 'destination.changed', destination: nextDestination });
    }
    this.store.wizard = state;
    return state;
  };

  PortalV1App.prototype.refreshWizardShipment = async function () {
    var state = this.store.wizard;
    if (!state.shipment_id) throw new TypeError('A server draft is required');
    var resource = await this.api.request('/client/v1/shipments/' + encodeURIComponent(state.shipment_id));
    this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, { type: 'canonical.replaced', resource: resource });
    return resource;
  };

  PortalV1App.prototype.saveWizardDraft = async function (includeDestination) {
    var state = this.store.wizard;
    var warehouse = state.warehouse_id || this.store.context.default_warehouse_id;
    if (!warehouse || !state.label.trim() || !state.kit_lines.length) throw new TypeError('The shipment draft is incomplete');
    if (state.shipment_id && this.resumedShipmentId === state.shipment_id && includeDestination !== true) {
      var resumedError = new TypeError('A resumed shipment requires a complete replacement recipient');
      resumedError.code = 'RESUMED_DRAFT_INCOMPLETE';
      throw resumedError;
    }
    if (!state.shipment_id) {
      var created = await this.api.mutate('/client/v1/shipments', {
        operation: 'shipment.create', resource: 'shipment:new', expectedVersion: 0,
        body: { warehouse_id: warehouse, label: state.label.trim() }
      });
      this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, { type: 'draft.saved', resource: created });
      state = this.store.wizard;
    }
    var body = buildWizardDraftBody(state, includeDestination);
    var updated = await this.api.mutate('/client/v1/shipments/' + encodeURIComponent(state.shipment_id), {
      operation: 'shipment.update', resource: state.shipment_id, expectedVersion: state.version, method: 'PATCH',
      body: body
    });
    this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, { type: 'draft.saved', resource: updated });
    var refreshed = await this.refreshWizardShipment();
    if (includeDestination === true && this.resumedShipmentId === state.shipment_id) {
      this.resumedShipmentId = null;
      this.resumedShipmentBaseline = null;
    }
    return refreshed;
  };

  PortalV1App.prototype.loadImportDiagnostics = async function (cursor) {
    var state = this.store.wizard;
    var imported = state.import;
    if (!state.shipment_id || !imported?.id) throw new TypeError('An invalid import is required');
    var path = '/client/v1/shipments/' + encodeURIComponent(state.shipment_id) + '/imports/' + encodeURIComponent(imported.id)
      + '?limit=50' + (cursor ? '&cursor=' + encodeURIComponent(cursor) : '');
    var resource = await this.api.request(path);
    var diagnostics = resource?.diagnostics;
    var items = Array.isArray(diagnostics?.items) ? diagnostics.items.slice(0, 50) : [];
    this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, {
      type: 'import.completed',
      resource: Object.assign({}, imported, resource, {
        diagnostic_items: items,
        diagnostic_next_cursor: typeof diagnostics?.next_cursor === 'string' ? diagnostics.next_cursor : null
      })
    });
    return resource;
  };

  PortalV1App.prototype.uploadWizardCsv = async function () {
    var state = this.store.wizard;
    if (!this.wizardFile && state.import?.status === 'imported') return true;
    if (!this.wizardFile) throw new TypeError('A replacement CSV file is required');
    if (this.resumedShipmentId === state.shipment_id
      && (!this.resumedShipmentBaseline || !sameWizardKit(this.resumedShipmentBaseline, state))) {
      var resumedImportError = new TypeError('A changed resumed kit cannot reuse the previous shipment revision');
      resumedImportError.code = 'RESUMED_KIT_IMPORT_CONFLICT';
      throw resumedImportError;
    }
    var file = this.wizardFile;
    var shipment = state.canonical?.current_revision_id ? state.canonical : await this.refreshWizardShipment();
    if (!shipment.current_revision_id) throw new TypeError('A canonical shipment revision is required');
    var imported = await this.api.mutate('/client/v1/shipments/' + encodeURIComponent(state.shipment_id) + '/imports', {
      operation: 'shipment.import.create', resource: state.shipment_id, expectedVersion: state.version,
      body: { revision_id: shipment.current_revision_id, file_name: file.name, byte_size: file.size, content_type: 'text/csv' }
    });
    await this.api.putSigned(imported.signed_url, file, { contentType: 'text/csv' });
    this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, {
      type: 'import.created', resource: { id: imported.id, version: imported.version, status: imported.status }
    });
    this.wizardFile = null;
    var input = this.view?.querySelector('[data-portal-wizard-file]');
    if (input) input.value = '';
    var completed = await this.api.mutate('/client/v1/shipments/' + encodeURIComponent(state.shipment_id) + '/imports/' + encodeURIComponent(imported.id) + '/complete', {
      operation: 'shipment.import.complete', resource: imported.id, expectedVersion: imported.version, body: {}
    });
    var importPath = '/client/v1/shipments/' + encodeURIComponent(state.shipment_id) + '/imports/' + encodeURIComponent(imported.id) + '?limit=50';
    this.importPollController?.abort();
    var pollController = new AbortController();
    this.importPollController = pollController;
    var importResource;
    try {
      if (completed.status === 'validating') {
        var self = this;
        importResource = await pollCanonicalImport({
          initial: completed,
          signal: pollController.signal,
          maxAttempts: 6,
          delayMs: 250,
          read: function (options) { return self.api.request(importPath, { signal: options.signal }); },
        });
      } else {
        importResource = canonicalPolledImport(await this.api.request(importPath, { signal: pollController.signal }), imported.id);
      }
    } finally {
      if (this.importPollController === pollController) this.importPollController = null;
    }
    importResource = Object.assign({}, importResource, { row_count: completed.row_count });
    if (importResource.status === 'invalid') {
      importResource.diagnostic_items = Array.isArray(importResource.diagnostics?.items) ? importResource.diagnostics.items.slice(0, 50) : [];
      importResource.diagnostic_next_cursor = typeof importResource.diagnostics?.next_cursor === 'string' ? importResource.diagnostics.next_cursor : null;
      delete importResource.diagnostics;
    }
    this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, { type: 'import.completed', resource: importResource });
    if (importResource.status === 'invalid') return false;
    if (importResource.status !== 'valid') throw new TypeError('The CSV import is not ready');
    var applied = await this.api.mutate('/client/v1/shipments/' + encodeURIComponent(state.shipment_id) + '/imports/' + encodeURIComponent(imported.id) + '/apply', {
      operation: 'shipment.import.apply', resource: imported.id, expectedVersion: importResource.version, body: {}
    });
    var canonicalShipment = await this.api.request('/client/v1/shipments/' + encodeURIComponent(state.shipment_id));
    this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, {
      type: 'import.applied', resource: Object.assign({}, applied, { row_count: completed.row_count }), shipment: canonicalShipment
    });
    if (this.resumedShipmentId === state.shipment_id) {
      this.resumedShipmentId = null;
      this.resumedShipmentBaseline = null;
    }
    return true;
  };

  PortalV1App.prototype.validateWizard = async function () {
    var state = this.store.wizard;
    var shipment = await this.refreshWizardShipment();
    if (!shipment.current_revision_id) throw new TypeError('A canonical shipment revision is required');
    if (state.recipient_mode === 'single' && !window.TodayMerchShipmentWizard.serializeDraft(state).destinations.length) {
      throw new TypeError('A canonical destination is required');
    }
    if (state.recipient_mode === 'csv' && state.import?.status !== 'imported') {
      throw new TypeError('A canonical import is required');
    }
    var validated = await this.api.mutate('/client/v1/shipments/' + encodeURIComponent(state.shipment_id) + '/validate', {
      operation: 'shipment.validate', resource: state.shipment_id, expectedVersion: this.store.wizard.version,
      body: { revision_id: shipment.current_revision_id }
    });
    this.store.wizard = window.TodayMerchShipmentWizard.reduce(this.store.wizard, { type: 'validation.completed', resource: validated });
    if (this.store.wizard.validation?.status !== 'valid' || this.store.wizard.validation?.valid !== true) {
      throw new TypeError('Canonical validation did not succeed');
    }
    return validated;
  };

  PortalV1App.prototype.setWizardError = function (error) {
    var form = this.view?.querySelector('[data-portal-wizard-form]');
    var target = form?.querySelector('[data-portal-wizard-error]');
    if (!target) return;
    var key = error?.code === 'VERSION_CONFLICT' ? 'errors.version_conflict'
      : error?.code === 'ACTION_FORBIDDEN' ? 'errors.forbidden'
        : error?.code === 'IMPORT_POLL_TIMEOUT' ? 'errors.import_timeout'
        : error?.code === 'IMPORTED_DRAFT_CONFLICT' ? 'errors.import_applied_changed'
          : error?.code === 'IMPORT_FILE_UNSAVED' ? 'errors.import_file_unsaved'
            : ['RESUMED_DRAFT_INCOMPLETE', 'RESUMED_KIT_IMPORT_CONFLICT'].includes(error?.code)
              ? 'errors.resume_requires_recipient' : 'errors.generic';
    target.textContent = this.t(key, 'Impossible de poursuivre. Vérifiez les champs et réessayez.')
      + (error?.request_id ? ' ' + this.t('errors.request_id', 'Référence : {{request_id}}', { request_id: error.request_id }) : '');
    Object.keys(error?.field_errors || {}).forEach(function (name) {
      var field = form.elements[name];
      if (field) {
        field.setAttribute('aria-invalid', 'true');
        field.setAttribute('aria-describedby', 'PortalWizardError');
      }
    });
    target.focus?.();
  };

  PortalV1App.prototype.advanceWizard = function () {
    var self = this;
    var form = this.view?.querySelector('[data-portal-wizard-form]');
    if (!form || !form.reportValidity()) return Promise.resolve(false);
    try { this.collectWizardStep(); } catch (error) { this.setWizardError(error); return Promise.resolve(false); }
    var state = this.store.wizard;
    var key = 'wizard:' + (state.shipment_id || 'new') + ':' + state.version + ':' + state.step;
    return this.guard.run(key, async function () {
      form.setAttribute('aria-busy', 'true');
      form.querySelectorAll('button').forEach(function (button) { button.disabled = true; });
      try {
        if (state.step === 1) {
          if (!self.resumedShipmentId || self.resumedShipmentId !== state.shipment_id) await self.saveWizardDraft(false);
          self.store.wizard = window.TodayMerchShipmentWizard.reduce(self.store.wizard, { type: 'step.changed', step: 2 });
        } else if (state.step === 2) {
          if (state.recipient_mode === 'single') await self.saveWizardDraft(true);
          else if (!await self.uploadWizardCsv()) { self.renderWizard(); return false; }
          self.store.wizard = window.TodayMerchShipmentWizard.reduce(self.store.wizard, { type: 'step.changed', step: 3 });
        } else if (state.step === 3) {
          if (state.recipient_mode === 'single') await self.saveWizardDraft(true);
          self.store.wizard = window.TodayMerchShipmentWizard.reduce(self.store.wizard, { type: 'step.changed', step: 4 });
        } else if (state.step === 4) {
          await self.validateWizard();
          self.store.wizard = window.TodayMerchShipmentWizard.reduce(self.store.wizard, { type: 'step.changed', step: 5 });
        } else {
          if (state.validation?.valid !== true
            || state.submission?.status === 'complete'
            || !Array.isArray(state.canonical?.allowed_actions)
            || !state.canonical.allowed_actions.includes('submit')) {
            throw new TypeError('Canonical submission permission is required before submission');
          }
          self.store.wizard = window.TodayMerchShipmentWizard.reduce(self.store.wizard, { type: 'submission.started' });
          var submitted = await self.api.mutate('/client/v1/shipments/' + encodeURIComponent(state.shipment_id) + '/submit', {
            operation: 'shipment.submit', resource: state.shipment_id, expectedVersion: state.version, body: {}
          });
          self.store.wizard = window.TodayMerchShipmentWizard.reduce(self.store.wizard, { type: 'submission.completed', resource: submitted });
        }
        self.renderWizard();
        return true;
      } catch (error) {
        if (error?.code === 'VERSION_CONFLICT' && self.store.wizard.shipment_id) {
          try { await self.refreshWizardShipment(); } catch (reloadError) { /* safe localized failure below */ }
          self.renderWizard();
        }
        self.setWizardError(error);
        return false;
      } finally {
        var current = self.view?.querySelector('[data-portal-wizard-form]');
        current?.removeAttribute('aria-busy');
        current?.querySelectorAll('button').forEach(function (button) { button.disabled = false; });
      }
    });
  };

  PortalV1App.prototype.saveAndExitWizard = async function () {
    try {
      var before = this.store.wizard;
      var state = this.collectWizardStep();
      if (before.dirty === false && sameWizardKit(before, state)
        && before.recipient_mode === state.recipient_mode
        && sameWizardDestination(before.destination, state.destination)
        && String(before.import?.id || '') === String(state.import?.id || '')
        && String(before.import?.status || '') === String(state.import?.status || '')) {
        state.dirty = false;
        this.store.wizard = state;
      }
      if (this.wizardFile) {
        var pendingFileError = new TypeError('A selected import file has not been applied');
        pendingFileError.code = 'IMPORT_FILE_UNSAVED';
        throw pendingFileError;
      }
      if (state.shipment_id && state.dirty === false) {
        await this.navigate('shipments');
        return;
      }
      if (state.recipient_mode === 'csv' && state.import?.status === 'imported') {
        var importedError = new TypeError('An applied import cannot be replaced by a kit-only draft');
        importedError.code = 'IMPORTED_DRAFT_CONFLICT';
        throw importedError;
      }
      var includeDestination = false;
      if (state.step > 1 && state.recipient_mode === 'single') {
        try { window.TodayMerchShipmentWizard.serializeDraft(state); includeDestination = true; } catch (error) { includeDestination = false; }
      }
      if (state.shipment_id && this.resumedShipmentId === state.shipment_id && includeDestination !== true) {
        var resumedError = new TypeError('A resumed shipment requires a complete replacement recipient');
        resumedError.code = 'RESUMED_DRAFT_INCOMPLETE';
        throw resumedError;
      }
      if (state.label.trim() && state.kit_lines.length) {
        await this.saveWizardDraft(includeDestination);
      }
      await this.navigate('shipments');
    } catch (error) {
      this.setWizardError(error);
    }
  };

  async function bootPortal(root) {
    var app = new PortalV1App(root);
    try { await app.bootstrap(); } catch (error) {
      if (app.shell) app.shell.hidden = false;
      app.renderError(error);
    }
  }

  function installGiftCampaigns() {
    window.TodayMerchGiftCampaigns?.install(PortalV1App, {
      parseRoute: parsePortalRoute, normalizeCampaign: normalizeCampaignResource,
      memberLabel: portalMemberLabel, buildCampaign: buildCampaignMutation
    });
  }

  PortalV1App.prototype.installBeneficiaryModules = function () {
    window.TodayMerchPortalBeneficiaries?.install(PortalV1App);
    this.bind();
  };

  PortalV1App.prototype.installPortalIntegrations = function () {
    window.TodayMerchPortalIntegrations?.install(PortalV1App);
    this.bind();
  };

  PortalV1App.prototype.installCampaignModules = function () {
    installGiftCampaigns();
    window.TodayMerchProductLibrary?.install(PortalV1App);
    window.TodayMerchPortalCampaignTypes?.install(PortalV1App);
    window.TodayMerchPortalBrand?.install(PortalV1App);
    // Each module guards its listeners, including when this instance was bound
    // before the optional definitions arrived.
    this.bind();
  };

  installGiftCampaigns();

  window.TodayMerchProductLibrary?.install(PortalV1App);
  window.TodayMerchPortalOperations?.install(PortalV1App, { normalizeInventory: normalizeInventoryResource, normalizeReorder: normalizeInventoryReorder });
  window.TodayMerchPortalInventory?.install(PortalV1App, { normalizeInventory: normalizeInventoryResource });
  window.TodayMerchPortalDeliveries?.install(PortalV1App, { normalizeInventory: normalizeInventoryResource });
  window.TodayMerchPortalDashboard?.install(PortalV1App, { normalizeCampaign: normalizeCampaignResource, canAction: canAction });
  window.TodayMerchPortalCampaignTypes?.install(PortalV1App);
  window.TodayMerchPortalBrand?.install(PortalV1App);
  window.TodayMerchProjectPortal?.install(PortalV1App);
  window.TodayMerchPortalOrders?.install(PortalV1App);
  window.TodayMerchPortalAccount?.install(PortalV1App);
  window.TodayMerchPortalBeneficiaries?.install(PortalV1App);
  window.TodayMerchPortalIntegrations?.install(PortalV1App);

  window.TodayMerchPortalDesigns?.install(PortalV1App);

  if (window.__TODAYMERCH_CUSTOMER_PORTAL_TEST__) {
    window.TodayMerchCustomerPortalTest = { ClientPortal: ClientPortal, postJSON: postJSON };
    window.TodayMerchCustomerPortalV1Test = {
      SHIPMENT_STATES: SHIPMENT_STATES,
      fallbackDictionaries: PORTAL_V1_FALLBACK_DICTIONARIES,
      PortalV1App: PortalV1App,
      backendCodeKey: backendCodeKey,
      buildProofDecision: buildProofDecision,
      buildWizardDraftBody: buildWizardDraftBody,
      sameWizardKit: sameWizardKit,
      canonicalCostProposal: canonicalCostProposal,
      normalizeProofResource: normalizeProofResource,
      normalizeProofVersionPage: normalizeProofVersionPage,
      normalizeProofDecisionPage: normalizeProofDecisionPage,
      normalizeProofAnnotationPage: normalizeProofAnnotationPage,
      buildProofAnnotation: buildProofAnnotation,
      buildProofAnnotationComment: buildProofAnnotationComment,
      buildProofComparison: buildProofComparison,
      buildProofPageModel: buildProofPageModel,
      normalizeProofPreview: normalizeProofPreview,
      activeProofPreviewUrl: activeProofPreviewUrl,
      normalizeInventoryResource: normalizeInventoryResource,
      normalizeDocumentResource: normalizeDocumentResource,
      normalizeDocumentVersion: normalizeDocumentVersion,
      normalizeDocumentDecision: normalizeDocumentDecision,
      buildDocumentDecision: buildDocumentDecision,
      filterDocumentResources: filterDocumentResources,
      normalizeGlobalSearchResult: normalizeGlobalSearchResult,
      normalizeGlobalSearchPage: normalizeGlobalSearchPage,
      createGlobalSearchDialogController: createGlobalSearchDialogController,
      normalizeInventoryReorder: normalizeInventoryReorder,
      canInventoryAction: canInventoryAction,
      filterInventoryResources: filterInventoryResources,
      inventoryCsv: inventoryCsv,
      normalizeShipmentSummary: normalizeShipmentSummary,
      normalizeShipmentDetail: normalizeShipmentDetail,
      normalizeCampaignResource: normalizeCampaignResource,
      campaignCalendarModel: campaignCalendarModel,
      normalizeProductCapabilities: normalizeProductCapabilities,
      productCapabilityForRoute: productCapabilityForRoute,
      buildCampaignMutation: buildCampaignMutation,
      projectDossierModel: projectDossierModel,
      notificationCodeKey: notificationCodeKey,
      normalizePortalMode: normalizePortalMode,
      pollCanonicalImport: pollCanonicalImport,
      canAction: canAction,
      buildConnectedDashboardModel: buildConnectedDashboardModel,
      createPortalStore: createPortalStore,
      createSubmissionGuard: createSubmissionGuard,
      formatMinor: formatMinor,
      contextTabsForRoute: contextTabsForRoute,
      canonicalBootstrapCompanyName: canonicalBootstrapCompanyName,
      legacyEntryAvailable: legacyEntryAvailable,
      legacyReadonlyRequested: legacyReadonlyRequested,
      parsePortalRoute: parsePortalRoute,
      recoverPortalError: recoverPortalError,
      selectDefaultWarehouse: selectDefaultWarehouse,
      routeFromHash: routeFromHash,
      shipmentLineMetrics: shipmentLineMetrics
    };
    return;
  }

  function startPortals() {
    document.querySelectorAll('[data-b2b-portal]').forEach(function (root) {
      void bootPortal(root);
    });
  }
  // Deferred dependencies execute in document order. Once parsing finishes,
  // this section is ready without waiting for unrelated deferred scripts.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startPortals, { once: true });
  else startPortals();
})();
